<template>
    <div class="sh060" id="sh060">
        <div v-if="isLoading" class="loading-container">
            <div class="vld-background" style="background: transparent;"></div>
            <div class="vld-content">
                <div class="vld-icon">
                    <svg viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg" width="64" height="64" stroke="#000">
                        <g fill="none" fill-rule="evenodd">
                            <g transform="translate(1 1)" stroke-width="2">
                                <circle stroke-opacity=".25" cx="18" cy="18" r="18"></circle>
                                <path d="M36 18c0-9.94-8.06-18-18-18">
                                <animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="0.8s" repeatCount="indefinite"></animateTransform>
                                </path>
                            </g>
                        </g>
                    </svg>
                </div>
                <p class="loading-message">{{ loadingMessage }}</p>
            </div>
        </div>
        <!-- ご注文手続き -->
        <h2>{{$t("sh030.labels.orderProcedure")}}</h2>
        <!--エラーメッセージ表示-->
        <div class="errorMessage">
            <message :listMess="listMessValid" :mapMsg="mapMessValid" :idScreen="SH060_PART" class="p-3" /> 
        </div>
        
        <div class="section-inner">
            <!-- ご注文確認 -->
            <h3>{{$t("sh060.labels.orderconfirmation")}}</h3>
            <ul class="flowchart mb64">
                <!-- お客様情報 -->
                <li v-if="tdkSkipFlg || sh060Init.dairiInputKbn == '1'"><span>{{$t("common.labels.step1")}}</span>{{$t("sh060.labels.cartOfOrderContents")}}</li>
                <!-- ご注文内容確認 -->
                <li v-if="confirmFlg" class="flow-current"><span>{{$t("common.labels.step3")}}</span>{{$t("common.labels.confirmationOfOrderContents")}}</li>
                <!-- ご注文登録完了 -->
                <li v-if="completeFlg"><span>{{$t("common.labels.step4")}}</span>{{$t("common.labels.orderRegistrationComplete")}}</li>
            </ul>
            <div class="sh060-body">
                <br>
                <input type="hidden" id="orderId" :value="sh060Init.orderNum"/>
                <input type="hidden" id="userId" :value="sh060Init.kokyakuNo"/>
                <input type="hidden" id="mail" :value="sh060Init.kokyakuMail1"/>
                <input type="hidden" id="cardNo" :value="sh060Request.cardNoDisp1 + sh060Request.cardNoDisp2 + sh060Request.cardNoDisp3 + sh060Request.cardNoDisp4"/>
                <input type="hidden" id="cardLimit" :value="sh060Request.limitMonth + sh060Request.limitYear"/>
                <input v-if="sh060Init.cardNameOption == 1" type="hidden" id="cardHolder" :value="sh060Request.cardNameNamae + sh060Request.cardNameMyouji"/>
                <input v-else type="hidden" id="cardHolder" :value="sh060Request.cardUserNm"/>
                <input type="hidden" id="seikyuuKin" :value="sh060Init.seikyuuKin"/>
                <input type="hidden" id="TelNo" :value="sh060Init.kokyakuTel1"/>
                <div v-for="(item,index) in sh060Init.cartInfo" :key="index">
                    <input type="hidden" class="ItemNm" :value="stringNvl(item.WEB_ITEM_NM,'')">
                </div>
                <input type="hidden" id="tdkZip" :value="sh060Init.orderInfo['KOKYAKU_ZIP']"/>
                <input type="hidden" id="tdkAddr" :value="stringNvl(sh060Init.orderInfo['KOKYAKU_ADDR1'],'')+stringNvl(sh060Init.orderInfo['KOKYAKU_ADDR2'],'')+stringNvl(sh060Init.orderInfo['KOKYAKU_ADDR3'],'')"/>
                <label id="cardNoDisp_lbl" hidden>{{$t('sh060.labels.cardnumber')}}</label>
                <label id="cardPayCnt_lbl" hidden>{{$t('sh060.labels.paymentfrequency')}}</label>
                <label id="bunkatuKaisu_lbl" hidden>{{$t('sh060.labels.numberOfTime')}}</label>
                <label id="lastBunkatuKaisu_lbl" hidden>{{$t('sh060.labels.numberOfTime')}}</label>
                <label id="lcvsCd_lbl" hidden>{{$t('sh060.labels.conveniencestorename')}}</label>
                <label id="cardName_lbl" hidden>{{$t('sh060.labels.nominalPerson')}}</label>
                <label id="cardSecurity_lbl" hidden>{{$t('sh060.labels.securitycode')}}</label>
                <div v-bind:style="styleObject">
                    <div>
                        <h4>
                            <!-- ご注文の確認 -->
                            {{$t("sh060.labels.orderConfirmation")}}
                        </h4>
                        <div class="settingMainSh060">
                            <div class="settingMainSh060Row" >
                                <!--複数届け先選択Button-->
                                <div v-if="sh060Init.kokyakuNo == '999999999' || sh060Init.kokyakuNo == null" class="settingMainSh060CardHeaderSub2"></div><!-- ゲスト購入の場合、変更ボタン表示崩れ防止 -->
                                <div v-if="sh060Init.hukusuFlg == 1 && sh060Init.kokyakuNo != '999999999' && sh060Request.hopeDayList.length < 2 && sh060Init.kessaiCd != Constants.KESSAI_AMAZONPAY && sh060Init.cartSplitUseFlg != 1" class="settingMainSh060CardHeaderSub2"><a href="javascript:void(0)" @click="gotoSettingPage(20);" class="card-link">{{$t('sh060.buttons.addMultTdk')}}</a></div>
                                <div v-if="sh060Init.hukusuFlg == 1 && sh060Init.kokyakuNo != '999999999' && sh060Request.hopeDayList.length < 2 && sh060Init.kessaiCd != Constants.KESSAI_AMAZONPAY && sh060Init.cartSplitUseFlg == 1" class="settingMainSh060CardHeaderSub2"><a v-if="sh060Init.cartSplitUseFlg == 1 && sh060Init.onlyStorePickupFlg != 1" href="javascript:void(0)" @click="gotoSettingPage(20);" class="card-link">{{$t('sh060.buttons.addMultTdk')}}</a></div>
                                 <!-- 【注文情報設定】第一行（お届け先情報、お届け希望日時、ギフト設定）-->
                                <div class="settingMainSh060OneColumn tdkInfoCol" v-for="(oneTdkInfo, tdkInfoIndex) in sh060Init.tdkInfo" v-bind:key="tdkInfoIndex">
                                    <div class="settingMainSh060Card">
                                        <!-- お届け先情報 -->
                                        <!-- 店頭受取以外の場合 90:店頭受取 -->
                                        <div class="settingMainSh060CardHeader" v-if="stringNvl(oneTdkInfo['BINSYU_KBN']) != '90'">
                                            <div class="settingMainSh060CardHeaderSub">
                                                <div class="settingMainSh060CardHeaderSub0" v-if="sh060Init.tdkInfo && sh060Init.tdkInfo.length > 1 && sh060Init.cartSplitUseFlg != 1">{{$t('sh060.labels.orderTdkNo')}}{{tdkInfoIndex+1}}</div>
                                                <div class="settingMainSh060CardHeaderSub0" v-if="sh060Init.tdkInfo && sh060Init.tdkInfo.length > 1 && sh060Init.cartSplitUseFlg == 1">{{$t('sh060.labels.orderTdkNo')}}{{oneTdkInfo['TDK_CNT']}}</div>
                                                <div class="settingMainSh060CardHeaderSub1">{{$t('sh060.labels.orderTdkAddArea')}}</div>
                                                <div v-if="sh060Request.amazonCheckoutSessionId == null" class="settingMainSh060CardHeaderSub2"><a href="javascript:void(0)" @click="gotoSettingPageForTdk(19,oneTdkInfo['TDK_SEQ'],'0');" id="tdkConfirmCopyMsg" class="card-link">{{$t('sh060.buttons.chanegeSettingArea')}}</a></div>
                                                <div v-else class="settingMainSh060CardHeaderSub2"><a href="javascript:void(0)" id="changeButton1" class="card-link">{{$t('sh060.buttons.chanegeSettingArea')}}</a></div>
                                            </div>
                                        </div>
                                        <!-- 店頭受取の場合 90:店頭受取 -->
                                        <div class="settingMainSh060CardHeader" v-if="stringNvl(oneTdkInfo['BINSYU_KBN']) == '90'">
                                            <div class="settingMainSh060CardHeaderSub" style="border-bottom:0px;" >
                                                <div class="settingMainSh060CardHeaderSub0" v-if="sh060Init.tdkInfo && sh060Init.tdkInfo.length > 1 && sh060Init.cartSplitUseFlg == 1">{{$t('sh060.labels.pickupInStore')}}{{oneTdkInfo['TDK_CNT']}}</div>
                                            </div>
                                        </div>
                                        <!-- 店頭受取以外の場合 90:店頭受取 -->
                                        <div class="settingMainSh060CardBody" v-if="stringNvl(oneTdkInfo['BINSYU_KBN']) != '90'">
                                            <!-- 注文者住所に送る -->
                                            <template v-if="sh060Init.siteFlg == 0">
                                                <template v-if="oneTdkInfo['TDK_FLG'] === 1 && oneTdkInfo['TDK_M_SEQ'] === 0 || (sh060Init.kessaiCd == '83' && sh060Request.amazonCheckoutSessionId != null)">
                                                    <h5 class="settingMainSh060CardBodyCardTitle" v-if="sh060Init.catalogFlg != 1">{{$t('sh060.messages.orderTdkAddAreaMsg1')}}</h5>
                                                    <p class="settingMainSh060CardBodyCardText">{{sh060Init.kokyakuNm1}}&nbsp;{{sh060Init.kokyakuNm2}}&nbsp;{{sh060Init.kokyakuNm3}}&nbsp;様</p>
                                                    <p class="settingMainSh060CardBodyCardText">〒{{sh060Init.orderInfo['KOKYAKU_ZIP']}}</p>
                                                    <template v-if="sh060Init.kokyakuNo == '999999999'">
                                                        <p class="settingMainSh060CardBodyCardText">
                                                                                {{stringNvl(sh060Init.orderInfo['KOKYAKU_ADDR1'])}}
                                                                                {{stringNvl(sh060Init.orderInfo['KOKYAKU_ADDR2'])}}
                                                                                {{stringNvl(sh060Init.orderInfo['KOKYAKU_ADDR3'])}}
                                                        </p>
                                                    </template>
                                                    <template v-else>
                                                        <p class="settingMainSh060CardBodyCardText">{{stringNvl(sh060Init.orderInfo['KOKYAKU_ADDR1'])}}
                                                                                {{stringNvl(sh060Init.orderInfo['KOKYAKU_ADDR2'])}}
                                                                                {{stringNvl(sh060Init.orderInfo['KOKYAKU_ADDR3'])}}
                                                        </p>
                                                    </template>
                                                </template>
                                                <!-- 別のお届け先に送る -->
                                                <template v-else >
                                                    <h5 class="settingMainSh060CardBodyCardTitle" v-if="sh060Init.catalogFlg != 1">{{$t('sh060.messages.orderTdkAddAreaMsg2')}}</h5>
                                                    <p class="settingMainSh060CardBodyCardText">{{oneTdkInfo['TDK_NM1']}}&nbsp;{{oneTdkInfo['TDK_NM2']}}&nbsp;{{oneTdkInfo['TDK_NM3']}}&nbsp;
                                                        <template v-if="sh060Init.tdkKeisyouPullDownFlg == 0">
                                                            様
                                                        </template>
                                                        <template v-else>
                                                            {{oneTdkInfo['TDK_TITLE']}}
                                                        </template>
                                                    </p>
                                                    <p class="settingMainSh060CardBodyCardText">〒{{oneTdkInfo['TDK_ZIP']}}</p>
                                                    <template v-if="sh060Init.kokyakuNo == '999999999'">
                                                        <p class="settingMainSh060CardBodyCardText">
                                                                                {{stringNvl(oneTdkInfo['TDK_ADDR1'])}}
                                                                                {{stringNvl(oneTdkInfo['TDK_ADDR2'])}}
                                                                                {{stringNvl(oneTdkInfo['TDK_ADDR3'])}}
                                                        </p>
                                                    </template>
                                                    <template v-else>
                                                        <p class="settingMainSh060CardBodyCardText">{{stringNvl(oneTdkInfo['TDK_ADDR1'])}}
                                                                                {{stringNvl(oneTdkInfo['TDK_ADDR2'])}}
                                                                                {{stringNvl(oneTdkInfo['TDK_ADDR3'])}}
                                                        </p>
                                                    </template>
                                                </template>
                                            </template>
                                            <template v-else>
                                                <template v-if="oneTdkInfo['TDK_FLG'] === 1 && oneTdkInfo['TDK_M_SEQ'] === 0" >
                                                    <h5 class="settingMainSh060CardBodyCardTitle" v-if="sh060Init.catalogFlg != 1">{{$t('sh060.messages.orderTdkAddAreaMsg1')}}</h5>
                                                    <p class="settingMainSh060CardBodyCardText">{{sh060Init.kokyakuNm1}}&nbsp;{{sh060Init.kokyakuNm2}}&nbsp;{{sh060Init.kokyakuNm3}}&nbsp;様</p>
                                                    <p class="settingMainSh060CardBodyCardText">〒{{sh060Init.orderInfo['KOKYAKU_ZIP']}}</p>
                                                    <template v-if="sh060Init.kokyakuNo == '999999999'">
                                                        <p class="settingMainSh060CardBodyCardText">
                                                                                {{stringNvl(sh060Init.orderInfo['KOKYAKU_ADDR1'])}}
                                                                                {{stringNvl(sh060Init.orderInfo['KOKYAKU_ADDR2'])}}
                                                                                {{stringNvl(sh060Init.orderInfo['KOKYAKU_ADDR3'])}}
                                                        </p>
                                                    </template>
                                                    <template v-else>
                                                        <p class="settingMainSh060CardBodyCardText">{{stringNvl(sh060Init.orderInfo['KOKYAKU_ADDR1'])}}
                                                                                {{stringNvl(sh060Init.orderInfo['KOKYAKU_ADDR2'])}}
                                                                                {{stringNvl(sh060Init.orderInfo['KOKYAKU_ADDR3'])}}
                                                        </p>
                                                    </template>
                                                </template>
                                                <!-- 別のお届け先に送る -->
                                                <template v-else >
                                                    <h5 class="settingMainSh060CardBodyCardTitle" v-if="sh060Init.catalogFlg != 1">{{$t('sh060.messages.orderTdkAddAreaMsg2')}}</h5>
                                                    <p class="settingMainSh060CardBodyCardText">{{oneTdkInfo['TDK_NM1']}}&nbsp;{{oneTdkInfo['TDK_NM2']}}&nbsp;{{oneTdkInfo['TDK_NM3']}}&nbsp;様</p>
                                                    <p class="settingMainSh060CardBodyCardText">〒{{oneTdkInfo['TDK_ZIP']}}</p>
                                                    <template v-if="sh060Init.kokyakuNo == '999999999'">
                                                        <p class="settingMainSh060CardBodyCardText">
                                                                                {{stringNvl(oneTdkInfo['TDK_ADDR1'])}}
                                                                                {{stringNvl(oneTdkInfo['TDK_ADDR2'])}}
                                                                                {{stringNvl(oneTdkInfo['TDK_ADDR3'])}}
                                                        </p>
                                                    </template>
                                                    <template v-else>
                                                        <p class="settingMainSh060CardBodyCardText">{{stringNvl(oneTdkInfo['TDK_ADDR1'])}}
                                                                                {{stringNvl(oneTdkInfo['TDK_ADDR2'])}}
                                                                                {{stringNvl(oneTdkInfo['TDK_ADDR3'])}}
                                                        </p>
                                                    </template>
                                                </template>
                                            </template>
                                        </div>
                                        <!-- 店頭受取以外の場合 90:店頭受取 -->
                                        <!-- 送主情報設定 -->
                                        <div class="settingMainSh060CardHeader" v-if="sh060Init.csmInfoOption == 1 && sh060Init.kokyakuNo != '999999999' && sh060Init.catalogFlg != 1 && stringNvl(oneTdkInfo['BINSYU_KBN']) != '90'">
                                            <div class="settingMainSh060CardHeaderSub">
                                                <div class="settingMainSh060CardHeaderSub1">{{$t('sh060.labels.orderOkuriAddArea')}}</div>
                                                <div class="settingMainSh060CardHeaderSub2"><a href="javascript:void(0)" @click="gotoSettingPageForTdk(19,oneTdkInfo['TDK_SEQ'],'3');" id="okuriComfirmCopyMsg" class="card-link">{{$t('sh060.buttons.chanegeSettingArea')}}</a></div>
                                            </div>
                                        </div>
                                        <!-- 店頭受取以外の場合 90:店頭受取 -->
                                        <template v-if="sh060Init.csmInfoOption == 1 && sh060Init.kokyakuNo != '999999999' && sh060Init.catalogFlg != 1 && stringNvl(oneTdkInfo['BINSYU_KBN']) != '90'">
                                            <template v-if="oneTdkInfo['CSM_NM1'] != null && oneTdkInfo['CSM_NM1'] != ''">
                                                <div class="settingMainSh060CardBody">
                                                    <p class="settingMainSh060CardBodyCardText">{{oneTdkInfo['CSM_NM1']}} &nbsp;{{oneTdkInfo['CSM_NM2']}}</p>
                                                    <p class="settingMainSh060CardBodyCardText">{{oneTdkInfo['CSM_NM3']}}</p>
                                                    <p class="settingMainSh060CardBodyCardText">〒{{oneTdkInfo['CSM_ZIP']}}</p>
                                                    <p class="settingMainSh060CardBodyCardText">
                                                        {{stringNvl(oneTdkInfo['CSM_ADDR1'])}}
                                                        {{stringNvl(oneTdkInfo['CSM_ADDR2'])}}
                                                        {{stringNvl(oneTdkInfo['CSM_ADDR3'])}}
                                                    </p>
                                                </div>
                                            </template>
                                            <template v-else>
                                                <div class="settingMainSh060CardBody">
                                                    <h5 class="settingMainSh060CardBodyCardTitle">{{$t('sh060.labels.same')}}</h5>
                                                </div>
                                            </template>
                                        </template>
                                        <!-- 請求書同梱設定 
                                        <div class="settingMainSh060CardHeader" v-if="sh060Init.siteSeikyudoukonOption == 1 && sh060Init.kokyakuNo != '999999999'">
                                            <div class="settingMainSh060CardHeaderSub">
                                                <div class="settingMainSh060CardHeaderSub1">{{$t('sh060.labels.orderSeikyuSetArea')}}</div>
                                                <div class="settingMainSh060CardHeaderSub2"><a href="javascript:void(0)" @click="sh060Init.tdkInfo.length > 1 ? gotoSettingPage(20) : gotoSettingPageForTdk(19,oneTdkInfo['TDK_SEQ'],'0');" id="doukonComfirmCopyMsg" class="card-link">{{$t('sh060.buttons.chanegeSettingArea')}}</a></div>
                                            </div>
                                        </div>
                                        <div class="settingMainSh060CardBody" v-if="sh060Init.siteSeikyudoukonOption == 1 && sh060Init.kokyakuNo != '999999999'">
                                            <h5 class="settingMainSh060CardBodyCardTitle">{{$t('sh060.labels.orderSeikyuSetAreaDoukon')}}{{oneTdkInfo['HARAIKOMI_DOUKON_FLG'] == 1 ? 'する':'しない'}}</h5>
                                        -->
                                        <!-- お届け商品 -->
                                        <div class="settingMainSh060CardHeader" v-if="sh060Init.cartSplitUseFlg != 1 && sh060Init.tdkInfo && sh060Init.tdkInfo.length > 1">
                                            <div class="settingMainSh060CardHeaderSub">
                                                <div class="settingMainSh060CardHeaderSub1">{{$t('sh060.labels.orderItemArea')}}</div>
                                            </div>
                                            <div class="settingMainSh060OneColumn" v-for="(oneTdkItemInfo, tdkItemIndex) in oneTdkInfo['TDK_ITEM_LIST'] " v-bind:key="tdkItemIndex">
                                                <div class="settingMainSh060CardHeaderSub">{{oneTdkItemInfo['WEB_ITEM_NM']}}</div>
                                                <div class="settingMainSh060CardHeaderSub0">{{oneTdkItemInfo['NOSHI_INFO']}}</div>
                                                <div class="settingMainSh060CardHeaderSub2">{{oneTdkItemInfo['QTY']}}個</div>
                                            </div>
                                        </div>

                                        <!-- お届け希望日時 -->
                                        <div class="settingMainSh060CardHeader" v-if="sh060Init.cartSplitUseFlg != 1 && (sh060Init.tdkkibouFlg == 1 || sh060Init.tdkTimeFlg == 1)">
                                            <div class="settingMainSh060CardHeaderSub">
                                                <div class="settingMainSh060CardHeaderSub1">{{$t('sh060.labels.orderTdkDateArea')}}</div>
                                                <div class="settingMainSh060CardHeaderSub2"><a href="javascript:void(0)" @click="gotoSettingPageForTdk(19,oneTdkInfo['TDK_SEQ'],'1');" id="timeComfirmCopyMsg" class="card-link">{{$t('sh060.buttons.chanegeSettingArea')}}</a></div>
                                            </div>
                                        </div>
                                        <div class="settingMainSh060CardBody" v-if="sh060Init.cartSplitUseFlg != 1 && (sh060Init.tdkkibouFlg == 1 || sh060Init.tdkTimeFlg == 1)">
                                            <!-- 通常時 -->
                                            <h5 class="settingMainSh060CardBodyCardTitle" v-if="sh060Init.tdkkibouFlg == 1 && sh060Init.teikiKbn != '2' && hatchuCnt == 0">
                                                {{$t('sh060.labels.orderTdkDateAreaDeliveryDates')}}{{hatchuCnt > 0 ? hopeDayStr : stringNvl(oneTdkInfo['TDK_YMD'], "指定なし")}}
                                            </h5>
                                            <!-- 自動発注時 -->
                                            <h5 class="settingMainSh060CardBodyCardTitle" v-if="sh060Init.tdkkibouFlg == 1 && sh060Init.teikiKbn != '2' && hatchuCnt > 0">
                                                {{$t('sh060.labels.orderTdkDateAreaDeliveryDates')}}
                                                <span v-for="(hopeDay,index) in sh060Request.hopeDayList" :key="index">
                                                    <template v-if="index > 0">
                                                        <span v-for="i in $t('sh060.labels.orderTdkDateAreaDeliveryDates').length" :key="i">&emsp;</span>
                                                    </template>
                                                    {{hopeDay}}
                                                    <br v-if="index < sh060Request.hopeDayList.length">
                                                </span>
                                            </h5>

                                            <h5 class="settingMainSh060CardBodyCardTitle" v-if="sh060Init.tdkTimeFlg == 1">{{$t('sh060.labels.orderTdkDateAreaDesiredDeliveryTime')}}{{stringNvl(oneTdkInfo['TDK_HMS_KBN_NM'],"指定なし")}}</h5>
                                        </div>
                                        <!-- カート分割対応 配送単位表示 -->
                                        <div class="settingMainSh060CardHeaderSub1" v-for="(oneHaisouInfo, haisouInfoIndex) in oneTdkInfo['TDK_HAISOU_LIST'] " v-bind:key="haisouInfoIndex" 
                                                    style="margin-top:0px!important;margin-bottom:0px!important;flex-basis:0px!important;">
                                            <!-- 購入する商品のみ表示対応 -->
                                            <div class="settingMainSh060CardHeader" v-if="sh060Init.cartSplitUseFlg == 1 && stringNvl(oneHaisouInfo['QTY_NOTZERO_COUNT_FLG']) == '1'">
                                                <!-- 店頭受取以外の場合 90:店頭受取 -->
                                                <div class="settingMainSh060CardHeaderSub" v-if="stringNvl(oneTdkInfo['BINSYU_KBN']) != '90'">
                                                    <div class="settingMainSh060CardHeaderSub1">
                                                        {{$t('sh060.labels.shippingNo')}}{{haisouInfoIndex+1}}
                                                        {{$t('sh060.labels.leftKakko')}}
                                                        {{oneHaisouInfo['TDK_ITEM_LIST'][0]['ONDO_NM']}}
                                                        {{$t('sh060.labels.rightKakko')}}
                                                    </div>
                                                </div>
                                                <!-- 店頭受取の場合 90:店頭受取 -->
                                                <div class="settingMainSh060CardHeaderSub" v-if="stringNvl(oneTdkInfo['BINSYU_KBN']) == '90'">
                                                    <div class="settingMainSh060CardHeaderSub1" v-if="sh060Init.tdkInfo && sh060Init.tdkInfo.length>1">
                                                        {{$t('sh060.labels.pickup')}}{{haisouInfoIndex+1}}
                                                    </div>
                                                    <div class="settingMainSh060CardHeaderSub1" v-else>
                                                        {{$t('sh060.labels.pickupInStore')}}{{haisouInfoIndex+1}}
                                                    </div>
                                                </div>
                                               <div class="settingMainSh060CardBody">
                                                    <table class="mb32">
                                                        <thead>
                                                            <tr>
                                                                <!--商品CD-->
                                                                <th class="w200">{{$t('common.labels.productCode')}}</th>
                                                                <!--商品名-->
                                                                <th>{{$t('common.labels.productName')}}</th>
                                                                <!--単価-->
                                                                <th class="w160" v-if="sh060Init.priceShow != 1">{{$t('common.labels.unitPrice')}}</th>
                                                                <!--数量-->
                                                                <th class="w80">{{$t('common.labels.quantity')}}</th>
                                                                <!--金額-->
                                                                <th class="w160" v-if="sh060Init.priceShow != 1">{{$t('common.labels.kingakuStr')}}
                                                                    <!--税込-->
                                                                    <span class="price-tax" v-if="sh060Init.orderInfo['TNK_DSP_KBN'] == '1'">{{$t('common.labels.taxincluded')}}</span>
                                                                    <!--税抜-->
                                                                    <span class="price-tax" v-else>{{$t('common.labels.excludingtax')}}</span>
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <!--通常商品情報-->
                                                            <tr v-for="(item, idx) in oneHaisouInfo['TDK_ITEM_LIST']" :key="idx" style="font-weight:normal;">
                                                                <!-- 購入する商品のみ表示対応 -->
                                                                <template v-if="item.DISP_QTY > 0">
                                                                    <!--商品CD-->
                                                                    <td scope="row" :aria-label="$t('common.labels.productCode')">
                                                                        {{item.ITEM_NO}}
                                                                    </td>
                                                                    <!--商品名-->
                                                                    <td :aria-label="$t('common.labels.productName')">
                                                                        <span class="cartOndo" v-if="stringNvl(item.ONDO_NM,'') != ''">【{{stringNvl(item.ONDO_NM,'')}}】</span>
                                                                        {{stringNvl(item.WEB_ITEM_NM,'')}}
                                                                    </td>
                                                                    <!--単価-->
                                                                    <td class="cart-price" :aria-label="$t('common.labels.unitPrice')" v-if="sh060Init.priceShow != 1">
                                                                        <!--税込-->
                                                                        <span v-if="sh060Init.orderInfo['TNK_DSP_KBN'] == '1'"> {{formatPrice(item.DISP_TNK_IN_ZEI)}}円 </span>
                                                                        <!--税抜-->
                                                                        <span v-else> {{formatPrice(item.DISP_TNK)}}円 </span>
                                                                    </td>
                                                                    <!--数量-->
                                                                    <td style="text-align: right;" :aria-label="$t('common.labels.quantity')">
                                                                        {{formatPrice(item.DISP_QTY)}}
                                                                    </td>
                                                                    <!--金額-->
                                                                    <!--税込-->
                                                                    <template v-if="sh060Init.orderInfo['TNK_DSP_KBN'] == '1' && sh060Init.priceShow != 1">
                                                                        <td class="cart-price" :aria-label="$t('common.labels.kingakuStr') + $t('common.labels.taxincluded')">
                                                                            <span class="price"> {{formatPrice(item.SHOUKEI_IN_ZEI)}}円 </span>
                                                                        </td>
                                                                    </template>
                                                                    <!--税抜-->
                                                                    <template v-else-if="sh060Init.priceShow != 1">
                                                                        <td class="cart-price" :aria-label="$t('common.labels.kingakuStr') + $t('common.labels.excludingtax')">
                                                                            <span class="price"> {{formatPrice(item.SHOUKEI)}}円 </span>
                                                                        </td>
                                                                    </template>
                                                                </template>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <!-- お届け希望日時 -->
                                                <!-- ECサイトオプション50504（非表示）かつ、ECサイトオプション50505（非表示）の場合は、お届け希望日時の枠自体を非表示にする -->
                                                <div class="settingMainSh060CardHeader" v-if="(sh060Init.tdkkibouFlg == 1 || sh060Init.tdkTimeFlg == 1)">
                                                    <div class="settingMainSh060CardHeaderSub">
                                                        <!-- 店頭受取以外の場合 90:店頭受取 -->
                                                        <div v-if="stringNvl(oneTdkInfo['BINSYU_KBN']) != '90'" class="settingMainSh060CardHeaderSub1">{{$t('sh060.labels.orderTdkDateArea')}}</div>
                                                        <!-- 店頭受取の場合 90:店頭受取 -->
                                                        <div v-if="stringNvl(oneTdkInfo['BINSYU_KBN']) == '90'" class="settingMainSh060CardHeaderSub1">{{$t('sh060.labels.pickupYmd')}}</div>
                                                        <div class="settingMainSh060CardHeaderSub2" 
                                                            v-if="(stringNvl(oneTdkInfo['BINSYU_KBN']) != '90' && stringNvl(oneHaisouInfo['TDK_YMD_CHG_BTN_DISP_FLG'])=='1') 
                                                                    || (stringNvl(oneTdkInfo['BINSYU_KBN']) == '90' && stringNvl(oneHaisouInfo['TDK_YMD_SET_NG_FLG'])!='1') ">
                                                            <a href="javascript:void(0)" 
                                                                @click="changeTdkDay(oneHaisouInfo['TDK_SEQ'],oneHaisouInfo['TDK_NO'],
                                                                oneHaisouInfo['TDK_M_SEQ'],oneHaisouInfo['TDK_FLG'],oneHaisouInfo['SAGYO_CD1'],
                                                                oneHaisouInfo['TDK_YMD'],oneHaisouInfo['TDK_HMS_KBN'],
                                                                oneHaisouInfo['TDK_ITEM_LIST'][0]['TDK_YMD_HISSU_FLG'],
                                                                oneHaisouInfo['TDK_ITEM_LIST'][0]['TDK_HSTM_HISSU_FLG'],
                                                                oneHaisouInfo['TDK_ITEM_LIST'][0]['CHAKUBI_KBN'],
                                                                oneHaisouInfo['CHAKUBI_KBN'],
                                                                oneHaisouInfo['TDK_ITEM_LIST'][0]['TDK_YMD_ERR_FLG'],
                                                                oneHaisouInfo['TDK_ITEM_LIST'][0]['TDK_HSTM_ERR_FLG'],
                                                            oneTdkInfo['BINSYU_KBN'],oneHaisouInfo['WAPPING_OK_FLG'],oneHaisouInfo['NOSHI_OK_FLG']);" 
                                                                id="changeTdkDay" class="card-link">
                                                                {{$t('sh060.buttons.chanegeSettingArea')}}
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                                <!-- ECサイトオプション50504（非表示）の場合は、お届け希望日時の枠自体を非表示にする -->
                                                <!-- 店頭受取以外の場合 90:店頭受取 -->
                                                <div class="settingMainSh060CardBody" v-if="(sh060Init.tdkkibouFlg == 1 || sh060Init.tdkTimeFlg == 1) && stringNvl(oneTdkInfo['BINSYU_KBN']) != '90' && stringNvl(oneHaisouInfo['TDK_YMD_WAKU_DISP_FLG']) == '1'">
                                                    <!-- 通常時 -->
                                                    <h5 class="settingMainSh060CardBodyCardTitle" v-if="sh060Init.tdkkibouFlg == 1 && sh060Init.teikiKbn != '2' && hatchuCnt == 0 && stringNvl(oneHaisouInfo['TDK_YMD_DISP_FLG']) == '1'">
                                                        {{$t('sh060.labels.orderTdkDateAreaDeliveryDates')}}
                                                        <span v-if="stringNvl(oneHaisouInfo['TDK_YMD'], '指定なし') != '指定なし'" 
                                                            :class="stringNvl(oneHaisouInfo['TDK_ITEM_LIST'][0]['TDK_YMD_HISSU_FLG']) == '1'?'text-danger':''">
                                                            <!-- 着日指定区分＝1 お届け日指定 日付 -->
                                                            {{sh060Init.chakubiOption == 1 && stringNvl(oneHaisouInfo['CHAKUBI_KBN']) == '1'?$t('sh060.labels.nomi'):''}}
                                                            {{oneHaisouInfo['TDK_YMD']}}
                                                            <!-- 着日指定区分＝2 日付 以降に届け -->
                                                            {{sh060Init.chakubiOption == 1 && stringNvl(oneHaisouInfo['CHAKUBI_KBN']) == '2'?$t('sh060.labels.ikou'):''}}
                                                        </span>
                                                        <!-- 希望日指定不可 -->
                                                        <span v-else-if="stringNvl(oneHaisouInfo['TDK_YMD_SET_NG_FLG']) == '1'">
                                                            {{stringNvl(oneHaisouInfo['TDK_YMD'], $t('sh060.labels.setNg1'))}}
                                                        </span>
                                                        <!-- 希望日指定必須 -->
                                                        <span v-else
                                                            :class="stringNvl(oneHaisouInfo['TDK_ITEM_LIST'][0]['TDK_YMD_HISSU_FLG']) == '1'?'text-danger':''">
                                                            {{stringNvl(oneHaisouInfo['TDK_YMD'], '指定なし')}}
                                                        </span>
                                                        <span v-if="sh060Init.chakubiOption == 1" class="text-danger">
                                                            {{stringNvl(oneHaisouInfo['TDK_YMD'], '指定なし') == '指定なし' 
                                                           && stringNvl(oneHaisouInfo['TDK_ITEM_LIST'][0]['TDK_YMD_HISSU_FLG']) == '1'?$t('sh060.labels.must'):''}}
                                                            {{stringNvl(oneHaisouInfo['TDK_YMD'], '指定なし') != '指定なし' 
                                                           && stringNvl(oneHaisouInfo['TDK_ITEM_LIST'][0]['TDK_YMD_ERR_FLG']) == '1'?$t('sh060.labels.setNg'):''}}
                                                        </span>
                                                    </h5>
                                                    <!-- 自動発注時 -->
                                                    <h5 class="settingMainSh060CardBodyCardTitle" v-if="sh060Init.tdkkibouFlg == 1 && sh060Init.teikiKbn != '2' && hatchuCnt > 0 && stringNvl(oneHaisouInfo['TDK_YMD_DISP_FLG']) == '1'">
                                                        {{$t('sh060.labels.orderTdkDateAreaDeliveryDates')}}
                                                        <span v-for="(hopeDay,index) in sh060Request.hopeDayList" :key="index">
                                                            <template v-if="index > 0">
                                                                <span v-for="i in $t('sh060.labels.orderTdkDateAreaDeliveryDates').length" :key="i">&emsp;</span>
                                                            </template>
                                                            {{hopeDay}}
                                                            <br v-if="index < sh060Request.hopeDayList.length">
                                                        </span>
                                                    </h5>
                                                    <!-- ECサイトオプション50505（非表示）の場合は、お届け希望日時の枠自体を非表示にする -->
                                                    <h5 class="settingMainSh060CardBodyCardTitle" v-if="sh060Init.tdkTimeFlg == 1 && stringNvl(oneHaisouInfo['TDK_HMS_DISP_FLG']) == '1'">
                                                        <!-- 希望時間： -->
                                                        {{$t('sh060.labels.orderTdkDateAreaDesiredDeliveryTime')}}
                                                        <!-- 希望時間 1:指定不可 -->
                                                        <span v-if="stringNvl(oneHaisouInfo['TDK_HMS_SET_NG_FLG']) == '1'">{{$t('sh060.labels.setNg1')}}</span>
                                                        <span v-else :class="stringNvl(oneHaisouInfo['TDK_ITEM_LIST'][0]['TDK_HSTM_HISSU_FLG']) == '1'?'text-danger':''">
                                                            {{stringNvl(oneHaisouInfo['TDK_HMS_KBN_NM'],"指定なし")}}
                                                        </span>
                                                        <span v-if="sh060Init.chakubiOption == 1" class="text-danger">
                                                            {{stringNvl(oneHaisouInfo['TDK_HMS_KBN_NM'], '指定なし') == '指定なし' 
                                                           && stringNvl(oneHaisouInfo['TDK_ITEM_LIST'][0]['TDK_HSTM_HISSU_FLG']) == '1'?$t('sh060.labels.must'):''}}
                                                            {{stringNvl(oneHaisouInfo['TDK_HMS_KBN_NM'], '指定なし') != '指定なし' 
                                                           && stringNvl(oneHaisouInfo['TDK_ITEM_LIST'][0]['TDK_HSTM_ERR_FLG']) == '1'?$t('sh060.labels.setNg'):''}}
                                                        </span>
                                                    </h5>
                                                </div>
                                                <!-- 店頭受取の場合 90:店頭受取 -->
                                                <div class="settingMainSh060CardBody" v-if="stringNvl(oneTdkInfo['BINSYU_KBN']) == '90'">
                                                    <!-- 通常時 -->
                                                    <h5 class="settingMainSh060CardBodyCardTitle" v-if="sh060Init.teikiKbn != '2'">
                                                        <!-- 受取日指定必須の場合、赤文字表示 -->
                                                        <span v-if="stringNvl(oneHaisouInfo['TDK_YMD'], '指定なし') != '指定なし'" 
                                                            :class="stringNvl(oneHaisouInfo['TDK_ITEM_LIST'][0]['TDK_YMD_HISSU_FLG']) == '1'?'text-danger':''">
                                                            <!-- 受取日指定 日付 -->
                                                            {{$t('sh060.labels.pickupYmd')}}{{oneHaisouInfo['TDK_YMD']}}
                                                        </span>
                                                        <!-- 受取日指定不可 -->
                                                        <span v-else-if="stringNvl(oneHaisouInfo['TDK_ITEM_LIST'][0]['TDK_YMD_ERR_FLG']) == '1'">
                                                            {{$t('sh060.labels.pickupYmd')}}{{stringNvl(oneHaisouInfo['TDK_YMD'], $t('sh060.labels.setNg1'))}}
                                                        </span>
                                                        <!-- 受取日指定必須 -->
                                                        <span v-else-if="stringNvl(oneHaisouInfo['TDK_ITEM_LIST'][0]['TDK_YMD_HISSU_FLG']) == '1'"
                                                            :class="stringNvl(oneHaisouInfo['TDK_ITEM_LIST'][0]['TDK_YMD_HISSU_FLG']) == '1'?'text-danger':''">
                                                            {{$t('sh060.labels.pickupYmd')}}{{stringNvl(oneHaisouInfo['TDK_YMD'], '指定なし')}}{{$t('sh060.labels.must')}}
                                                        </span>
                                                        <!-- 受取日指定なし -->
                                                        <span v-else>
                                                            {{$t('sh060.labels.pickupYmd')}}{{stringNvl(oneHaisouInfo['TDK_YMD'], '指定なし')}}
                                                        </span>
                                                    </h5>
                                                </div>
                                                <!-- ギフト設定 -->
                                                <!-- ECサイトオプション50512（ギフト利用、しない）かつ、オプション50506(のし利用しない)の場合は、ギフト設定の枠自体を非表示にする -->
                                                <!-- 配送ごとの商品に、包装可の商品が1件もない場合、非表示にする -->
                                                <!-- 配送ごとの商品に、包装可且つのし可の商品が1件もない場合、非表示にする -->
                                                <div class="settingMainSh060CardHeader" v-if="(sh060Init.giftFlg == 1 || sh060Init.nosiFlg == 1) 
                                                    && (stringNvl(oneHaisouInfo['WAPPING_OK_FLG']) == '1' && stringNvl(oneHaisouInfo['NOSHI_OK_FLG']) == '1')">
                                                    <div class="settingMainSh060CardHeaderSub">
                                                        <div class="settingMainSh060CardHeaderSub1">{{$t('sh060.labels.orderGistSetArea')}}</div>
                                                        <div class="settingMainSh060CardHeaderSub2"><a href="javascript:void(0)" 
                                                            @click="changeTdkDay(oneHaisouInfo['TDK_SEQ'],oneHaisouInfo['TDK_NO'],
                                                            oneHaisouInfo['TDK_M_SEQ'],oneHaisouInfo['TDK_FLG'],oneHaisouInfo['SAGYO_NM1'],
                                                            oneHaisouInfo['TDK_YMD'],oneHaisouInfo['TDK_HMS_KBN'],
                                                            oneHaisouInfo['TDK_ITEM_LIST'][0]['TDK_YMD_HISSU_FLG'],
                                                            oneHaisouInfo['TDK_ITEM_LIST'][0]['TDK_HSTM_HISSU_FLG'],
                                                            oneHaisouInfo['TDK_ITEM_LIST'][0]['CHAKUBI_KBN'],
                                                            oneHaisouInfo['CHAKUBI_KBN'],
                                                            oneHaisouInfo['TDK_ITEM_LIST'][0]['TDK_YMD_ERR_FLG'],
                                                            oneHaisouInfo['TDK_ITEM_LIST'][0]['TDK_HSTM_ERR_FLG'],
                                                            oneTdkInfo['BINSYU_KBN'],oneHaisouInfo['WAPPING_OK_FLG'],oneHaisouInfo['NOSHI_OK_FLG']);" 
                                                            id="changeTdkGift" class="card-link">{{$t('sh060.buttons.chanegeSettingArea')}}</a></div>
                                                    </div>
                                                </div>
                                                <!-- ECサイトオプション50512（非表示）の場合は、ギフト設定の枠自体を非表示にする -->
                                                <div class="settingMainSh060CardBody" v-if="(sh060Init.giftFlg == 1 || sh060Init.nosiFlg == 1) 
                                                    && (stringNvl(oneHaisouInfo['WAPPING_OK_FLG']) == '1' && stringNvl(oneHaisouInfo['NOSHI_OK_FLG']) == '1')">
                                                    <table class="sh060-table-giftSetting" id="sh060_table_giftSetting" style="border:0px;font-weight:normal">
                                                        <tr v-if="sh060Init.giftFlg == 1 
                                                            && (stringNvl(oneHaisouInfo['WAPPING_OK_FLG']) != '0' 
                                                                    || (stringNvl(oneHaisouInfo['WAPPING_OK_FLG']) == '1' && stringNvl(oneHaisouInfo['NOSHI_OK_FLG']) == '1')
                                                                )">
                                                            <!-- ギフト設定 -->
                                                            <th style="width:10%;margin:0;padding:7px 0 8px 0;vertical-align:middle;border:0px;">
                                                                {{$t("sh060.labels.giftSetArea")}}
                                                            </th>
                                                            <td colspan="3" style="width:90%;vertical-align:middle;border:0px;margin:0;padding:7px 0 8px 0;">
                                                                <span>{{stringNvl(oneHaisouInfo['GIFT_KBN_NM'], '設定なし')}}</span>
                                                            </td>
                                                        </tr>
                                                        <tr v-if="sh060Init.nosiFlg == 1 
                                                            && (stringNvl(oneHaisouInfo['WAPPING_OK_FLG']) == '1' && stringNvl(oneHaisouInfo['NOSHI_OK_FLG']) == '1')">
                                                            <!-- のし・包装 -->
                                                            <th style="width:10%;margin:0;padding:7px 0 8px 0;vertical-align:middle;border:0px;">
                                                                {{$t("sh060.labels.noshiHousou")}}
                                                            </th>
                                                            <!-- 包装 -->
                                                            <td style="width:30%;vertical-align:middle;border:0px;margin:0;padding:7px 0 8px 0;">
                                                                <span>{{$t('sh060.labels.housou')}}{{stringNvl(oneHaisouInfo['SAGYO_NM2'], '設定なし')}}</span>
                                                            </td>
                                                            <!-- のし(エコ包装) -->
                                                            <td colspan="2" v-if="sh060Init.nosiFlg == 1 && (
                                                                    (stringNvl(oneHaisouInfo['SAGYO_CD1'],'') == '' && stringNvl(oneHaisouInfo['SAGYO_CD2'],'') == '' && getItemNoshiCd(oneHaisouInfo['TDK_ITEM_LIST'])=='')
                                                                    || (stringNvl(oneHaisouInfo['SAGYO_CD2'],'') != '' && sh060Init.ecoHousouLst != null && sh060Init.ecoHousouLst.includes(stringNvl(oneHaisouInfo['SAGYO_CD2'])))
                                                                    )"
                                                                style="width:60%;vertical-align:middle;border:0px;margin:0;padding:7px 0 8px 0;">
                                                                <span>{{$t('sh060.labels.noshi')}}{{stringNvl(oneHaisouInfo['SAGYO_NM1'], '設定なし')}}</span>
                                                            </td>
                                                            <!-- のし(エコ包装以外) -->
                                                            <td colspan="2" v-if="sh060Init.nosiFlg == 1 
                                                                && (stringNvl(oneHaisouInfo['SAGYO_CD1'],'') == '' && stringNvl(oneHaisouInfo['SAGYO_CD2'],'') != ''
                                                                        && getItemNoshiCd(oneHaisouInfo['TDK_ITEM_LIST']) != ''
                                                                    )"
                                                                style="width:60%;vertical-align:middle;border:0px;margin:0;padding:7px 0 8px 0;">
                                                                <span>{{$t('sh060.labels.noshi')}}{{stringNvl(getItemNoshiNm(oneHaisouInfo['TDK_ITEM_LIST']), '設定なし')}}</span>
                                                            </td>
                                                        </tr>
                                                        <!-- エコ包装 -->
                                                        <tr v-if="sh060Init.nosiFlg == 1 && (stringNvl(oneHaisouInfo['WAPPING_OK_FLG']) == '1' && stringNvl(oneHaisouInfo['NOSHI_OK_FLG']) == '1') && (
                                                                (stringNvl(oneHaisouInfo['SAGYO_CD1'],'') == '' && stringNvl(oneHaisouInfo['SAGYO_CD2'],'') == '' && getItemNoshiCd(oneHaisouInfo['TDK_ITEM_LIST'])=='')
                                                                || (stringNvl(oneHaisouInfo['SAGYO_CD2'],'') != '' && sh060Init.ecoHousouLst != null && sh060Init.ecoHousouLst.includes(stringNvl(oneHaisouInfo['SAGYO_CD2'])))
                                                                )">
                                                            <th style="width:10%;margin:0;padding:7px 0 8px 0px;vertical-align:middle;border:0;">
                                                                <span>&emsp;</span>
                                                            </th>
                                                            <!-- 名前 -->
                                                            <td style="width:30%;vertical-align:middle;border:0px;margin:0;padding:7px 0 8px 0;">
                                                                <span>{{$t('sh060.labels.noshiHousouName')}}{{stringNvl(oneHaisouInfo['NOSHI_NAIRE1'], '設定なし')}}</span>
                                                            </td>
                                                            <!-- 会社 -->
                                                            <td style="width:30%;vertical-align:middle;border:0px;margin:0;padding:7px 0 8px 0;">
                                                                <span>{{$t('sh060.labels.noshiHousouCompany')}}{{stringNvl(oneHaisouInfo['NOSHI_NAIRE2'], '設定なし')}}</span>
                                                            </td>
                                                            <!-- 肩書 -->
                                                            <td style="width:30%;vertical-align:middle;border:0px;margin:0;padding:7px 0 8px 0;">
                                                                <span>{{$t('sh060.labels.noshiHousouKatagaki')}}{{stringNvl(oneHaisouInfo['NOSHI_NAIRE3'], '設定なし')}}</span>
                                                            </td>
                                                        </tr>
                                                        <!-- エコ包装以外 -->
                                                        <tr v-if="sh060Init.nosiFlg == 1 && (stringNvl(oneHaisouInfo['WAPPING_OK_FLG']) == '1' && stringNvl(oneHaisouInfo['NOSHI_OK_FLG']) == '1') && (
                                                                stringNvl(oneHaisouInfo['SAGYO_CD1'],'') == '' && stringNvl(oneHaisouInfo['SAGYO_CD2'],'') != ''
                                                                    && getItemNoshiCd(oneHaisouInfo['TDK_ITEM_LIST']) != ''
                                                                )"
                                                                >
                                                            <th style="width:120px;margin:0;padding:7px 0 8px 0px;vertical-align:middle;border:0;">
                                                                <span>&emsp;</span>
                                                            </th>
                                                            <td colspan="3" style="vertical-align:middle;border:0px;margin:0;padding:7px 0 8px 0;">
                                                                <!-- 名入れ -->
                                                                <span>{{$t('sh060.labels.naire')}}{{stringNvl(getItemNaire(oneHaisouInfo['TDK_ITEM_LIST']),'設定なし')}}</span>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </div>
                                                <!-- この配送ギフト設定をすべてに反映する -->
                                                <div class="settingMainSh060CardHeader" v-if="(sh060Init.giftFlg == 1 || sh060Init.nosiFlg == 1)
                                                        && (stringNvl(oneHaisouInfo['WAPPING_OK_FLG']) == '1' && stringNvl(oneHaisouInfo['NOSHI_OK_FLG']) == '1')
                                                        && ((sh060Init.tdkNoCount && sh060Init.tdkNoCount >1) || ((sh060Init.tdkNoCount && sh060Init.tdkNoCount == 1) && oneTdkInfo.TDK_HAISOU_LIST.length>1))">
                                                    <div class="settingMainSh060CardHeaderSub" style="border-bottom:none;margin-bottom:0;">
                                                        <div class="settingMainSh060CardHeaderSub1"></div>
                                                        <div class="settingMainSh060CardHeaderSub2"><a href="javascript:void(0)" 
                                                            @click="copyTdkGiftSettingConfirm(oneHaisouInfo['TDK_SEQ'],oneHaisouInfo['TDK_NO']);" 
                                                            id="copyTdkGiftSetting" class="card-link">{{$t('sh060.buttons.copyTdkGiftSetting')}}</a></div>
                                                    </div>
                                                </div>
                                            </div>
                                            <br>
                                        </div>
                                        <!-- 届先単位の合計金額 -->
                                        <div v-if="sh060Init.cartSplitUseFlg == 1" class="ml-auto mr-0" style="margin-bottom:13px!important;margin-right:4px!important;margin-top:9px!important;">
                                            <div style="border-bottom: 1px solid #000;width: 100%;margin: 10px 0;"></div>
                                            <table class="personal shopping-total" summary="届先単位合計金額">
                                                <tr>
                                                    <th class="w200">
                                                        {{$t('sh060.labels.itemTdkTotalValue')}}
                                                    </th>
                                                    <!--税抜-->
                                                    <template v-if="oneTdkInfo['TNK_DSP_KBN'] != '1'">
                                                        <td class="cart-price" :aria-label="$t('sh060.labels.itemTdkTotalValue')">
                                                            <span class="price"> {{formatPrice(oneTdkInfo['ITEMSUM_TAX_EX_TDK'])}}円 </span>
                                                        </td>
                                                    </template>
                                                    <!--税込-->
                                                    <template v-else>
                                                        <td class="cart-price" :aria-label="$t('sh060.labels.itemTdkTotalValue')">
                                                            <span class="price"> {{formatPrice(oneTdkInfo['ITEMSUM_TAX_IN_TDK'])}}円 </span>
                                                        </td>
                                                    </template>
                                                </tr>
                                                <tr v-if="(oneTdkInfo['TNK_DSP_KBN'] != '1' && formatPrice(oneTdkInfo['SORYO_TAX_EX_TDK']) != 0) || (oneTdkInfo['TNK_DSP_KBN'] == '1' && formatPrice(oneTdkInfo['SORYO_TAX_IN_TDK']) != 0)">
                                                    <th class="w200">
                                                        {{$t('sh060.labels.shippingcost')}}
                                                    </th>
                                                    <!--税抜-->
                                                    <template v-if="oneTdkInfo['TNK_DSP_KBN'] != '1'">
                                                        <td class="cart-price" :aria-label="$t('sh060.labels.shippingcost')">
                                                            <span class="price"> {{formatPrice(oneTdkInfo['SORYO_TAX_EX_TDK'])}}円 </span>
                                                        </td>
                                                    </template>
                                                    <!--税込-->
                                                    <template v-else>
                                                        <td class="cart-price" :aria-label="$t('sh060.labels.shippingcost')">
                                                            <span class="price"> {{formatPrice(oneTdkInfo['SORYO_TAX_IN_TDK'])}}円 </span>
                                                        </td>
                                                    </template>
                                                </tr>
                                                <tr>
                                                    <th class="w200">
                                                        {{$t('sh060.labels.subtotal')}}
                                                    </th>
                                                    <!--税抜-->
                                                    <template v-if="oneTdkInfo['TNK_DSP_KBN'] != '1'">
                                                        <td class="cart-price" :aria-label="$t('sh060.labels.shippingcost')">
                                                            <span class="price"> {{formatPrice(oneTdkInfo['TOTAL_EX_TDK'])}}円 </span>
                                                        </td>
                                                    </template>
                                                    <!--税込-->
                                                    <template v-else>
                                                        <td class="cart-price" :aria-label="$t('sh060.labels.shippingcost')">
                                                            <span class="price"> {{formatPrice(oneTdkInfo['TOTAL_IN_TDK'])}}円 </span>
                                                        </td>
                                                    </template>
                                                </tr>
                                            </table>
                                        </div>
                                        <!-- ギフト設定 
                                        <div class="settingMainSh060CardHeader" v-if="sh060Init.giftFlg == 1 || sh060Init.nosiFlg == 1">
                                            <div class="settingMainSh060CardHeaderSub">
                                                <div class="settingMainSh060CardHeaderSub1">{{$t('sh060.labels.orderGistSetArea')}}</div>
                                                <div class="settingMainSh060CardHeaderSub2"><a href="javascript:void(0)" @click="gotoSettingPageForTdk(19,oneTdkInfo['TDK_SEQ'],'2');" id="giftComfirmCopyMsg" class="card-link">{{$t('sh060.buttons.chanegeSettingArea')}}</a></div>
                                            </div>
                                        </div>
                                        <div class="settingMainSh060CardBody" v-if="sh060Init.giftFlg == 1 || sh060Init.nosiFlg == 1">
                                            -- ギフト設定 --
                                            <h5 class="settingMainSh060CardBodyCardTitle" v-if="sh060Init.giftFlg == 1">{{$t('sh060.labels.orderGistSetAreaSetting')}}{{stringNvl(oneTdkInfo['GIFT_KBN_NM'],"指定なし")}}</h5>
                                            -- のし --
                                            <h5 class="settingMainSh060CardBodyCardTitle" v-if="sh060Init.nosiFlg == 1">{{$t('sh060.labels.orderGistSetAreaNoshi')}}{{stringNvl(oneTdkInfo['EC_SAGYO_NM1'],"指定なし")}}</h5>
                                            -- 包装紙 --
                                            <h5 class="settingMainSh060CardBodyCardTitle" v-if="sh060Init.nosiFlg == 1">{{$t('sh060.labels.orderGistSetAreaHousoushi')}}{{stringNvl(oneTdkInfo['EC_SAGYO_NM2'],"指定なし")}}</h5>
                                            -- 送り主名1 --
                                            <h5 class="settingMainSh060CardBodyCardTitle" v-if="sh060Init.nosiFlg == 1">{{$t('sh060.labels.orderGistSetAreaOkuriNushi1')}}{{stringNvl(oneTdkInfo['NOSHI_NAIRE1'],"指定なし")}}</h5>
                                            -- 送り主名2 --
                                            <h5 class="settingMainSh060CardBodyCardTitle" v-if="sh060Init.nosiFlg == 1">{{$t('sh060.labels.orderGistSetAreaOkuriNushi2')}}{{stringNvl(oneTdkInfo['NOSHI_NAIRE2'],"指定なし")}}</h5>
                                        </div>-->
                                    </div>
                                </div>
                                
                                <!-- ギフト設定 -->
                                <div class="settingMainSh060OneColumn giftInfoCol" v-if="sh060Init.cartSplitUseFlg != 1 && (sh060Init.giftFlg == 1 || sh060Init.nosiFlg == 1 || sh060Init.housoushiFlg == 1 || sh060Init.noshiNaireFlg == 1)">
                                    <div class="settingMainSh060Card">
                                        <div class="settingMainSh060CardHeader">
                                            <div class="settingMainSh060CardHeaderSub">
                                                <div class="settingMainSh060CardHeaderSub1">{{$t('sh060.labels.giftSetArea')}}</div>
                                            </div>
                                        </div>
                                        <div class="settingMainSh060CardBody">
                                            <table class="sh060-body-order-tbl-person sh060-body-order-tbl-mb32" id="sh060_table_haiso" >
                                                <tr id="tdkGiftScroll" v-if="sh060Init.giftFlg == 1">
                                                    <th>
                                                        <!-- ギフト設定 -->
                                                        {{$t("sh030.labels.giftSetting")}}
                                                    </th>
                                                    <td>
                                                        <template v-if="sh060Init.siteFlg != 1">
                                                            <select class="sh060-sel-giftCd" name="giftCd" id="giftCd" v-model="sh060Request.giftCd">
                                                                <option v-for="gift in sh060Init.giftList" :key="gift.KEY" :value="gift.KEY">{{gift.VALUE}}</option>
                                                            </select>
                                                        </template>
                                                        <template v-else>
                                                            <!-- BtoBの場合 -->
                                                            <div class="giftKbn" v-for="gift in sh060Init.giftList" :key="gift.KEY">
                                                                <input class="sh060-inp-giftKbnInput" type="radio" name="giftCd" :value="gift.KEY" v-model="sh060Request.giftCd" :id="'giftKbn_'+gift.KEY">
                                                                <label class="sh060-lbl-giftKbnInput" :for="'giftKbn_'+gift.KEY">{{gift.VALUE}}</label>
                                                            </div>
                                                        </template>
                                                        
                                                    </td>
                                                </tr>
                                                <tr v-bind:id="sh060Init.giftFlg == 1 ? '':'tdkGiftScroll'" v-if="sh060Init.nosiFlg == 1 || sh060Init.housoushiFlg == 1 || sh060Init.noshiNaireFlg == 1 ">
                                                    <th>
                                                        <!-- のし・包装紙 -->
                                                        {{$t("sh060.labels.wrappingPaper")}}
                                                    </th>
                                                    <td>
                                                        <!-- のし -->
                                                        <div v-if="sh060Init.nosiFlg == 1 ">
                                                            {{$t("sh030.labels.works")}}&nbsp;
                                                            <select class="sh060-sel-sagyoKanriKomokuCd" :id="'sagyoKanriKomokuCd'" v-model="sh060Request.sagyoKanriKomokuCd">
                                                                <option value=""></option>
                                                                <option v-for="noshi in sh060Init.noshiList" :key="noshi.KEY" :value="noshi.KEY">{{noshi.VALUE}}</option>
                                                            </select>
                                                            <div v-html="descriptionInfo[28]"></div>
                                                        </div>
                                                        <!-- 包装紙 -->
                                                        <div v-if="sh060Init.housoushiFlg == 1 ">
                                                            {{$t("sh030.labels.wrappingPaper")}}&nbsp;
                                                            <select class="sh060-sel-sagyoKanriKomokuCd2" :id="'sagyoKanriKomokuCd2'" v-model="sh060Request.sagyoKanriKomokuCd2">
                                                                <option value=""></option>
                                                                <option v-for="housoushi in sh060Init.housoushiList" :key="housoushi.KEY" :value="housoushi.KEY">{{housoushi.VALUE}}</option>
                                                            </select>
                                                            <br>
                                                        </div>
                                                        <!-- 送り主名-->
                                                        <div v-if="sh060Init.noshiNaireFlg == 1 ">
                                                            <!-- 送り主名1 -->
                                                            {{$t("sh030.labels.senderName")}}１&nbsp;
                                                            <input-check :id="'noshiNaire1_'" :name="'noshiNaire1_'"  
                                                                class="sh060-inp-okurinushi" type="text" v-model="sh060Request.noshiNaire1"/>
                                                            <br>
                                                            <!-- 送り主名2 -->
                                                            {{$t("sh030.labels.senderName")}}２&nbsp;
                                                            <input-check :id="'noshiNaire2_'" class="sh060-inp-okurinushi" type="text" v-model="sh060Request.noshiNaire2"/>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <!-- 備考欄 -->
                                <div class="settingMainSh060OneColumn bikoInfoCol" v-if="sh060Init.bikouFlg == 1">
                                    <div class="settingMainSh060Card">
                                        <div class="settingMainSh060CardHeader">
                                            <div class="settingMainSh060CardHeaderSub">
                                                <div class="settingMainSh060CardHeaderSub1">{{$t('sh060.labels.bikouSetArea')}}</div>
                                                <!-- <div class="settingMainSh060CardHeaderSub2"><a href="javascript:void(0)" @click="gotoSettingPageForTdk(19,0,'4');" id="giftComfirmCopyMsg" class="card-link">{{$t('sh060.buttons.chanegeSettingArea')}}</a></div>-->
                                            </div>
                                        </div>
                                        <div class="settingMainSh060CardBody">
                                            <!-- 備考 -->
                                            <!--<h5 class="settingMainSh060CardBodyCardTitle">{{stringNvl(sh060Init.tdkInfo[0]['BIKOU'],"")}}</h5>-->
                                            <textarea id="biko" name="biko" rows="4" cols="75" maxlength="500" v-model="sh060Request.biko"> </textarea>
                                        </div>
                                    </div>
                                </div>
                                <!-- お支払方法 -->
                                <div class="settingMainSh060OneColumn paymentInfoCol" v-if="sh060Init.priceShow != 1">
                                    <div class="settingMainSh060Card">
                                        <div class="settingMainSh060CardHeader">
                                            <div class="settingMainSh060CardHeaderSub">
                                                <div class="settingMainSh060CardHeaderSub1">{{$t('sh060.labels.orderPaySettArea')}}</div>
                                                <div v-if="sh060Request.amazonCheckoutSessionId == null && sh060Request.kessaiCd == '993' && sh060Init.seikyuuKin <= 0 "></div>
                                                <div v-else-if="sh060Init.teikiInfo && sh060Init.teikiInfo.length>0" class="settingMainSh060CardHeaderSub2">
                                                    <!--お支払方法変更 定期注文の場合変更不可-->
                                                </div>
                                                <div v-else-if="sh060Request.amazonCheckoutSessionId == null" class="settingMainSh060CardHeaderSub2">
                                                    <a href="javascript:void(0)" @click="gotoSettingPage(21);" id="payComfirmCopyMsg" class="card-link">
                                                        {{$t('sh060.buttons.chanegeSettingAreaUpdate')}}</a></div>
                                                <div v-else class="settingMainSh060CardHeaderSub2">
                                                    <!--お支払方法変更-->
                                                    <a href="javascript:void(0)" id="changeButton2" class="card-link">{{$t('sh060.labels.amazonPayInfoKoushin')}}</a>
                                                    <a style="margin-left:300px;" href="javascript:void(0)" @click="gotoSettingPage(21);" id="payComfirmCopyMsg" class="card-link">
                                                        {{$t('sh060.labels.amazonPayIgai')}}</a>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="settingMainSh060CardBody">
                                            <span id="errorCashDelivery_lbl" hidden>{{stringNvl(sh060Init.orderInfo['SIHARAI_HOHO_KBN_NM'],"指定なし")}}</span>
                                            <h5  v-if="sh060Init.kessaiCd == null || sh060Init.kessaiCd == '' || sh060Init.kessaiCd == undefined" class="settingMainSh060CardBodyCardTitle">指定なし</h5>
                                            <h5  v-else-if="sh060Init.kessaiCd != Constants.KESSAI_AMAZONPAY || (sh060Init.kessaiCd == Constants.KESSAI_AMAZONPAY && (sh060Init.orderInfo == null || sh060Init.orderInfo['AMAZON_PAY_INFO'] == null))" class="settingMainSh060CardBodyCardTitle">{{stringNvl(sh060Init.orderInfo['SIHARAI_HOHO_KBN_NM'],"指定なし")}}</h5>
                                            <h5  v-else class="settingMainSh060CardBodyCardTitle">{{stringNvl(sh060Init.orderInfo['AMAZON_PAY_INFO'],"指定なし")}}</h5>
                                            <div class="personal mb64" :summary="$t('sh060.labels.newPayment')" v-if="sh060Init.kessaiCd != Constants.KESSAI_AMAZONPAY">
                                                <!--クレジットカード情報 -->
                                                <tr> 
                                                    <td> 
                                                        <template v-if="creditFlg && sh060Init.teikiAddFlg == '0' && doQuotationFlg == 0">
                                                            <template v-if="stringNvl(sh060Init.cardNoDisp) != ''">
                                                                <input type="radio" name="card_flg"
                                                                    value="1" v-model="sh060Request.cardFlg" id="card_flg1" @click="showCloseNewCardArea(0)"/>
                                                                <label for="card_flg1">
                                                                    <!-- 前回と同じカードを使う -->
                                                                    {{$t('sh060.labels.usethesamecardaslasttime')}}
                                                                </label>
                                                                <div v-if="showNowCardFlg === 0" class="sh060tbl">
                                                                    <div>
                                                                        <!-- カード番号 -->
                                                                        <div>
                                                                            <label class="col-form-label font-weight-bold">
                                                                                {{$t('sh060.labels.cardnumber')}}
                                                                            </label>
                                                                        </div>
                                                                        <div>
                                                                            {{sh060Init.cardNoDisp}}
                                                                        </div>
                                                                    </div>
                                                                    <div>
                                                                        <!-- 有効期限 -->
                                                                        <div>
                                                                            <label class="col-form-label font-weight-bold">
                                                                                {{$t('sh060.labels.expirationdate')}}
                                                                            </label>
                                                                        </div>
                                                                        <div>
                                                                            {{sh060Init.cardLimit}}
                                                                        </div>
                                                                    </div>
                                                                    <div v-if="sh060Init.securityCodeUseFlg">
                                                                        <div>
                                                                            <!-- セキュリティコード -->
                                                                            <label class="col-form-label font-weight-bold">
                                                                                {{$t('sh060.labels.securitycode')}}
                                                                            </label>
                                                                        </div>
                                                                        <div>
                                                                            <input-check type="text" size="4" maxlength="4" name="cardSecurity" class="numcode"
                                                                                id="cardSecurity"
                                                                                v-model="sh060Request.cardSecurity"
                                                                                autocomplete="off"/>
                                                                        </div>
                                                                    </div>
                                                                    <div>
                                                                        <!-- お支払方法 -->
                                                                        <div>
                                                                            <label class="col-form-label font-weight-bold">
                                                                            {{$t('sh060.labels.paymentMethod')}}
                                                                            </label>
                                                                        </div>
                                                                        <div>
                                                                            <select v-model="sh060Request.lastCardPayCnt" name="lastCardPayCnt" id="lastCardPayCnt" @change="chgCardPayCnt">
                                                                                <option v-for="payCnt in sh060Init.payCntList" :key="payCnt.KEY" :value="payCnt.KEY">{{payCnt.VALUE}}</option>
                                                                            </select>
                                                                        </div>
                                                                    </div>
                                                                    <div v-if="isBunkatuFlg">
                                                                        <!-- お支払回数 -->
                                                                        <div>
                                                                            <label class="col-form-label font-weight-bold">
                                                                            {{$t('sh060.labels.paymentfrequency')}}
                                                                            </label>
                                                                        </div>
                                                                        <div>
                                                                            <select v-model="sh060Request.lastBunkatuKaisu" name="lastBunkatuKaisu" id="lastBunkatuKaisu">
                                                                                <option v-for="kaisu in sh060Init.bunkatuKaisuList" :key="kaisu.KEY" :value="kaisu.KEY">{{kaisu.VALUE}}</option>
                                                                            </select>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <hr>
                                                                <input type="radio" name="card_flg" v-model="sh060Request.cardFlg" value="0" id="card_flg0" @click="showCloseNewCardArea(1)"/>
                                                                <label for="card_flg0">
                                                                    <!-- 新しいカードを使う -->
                                                                    {{$t('sh060.labels.usenewcard')}}
                                                                </label>
                                                            </template>
                                                            <template v-if="showNowCardFlg === 1">
                                                                <span v-html="descriptionInfo[5]"></span>
                                                                <template v-if="sh060Init.kessaiCompKbn == 'JCS' || sh060Init.kessaiCompKbn == 'GMO' || sh060Init.kessaiCompKbn == 'SGP'">
                                                                    <iframe name="dummyframe" id="dummyframe" ref="dummyframe" style="display:none"></iframe>
                                                                    <form :action="sh060Init.serverUrl" 
                                                                        METHOD="POST" ref="form" name="form" ENCTYPE="application/x-www-form-urlencode" target="dummyframe">

                                                                        <input type="hidden" name="tourokuKbn" :value="tourokuKbn">    <!-- 登録区分 -->
                                                                        <input type="hidden" name="merchantId" :value="sh060Init.merchantId">    <!-- 加盟店ID -->
                                                                        <input v-if="sh060Request.cardSaveFlg" type="hidden" name="dbKey1" :value="sh060Init.newDbKey">    <!-- 加盟店ID -->
                                                                        <input type="hidden" name="amount" :value="sh060Init.seikyuuKin">    <!-- オーソリ金額 -->
                                                                        <input type="hidden" name="backUrl" :value="sh060Init.backUrl">    <!-- 戻りURL -->
                                                                        <input type="hidden" name="orderNum" :value="sh060Init.orderNum">    <!-- 注文番号 -->
                                                                        <input type="hidden" name="cardKbn" :value="sh060Init.cardKbn">    <!-- カード情報返却区分 -->
                                                                        <input type="hidden" name="optionalAreaName1" value="coNo">
                                                                        <input type="hidden" name="optionalAreaValue1" :value="sh060Init.coNo">    <!-- 会社NO -->
                                                                        <input type="hidden" name="optionalAreaName2" value="kessaiCd">
                                                                        <input type="hidden" name="optionalAreaValue2" :value="sh060Init.kessaiCd">    <!-- 決済方法CD -->
                                                                        <input type="hidden" name="shopID" :value="sh060Init.bgShopId">    <!-- blueGate Shop ID -->
                                                                        <input type="hidden" name="paymentMode" :value="sh060Request.cardPayCnt">    <!-- 支払区分コード -->
                                                                        <input v-if="isBunkatu(sh060Request.cardPayCnt)" type="hidden" name="paymentCount" :value="sh060Request.bunkatuKaisu">    <!-- 分割回数 -->
                                                                        <input type="hidden" name="msgDigest" :value="msgDigest">    <!-- 注文受付メッセージダイジェスト -->
                                                                        
                                                                        <input type="hidden" name="pan" :value="pan">
                                                                        <input type="hidden" name="expiryDate" :value="expiryDate">
                                                                        <input v-if="sh060Init.securityCodeUseFlg" type="hidden" name="securityCode" :value="sh060Request.securityCode">
                                                                    </form>

                                                                    <!--JCS 3D-->
                                                                    <template v-if="sh060Init.kessaiCompKbn == 'JCS' && sh060Init.security3DFlg == '1'">
                                                                        <form :action="sh060Init.serverUrl" METHOD="POST" ENCTYPE="application/x-www-form-urlencode" 
                                                                            ref="formJasTaking" name="formJasTaking" target="_self">
                                                                        
                                                                            <input type="hidden" name="tourokuKbn"         v-model="jasNewCardTaking.tourokuKbn">              <!-- 登録区分 -->
                                                                            <input type="hidden" name="merchantId"         v-model="jasNewCardTaking.merchantId">              <!-- 加盟店ID -->
                                                                            <input type="hidden" name="senddate"           v-model="jasNewCardTaking.senddate">                <!-- 電文送信日 -->
                                                                            <input type="hidden" name="sendtime"           v-model="jasNewCardTaking.sendtime">                <!-- 電文送信時間 -->
                                                                            <input type="hidden" name="pan"                v-model="jasNewCardTaking.pan">                     <!-- カード番号 -->
                                                                            <input type="hidden" name="expiryDate"         v-model="jasNewCardTaking.expiryDate">              <!-- 有効期限 -->
                                                                            <input type="hidden" name="cardKbn"            v-model="jasNewCardTaking.cardKbn">                 <!-- カード情報返却区分 -->
                                                                            <input type="hidden" name="backUrl"            v-model="jasNewCardTaking.backUrl">                 <!-- 戻りURL -->
                                                                            <input type="hidden" name="optionalAreaName1"  v-model="jasNewCardTaking.optionalAreaName1">       
                                                                            <input type="hidden" name="optionalAreaValue1" v-model="jasNewCardTaking.optionalAreaValue1">      <!-- 会社NO -->
                                                                            <input type="hidden" name="optionalAreaName2"  v-model="jasNewCardTaking.optionalAreaName2">       
                                                                            <input type="hidden" name="optionalAreaValue2" v-model="jasNewCardTaking.optionalAreaValue2">      <!-- 決済方法CD -->
                                                                            <input type="hidden" name="optionalAreaName3"  v-model="jasNewCardTaking.optionalAreaName3">       
                                                                            <input type="hidden" name="optionalAreaValue3" v-model="jasNewCardTaking.optionalAreaValue3">      
                                                                            <input type="hidden" name="optionalAreaName4"  v-model="jasNewCardTaking.optionalAreaName4">       
                                                                            <input type="hidden" name="optionalAreaValue4" v-model="jasNewCardTaking.optionalAreaValue4">
                                                                            <input type="hidden" name="optionalAreaName5"  v-model="jasNewCardTaking.optionalAreaName5">
                                                                            <input type="hidden" name="optionalAreaValue5" v-model="jasNewCardTaking.optionalAreaValue5">
                                                                            <input type="hidden" name="optionalAreaName6"  v-model="jasNewCardTaking.optionalAreaName6">
                                                                            <input type="hidden" name="optionalAreaValue6" v-model="jasNewCardTaking.optionalAreaValue6">
                                                                            <input type="hidden" name="optionalAreaName7"  v-model="jasNewCardTaking.optionalAreaName7">
                                                                            <input type="hidden" name="optionalAreaValue7" v-model="jasNewCardTaking.optionalAreaValue7">
                                                                            <input type="hidden" name="optionalAreaName8"  v-model="jasNewCardTaking.optionalAreaName8">
                                                                            <input type="hidden" name="optionalAreaValue8" v-model="jasNewCardTaking.optionalAreaValue8">
                                                                            <input type="hidden" name="optionalAreaName9"  v-model="jasNewCardTaking.optionalAreaName9">
                                                                            <input type="hidden" name="optionalAreaValue9" v-model="jasNewCardTaking.optionalAreaValue9">
                                                                            <input type="hidden" name="optionalAreaName10"  v-model="jasNewCardTaking.optionalAreaName10">
                                                                            <input type="hidden" name="optionalAreaValue10" v-model="jasNewCardTaking.optionalAreaValue10">

                                                                            <input type="hidden" name="shopID"             v-model="jasNewCardTaking.shopID">                  <!-- blueGate Shop ID -->
                                                                            <input type="hidden" name="msgDigest"          v-model="jasNewCardTaking.msgDigest">               <!-- 注文受付メッセージダイジェスト -->
                                                                        </form>

                                                                        <form  :action="sh060Init.serverUrl" METHOD="POST"  ENCTYPE="application/x-www-form-urlencode" 
                                                                            ref="formJas3D" name="formJas3D" target="_self">
                                                                        
                                                                            <input type="hidden" name="tourokuKbn"         v-model="jasNewCard3D.tourokuKbn">              <!-- 登録区分 -->
                                                                            <input type="hidden" name="merchantId"         v-model="jasNewCard3D.merchantId">              <!-- 加盟店ID -->
                                                                            <input type="hidden" name="cardPassword"       v-model="jasNewCard3D.cardPassword" v-if="jcsMemberType == '0' || jcsMemberType == '1'">  <!-- カード情報パスワード  -->
                                                                            <input type="hidden" name="dbKey1"             v-model="jasNewCard3D.dbKey1" v-if="jcsMemberType == '2'"> <!-- DB キー -->
                                                                            <input type="hidden" name="orderNum"           v-model="jasNewCard3D.orderNum">                <!-- 注文番号 -->
                                                                            <input type="hidden" name="amount"             v-model="jasNewCard3D.amount">                  <!-- 売上金額 -->
                                                                            <input type="hidden" name="taxAndDeliCharge"   v-model="jasNewCard3D.taxAndDeliCharge">        <!-- 税送料  -->
                                                                            <input type="hidden" name="backUrl"            v-model="jasNewCard3D.backUrl">                 <!-- 戻りURL -->
                                                                            <input type="hidden" name="optionalAreaName1"  v-model="jasNewCard3D.optionalAreaName1">       
                                                                            <input type="hidden" name="optionalAreaValue1" v-model="jasNewCard3D.optionalAreaValue1">      <!-- 会社NO -->
                                                                            <input type="hidden" name="optionalAreaName2"  v-model="jasNewCard3D.optionalAreaName2">       
                                                                            <input type="hidden" name="optionalAreaValue2" v-model="jasNewCard3D.optionalAreaValue2">      <!-- 決済方法CD -->
                                                                            <input type="hidden" name="optionalAreaName3"  v-model="jasNewCard3D.optionalAreaName3">       
                                                                            <input type="hidden" name="optionalAreaValue3" v-model="jasNewCard3D.optionalAreaValue3">      
                                                                            <input type="hidden" name="optionalAreaName4"  v-model="jasNewCard3D.optionalAreaName4"> 
                                                                            <input type="hidden" name="optionalAreaValue4" v-model="jasNewCard3D.optionalAreaValue4">
                                                                            <input type="hidden" name="optionalAreaName5"  v-model="jasNewCard3D.optionalAreaName5">
                                                                            <input type="hidden" name="optionalAreaValue5" v-model="jasNewCard3D.optionalAreaValue5">
                                                                            <input type="hidden" name="optionalAreaName6"  v-model="jasNewCard3D.optionalAreaName6">
                                                                            <input type="hidden" name="optionalAreaValue6" v-model="jasNewCard3D.optionalAreaValue6">
                                                                            <input type="hidden" name="optionalAreaName7"  v-model="jasNewCard3D.optionalAreaName7">
                                                                            <input type="hidden" name="optionalAreaValue7" v-model="jasNewCard3D.optionalAreaValue7">
                                                                            <input type="hidden" name="optionalAreaName8"  v-model="jasNewCard3D.optionalAreaName8">
                                                                            <input type="hidden" name="optionalAreaValue8" v-model="jasNewCard3D.optionalAreaValue8">
                                                                            <input type="hidden" name="optionalAreaName9"  v-model="jasNewCard3D.optionalAreaName9">
                                                                            <input type="hidden" name="optionalAreaValue9" v-model="jasNewCard3D.optionalAreaValue9">
                                                                            <input type="hidden" name="optionalAreaName10"  v-model="jasNewCard3D.optionalAreaName10">
                                                                            <input type="hidden" name="optionalAreaValue10" v-model="jasNewCard3D.optionalAreaValue10">
                                                                            <input type="hidden" name="shopID"             v-model="jasNewCard3D.shopID" v-if="jcsMemberType == '2'">         <!-- BlueGate ショップ ID -->
                                                                            <!--<input type="hidden" name="accountMethod"      v-model="jasNewCard3D.accountMethod" v-if="jcsMemberType == '2'"> --> <!-- 決済手段登録番号 -->
                                                                            
                                                                            <input type="hidden" name="authenticationInd"                      v-model="jasNewCard3D.authenticationInd">
                                                                            <input type="hidden" name="threeDSReqAuthMethod"                   v-model="jasNewCard3D.threeDSReqAuthMethod">
                                                                            <input type="hidden" name="threeDSReqAuthTimestamp"                v-model="jasNewCard3D.threeDSReqAuthTimestamp">
                                                                            <input type="hidden" name="challengeInd"                           v-model="jasNewCard3D.challengeInd">
                                                                            <input type="hidden" name="acctType"                               v-model="jasNewCard3D.acctType">
                                                                            <input type="hidden" name="merchantName"                           v-model="jasNewCard3D.merchantName">
                                                                            <input type="hidden" name="chAccAgeInd"                            v-model="jasNewCard3D.chAccAgeInd">
                                                                            <input type="hidden" name="chAccChange"                            v-model="jasNewCard3D.chAccChange">
                                                                            <input type="hidden" name="chAccChangeInd"                         v-model="jasNewCard3D.chAccChangeInd">
                                                                            <input type="hidden" name="chAccDate"                              v-model="jasNewCard3D.chAccDate">
                                                                            <input type="hidden" name="chAccPwChange"                          v-model="jasNewCard3D.chAccPwChange">
                                                                            <input type="hidden" name="chAccPwChangeInd"                       v-model="jasNewCard3D.chAccPwChangeInd">
                                                                            <input type="hidden" name="nbPurchaseAccount"                      v-model="jasNewCard3D.nbPurchaseAccount">
                                                                            <input type="hidden" name="provisionAttemptsDay"                   v-model="jasNewCard3D.provisionAttemptsDay">
                                                                            <input type="hidden" name="txnActivityDay"                         v-model="jasNewCard3D.txnActivityDay">
                                                                            <input type="hidden" name="txnActivityYear"                        v-model="jasNewCard3D.txnActivityYear">
                                                                            <input type="hidden" name="paymentAccAge"                          v-model="jasNewCard3D.paymentAccAge">
                                                                            <input type="hidden" name="paymentAccInd"                          v-model="jasNewCard3D.paymentAccInd">
                                                                            <input type="hidden" name="shipAddressUsage"                       v-model="jasNewCard3D.shipAddressUsage">
                                                                            <input type="hidden" name="shipAddressUsageInd"                    v-model="jasNewCard3D.shipAddressUsageInd">
                                                                            <input type="hidden" name="shipNameIndicator"                      v-model="jasNewCard3D.shipNameIndicator">
                                                                            <input type="hidden" name="suspiciousAccActivity"                  v-model="jasNewCard3D.suspiciousAccActivity">
                                                                            <input type="hidden" name="addrMatch"                              v-model="jasNewCard3D.addrMatch">
                                                                            <input type="hidden" name="billAddrCity"                           v-model="jasNewCard3D.billAddrCity">
                                                                            <input type="hidden" name="billAddrCountry"                        v-model="jasNewCard3D.billAddrCountry">
                                                                            <input type="hidden" name="billAddrLine1"                          v-model="jasNewCard3D.billAddrLine1">
                                                                            <input type="hidden" name="billAddrLine2"                          v-model="jasNewCard3D.billAddrLine2">
                                                                            <input type="hidden" name="billAddrLine3"                          v-model="jasNewCard3D.billAddrLine3">
                                                                            <input type="hidden" name="billAddrPostCode"                       v-model="jasNewCard3D.billAddrPostCode">
                                                                            <input type="hidden" name="billAddrState"                          v-model="jasNewCard3D.billAddrState">
                                                                            <input type="hidden" name="email"                                  v-model="jasNewCard3D.email">
                                                                            <input type="hidden" name="homePhoneCc"                            v-model="jasNewCard3D.homePhoneCc">
                                                                            <input type="hidden" name="homePhoneSubscriber"                    v-model="jasNewCard3D.homePhoneSubscriber">
                                                                            <input type="hidden" name="mobilePhoneCc"                          v-model="jasNewCard3D.mobilePhoneCc">
                                                                            <input type="hidden" name="mobilePhoneSubscriber"                  v-model="jasNewCard3D.mobilePhoneSubscriber">
                                                                            <input type="hidden" name="cardholderName"                         v-model="jasNewCard3D.cardholderName">
                                                                            <input type="hidden" name="shipAddrCity"                           v-model="jasNewCard3D.shipAddrCity">
                                                                            <input type="hidden" name="shipAddrCountry"                        v-model="jasNewCard3D.shipAddrCountry">
                                                                            <input type="hidden" name="shipAddrLine1"                          v-model="jasNewCard3D.shipAddrLine1">
                                                                            <input type="hidden" name="shipAddrLine2"                          v-model="jasNewCard3D.shipAddrLine2">
                                                                            <input type="hidden" name="shipAddrLine3"                          v-model="jasNewCard3D.shipAddrLine3">
                                                                            <input type="hidden" name="shipAddrPostCode"                       v-model="jasNewCard3D.shipAddrPostCode">
                                                                            <input type="hidden" name="shipAddrState"                          v-model="jasNewCard3D.shipAddrState">
                                                                            <input type="hidden" name="workPhoneCc"                            v-model="jasNewCard3D.workPhoneCc">
                                                                            <input type="hidden" name="workPhoneSubscriber"                    v-model="jasNewCard3D.workPhoneSubscriber">
                                                                            <input type="hidden" name="purchaseInstalData"                     v-model="jasNewCard3D.purchaseInstalData">
                                                                            <input type="hidden" name="deliveryEmailAddress"                   v-model="jasNewCard3D.deliveryEmailAddress">
                                                                            <input type="hidden" name="deliveryTimeframe"                      v-model="jasNewCard3D.deliveryTimeframe">
                                                                            <input type="hidden" name="giftCardAmount"                         v-model="jasNewCard3D.giftCardAmount">
                                                                            <input type="hidden" name="giftCardCount"                          v-model="jasNewCard3D.giftCardCount">
                                                                            <input type="hidden" name="giftCardCurr"                           v-model="jasNewCard3D.giftCardCurr">
                                                                            <input type="hidden" name="preOrderDate"                           v-model="jasNewCard3D.preOrderDate">
                                                                            <input type="hidden" name="preOrderPurchaseInd"                    v-model="jasNewCard3D.preOrderPurchaseInd">
                                                                            <input type="hidden" name="reorderItemsInd"                        v-model="jasNewCard3D.reorderItemsInd">
                                                                            <input type="hidden" name="shipIndicator"                          v-model="jasNewCard3D.shipIndicator">
                                                                            <input type="hidden" name="messageCategory"                        v-model="jasNewCard3D.messageCategory">
                                                                            <input type="hidden" name="recurringExpiry"                        v-model="jasNewCard3D.recurringExpiry">
                                                                            <input type="hidden" name="recurringFrequency"                     v-model="jasNewCard3D.recurringFrequency">
                                                                            <input type="hidden" name="transType"                              v-model="jasNewCard3D.transType">
                                                                            <input type="hidden" name="priorTransID"                           v-model="jasNewCard3D.priorTransID">

                                                                            <input type="hidden" name="msgDigest"          v-model="jasNewCard3D.msgDigest">               <!-- 注文受付メッセージダイジェスト -->
                                                                        </form>

                                                                        <form :action="sh060Init.serverUrl" METHOD="POST"  ENCTYPE="application/x-www-form-urlencode" 
                                                                            ref="formJasOsori" name="formJasOsori" target="_self">

                                                                                <input type="hidden" name="tourokuKbn"          v-model="jasNewCardOsori.tourokuKbn">         <!-- 登録区分 -->
                                                                                <input type="hidden" name="merchantId"          v-model="jasNewCardOsori.merchantId">         <!-- 加盟店 ID -->
                                                                                <input type="hidden" name="dbKey1"              v-model="jasNewCardOsori.dbKey1" v-if="jcsMemberType == '1' || jcsMemberType == '2'"> <!-- DB キー -->
                                                                                <input type="hidden" name="amount"              v-model="jasNewCardOsori.amount">             <!-- オーソリ金額 -->
                                                                                <!--<input type="hidden" name="taxAndDeliCharge"    v-model="jasNewCardOsori.taxAndDeliCharge"> -->  <!-- 税送料 -->
                                                                                <input type="hidden" name="backUrl"             v-model="jasNewCardOsori.backUrl" >            <!-- 戻り URL -->
                                                                                <input type="hidden" name="orderNum"            v-model="jasNewCardOsori.orderNum">           <!-- 注文番号  -->
                                                                                <input type="hidden" name="cardPassword"        v-model="jasNewCardOsori.cardPassword" v-if="jcsMemberType == '0' || jcsMemberType == '1'">       <!-- カード情報パスワード -->
                                                                                <input type="hidden" name="securityCode"        v-model="jasNewCardOsori.securityCode">       <!-- セキュリティコード -->
                                                                                <input type="hidden" name="optionalAreaName1"   v-model="jasNewCardOsori.optionalAreaName1">  <!-- 自由使用領域1(項目名) -->
                                                                                <input type="hidden" name="optionalAreaValue1"  v-model="jasNewCardOsori.optionalAreaValue1"> <!-- 自由使用領域1(設定値) -->
                                                                                <input type="hidden" name="optionalAreaName2"   v-model="jasNewCardOsori.optionalAreaName2">  <!-- 自由使用領域2(項目名) -->
                                                                                <input type="hidden" name="optionalAreaValue2"  v-model="jasNewCardOsori.optionalAreaValue2"> <!-- 自由使用領域2(設定値) -->
                                                                                <input type="hidden" name="optionalAreaName3"   v-model="jasNewCardOsori.optionalAreaName3">  <!-- 自由使用領域3(項目名) -->
                                                                                <input type="hidden" name="optionalAreaValue3"  v-model="jasNewCardOsori.optionalAreaValue3"> <!-- 自由使用領域3(設定値) -->
                                                                                <input type="hidden" name="optionalAreaName4"   v-model="jasNewCardOsori.optionalAreaName4">  <!-- 自由使用領域4(項目名) -->
                                                                                <input type="hidden" name="optionalAreaValue4"  v-model="jasNewCardOsori.optionalAreaValue4"> <!-- 自由使用領域4(設定値) -->
                                                                                <input type="hidden" name="optionalAreaName5"  v-model="jasNewCardOsori.optionalAreaName5">
                                                                                <input type="hidden" name="optionalAreaValue5" v-model="jasNewCardOsori.optionalAreaValue5">
                                                                                <input type="hidden" name="optionalAreaName6"  v-model="jasNewCardOsori.optionalAreaName6">
                                                                                <input type="hidden" name="optionalAreaValue6" v-model="jasNewCardOsori.optionalAreaValue6">
                                                                                <input type="hidden" name="optionalAreaName7"  v-model="jasNewCardOsori.optionalAreaName7">
                                                                                <input type="hidden" name="optionalAreaValue7" v-model="jasNewCardOsori.optionalAreaValue7">
                                                                                <input type="hidden" name="optionalAreaName8"  v-model="jasNewCardOsori.optionalAreaName8">
                                                                                <input type="hidden" name="optionalAreaValue8" v-model="jasNewCardOsori.optionalAreaValue8">
                                                                                <input type="hidden" name="optionalAreaName9"  v-model="jasNewCardOsori.optionalAreaName9">
                                                                                <input type="hidden" name="optionalAreaValue9" v-model="jasNewCardOsori.optionalAreaValue9">
                                                                                <input type="hidden" name="optionalAreaName10"  v-model="jasNewCardOsori.optionalAreaName10">
                                                                                <input type="hidden" name="optionalAreaValue10" v-model="jasNewCardOsori.optionalAreaValue10">
                                                                                <input type="hidden" name="msgVerNum"           v-model="jasNewCardOsori.msgVerNum">          <!-- 3D version -->
                                                                                <input type="hidden" name="xid"                 v-model="jasNewCardOsori.xid">                <!-- 3D xid -->
                                                                                <input type="hidden" name="xStatus"             v-model="jasNewCardOsori.xStatus">            <!-- 3D status  -->
                                                                                <input type="hidden" name="eci"                 v-model="jasNewCardOsori.eci">                <!-- 3D eci -->
                                                                                <input type="hidden" name="cavv"                v-model="jasNewCardOsori.cavv">               <!-- 3D cavv -->
                                                                                <input type="hidden" name="cavvAlgorithm"       v-model="jasNewCardOsori.cavvAlgorithm">      <!-- 3D cavvAlgorithm -->
                                                                                <input type="hidden" name="paymentMode"         v-model="jasNewCardOsori.paymentMode">        <!-- 支払区分コード -->
                                                                                <input type="hidden" name="startPayMonth"       v-model="jasNewCardOsori.startPayMonth">      <!-- 支払開始月  -->
                                                                                <input type="hidden" name="paymentCount"        v-model="jasNewCardOsori.paymentCount">       <!-- 分割回数  -->
                                                                                <input type="hidden" name="initialAmount"       v-model="jasNewCardOsori.initialAmount">      <!-- 初回金額  -->
                                                                                <input type="hidden" name="bonusMonth"          v-model="jasNewCardOsori.bonusMonth">         <!-- ボーナス支払月 -->
                                                                                <input type="hidden" name="bonusAmount"         v-model="jasNewCardOsori.bonusAmount">        <!-- ボーナス支払金額 -->
                                                                                <input type="hidden" name="bonusCount"          v-model="jasNewCardOsori.bonusCount">         <!-- ボーナス回数  -->
                                                                                <input type="hidden" name="shopID"              v-model="jasNewCardOsori.shopID"        v-if="jcsMemberType == '2'"> <!-- BlueGate ショップ ID -->
                                                                                <input type="hidden" name="bgpasswd"            v-model="jasNewCardOsori.bgpasswd"      v-if="jcsMemberType == '2'"> <!-- BlueGate password -->
                                                                                <input type="hidden" name="accountMethod"       v-model="jasNewCardOsori.accountMethod" v-if="jcsMemberType == '2'"> <!-- 決済手段登録番号 -->
                                                                                <input type="hidden" name="msgDigest"           v-model="jasNewCardOsori.msgDigest">         <!-- 注文受付メッセージダイジェスト -->
                                                                        </form>
                                                                    </template>

                                                                    <div class="">
                                                                        <div class="sh060tbl" :summary="$t('sh060.labels.cardnumber')">
                                                                            <div  class="creditCardnumberArea">
                                                                                <!-- カード番号(タイトル) -->
                                                                                <div>
                                                                                    <label class="col-form-label font-weight-bold">
                                                                                        {{$t('sh060.labels.cardnumber')}}
                                                                                    </label>
                                                                                </div>
                                                                                <!-- カード番号(入力内容) -->
                                                                                <div v-if="sh060Init.creditInpNumOption == 0"  class="form-row">
                                                                                    <div class="d-flex justify-content-between w-100 h-100">
                                                                                        <div class="form-check form-check-inline">
                                                                                            <input-check type="tel" class="num" size="4" style=" width:50px;"
                                                                                                        :maxlength="4" v-model="sh060Request.cardNoDisp1" autocomplete="off" />
                                                                                            -
                                                                                        </div>
                                                                                        <div class="form-check form-check-inline">
                                                                                            <input-check type="tel" class="num" size="4" style=" width:50px;"
                                                                                                        :maxlength="4" v-model="sh060Request.cardNoDisp2" autocomplete="off" />
                                                                                            -
                                                                                        </div>
                                                                                        <div class="form-check form-check-inline">
                                                                                            <input-check type="tel" class="num" size="4" style=" width:50px;"
                                                                                                        :maxlength="4" v-model="sh060Request.cardNoDisp3" autocomplete="off" />
                                                                                            -
                                                                                        </div>
                                                                                        <div class="form-check form-check-inline">
                                                                                            <input-check type="tel" class="num" size="4" style=" width:50px;"
                                                                                                        :maxlength="4" v-model="sh060Request.cardNoDisp4" autocomplete="off" />
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div v-else>
                                                                                    <div class="d-flex justify-content-between w-100 h-100">
                                                                                        <div class="form-check form-check-inline">
                                                                                            <input-check type="tel" class="num" size="20" style=" width:50%;"
                                                                                                        :maxlength="20" v-model="sh060Request.cardNoDisp" autocomplete="off" @on-input-change="onCredit" @input="onCredit"/>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>    
                                                                            <div class="creditExpirationdateArea">
                                                                                <!-- 有効期限(タイトル) -->
                                                                                <div>
                                                                                    <label class="col-form-label font-weight-bold">
                                                                                        {{$t('sh060.labels.expirationdate')}}
                                                                                    </label>
                                                                                </div>
                                                                                <!-- 有効期限(タイトル) -->
                                                                                <template v-if="sh060Init.ymPulldownFlg == 1">
                                                                                    <div class="form-row">
                                                                                        <div class="d-flex justify-content-between ">
                                                                                            <div class="form-check form-check-inline">
                                                                                                <select v-model="sh060Request.limitMonth" name="limitMonth" id="limitMonth" class="cardPayCnt">
                                                                                                    <option v-for="payCnt in sh060Init.monKbnList" :key="payCnt.KEY" :value="payCnt.KEY">{{payCnt.VALUE}}</option>
                                                                                                </select>/
                                                                                            </div>
                                                                                        </div>
                                                                                        <div class="d-flex justify-content-between">
                                                                                            <div class="form-check form-check-inline">
                                                                                                <select v-model="sh060Request.limitYear" name="limitYear" id="limitYear" class="cardPayCnt">
                                                                                                    <option v-for="payCnt in sh060Init.yearList" :key="payCnt.KEY" :value="payCnt.KEY">{{payCnt.VALUE}}</option>
                                                                                                </select>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </template>
                                                                                <template v-else>
                                                                                    <input-check type="tel" class="num" size="2"
                                                                                        maxlength="2" v-model="sh060Request.limitMonth"
                                                                                        name="limitMonth" id="limitMonth" autocomplete="off" @on-input-change="onBlur"/>
                                                                                        <!-- 月 -->
                                                                                        {{$t('sh060.labels.month')}}/20
                                                                                    <input-check type="tel" class="num" size="2"
                                                                                        maxlength="2" v-model="sh060Request.limitYear"
                                                                                        name="limitYear" id="limitYear"
                                                                                        autocomplete="off" />
                                                                                        <!-- 年 -->
                                                                                        {{$t('sh060.labels.year')}}
                                                                                </template>
                                                                            </div>
                                                                            <div v-if="sh060Init.kessaiCompKbn == 'GMO'" class="creditCardHolderArea">
                                                                                <!-- カードの名義人(タイトル) -->
                                                                                <div class="col-form-label font-weight-bold">
                                                                                    {{$t('sh060.labels.cardHolder')}}
                                                                                </div>
                                                                                <!-- カードの名義人(入力内容) -->
                                                                                <div  class="form-row">
                                                                                    <div class="d-flex justify-content-between">
                                                                                        <div v-if="sh060Init.cardNameOption == 1" class="form-check form-check-inline ">
                                                                                            <span v-html="descriptionInfo[21]"></span>
                                                                                            <input-check type="text" size="10" name="cardNameNamae"
                                                                                                        maxlength="50" class="code" id="cardNameNamae"
                                                                                                        v-model="sh060Request.cardNameNamae" autocomplete="off" :placeholder="descriptionInfo[23]"/>
                                                                                            <span v-html="descriptionInfo[22]"></span>
                                                                                            <input-check type="text" size="10" maxlength="50"
                                                                                                        name="cardNameMyouji" class="code" id="cardNameMyouji"
                                                                                                        v-model="sh060Request.cardNameMyouji" autocomplete="off" :placeholder="descriptionInfo[24]"/>
                                                                                        </div>
                                                                                        <div v-else class="form-check form-check-inline">
                                                                                            <input type="text" size="20" name="cardUserNm"
                                                                                                    maxlength="100" id="cardUserNm"
                                                                                                    v-model="sh060Request.cardUserNm" autocomplete="off" :placeholder="descriptionInfo[20]"/>
                                                                                        </div>
                                                                                        <span class="form-check-inline" v-html="descriptionInfo[16]"></span>
                                                                                    </div>
                                                                                    
                                                                                </div>
                                                                            </div>
                                                                            <div v-if="sh060Init.securityCodeUseFlg" class="creditSecuritycodeArea">
                                                                                <!-- セキュリティコード(タイトル) -->
                                                                                <div>
                                                                                    <label class="col-form-label font-weight-bold">
                                                                                        {{$t('sh060.labels.securitycode')}}
                                                                                    </label>
                                                                                </div>
                                                                                <!-- セキュリティコード(入力内容) -->
                                                                                <div  class="form-row">
                                                                                    <div class="d-flex justify-content-between ">
                                                                                        <div class="form-check form-check-inline">
                                                                                            <input-check type="text" size="4" maxlength="4" name="cardSecurity" class="numcode"
                                                                                                        id="cardSecurity" v-model="sh060Request.securityCode" autocomplete="off"/>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div class="creditPaymentMethodArea">
                                                                                <!-- お支払方法(タイトル)  -->
                                                                                <div>
                                                                                    <label class="col-form-label font-weight-bold">
                                                                                        {{$t('sh060.labels.paymentMethod')}}
                                                                                    </label>
                                                                                </div>
                                                                                <!-- お支払方法(入力内容)  -->
                                                                                <div class="form-row">
                                                                                    <div class="d-flex justify-content-between">
                                                                                        <div class="form-check form-check-inline">
                                                                                            <select v-model="sh060Request.cardPayCnt" name="cardPayCnt" id="cardPayCnt" @change="chgCardPayModel">
                                                                                                <option v-for="payCnt in sh060Init.payCntList" :key="payCnt.KEY" :value="payCnt.KEY">{{payCnt.VALUE}}</option>
                                                                                            </select>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div v-if="isBunkatuFlg" class="creditPaymentfrequencyArea">
                                                                                <!-- お支払回数(タイトル) -->
                                                                                <div>
                                                                                    <label class="col-form-label font-weight-bold">
                                                                                        {{$t('sh060.labels.paymentfrequency')}}
                                                                                    </label>
                                                                                </div>
                                                                                <!-- お支払回数(入力内容) -->
                                                                                <div class="form-row">
                                                                                    <div class="d-flex justify-content-between ">
                                                                                        <div class="form-check form-check-inline">
                                                                                            <select v-model="sh060Request.bunkatuKaisu" name="bunkatuKaisu" id="bunkatuKaisu">
                                                                                                <option v-for="kaisu in sh060Init.bunkatuKaisuList" :key="kaisu.KEY" :value="kaisu.KEY">{{kaisu.VALUE}}</option>
                                                                                            </select>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    
                                                                </template>
                                                                <div v-else class="">
                                                                    <div class="sh060tbl" :summary="$t('sh060.labels.cardnumber')">
                                                                        <div class="creditCardnumberArea">
                                                                            <!-- カード番号(タイトル) -->
                                                                            <div>
                                                                                <label class="col-form-label font-weight-bold">
                                                                                    {{$t('sh060.labels.cardnumber')}}
                                                                                </label>
                                                                            </div>
                                                                            <!-- カード番号(入力内容) -->
                                                                            <div v-if="sh060Init.creditInpNumOption == 0" class="form-row">
                                                                                <div class="d-flex justify-content-between w-100 h-100">
                                                                                    <div class="form-check form-check-inline">
                                                                                        <input-check type="tel" class="num" size="4" style=" width:50px;" :maxlength="4" v-model="sh060Request.cardNoDisp1" autocomplete="off" />
                                                                                        -
                                                                                    </div>
                                                                                    <div class="form-check form-check-inline">
                                                                                        <input-check type="tel" class="num" size="4" style=" width:50px;" :maxlength="4" v-model="sh060Request.cardNoDisp2" autocomplete="off" />
                                                                                        -
                                                                                    </div>
                                                                                    <div class="form-check form-check-inline">
                                                                                        <input-check type="tel" class="num" size="4" style=" width:50px;" :maxlength="4" v-model="sh060Request.cardNoDisp3" autocomplete="off" />
                                                                                        -
                                                                                    </div>
                                                                                    <div class="form-check form-check-inline">
                                                                                        <input-check type="tel" class="num" size="4" style=" width:50px;" :maxlength="4" v-model="sh060Request.cardNoDisp4" autocomplete="off" />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div v-else>
                                                                                <div class="d-flex justify-content-between w-100 h-100">
                                                                                    <div class="form-check form-check-inline">
                                                                                        <input-check type="tel" class="num" size="20" style=" width:50%;" :maxlength="20" v-model="sh060Request.cardNoDisp" autocomplete="off" @on-input-change="onCredit" @input="onCredit"/>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <input type="hidden" id="cardNoDisp" />
                                                                        </div>
                                                                        <div class="creditExpirationdateArea">
                                                                            <!-- 有効期限(タイトル) -->
                                                                            <div class="col-form-label font-weight-bold">
                                                                                {{$t('sh060.labels.expirationdate')}}
                                                                            </div>
                                                                            <!-- 有効期限(入力内容) -->
                                                                            <template v-if="sh060Init.ymPulldownFlg == 1">
                                                                                <div class="form-row">
                                                                                    <div class="d-flex justify-content-between ">
                                                                                        <div class="form-check form-check-inline">
                                                                                            <select v-model="sh060Request.limitMonth" name="limitMonth" id="limitMonth" class="cardPayCnt">
                                                                                                <option v-for="payCnt in sh060Init.monKbnList" :key="payCnt.KEY" :value="payCnt.KEY">{{payCnt.VALUE}}</option>
                                                                                            </select>/
                                                                                        </div>
                                                                                    </div>
                                                                                    <div class="d-flex justify-content-between">
                                                                                        <div class="form-check form-check-inline">
                                                                                            <select v-model="sh060Request.limitYear" name="limitYear" id="limitYear" class="cardPayCnt">
                                                                                                <option v-for="payCnt in sh060Init.yearList" :key="payCnt.KEY" :value="payCnt.KEY">{{payCnt.VALUE}}</option>
                                                                                            </select>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </template>
                                                                            <template v-else>
                                                                                    <input-check type="tel" class="num" size="2"
                                                                                        maxlength="2" v-model="sh060Request.limitMonth"
                                                                                        name="limitMonth" id="limitMonth" autocomplete="off" @on-input-change="onBlur"/>
                                                                                        <!-- 月 -->
                                                                                        {{$t('sh060.labels.month')}}/20
                                                                                    <input-check type="tel" class="num" size="2"
                                                                                        maxlength="2" v-model="sh060Request.limitYear"
                                                                                        name="limitYear" id="limitYear"
                                                                                        autocomplete="off"/>
                                                                                        <!-- 年 -->
                                                                                        {{$t('sh060.labels.year')}}
                                                                            </template>
                                                                        </div>
                                                                        <div class="creditCardHolderArea">
                                                                            <!-- カードの名義人(タイトル) -->
                                                                            <div class="col-form-label font-weight-bold">
                                                                                {{$t('sh060.labels.cardHolder')}}
                                                                            </div>
                                                                            <!-- カードの名義人(入力内容) -->
                                                                            <div  class="form-row">
                                                                                <div class="d-flex justify-content-between">
                                                                                    <div v-if="sh060Init.cardNameOption == 1" class="form-check form-check-inline">
                                                                                        <span v-html="descriptionInfo[21]"></span>
                                                                                        <input-check type="text" size="10" name="cardNameNamae"
                                                                                                    maxlength="50" class="code" id="cardNameNamae"
                                                                                                    v-model="sh060Request.cardNameNamae" autocomplete="off" :placeholder="descriptionInfo[23]"/>
                                                                                        <span v-html="descriptionInfo[22]"></span>
                                                                                        <input-check type="text" size="10" maxlength="50"
                                                                                                    name="cardNameMyouji" class="code" id="cardNameMyouji"
                                                                                                    v-model="sh060Request.cardNameMyouji" autocomplete="off" :placeholder="descriptionInfo[24]"/>
                                                                                    </div>
                                                                                    <div v-else class="form-check form-check-inline">
                                                                                            <input type="text" size="20" name="cardUserNm"
                                                                                                    maxlength="100" id="cardUserNm"
                                                                                                    v-model="sh060Request.cardUserNm" autocomplete="off" :placeholder="descriptionInfo[20]"/>
                                                                                    </div>
                                                                                    <span class="form-check-inline" v-html="descriptionInfo[16]"></span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div class="creditPaymentMethodArea">
                                                                            <!--お支払方法(タイトル) -->
                                                                            <div class="col-form-label font-weight-bold">
                                                                                {{$t('sh060.labels.paymentMethod')}}
                                                                            </div>
                                                                            <!--お支払方法(入力内容) -->
                                                                            <div class="form-row">
                                                                                <div class="d-flex justify-content-between ">
                                                                                    <div class="form-check form-check-inline">
                                                                                        <select v-model="sh060Request.cardPayCnt" name="cardPayCnt" id="cardPayCnt" class="cardPayCnt" @change="chgCardPayModel">
                                                                                            <option v-for="payCnt in sh060Init.payCntList" :key="payCnt.KEY" :value="payCnt.KEY">{{payCnt.VALUE}}</option>
                                                                                        </select>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div v-if="isBunkatuFlg" class="creditPaymentfrequencyArea">
                                                                            <!-- お支払回数(タイトル) -->
                                                                            <div class="col-form-label font-weight-bold">
                                                                                {{$t('sh060.labels.paymentfrequency')}}
                                                                            </div>
                                                                            <!-- お支払回数(入力内容) -->
                                                                            <div class="form-row">
                                                                                <div class="d-flex justify-content-between ">
                                                                                    <div class="form-check form-check-inline">
                                                                                        <select v-model="sh060Request.bunkatuKaisu" name="bunkatuKaisu" id="bunkatuKaisu">
                                                                                            <option v-for="kaisu in sh060Init.bunkatuKaisuList" :key="kaisu.KEY" :value="kaisu.KEY">{{kaisu.VALUE}}</option>
                                                                                        </select>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div v-if="sh060Init.securityCodeUseFlg" class="creditSecuritycodeArea">
                                                                            <!-- セキュリティコード(タイトル) -->
                                                                            <div class="col-form-label font-weight-bold">
                                                                                {{$t('sh060.labels.securitycode')}}
                                                                            </div>
                                                                            <!-- セキュリティコード(入力内容) -->
                                                                            <div class="form-row">
                                                                                <div class="d-flex justify-content-between ">
                                                                                    <div class="form-check form-check-inline">
                                                                                        <input-check type="text" size="4" maxlength="4" name="cardSecurity" class="numcode"
                                                                                                    id="cardSecurity" v-model="sh060Request.securityCode" autocomplete="off"/>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </template>
                                                            <template v-if="sh060Init.kessaiCompKbn == 'SPS' && sh060Init.securitySps3DFlg == '1'">
                                                                <form :action="sh060Init.serverUrl" method="POST" ref="formSps3D" name="formSps3D" target="_self">
                                                                    <input type="hidden" name="MerchantId" v-model="sps3DSAuthori.merchantId">
                                                                    <input type="hidden" name="EncryptValue" v-model="sps3DSAuthori.encValue">
                                                                </form>
                                                            </template>
                                                            <template v-if="sh060Init.creditHozonRiyoFlg == '1'">
                                                                <hr v-if="sh060Init.kokyakuNo != '999999999'">
                                                                <div style="margin:10px 0px 5px 0px;" v-if="sh060Init.kokyakuNo != '999999999'">
                                                                            <input v-if="sh060Init.teikiFlg == '1' || (sh060Init.generalFlg == '1' && sh060Init.fea042TeikiFlg == '1')" type="hidden" v-model="sh060Request.cardSaveFlg" name="card_save_flg" id="_card_save_flg" value="1">
                                                                            <input v-if="sh060Init.teikiFlg == '1' || (sh060Init.generalFlg == '1' && sh060Init.fea042TeikiFlg == '1')" disabled="true" name="card_save_flg" id="_card_save_flg" v-model="sh060Request.cardSaveFlg" @click="setCardSaveFlg()" type="checkbox" value="1">
                                                                            <input v-else name="card_save_flg" id="_card_save_flg" v-model="sh060Request.cardSaveFlg" @click="setCardSaveFlg()" type="checkbox" value="1">
                                                                    <label for="_card_save_flg" onclick="">
                                                                        <!-- クレジットカード情報を保存する -->
                                                                        {{$t("sh060.labels.savecreditcardinformation")}}
                                                                    </label>
                                                                    <template v-if="sh060Init.generalFlg == '1' && sh060Init.fea042TeikiFlg == '1'">
                                                                        <br>
                                                                        <span v-html="descriptionInfo[14]"></span>
                                                                    </template>
                                                                    <template v-else-if="sh060Init.teikiFlg == '1'">
                                                                        <br>
                                                                        <span v-html="descriptionInfo[2]"></span>
                                                                    </template>
                                                                    <template v-else>
                                                                        <template v-if="stringNvl(sh060Init.cardNoDisp) != ''">
                                                                            <br>
                                                                            <span v-html="descriptionInfo[4]"></span>
                                                                        </template>
                                                                        <br>
                                                                        <span v-html="descriptionInfo[1]"></span>
                                                                    </template>
                                                                </div>
                                                                <input type="hidden" v-model="sh060Request.token" name="card_token" id="card_token">
                                                            </template>
                                                        </template>
                                                        <template v-else-if="conveniFlg">
                                                            <table class="purchase-history">
                                                                <tbody>
                                                                    <tr>
                                                                        <th>
                                                                            <!-- コンビニ名 -->
                                                                            {{$t('sh060.labels.conveniencestorename')}}
                                                                            <span class="※">{{$t('common.labels.komeMark')}}</span>
                                                                        </th>
                                                                        <td width="65%" bgcolor="#FFFFFF">
                                                                            <select name="cvsCd" id="_cvsCd">
                                                                                <option v-for="cvsCd in sh060Init.cvsCdList" :key="cvsCd.KEY" :value="cvsCd.KEY">{{cvsCd.VALUE}}</option>
                                                                            </select>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </template>
                                                    </td>
                                                </tr>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- ポイント利用 -->
                                <div class="settingMainSh060PointHide" v-if="sh060Init.pointCoupon == 0">
                                    <div class="settingMainSh060OneColumn pointInfoCol" v-if="sh060Init.pointFlg === 1 && sh060Init.kokyakuNo != '999999999'">
                                        <div class="settingMainSh060Card">
                                            <div class="settingMainSh060CardHeader">
                                                <div class="settingMainSh060CardHeaderSub" v-if="sh060Init.teikiAddFlg != 1">
                                                    <div class="settingMainSh060CardHeaderSub1">{{$t('sh060.labels.orderPonSettArea')}}</div>
                                                    <template v-if="pointChangeFlg == 1">
                                                        <div class="settingMainSh060CardHeaderSub2"><a href="javascript:void(0)" @click="gotoSettingPage(105);" id="pointComfirmCopyMsg" class="card-link">{{$t('sh060.buttons.chanegeSettingArea')}}</a></div>
                                                    </template> 
                                                </div>
                                            </div>
                                            <div class="settingMainSh060CardBody">
                                                <!-- 保有ポイント -->
                                                <h5 class="settingMainSh060CardBodyCardTitle">{{$t('sh060.labels.hoyuuPoint')}}{{stringNvl(sh060Init.totalPoint,"0")}}{{$t('common.labels.pt')}}</h5>
                                                <!-- 合計ご利用ポイント -->
                                                <h5 class="settingMainSh060CardBodyCardTitle" v-if="hatchuCnt > 0">{{$t('sh060.labels.totalUsePoint')}}{{stringNvl(sh060Init.orderInfo['TOTAL_POINT_KIN'],"0")}}{{$t('common.labels.pt')}}</h5>
                                                <!-- 今回ご利用ポイント -->
                                                <h5 class="settingMainSh060CardBodyCardTitle">{{$t('sh060.labels.konkaiUsePoint')}}{{stringNvl(sh060Init.pointKin,"0")}}{{$t('common.labels.pt')}}</h5>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- クーポン利用 -->
                                <div class="settingMainSh060OneColumn couponInfoCol" v-if="sh060Init.couponRiyouFlg == '1' && sh060Init.teikiAddFlg != 1 && sh060Init.kokyakuNo != Constants.GUEST_KOKYAKU_NO">
                                    <div class="settingMainSh060Card">
                                        <div class="settingMainSh060CardHeader">
                                            <div class="settingMainSh060CardHeaderSub">
                                                <div class="settingMainSh060CardHeaderSub1">{{$t('sh060.labels.orderCouSettArea')}}</div>
                                                <div v-if="sh060Init.couponInputFlg == '0'" class="settingMainSh060CardHeaderSub2">
                                                    <a href="javascript:void(0)" @click="gotoCouponPage(107);" id="couponComfirmCopyMsg" class="card-link">
                                                        {{$t('sh060.buttons.chanegeSettingArea')}}
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="settingMainSh060CardBody">
                                            <div v-if="sh060Init.couponInputFlg == '0'">
                                                <h5 v-if="sh060Init.isExistsRiyouCouponFlg == 0 && sh060Init.couponCount == 0" class="settingMainSh060CardBodyCardTitle">{{$t('sh060.labels.noRiyouTilte')}}</h5>
                                                <h5 v-else-if="sh060Init.isExistsRiyouCouponFlg == 1 && sh060Init.couponCount == 0" class="settingMainSh060CouponBodyCouponTitle">{{$t('sh060.labels.riyouTitle')}}</h5>
                                            </div>
                                            <div v-else>
                                                <div class="settingMainSh060CouponBodyCouponAddInfo">
                                                    <span>{{ $t('sh060.labels.couponAddTitle') }}</span>
                                                    <div class="settingMainSh060CouponBodyCouponSearch">
                                                        <input-check size="20" type="text" :maxlength="20" class="settingMainSh060CouponBodyCouponInput code" v-model="addCouponCd"/>
                                                        <input class="settingMainSh060CouponBodyCouponBtnAdd" type="button" @click="addCoupon();" :value="$t('sh060.buttons.btnAdd')">
                                                    </div>
                                                    <span v-html="descriptionInfo[7]"></span>
                                                </div>
                                            </div>
                                            <div v-if="sh060Init.couponCount > 0">
                                                <h5>{{ sh060Init.couponCount }}{{ $t('sh060.labels.selectedCouponTitle') }}</h5>
                                                <ul>
                                                    <li class="settingMainSh060CouponBodyCouponList" v-for="(couponItem, couponIndex) in sh060Init.couponList" :key="couponIndex">
                                                        {{ couponItem.COUPON_TITLE }}
                                                        <div class="settingMainSh060CouponBodyCouponClear">
                                                            <a v-if="sh060Init.couponInputFlg == '1'" 
                                                                class="settingMainSh060CouponBodyCouponClearBtnCouponClear" 
                                                                href="javascripit:void()"
                                                                @click="deleteCoupon(couponItem.COUPON_CD)">
                                                                    {{ $t('sh060.buttons.btnClear') }}
                                                            </a>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                            </div>                          
                        </div>
                    </div>
                    <!-- 自動発注概要（タイトルと説明） -->
                    <div v-if="hatchuCnt > 0" class="hachuInfoTitleArea ml-auto mr-0">
                        <h4 class="hachuInfoTitle">
                            {{$t('sh060.labels.hachuInfo')}}
                        </h4>
                        <!-- 項目説明マスタ[11] -->
                        <div class="hachuDescriptionTop mb64" v-if="descriptionInfo[11] != ''">
                            <span v-html="descriptionInfo[11]"></span>
                        </div>
                    </div>

                    <!-- 定期商品ある場合（タイトルと説明） 
                    <div v-if="sh060Init.teikiInfo && sh060Init.teikiInfo.length>0" class="hachuInfoTitleArea ml-auto mr-0">
                        -- 項目説明マスタ[15] --
                        <div class="teikiDescriptionTop mb6" v-if="descriptionInfo[15] != ''">
                            <span v-html="descriptionInfo[15]"></span>
                        </div>
                    </div>-->

                    <!-- list order -->
                    <table class="mb32" v-if="sh060Init.cartSplitUseFlg != 1">
                        <thead>
                            <tr>
                                <!--商品CD-->
                                <th class="w200">{{$t('common.labels.productCode')}}</th>
                                <!--商品名-->
                                <th>{{$t('common.labels.productName')}}</th>
                                <!--単価-->
                                <th class="w160" v-if="sh060Init.priceShow != 1">{{$t('common.labels.unitPrice')}}</th>
                                <!--数量-->
                                <th class="w80">{{$t('common.labels.quantity')}}</th>
                                <!--匹数-->
                                <th v-if="sh060Init.auraOption == 1" class="w80">{{$t('common.labels.animalQty')}}</th>
                                <!--金額-->
                                <th class="w160" v-if="sh060Init.priceShow != 1">{{$t('common.labels.kingakuStr')}}
                                    <!--税込-->
                                    <span class="price-tax" v-if="sh060Init.orderInfo['TNK_DSP_KBN'] == '1'">{{$t('common.labels.taxincluded')}}</span>
                                    <!--税抜-->
                                    <span class="price-tax" v-else>{{$t('common.labels.excludingtax')}}</span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <!--通常商品情報-->
                            <tr v-for="(item, idx) in sh060Init.cartInfo" :key="idx">
                                <!--商品CD-->
                                <td scope="row" :aria-label="$t('common.labels.productCode')">
                                    {{item.ITEM_NO}}
                                </td>
                                <!--商品名-->
                                <td :aria-label="$t('common.labels.productName')">
                                    <span class="cartOndo" v-if="stringNvl(item.ONDO_NM,'') != ''">【{{stringNvl(item.ONDO_NM,'')}}】</span>
                                    {{stringNvl(item.WEB_ITEM_NM,'')}}
                                    <div v-for="(optionItem, index) in sh060Init.orderOptionLst" :key="index">
                                        <dt v-if="item.SEQ == optionItem.SEQ && item.OPTION_GROUP_CD == optionItem.OP_GP_CD">{{$t(optionItem.OPTION_NAME)}}</dt>
                                    </div>
                                </td>
                                <!--単価-->
                                <td class="cart-price" :aria-label="$t('common.labels.unitPrice')" v-if="sh060Init.priceShow != 1">
                                    <!--税込-->
                                    <span v-if="sh060Init.orderInfo['TNK_DSP_KBN'] == '1'"> {{formatPrice(item.DISP_TNK_IN_ZEI)}}円 </span>
                                    <!--税抜-->
                                    <span v-else> {{formatPrice(item.DISP_TNK)}}円 </span>
                                </td>
                                <!--数量-->
                                <td style="text-align: right;" :aria-label="$t('common.labels.quantity')">
                                    {{formatPrice(item.DISP_QTY)}}
                                </td>
                                <!--匹数-->
                                <td v-if="sh060Init.auraOption == 1 && item.SYUKKA_NUM <= 1"  style="text-align: right;" :aria-label="$t('common.labels.animalQty')">
                                    {{"-"}}
                                </td>
                                <td v-else-if="sh060Init.auraOption == 1 && item.SYUKKA_NUM > 1"  style="text-align: right;" :aria-label="$t('common.labels.animalQty')">
                                    {{formatPrice(item.ANIMAL_QTY)}}
                                </td>
                                <!--金額-->
                                <!--税込-->
                                <template v-if="sh060Init.orderInfo['TNK_DSP_KBN'] == '1' && sh060Init.priceShow != 1">
                                    <td class="cart-price" :aria-label="$t('common.labels.kingakuStr') + $t('common.labels.taxincluded')">
                                        <span class="price"> {{formatPrice(item.SHOUKEI_IN_ZEI)}}円 </span>
                                    </td>
                                </template>
                                <!--税抜-->
                                <template v-else-if="sh060Init.priceShow != 1">
                                    <td class="cart-price" :aria-label="$t('common.labels.kingakuStr') + $t('common.labels.excludingtax')">
                                        <span class="price"> {{formatPrice(item.SHOUKEI)}}円 </span>
                                    </td>
                                </template>
                            </tr>
                            <!--定期追加商品情報-->
                            <tr  class="teikiInfo" v-if="sh060Init.teikiInfo && sh060Init.teikiInfo.length>0">
                                <th colspan="5"><span v-html="descriptionInfo[15]"></span></th>
                            </tr>
                            <tr v-for="(itm,index) in sh060Init.teikiInfo" :key="index">
                                <td>{{itm.S_ITEM_CD}}</td>
                                <td>
                                    <span class="teikiOndo" v-if="stringNvl(itm.ONDO_NM,'') != ''">【{{stringNvl(itm.ONDO_NM,'')}}】</span>
                                    {{itm.ITEM_NM}}
                                </td>
                                <td class="cart-price">
                                    <span v-if="sh060Init.orderInfo['TNK_DSP_KBN'] == '1'">{{formatPrice(itm.SALE_ZEI_K_TNK)}}円</span>
                                    <span v-else>{{formatPrice(itm.SALE_TNK)}}円</span>
                                </td>
                                <td style="text-align: right;">{{itm.QTY}}</td>
                                <td class="cart-price">
                                    <span class="price" v-if="sh060Init.orderInfo['TNK_DSP_KBN'] == '1'">{{formatPrice(itm.ITEMSUM_TAX_IN)}}円</span>
                                    <span class="price" v-else>{{formatPrice(itm.ITEMSUM_TAX_EX)}}円</span>
                                </td>
                            </tr>
                            <!--プロモ商品情報-->
                            <tr v-for="(itm,index) in sh060Init.promoInfo" :key="index">
                                <td>{{itm.M_ITEM_CD}}</td>
                                <td>{{itm.TOKU_ITEM_NM}}</td>
                                <td class="cart-price">
                                    <span>{{formatPrice(itm.DISP_TNK)}}円</span>
                                </td>
                                <td style="text-align: right;">{{itm.TOKU_ITEM_QTY}}</td>
                                <td class="cart-price">
                                    <span class="price">{{formatPrice(itm.DISP_SHOUKEI)}}円</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <!-- ポイント交換商品一覧 -->
                    <table class="mb32" v-if="sh060Init.pointInfo != null && sh060Init.pointInfo != ''">
                        <thead>
                            <tr>
                                <!-- 商品CD -->
                                <th class="w200">{{$t('common.labels.productCode')}}</th>
                                <!-- 商品名 -->
                                <th>{{$t('common.labels.productName')}}</th>
                                <!-- ポイント数 -->
                                <th class="w160">{{$t('pt460.labels.pointsu')}}</th>
                                <!-- 数量 -->
                                <th class="w80">{{$t('common.labels.quantity')}}</th>
                                <!-- 合計 -->
                                <th class="w160">{{$t('pt460.labels.pointkei')}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <!-- ポイント交換商品情報 -->
                            <tr v-for="(itm,index) in sh060Init.pointInfo" :key="index">
                                <td>{{itm.S_ITEM_CD}}</td>
                                <td>{{itm.ITEM_NM}}</td>
                                <td class="cart-price"><span>{{formatPrice(itm.RIYO_POINT)}}pt</span></td>
                                <td style="text-align: right;">{{formatPrice(itm.QTY)}}</td>
                                <td class="cart-price">
                                    <span class="price">{{formatPrice(itm.TOTAL_POINT)}}pt</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <!-- total -->
                    <div class="row" v-if="sh060Init.priceShow != 1">
                        <template>
                            <div class="ml-auto mr-0" v-if="sh060Init.taxDispFlg == 1 && hatchuCnt == 0">
                                <table class="personal shopping-total mb64">
                                    <tr v-if="sh060Init.orderInfo['TNK_DSP_KBN'] == '2' && sh060Init.totalTaxRt1Ex > 0">
                                        <th class="w200">
                                            <!-- 10%対象税抜計 -->
                                            {{$t('sh060.labels.totalTaxRt1TaxExTitle')}}
                                        </th>
                                        <td class="cart-price">
                                            <span>{{formatPrice(sh060Init.totalTaxRt1Ex)}}円</span>
                                        </td>
                                    </tr>
                                    <tr v-if="sh060Init.orderInfo['TNK_DSP_KBN'] == '1' && sh060Init.totalTaxRt1In > 0">
                                        <th class="w200">
                                            <!-- 10%対象税込計 -->
                                            {{$t('sh060.labels.totalTaxRt1TaxInTitle')}}
                                        </th>
                                        <td class="cart-price">
                                            <span>{{formatPrice(sh060Init.totalTaxRt1In)}}円</span>
                                        </td>
                                    </tr>
                                    <tr v-if="sh060Init.totalTaxRt1Tax > 0">
                                        <th class="w200" v-if="sh060Init.orderInfo['TNK_DSP_KBN'] == '1'">
                                            <!-- 10%内消費税 -->
                                            {{$t('sh060.labels.totalTaxRt1TaxTitle') + $t('common.labels.newConsumption')}}
                                        </th>
                                        <th v-else class="w200">
                                            <!-- 10%消費税 -->
                                            {{$t('sh060.labels.totalTaxRt1TaxTitle') + $t('common.labels.consumptionTax')}}
                                        </th>
                                        <td class="cart-price">
                                            <span v-if="sh060Init.orderInfo['TNK_DSP_KBN'] == '1'">({{formatPrice(sh060Init.totalTaxRt1Tax)}}円)</span>
                                            <span v-else>{{formatPrice(sh060Init.totalTaxRt1Tax)}}円</span>
                                        </td>
                                    </tr>

                                    <tr v-if="sh060Init.orderInfo['TNK_DSP_KBN'] == '2' && sh060Init.totalTaxRt2Ex > 0">
                                        <th class="w200">
                                            <!-- 8%対象税抜計 -->
                                            {{$t('sh060.labels.totalTaxRt2TaxExTitle')}}
                                        </th>
                                        <td class="cart-price">
                                            <span>{{formatPrice(sh060Init.totalTaxRt2Ex)}}円</span>
                                        </td>
                                    </tr>
                                    <tr v-if="sh060Init.orderInfo['TNK_DSP_KBN'] == '1' && sh060Init.totalTaxRt2In > 0">
                                        <th class="w200">
                                            <!-- 8%対象税込計 -->
                                            {{$t('sh060.labels.totalTaxRt2TaxInTitle')}}
                                        </th>
                                        <td class="cart-price">
                                            <span>{{formatPrice(sh060Init.totalTaxRt2In)}}円</span>
                                        </td>
                                    </tr>
                                    <tr v-if="sh060Init.totalTaxRt2Tax > 0">
                                        <th class="w200" v-if="sh060Init.orderInfo['TNK_DSP_KBN'] == '1'">
                                            <!-- 8%内消費税 -->
                                            {{$t('sh060.labels.totalTaxRt2TaxTitle') + $t('common.labels.newConsumption')}}
                                        </th>
                                        <th v-else class="w200">
                                            <!-- 8%消費税 -->
                                            {{$t('sh060.labels.totalTaxRt2TaxTitle') + $t('common.labels.consumptionTax')}}
                                        </th>
                                        <td class="cart-price">
                                            <span v-if="sh060Init.orderInfo['TNK_DSP_KBN'] == '1'">({{formatPrice(sh060Init.totalTaxRt2Tax)}}円)</span>
                                            <span v-else>{{formatPrice(sh060Init.totalTaxRt2Tax)}}円</span>
                                        </td>
                                    </tr>

                                    <tr v-if="sh060Init.totalTaxRt3Ex > 0">
                                        <th class="w200">
                                            <!-- 非課税対象計 -->
                                            {{$t('sh060.labels.totalTaxRt3Title')}}
                                        </th>
                                        <td class="cart-price">
                                            <span>{{formatPrice(sh060Init.totalTaxRt3Ex)}}円</span>
                                        </td>
                                    </tr>
                                </table>
                            </div>

                            <div class="ml-auto mr-0">
                                <h5 v-if="hatchuCnt > 0">{{$t('sh060.labels.hachuOncePayment')}}</h5>
                                <table class="personal shopping-total" summary="注文内容">
                                    <template v-if="sh060Init.orderInfo['TNK_DSP_KBN'] == '1'">
                                        <tr>
                                            <th class="w200">
                                                <!-- ご注文金額小計(税込) -->
                                                {{$t('sh060.labels.itemValueSubtotalin')}}
                                            </th>
                                            <td class="cart-price">
                                                <span class="">{{formatPrice(sh060Init.orderInfo['ITEMSUM_TAX_IN'])}}円</span>
                                            </td>
                                        </tr>
                                    </template>
                                    <template v-else>
                                        <tr>
                                            <th class="w200">
                                                {{$t('sh060.labels.itemValueSubtotalex')}}
                                            </th>
                                            <td class="cart-price">
                                                <span class="">{{formatPrice(sh060Init.orderInfo['ITEMSUM_TAX_EX'])}}円</span>
                                            </td>
                                        </tr>
                                    </template>
                                    <tr v-if="sh060Init.soryoTotal > 0">
                                        <th class="w200">
                                            <!-- 送料 -->
                                            {{$t('sh060.labels.shippingcost')}}
                                        </th>
                                        <td class="cart-price">
                                            <span class="">{{formatPrice(sh060Init.soryoTotal)}}円</span>
                                        </td>
                                    </tr>
                                    <tr v-if="sh060Init.daiTesuuKinTotal > 0">
                                        <th class="w200">
                                            <!-- 代引手数料 -->
                                            {{$t('sh060.labels.cod')}}
                                        </th>
                                        <td class="cart-price">
                                            <span class="">{{formatPrice(sh060Init.daiTesuuKinTotal)}}円</span>
                                        </td>
                                    </tr>

                                    <tr v-if="sh060Init.sonotaTesuuKDinTotal1 > 0">
                                        <th class="w200">
                                            <!-- 払込票手数料 -->
                                            {{$t('sh060.labels.paymentslipfee')}}
                                        </th>
                                        <td class="cart-price">
                                            <span class="">{{formatPrice(sh060Init.sonotaTesuuKDinTotal1)}}円</span>
                                        </td>
                                    </tr>
                                    <tr v-if="sh060Init.kessaiTesuKinTotal > 0">
                                        <th class="w200">
                                            <!-- 決済手数料 -->
                                            {{$t('sh060.labels.kessaiTesuTitle')}}
                                        </th>
                                        <td class="cart-price">
                                            <span class="">{{formatPrice(sh060Init.kessaiTesuKinTotal)}}円</span>
                                        </td>
                                    </tr>
                                    <tr v-if="sh060Init.kinTypeUketoriServiceFlg == '1' && sh060Init.sonotaTesuuKDinTotal2 != '0'">
                                        <th class="w200">
                                            <!-- 受取サービス手数料 -->
                                            {{$t('sh060.labels.receivingservicefee')}}
                                        </th>
                                        <td class="cart-price">
                                            <span class="">{{formatPrice(sh060Init.sonotaTesuuKDinTotal2)}}円</span>
                                        </td>
                                    </tr>
                                    <tr v-if="stringNvl(sh060Init.promoKin,'0') != '0' && hatchuCnt == 0">
                                        <th class="w200">
                                            <!-- キャンペーン値引 -->
                                            {{$t('sh060.labels.campaigndiscount')}}
                                        </th>
                                        <td class="cart-price">
                                            <span class="price">-{{formatPrice(sh060Init.promoKin)}}円</span>
                                        </td>
                                    </tr>
                                    <tr v-if="stringNvl(sh060Init.matomeWaribikiKin,'0') != '0' && hatchuCnt == 0">
                                        <th class="w200">
                                            <!-- まとめ買い割引金 -->
                                            {{$t('sh060.labels.matomeWaribiki')}}
                                        </th>
                                        <td class="cart-price">
                                            <span class="price">-{{formatPrice(sh060Init.matomeWaribikiKin)}}円</span>
                                        </td>
                                    </tr>
                                    <tr v-if="sh060Init.cupponNebikiKin > 0 && hatchuCnt == 0">
                                        <th class="w200">
                                            <!-- クッポン減額 -->
                                            {{$t('sh060.labels.orderCouSettArea').replace('：','')}}
                                        </th>
                                        <td class="cart-price">
                                            <span class="price">-{{formatPrice(sh060Init.cupponNebikiKin)}}円</span>
                                        </td>
                                    </tr>
                                    <tr v-if="stringNvl(sh060Init.pointKin,'0') != '0' && sh060Init.homerUseFlg == 0 && hatchuCnt == 0">
                                        <th class="w200">
                                            <!-- 利用ポイント-->
                                            {{$t('sh060.labels.pointstousethistime')}}
                                        </th>
                                        <td class="cart-price">
                                            <span class="price">-{{formatPrice(sh060Init.pointKin)}}{{$t("sh050.labels.pt")}}</span>
                                        </td>
                                    </tr>
                                    <!--消費税-->
                                    <tr v-if="sh060Init.orderInfo['TNK_DSP_KBN'] == '2'">
                                        <!-- 消費税：税抜表示時 -->
                                        <th class="w200">
                                            {{$t('common.labels.consumptionTax')}}
                                        </th>
                                        <td class="cart-price">
                                            <span v-if="hatchuCnt == 0">{{formatPrice(sh060Init.totalTaxRt1Tax + sh060Init.totalTaxRt2Tax)}}円</span>
                                            <span v-else>{{formatPrice(sh060Init.orderInfo['TOTAL_SEIKYU_TAX'])}}円</span>
                                        </td>
                                    </tr>
                                    <tr v-if="sh060Init.orderInfo['TNK_DSP_KBN'] == '1'">
                                        <th class="w200">
                                        <!-- 消費税：税込表示時 -->
                                            {{$t('common.labels.newConsumption')}}
                                        </th>
                                        <td class="cart-price">
                                            <span v-if="hatchuCnt == 0">({{formatPrice(sh060Init.totalTaxRt1Tax + sh060Init.totalTaxRt2Tax)}}円)</span>
                                            <span v-else>({{formatPrice(sh060Init.orderInfo['TOTAL_SEIKYU_TAX'])}}円)</span>
                                        </td>
                                    </tr>

                                    <tr v-if="sh060Init.orderInfo['KESSAI_CD'] != '6' && sh060Init.seikyuuKinDispFlg == 1 && hatchuCnt == 0">
                                        <th class="w200">
                                            <!-- ご請求金額（税込） -->
                                            {{$t('sh060.labels.billedamount(taxincluded)')}}
                                        </th>
                                        <td class="cart-price">
                                            <span class="price">{{formatPrice(sh060Init.seikyuuKin)}}円</span>
                                        </td>
                                    </tr>
                                    <tr v-if="sh060Init.orderInfo['KESSAI_CD'] != '6' && sh060Init.seikyuuKinDispFlg == 1 && hatchuCnt > 0">
                                        <th class="w200">
                                            <!-- ご請求金額（税込） -->
                                            {{$t('sh060.labels.orderamountsubtotal(taxincluded)')}}
                                        </th>
                                        <td class="cart-price">
                                            <span class="price">{{formatPrice(sh060Init.orderInfo['TOTAL_SEIKYU_TAX_IN'])}}円</span>
                                        </td>
                                    </tr>

                                </table>
                                <!-- 項目説明マスタ[12] -->
                                <div class="ml-auto mr-0 hachuDescriptionMiddle01 mb64 text-left" v-if="descriptionInfo[12] != '' && hatchuCnt > 0">
                                    <span v-html="descriptionInfo[12]"></span>
                                </div>
                                <!-- 獲得ポイント数:XXXXpt(合計) -->
                                <div class="text-right mb64 row d-flex justify-content-end  pt-2" v-if="sh060Init.totalGivenPointNum > 0 && sh060Init.givenPointFlg == '1' && hatchuCnt == 0">
                                    <div class="givenPointTitle">{{$t('sh060.labels.totalGivenPointNumTitle')}}:</div>
                                    <div class="givenPointNum">{{formatPrice(sh060Init.totalGivenPointNum)}}</div>
                                    <div class="givenPointPT">pt</div>
                                </div>
                            </div>

                            <!-- お支払総額（自動発注時） -->
                            <div class="ml-auto mr-0 hachuSumPayment mb05" v-if="hatchuCnt > 0">
                                <h5>{{$t('sh060.labels.hachuSumPayment[0]')}}
                                        {{$t('sh060.labels.hachuSumPayment[1]')}}{{$t('sh060.labels.hachuSumPayment[2]')}}{{hatchuCnt}}{{$t('sh060.labels.hachuSumPayment[3]')}}{{$t('sh060.labels.hachuSumPayment[4]')}}</h5>
                                <table class="personal shopping-total mb16" summary="ご請求金額合計1">
                                    <template v-if="sh060Init.orderInfo['TNK_DSP_KBN'] == '1'">
                                        <tr>
                                            <th class="w200">
                                                <!-- ご注文金額小計(税込) -->
                                                {{$t('sh060.labels.itemValueSubtotalin')}}
                                            </th>
                                            <td class="cart-price">
                                                <span class="">{{formatPrice(sh060Init.orderInfo['ITEMSUM_TAX_IN'] * hatchuCnt)}}円</span>
                                            </td>
                                        </tr>
                                    </template>
                                    <template v-else>
                                        <tr>
                                            <th class="w200">
                                                {{$t('sh060.labels.itemValueSubtotalex')}}
                                            </th>
                                            <td class="cart-price">
                                                <span class="">{{formatPrice(sh060Init.orderInfo['ITEMSUM_TAX_EX']  * hatchuCnt)}}円</span>
                                            </td>
                                        </tr>
                                    </template>

                                    <tr v-if="sh060Init.orderInfo['TNK_DSP_KBN'] == '2'">
                                        <!-- 消費税：税抜表示時 -->
                                        <th class="w200">
                                            {{$t('common.labels.consumptionTax')}}
                                        </th>
                                        <td class="cart-price">
                                            <span>{{formatPrice(sh060Init.orderInfo['TOTAL_SEIKYU_TAX']  * hatchuCnt)}}円</span>
                                        </td>
                                    </tr>
                                    <tr v-if="sh060Init.orderInfo['TNK_DSP_KBN'] == '1'">
                                        <th class="w200">
                                        <!-- 消費税：税込表示時 -->
                                            {{$t('common.labels.newConsumption')}}
                                        </th>
                                        <td class="cart-price">
                                            <span>({{formatPrice(sh060Init.orderInfo['TOTAL_SEIKYU_TAX']  * hatchuCnt)}}円)</span>
                                        </td>
                                    </tr>
                                    <tr v-if="sh060Init.soryoTotal > 0">
                                        <th class="w200">
                                            <!-- 送料 -->
                                            {{$t('sh060.labels.shippingcost')}}
                                        </th>
                                        <td class="cart-price">
                                            <span class="">{{formatPrice(sh060Init.soryoTotal * hatchuCnt)}}円</span>
                                        </td>
                                    </tr>

                                    <tr v-if="sh060Init.daiTesuuKinTotal > 0">
                                        <th class="w200">
                                            <!-- 代引手数料 -->
                                            {{$t('common.labels.circleMarkB')}}{{$t('sh060.labels.cod')}}
                                        </th>
                                        <td class="cart-price">
                                            <span class="">{{formatPrice(sh060Init.daiTesuuKinTotal * hatchuCnt)}}円</span>
                                        </td>
                                    </tr>

                                    <tr v-if="sh060Init.sonotaTesuuKDinTotal1 > 0">
                                        <th class="w200">
                                            <!-- 払込票手数料 -->
                                            {{$t('common.labels.circleMarkB')}}{{$t('sh060.labels.paymentslipfee')}}
                                        </th>
                                        <td class="cart-price">
                                            <span class="">{{formatPrice(sh060Init.sonotaTesuuKDinTotal1) * hatchuCnt}}円</span>
                                        </td>
                                    </tr>
                                    <tr v-if="sh060Init.kessaiTesuKinTotal > 0">
                                        <th class="w200">
                                            <!-- 決済手数料 -->
                                            {{$t('common.labels.circleMarkB')}}{{$t('sh060.labels.kessaiTesuTitle')}}
                                        </th>
                                        <td class="cart-price">
                                            <span class="">{{formatPrice(sh060Init.kessaiTesuKinTotal * hatchuCnt)}}円</span>
                                        </td>
                                    </tr>
                                    <tr v-if="sh060Init.kinTypeUketoriServiceFlg == '1' && sh060Init.sonotaTesuuKDinTotal2 != '0'">
                                        <th class="w200">
                                            <!-- 受取サービス手数料 -->
                                            {{$t('common.labels.circleMarkB')}}{{$t('sh060.labels.receivingservicefee')}}
                                        </th>
                                        <td class="cart-price">
                                            <span class="">{{formatPrice(sh060Init.sonotaTesuuKDinTotal2 * hatchuCnt)}}円</span>
                                        </td>
                                    </tr>
                                    <tr v-if="stringNvl(sh060Init.promoKin,'0') != '0'">
                                        <th class="w200">
                                            <!-- キャンペーン値引 -->
                                            {{$t('common.labels.komeMark')}}{{$t('sh060.labels.campaigndiscount')}}
                                        </th>
                                        <td class="cart-price">
                                            <span class="price">-{{formatPrice(sh060Init.promoKin * hatchuCnt)}}円</span>
                                        </td>
                                    </tr>
                                    <tr v-if="stringNvl(sh060Init.matomeWaribikiKin,'0') != '0'">
                                        <th class="w200">
                                            <!-- まとめ買い割引金 -->
                                            {{$t('common.labels.komeMark')}}{{$t('sh060.labels.matomeWaribiki')}}
                                        </th>
                                        <td class="cart-price">
                                            <span class="price">-{{formatPrice(sh060Init.matomeWaribikiKin * hatchuCnt)}}円</span>
                                        </td>
                                    </tr>
                                    <tr v-if="sh060Init.cupponNebikiKin > 0">
                                        <th class="w200">
                                            <!-- クッポン減額 -->
                                            {{$t('common.labels.komeMark')}}{{$t('sh060.labels.orderCouSettArea').replace('：','')}}
                                        </th>
                                        <td class="cart-price">
                                            <span class="price">-{{formatPrice(sh060Init.cupponNebikiKin * hatchuCnt)}}円</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th class="w200">
                                            <!-- 自動発注合計 -->
                                            {{$t('sh060.labels.hachuValueSubtotal')}}
                                        </th>
                                        <td class="cart-price">
                                            <span class="">{{formatPrice(hatchuKin*hatchuCnt)}}円</span>
                                        </td>
                                    </tr>
                                </table>
                                <table class="personal shopping-total " summary="ご請求金額合計2">
                                    <tr v-if="stringNvl(sh060Init.orderInfo['TOTAL_POINT_KIN'],'0') != '0' && sh060Init.homerUseFlg == 0">
                                        <th class="w200">
                                            <!-- 合計ご利用ポイント-->
                                            {{$t('common.labels.komeMark')}}{{$t('sh060.labels.pointstouseSum')}}
                                        </th>
                                        <td class="cart-price">
                                            <span class="price">-{{formatPrice(sh060Init.orderInfo['TOTAL_POINT_KIN'])}}{{$t("sh050.labels.pt")}}</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th class="w200">
                                            <!-- ご請求金額合計（税込） -->
                                            {{$t('sh060.labels.totalSeikyuKinTitle') + $t('sh060.labels.taxincluded')}}
                                        </th>
                                        <td class="cart-price">
                                            <span class="price">{{formatPrice(totalSeikyuKin)}}円</span>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <!-- 項目説明マスタ[13] -->
                            <div class="ml-auto mr-0 hachuDescriptionBottom mb64 text-left" v-if="descriptionInfo[13] != '' && hatchuCnt > 0">
                                <span v-html="descriptionInfo[13]"></span>
                            </div>
                        </template>
                    </div>
                    <!-- 定期購入概要 -->
                    <div v-if="sh060Init.teikiFlg==1" class="teikiInfo ml-auto mr-0">
                        <h4 class="teikiInfoTitle">
                            {{$t('sh060.labels.teikiInfo')}}
                        </h4>
                        <!-- 項目説明マスタ[9] -->
                        <div class="teikiDescriptionTop mb64" v-if="descriptionInfo[9] != ''">
                            <span v-html="descriptionInfo[9]"></span>
                        </div>
                        <!-- お届け日間隔指定 -->
                        <table v-if="sh060Init.teikiKbn == '2'" class="mb64 teikiShipinfo personal" summary="定期購入概要">
                            <!--お届け間隔 -->                            
                            <tr>
                                <th class="w200">{{$t('sh060.labels.teikiShipLead')}}</th>
                                <td colspan="4">
                                    <div class="teikiTdkLead">
                                        <span class="mr-3">
                                            <select name="hopeDay" id="hopeDay" class="hopeDay" v-model="sh060Request.hopeDay" @change="resetTeiki()">
                                                <option v-for="day in sh060Init.tdkYmdList" :value="day.KEY" :key="day.KEY" >{{replaceCharacters(day.VALUE)}}</option>
                                            </select>
                                            <span class="teikiShipLeadSet1">{{$t('sh060.labels.teikiShipLeadSet[0]')}}</span>
                                            <select name="hopeDayCnt" id="hopeDayCnt" class="hopeDayCnt" v-model="sh060Request.hopeDayCnt" @change="resetTeiki()">
                                                <option v-for="cnt in sh060Init.hopeDayCntList" :value="cnt.KEY" :key="cnt.KEY" >{{cnt.VALUE}}</option>
                                            </select>
                                            <span class="teikiShipLeadSet2">{{$t('sh060.labels.teikiShipLeadSet[3]')}}</span>
                                            <span class="teikiShipLeadSet3">{{$t('sh060.labels.teikiShipLeadSet[4]')}}</span>
                                        </span>
                                        <input class="teikiShipCheck submit-button" type="submit" @click="teikiShipCheck()" :value="$t('sh060.buttons.teikiShipCheck')">
                                        <span class="teikiShipCheckErr text-danger" v-if="teikiShipCheckErr">{{$t('sh060.labels.teikiShipCheckErr')}}</span>
                                    </div>
                                </td>
                            </tr>
                            <!-- 直近のお届け日 カレンダー -->
                            <tr>
                                <th class="w200" rowspan="2">{{$t('sh060.labels.teikiShipSoon')}}</th>
                                <td colspan="4">
                                    <div class="mb32">
                                        <div v-for="(tdkMonth, tmIndex) in teikiMonths" :key="'tm_' + tmIndex" class="row" style="margin: 0 -15px -15px 0 !important;">
                                            <div class="dt-col">
                                                <div>{{tdkMonth.monthNm}}</div>
                                                <div class="dt-table">
                                                    <div class="dt-row">
                                                        <div class="dt-cell sunDay">日</div>
                                                        <div class="dt-cell">月</div>
                                                        <div class="dt-cell">火</div>
                                                        <div class="dt-cell">水</div>
                                                        <div class="dt-cell">木</div>
                                                        <div class="dt-cell">金</div>
                                                        <div class="dt-cell saturDay">土</div>
                                                    </div>
                                                    
                                                    <div class="dt-row" v-for="(week, wIndex) in tdkMonth.weeks" :key="'w_' + wIndex">
                                                        <div class="dt-cell" v-for="(day, dIndex) in week" :key="dIndex" 
                                                            v-bind:class="calendarColor(day)">
                                                            <span>{{(day && day.val) ? day.text : ''}}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <p id="teikiShipColor"><span class="firstDay">&emsp;</span>{{$t('common.labels.3dotLeader')}}{{$t('sh060.labels.teikiShipFirst')}}&emsp;<span class="nextDay">&emsp;</span>{{$t('common.labels.3dotLeader')}}{{$t('sh060.labels.teikiShipAfter')}}</p>
                                </td>
                            </tr>
                            <!-- 直近のお届け日 日程 -->
                            <tr>
                                <th class="w200 teikiShipFirstH firstDay">{{$t('sh060.labels.teikiShipFirst')}}</th>
                                <td class="w200 teikiShipFirstD">{{teikiFirstDay}}</td>
                                <th class="w200 teikiShipSecondH nextDay">{{$t('sh060.labels.teikiShipSecond')}}</th>
                                <td class="w200 teikiShipSecondD">{{teikiNextDay}}</td>
                            </tr>
                        </table>
                        <div class="row teikiPayment">
                            <template>
                                <div class="ml-auto mr-0 teikiFirstPayment mb05">
                                    <h5>{{$t('sh060.labels.teikiFirstPayment')}}</h5>
                                    <table class="personal shopping-total" summary="初回お支払い金額">
                                        <template v-if="sh060Init.orderInfo['TNK_DSP_KBN'] == '1'">
                                            <tr>
                                                <th class="w200">
                                                    <!-- ご注文金額小計(税込) -->
                                                    {{$t('sh060.labels.itemValueSubtotalin')}}
                                                </th>
                                                <td class="cart-price">
                                                    <span class="">{{formatPrice(sh060Init.teikiIn)}}円</span>
                                                </td>
                                            </tr>
                                        </template>
                                        <template v-else>
                                            <tr>
                                                <th class="w200">
                                                    {{$t('sh060.labels.itemValueSubtotalex')}}
                                                </th>
                                                <td class="cart-price">
                                                    <span class="">{{formatPrice(sh060Init.teikiEx)}}円</span>
                                                </td>
                                            </tr>
                                        </template>

                                        
                                        <template v-if="sh060Init.orderInfo['TNK_DSP_KBN'] == '1'">
                                            <tr v-if="sh060Init.teikiSoryoKin > 0">
                                                <th class="w200">
                                                    <!-- 送料 -->
                                                    {{$t('sh060.labels.shippingcost')}}
                                                </th>
                                                <td class="cart-price">
                                                    <span class="">{{formatPrice(sh060Init.teikiSoryoKin)}}円</span>
                                                </td>
                                            </tr>
                                        </template>
                                        <template v-else>
                                            <tr v-if="sh060Init.teikiSoryoKinEx > 0">
                                                <th class="w200">
                                                    <!-- 送料 -->
                                                    {{$t('sh060.labels.shippingcost')}}
                                                </th>
                                                <td class="cart-price">
                                                    <span class="">{{formatPrice(sh060Init.teikiSoryoKinEx)}}円</span>
                                                </td>
                                            </tr>
                                        </template>
                                        <template v-if="sh060Init.orderInfo['TNK_DSP_KBN'] == '1'">
                                            <tr v-if="sh060Init.teikiDaiTesuKin > 0">
                                                <th class="w200">
                                                    <!-- 代引手数料 -->
                                                    {{$t('sh060.labels.cod')}}
                                                </th>
                                                <td class="cart-price">
                                                    <span class="">{{formatPrice(sh060Init.teikiDaiTesuKin)}}円</span>
                                                </td>
                                            </tr>
                                        </template>
                                        <template v-else>
                                            <tr v-if="sh060Init.teikiDaiTesuKinEx > 0">
                                                <th class="w200">
                                                    <!-- 代引手数料 -->
                                                    {{$t('sh060.labels.cod')}}
                                                </th>
                                                <td class="cart-price">
                                                    <span class="">{{formatPrice(sh060Init.teikiDaiTesuKinEx)}}円</span>
                                                </td>
                                            </tr>
                                        </template>
                                        
                                        <template v-if="sh060Init.orderInfo['TNK_DSP_KBN'] == '1'">
                                            <tr v-if="sh060Init.teikiHaraiTesuKin > 0">
                                                <th class="w200">
                                                    <!-- 払込票手数料 -->
                                                    {{$t('sh060.labels.paymentslipfee')}}
                                                </th>
                                                <td class="cart-price">
                                                    <span class="">{{formatPrice(sh060Init.teikiHaraiTesuKin)}}円</span>
                                                </td>
                                            </tr>
                                        </template>
                                        <template v-else>
                                            <tr v-if="sh060Init.teikiHaraiTesuKinEx > 0">
                                                <th class="w200">
                                                    <!-- 払込票手数料 -->
                                                    {{$t('sh060.labels.paymentslipfee')}}
                                                </th>
                                                <td class="cart-price">
                                                    <span class="">{{formatPrice(sh060Init.teikiHaraiTesuKinEx)}}円</span>
                                                </td>
                                            </tr>
                                        </template>
                                        
                                        <template v-if="sh060Init.orderInfo['TNK_DSP_KBN'] == '1'">
                                            <tr v-if="sh060Init.teikiKessaiTesuKin > 0">
                                                <th class="w200">
                                                    <!-- 決済手数料 -->
                                                    {{$t('sh060.labels.kessaiTesuTitle')}}
                                                </th>
                                                <td class="cart-price">
                                                    <span class="">{{formatPrice(sh060Init.teikiKessaiTesuKin)}}円</span>
                                                </td>
                                            </tr>
                                        </template>
                                        <template v-else>
                                            <tr v-if="sh060Init.teikiKessaiTesuKinEx > 0">
                                                <th class="w200">
                                                    <!-- 決済手数料 -->
                                                    {{$t('sh060.labels.kessaiTesuTitle')}}
                                                </th>
                                                <td class="cart-price">
                                                    <span class="">{{formatPrice(sh060Init.teikiKessaiTesuKinEx)}}円</span>
                                                </td>
                                            </tr>
                                        </template>
                                        
                                        <template v-if="sh060Init.orderInfo['TNK_DSP_KBN'] == '1'">
                                            <tr v-if="sh060Init.kinTypeUketoriServiceFlg == '1' && sh060Init.teikiUketoriTesuKin != '0'">
                                                <th class="w200">
                                                    <!-- 受取サービス手数料 -->
                                                    {{$t('sh060.labels.receivingservicefee')}}
                                                </th>
                                                <td class="cart-price">
                                                    <span class="">{{formatPrice(sh060Init.teikiUketoriTesuKin)}}円</span>
                                                </td>
                                            </tr>
                                        </template>
                                        <template v-else>
                                            <tr v-if="sh060Init.kinTypeUketoriServiceFlg == '1' && sh060Init.teikiUketoriTesuKinEx != '0'">
                                                <th class="w200">
                                                    <!-- 受取サービス手数料 -->
                                                    {{$t('sh060.labels.receivingservicefee')}}
                                                </th>
                                                <td class="cart-price">
                                                    <span class="">{{formatPrice(sh060Init.teikiUketoriTesuKinEx)}}円</span>
                                                </td>
                                            </tr>
                                        </template>
                                        <tr v-if="sh060Init.orderInfo['TNK_DSP_KBN'] == '1'">
                                            <th class="w200">
                                            <!-- 消費税：税込表示時 -->
                                                {{$t('common.labels.newConsumption')}}
                                            </th>
                                            <td class="cart-price">
                                                <span>({{formatPrice(sh060Init.teikiZei)}}円)</span>
                                            </td>
                                        </tr>
                                        <tr v-if="sh060Init.orderInfo['TNK_DSP_KBN'] == '2'">
                                            <!-- 消費税：税抜表示時 -->
                                            <th class="w200">
                                                {{$t('common.labels.consumptionTax')}}
                                            </th>
                                            <td class="cart-price">
                                                <span>{{formatPrice(sh060Init.teikiZei)}}円</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th class="w200">
                                                <!-- ご請求金額（税込） -->
                                                {{$t('sh060.labels.billedamount(taxincluded)')}}
                                            </th>
                                            <td class="cart-price">
                                                <span v-if="sh060Init.orderInfo['TNK_DSP_KBN'] == '1'" class="price">{{formatPrice(sh060Init.teikiSeikyuIn)}}円</span>
                                                <span v-else class="price">{{formatPrice(sh060Init.teikiSeikyuEx)}}円</span>
                                                <!-- <span class="price">{{formatPrice(sh060Init.seikyuuKin)}}円ご請求金額（税込）</span> -->
                                            </td>
                                        </tr>
                                    </table>
                                    <!-- 今回獲得ポイント数:XXXXpt(定期_初回) -->
                                    <div class="text-right mb64 row d-flex justify-content-end  pt-2" v-if="sh060Init.teikiPointFuyoKin > 0 && sh060Init.givenPointFlg == '1' ">
                                        <div class="givenPointTeikiFirstTitle">{{$t('sh060.labels.totalGivenPointNumTitle')}}:</div>
                                        <div class="givenPointTeikiFirstNum">{{formatPrice(sh060Init.teikiPointFuyoKin)}}</div>
                                        <div class="givenPointTeikiFirstPT">pt</div>
                                    </div>
                                </div>

                                <div class="ml-auto mr-0 teikiAllPayment mb05">
                                    <h5>{{$t('sh060.labels.teikiAllPayment[0]')}}
                                        {{$t('sh060.labels.teikiAllPayment[1]')}}{{sh060Init.teikiKeizokuEx}}{{$t('sh060.labels.teikiAllPayment[2]')}}{{$t('sh060.labels.teikiAllPayment[3]')}}</h5>
                                    <table class="personal shopping-total" summary="定期購入額">
                                        <template v-if="sh060Init.orderInfo['TNK_DSP_KBN'] == '1'">
                                            <tr>
                                                <th class="w200">
                                                    <!-- ご注文金額小計(税込) -->
                                                    {{$t('sh060.labels.itemValueSubtotalin')}}
                                                </th>
                                                <td class="cart-price">
                                                    <span class="">{{formatPrice(sh060Init.teikiTotalIn)}}円</span>
                                                </td>
                                            </tr>
                                        </template>
                                        <template v-else>
                                            <tr>
                                                <th class="w200">
                                                    {{$t('sh060.labels.itemValueSubtotalex')}}
                                                </th>
                                                <td class="cart-price">
                                                    <span class="">{{formatPrice(sh060Init.teikiTotalEx)}}円</span>
                                                </td>
                                            </tr>
                                        </template>

                                        <template v-if="sh060Init.orderInfo['TNK_DSP_KBN'] == '1'" >
                                            <tr v-if="sh060Init.teikiTotalSoryoKin > 0">
                                                <th class="w200">
                                                    <!-- 送料 -->
                                                    {{$t('sh060.labels.shippingcost')}}
                                                </th>
                                                <td class="cart-price">
                                                    <span class="">{{formatPrice(sh060Init.teikiTotalSoryoKin)}}円</span>
                                                </td>
                                            </tr>
                                        </template>
                                        <template v-else>
                                            <tr v-if="sh060Init.teikiTotalSoryoKinEx > 0">
                                                <th class="w200">
                                                    <!-- 送料 -->
                                                    {{$t('sh060.labels.shippingcost')}}
                                                </th>
                                                <td class="cart-price">
                                                    <span class="">{{formatPrice(sh060Init.teikiTotalSoryoKinEx)}}円</span>
                                                </td>
                                            </tr>
                                        </template>
                                       
                                        <template v-if="sh060Init.orderInfo['TNK_DSP_KBN'] == '1'">
                                            <tr v-if="sh060Init.teikiTotalDaiTesuKin > 0">
                                                <th class="w200">
                                                    <!-- 代引手数料 -->
                                                    {{$t('sh060.labels.cod')}}
                                                </th>
                                                <td class="cart-price">
                                                    <span class="">{{formatPrice(sh060Init.teikiTotalDaiTesuKin)}}円</span>
                                                </td>
                                            </tr>
                                        </template>
                                        <template v-else>
                                            <tr v-if="sh060Init.teikiTotalDaiTesuKinEx > 0">
                                                <th class="w200">
                                                    <!-- 代引手数料 -->
                                                    {{$t('sh060.labels.cod')}}
                                                </th>
                                                <td class="cart-price">
                                                    <span class="">{{formatPrice(sh060Init.teikiTotalDaiTesuKinEx)}}円</span>
                                                </td>
                                            </tr>
                                        </template>
                                        <template v-if="sh060Init.orderInfo['TNK_DSP_KBN'] == '1'">
                                            <tr v-if="sh060Init.teikiTotalHaraiTesuKin > 0">
                                                <th class="w200">
                                                    <!-- 払込票手数料 -->
                                                    {{$t('sh060.labels.paymentslipfee')}}
                                                </th>
                                                <td class="cart-price">
                                                    <span class="">{{formatPrice(sh060Init.teikiTotalHaraiTesuKin)}}円</span>
                                                </td>
                                            </tr>
                                        </template>
                                        <template v-else>
                                            <tr v-if="sh060Init.teikiTotalHaraiTesuKinEx > 0">
                                                <th class="w200">
                                                    <!-- 払込票手数料 -->
                                                    {{$t('sh060.labels.paymentslipfee')}}
                                                </th>
                                                <td class="cart-price">
                                                    <span class="">{{formatPrice(sh060Init.teikiTotalHaraiTesuKinEx)}}円</span>
                                                </td>
                                            </tr>
                                        </template>
                                        <template v-if="sh060Init.orderInfo['TNK_DSP_KBN'] == '1'">
                                            <tr v-if="sh060Init.teikiTotalKessaiTesuKin > 0">
                                                <th class="w200">
                                                    <!-- 決済手数料 -->
                                                    {{$t('sh060.labels.kessaiTesuTitle')}}
                                                </th>
                                                <td class="cart-price">
                                                    <span class="">{{formatPrice(sh060Init.teikiTotalKessaiTesuKin)}}円</span>
                                                </td>
                                            </tr>
                                        </template>
                                        <template v-else>
                                            <tr v-if="sh060Init.teikiTotalKessaiTesuKinEx > 0">
                                                <th class="w200">
                                                    <!-- 決済手数料 -->
                                                    {{$t('sh060.labels.kessaiTesuTitle')}}
                                                </th>
                                                <td class="cart-price">
                                                    <span class="">{{formatPrice(sh060Init.teikiTotalKessaiTesuKinEx)}}円</span>
                                                </td>
                                            </tr>
                                        </template>
                                        <template v-if="sh060Init.orderInfo['TNK_DSP_KBN'] == '1'">
                                            <tr v-if="sh060Init.kinTypeUketoriServiceFlg == '1' && sh060Init.teikiTotalUketoriTesuKin != '0'">
                                                <th class="w200">
                                                    <!-- 受取サービス手数料 -->
                                                    {{$t('sh060.labels.receivingservicefee')}}
                                                </th>
                                                <td class="cart-price">
                                                    <span class="">{{formatPrice(sh060Init.teikiTotalUketoriTesuKin)}}円</span>
                                                </td>
                                            </tr>
                                        </template>
                                        <template v-else>
                                            <tr v-if="sh060Init.kinTypeUketoriServiceFlg == '1' && sh060Init.teikiTotalUketoriTesuKinEx != '0'">
                                                <th class="w200">
                                                    <!-- 受取サービス手数料 -->
                                                    {{$t('sh060.labels.receivingservicefee')}}
                                                </th>
                                                <td class="cart-price">
                                                    <span class="">{{formatPrice(sh060Init.teikiTotalUketoriTesuKiEx)}}円</span>
                                                </td>
                                            </tr>
                                        </template>
                                        <tr v-if="sh060Init.orderInfo['TNK_DSP_KBN'] == '1'">
                                            <th class="w200">
                                            <!-- 消費税：税込表示時 -->
                                                {{$t('common.labels.newConsumption')}}
                                            </th>
                                            <td class="cart-price">
                                                <span>({{formatPrice(sh060Init.teikiTotalZei)}}円)</span>
                                            </td>
                                        </tr>
                                        <tr v-if="sh060Init.orderInfo['TNK_DSP_KBN'] == '2'">
                                            <!-- 消費税：税抜表示時 -->
                                            <th class="w200">
                                                {{$t('common.labels.consumptionTax')}}
                                            </th>
                                            <td class="cart-price">
                                                <span>{{formatPrice(sh060Init.teikiTotalZei)}}円</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th class="w200">
                                                <!-- ご請求金額（税込） -->
                                                {{$t('sh060.labels.billedamount(taxincluded)')}}
                                            </th>
                                            <td class="cart-price">
                                                <span v-if="sh060Init.orderInfo['TNK_DSP_KBN'] == '1'" class="price">{{formatPrice(sh060Init.teikiSeikyuTotalIn)}}円</span>
                                                <span v-else class="price">{{formatPrice(sh060Init.teikiSeikyuTotalEx)}}円</span>
                                            </td>
                                        </tr>
                                    </table>
                                    <!-- 全部獲得ポイント数:XXXXpt(定期_合計) -->
                                    <div class="text-right mb64 row d-flex justify-content-end  pt-2" v-if="sh060Init.teikiPointFuyoTotalKin > 0 && sh060Init.givenPointFlg == '1' ">
                                        <div class="givenPointTeikiSumTitle">{{$t('sh060.labels.totalGivenPointNumALLTitle')}}:</div>
                                        <div class="givenPointTeikiSumNum">{{formatPrice(sh060Init.teikiPointFuyoTotalKin)}}</div>
                                        <div class="givenPointTeikiSumPT">pt</div>
                                    </div>
                                </div>
                                <!-- 項目説明マスタ[10] -->
                                <div class="ml-auto mr-0 teikiDescriptionBottom mb64 text-left" v-if="descriptionInfo[10] != ''">
                                    <span v-html="descriptionInfo[10]"></span>
                                </div>
                            </template>
                        </div>
                    </div>
                    <!-- 自動発注 今回請求額 -->
                    <div v-if="hatchuCnt > 0" class="hachuInfo ml-auto mr-0">
                        <h4 class="hachuInfoTitleFirst">
                            {{$t('sh060.labels.hachuFirstPayment')}}
                        </h4>
                        <div class="row hachuPayment">
                            <template>
                                <div class="ml-auto mr-0 hachuFirstPayment mb05">
                                    <table class="personal shopping-total">
                                        <tr v-if="sh060Init.orderInfo['TNK_DSP_KBN'] == '2' && sh060Init.totalTaxRt1Ex > 0">
                                            <th class="w200">
                                                <!-- 10%対象税抜計 -->
                                                {{$t('sh060.labels.totalTaxRt1TaxExTitle')}}
                                            </th>
                                            <td class="cart-price">
                                                <span>{{formatPrice(sh060Init.totalTaxRt1Ex)}}円</span>
                                            </td>
                                        </tr>
                                        <tr v-if="sh060Init.orderInfo['TNK_DSP_KBN'] == '1' && sh060Init.totalTaxRt1In > 0">
                                            <th class="w200">
                                                <!-- 10%対象税込計 -->
                                                {{$t('sh060.labels.totalTaxRt1TaxInTitle')}}
                                            </th>
                                            <td class="cart-price">
                                                <span>{{formatPrice(sh060Init.totalTaxRt1In)}}円</span>
                                            </td>
                                        </tr>
                                        <tr v-if="sh060Init.totalTaxRt1Tax > 0">
                                            <th class="w200" v-if="sh060Init.orderInfo['TNK_DSP_KBN'] == '1'">
                                                <!-- 10%内消費税 -->
                                                {{$t('sh060.labels.totalTaxRt1TaxTitle') + $t('common.labels.newConsumption')}}
                                            </th>
                                            <th v-else class="w200">
                                                <!-- 10%消費税 -->
                                                {{$t('sh060.labels.totalTaxRt1TaxTitle') + $t('common.labels.consumptionTax')}}
                                            </th>
                                            <td class="cart-price">
                                                <span v-if="sh060Init.orderInfo['TNK_DSP_KBN'] == '1'">({{formatPrice(sh060Init.totalTaxRt1Tax)}}円)</span>
                                                <span v-else>{{formatPrice(sh060Init.totalTaxRt1Tax)}}円</span>
                                            </td>
                                        </tr>
                                        <tr v-if="sh060Init.orderInfo['TNK_DSP_KBN'] == '2' && sh060Init.totalTaxRt2Ex > 0">
                                            <th class="w200">
                                                <!-- 8%対象税抜計 -->
                                                {{$t('sh060.labels.totalTaxRt2TaxExTitle')}}
                                            </th>
                                            <td class="cart-price">
                                                <span>{{formatPrice(sh060Init.totalTaxRt2Ex)}}円</span>
                                            </td>
                                        </tr>
                                        <tr v-if="sh060Init.orderInfo['TNK_DSP_KBN'] == '1' && sh060Init.totalTaxRt2In > 0">
                                            <th class="w200">
                                                <!-- 8%対象税込計 -->
                                                {{$t('sh060.labels.totalTaxRt2TaxInTitle')}}
                                            </th>
                                            <td class="cart-price">
                                                <span>{{formatPrice(sh060Init.totalTaxRt2In)}}円</span>
                                            </td>
                                        </tr>
                                        <tr v-if="sh060Init.totalTaxRt2Tax > 0">
                                            <th class="w200" v-if="sh060Init.orderInfo['TNK_DSP_KBN'] == '1'">
                                                <!-- 8%内消費税 -->
                                                {{$t('sh060.labels.totalTaxRt2TaxTitle') + $t('common.labels.newConsumption')}}
                                            </th>
                                            <th v-else class="w200">
                                                <!-- 8%消費税 -->
                                                {{$t('sh060.labels.totalTaxRt2TaxTitle') + $t('common.labels.consumptionTax')}}
                                            </th>
                                            <td class="cart-price">
                                                <span v-if="sh060Init.orderInfo['TNK_DSP_KBN'] == '1'">({{formatPrice(sh060Init.totalTaxRt2Tax)}}円)</span>
                                                <span v-else>{{formatPrice(sh060Init.totalTaxRt2Tax)}}円</span>
                                            </td>
                                        </tr>
                                        <tr v-if="sh060Init.totalTaxRt3Ex > 0">
                                            <th class="w200">
                                                <!-- 非課税対象計 -->
                                                {{$t('sh060.labels.totalTaxRt3Title')}}
                                            </th>
                                            <td class="cart-price">
                                                <span>{{formatPrice(sh060Init.totalTaxRt3Ex)}}円</span>
                                            </td>
                                        </tr>
                                    </table>
                                </div>

                                <div class="ml-auto mr-0 hachuSumPayment mb05">
                                    <table class="personal shopping-total" summary="今回ご請求金額">
                                        <template v-if="sh060Init.orderInfo['TNK_DSP_KBN'] == '1'">
                                            <tr>
                                                <th class="w200">
                                                    <!-- ご注文金額小計(税込) -->
                                                    {{$t('sh060.labels.itemValueSubtotalin')}}
                                                </th>
                                                <td class="cart-price">
                                                    <span class="">{{formatPrice(sh060Init.orderInfo['ITEMSUM_TAX_IN'])}}円</span>
                                                </td>
                                            </tr>
                                        </template>
                                        <template v-else>
                                            <tr>
                                                <th class="w200">
                                                    {{$t('sh060.labels.itemValueSubtotalex')}}
                                                </th>
                                                <td class="cart-price">
                                                    <span class="">{{formatPrice(sh060Init.orderInfo['ITEMSUM_TAX_EX'])}}円</span>
                                                </td>
                                            </tr>
                                        </template>

                                        <tr v-if="sh060Init.orderInfo['TNK_DSP_KBN'] == '2'">
                                            <!-- 消費税：税抜表示時 -->
                                            <th class="w200">
                                                {{$t('common.labels.consumptionTax')}}
                                            </th>
                                            <td class="cart-price">
                                                <span>{{formatPrice(sh060Init.orderInfo['TOTAL_SEIKYU_TAX'])}}円</span>
                                            </td>
                                        </tr>
                                        <tr v-if="sh060Init.orderInfo['TNK_DSP_KBN'] == '1'">
                                            <th class="w200">
                                            <!-- 消費税：税込表示時 -->
                                                {{$t('common.labels.newConsumption')}}
                                            </th>
                                            <td class="cart-price">
                                                <span>({{formatPrice(sh060Init.orderInfo['TOTAL_SEIKYU_TAX'])}}円)</span>
                                            </td>
                                        </tr>
                                        <tr v-if="sh060Init.soryoTotal > 0 && sh060Init.seikyuuKin > 0">
                                            <th class="w200">
                                                <!-- 送料 -->
                                                {{$t('sh060.labels.shippingcost')}}
                                            </th>
                                            <td class="cart-price">
                                                <span class="">{{formatPrice(sh060Init.soryoTotal)}}円</span>
                                            </td>
                                        </tr>

                                        <tr v-if="sh060Init.daiTesuuKinTotal > 0 && sh060Init.seikyuuKin > 0">
                                            <th class="w200">
                                                <!-- 代引手数料 -->
                                                {{$t('sh060.labels.cod')}}
                                            </th>
                                            <td class="cart-price">
                                                <span class="">{{formatPrice(sh060Init.daiTesuuKinTotal)}}円</span>
                                            </td>
                                        </tr>

                                        <tr v-if="sh060Init.sonotaTesuuKDinTotal1 > 0 && sh060Init.seikyuuKin > 0">
                                            <th class="w200">
                                                <!-- 払込票手数料 -->
                                                {{$t('sh060.labels.paymentslipfee')}}
                                            </th>
                                            <td class="cart-price">
                                                <span class="">{{formatPrice(sh060Init.sonotaTesuuKDinTotal1)}}円</span>
                                            </td>
                                        </tr>
                                        <tr v-if="sh060Init.kessaiTesuKinTotal > 0 && sh060Init.seikyuuKin > 0">
                                            <th class="w200">
                                                <!-- 決済手数料 -->
                                                {{$t('sh060.labels.kessaiTesuTitle')}}
                                            </th>
                                            <td class="cart-price">
                                                <span class="">{{formatPrice(sh060Init.kessaiTesuKinTotal)}}円</span>
                                            </td>
                                        </tr>
                                        <tr v-if="sh060Init.kinTypeUketoriServiceFlg == '1' && sh060Init.sonotaTesuuKDinTotal2 != '0' && sh060Init.seikyuuKin > 0">
                                            <th class="w200">
                                                <!-- 受取サービス手数料 -->
                                                {{$t('sh060.labels.receivingservicefee')}}
                                            </th>
                                            <td class="cart-price">
                                                <span class="">{{formatPrice(sh060Init.sonotaTesuuKDinTotal2)}}円</span>
                                            </td>
                                        </tr>
                                        
                                        <tr v-if="stringNvl(sh060Init.promoKin,'0') != '0'">
                                            <th class="w200">
                                                <!-- キャンペーン値引 -->
                                                {{$t('sh060.labels.campaigndiscount')}}
                                            </th>
                                            <td class="cart-price">
                                                <span class="price">-{{formatPrice(sh060Init.promoKin)}}円</span>
                                            </td>
                                        </tr>
                                        <tr v-if="stringNvl(sh060Init.matomeWaribikiKin,'0') != '0'">
                                            <th class="w200">
                                                <!-- まとめ買い割引金 -->
                                                {{$t('sh060.labels.matomeWaribiki')}}
                                            </th>
                                            <td class="cart-price">
                                                <span class="price">-{{formatPrice(sh060Init.matomeWaribikiKin)}}円</span>
                                            </td>
                                        </tr>
                                        <tr v-if="sh060Init.cupponNebikiKin > 0">
                                            <th class="w200">
                                                <!-- クッポン減額 -->
                                                {{$t('sh060.labels.orderCouSettArea').replace('：','')}}
                                            </th>
                                            <td class="cart-price">
                                                <span class="price">-{{formatPrice(sh060Init.cupponNebikiKin)}}円</span>
                                            </td>
                                        </tr>
                                        <tr v-if="stringNvl(sh060Init.pointKin,'0') != '0' && sh060Init.homerUseFlg == 0">
                                            <th class="w200">
                                                <!-- 利用ポイント-->
                                                {{$t('sh060.labels.pointstousethistime')}}
                                            </th>
                                            <td class="cart-price">
                                                <span class="price">-{{formatPrice(sh060Init.pointKin)}}{{$t("sh050.labels.pt")}}</span>
                                            </td>
                                        </tr>
                                    </table>
                                    <table class="personal shopping-total" summary="今回ご請求金額">
                                        <tr v-if="sh060Init.orderInfo['KESSAI_CD'] != '6' && sh060Init.seikyuuKinDispFlg == 1">
                                            <th class="w200">
                                                <!-- ご請求金額（税込） -->
                                                {{$t('sh060.labels.hachuFirstPayment')}}
                                            </th>
                                            <td class="cart-price">
                                                <span class="price">{{formatPrice(sh060Init.seikyuuKin)}}円</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th class="w200">
                                                <!-- 初回お届け希望日 -->
                                                {{$t('sh060.labels.hachuShipFirst')}}
                                            </th>
                                            <td class="">
                                                <span class="">{{sh060Request.hopeDayList[0]}}</span>
                                            </td>
                                        </tr>
                                    </table>
                                    <!-- 今回獲得ポイント数:XXXXpt(自動発注_初回) -->
                                    <div class="text-right mb64 row d-flex justify-content-end  pt-2" v-if="sh060Init.totalGivenPointNum > 0 && sh060Init.givenPointFlg == '1' ">
                                        <div class="givenPointAutoOrderFirstTitle">{{$t('sh060.labels.totalGivenPointNumTitle')}}:</div>
                                        <div class="givenPointAutoOrderFirstNum">{{formatPrice(sh060Init.totalGivenPointNum)}}</div>
                                        <div class="givenPointAutoOrderFirstPT">pt</div>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                    <div class="guide mb64" v-if="descriptionInfo[3] != ''">
                        <p class="mb08">
                            <span v-html="descriptionInfo[3]"></span>
                        </p>
                    </div>
                    <div class="birthdayCheck" v-if="sh060Init.birthdayFlg == 1">
                        <div v-html="descriptionInfo[6]"></div>
                        <div class="label" >
                            <span hidden id="birthDay_lbl">
                                <span>{{$t('common.labels.birthday')}}</span>
                            </span>
                        </div>
                        <div class="mt-3">
                            <template v-if="sh060Init.siteFlg != '1' && sh060Init.kokyakuNo != '999999999' && sh060Init.birthDayYYYY != null">
                                <label id="birthDay_lbl">
                                    <span>{{$t('common.labels.birthday')}}</span>
                                </label>
                                {{sh060Request.birthDayYYYY}}年
                                {{sh060Request.birthDayMM}}月
                                {{sh060Request.birthDayDD}}日
                            </template>
                            <template v-else>
                                <input-check type="text" id="birthDayYYYY" class="birthYearInput numcode" name="birthDay_YYYY" maxlength="4" size="7" v-model="sh060Request.birthDayYYYY"/>
                                <span class="birthYear">{{$t('common.labels.year')}}</span>
                                <select v-model="sh060Request.birthDayMM" name="birthDay_MM" class="birthMonthSelect">
                                    <option></option>
                                    <template v-for="mm in 12" >
                                        <option v-if="mm < 10" :key="mm" :value="'0'+mm">{{'0'+mm}}</option>
                                        <option v-else :key="mm" :value="mm">{{mm}}</option>
                                    </template>
                                </select>
                                <span class="birthMonth">{{$t('common.labels.month')}}</span>
                                <select v-model="sh060Request.birthDayDD" name="birthDay_DD" class="birthDaySelect">
                                    <option></option>
                                    <template v-for="dd in 31" >
                                        <option v-if="dd < 10" :key="dd" :value="'0'+dd">{{'0'+dd}}</option>
                                        <option v-else :key="dd" :value="dd">{{dd}}</option>
                                    </template>
                                </select>
                                <span class="birthDay">{{$t('common.labels.day')}}</span>
                            </template>
                        </div>
                    </div>
                    <div style="text-align:center" v-if="sh060Init.kessaiCd == Constants.KESSAI_AMAZONPAY &&  (sh060Init.kokyakuNo == null || sh060Init.kokyakuNo == '999999999')">
                        <input  type="checkbox" id="infoRegister" ref="infoRegister" v-model="sh060Request.infoRegister" v-on:click="checkRegisterFun($event.currentTarget.checked)"><label> 注文時、会員登録をする</label>
                    </div>
                   
                </div>
            </div>
            <div  class="pt400" id="pt400" v-if="checkRegister == true && sh060Init.kessaiCd == Constants.KESSAI_AMAZONPAY &&  (sh060Init.kokyakuNo == null || sh060Init.kokyakuNo == '999999999')">
                <div>
                    <div class="inputCondition">
                        <div class="customer">
                                <!--会員ID -->
                            <div class="kaiinIdLine">
                                <div class="label">
                                    <label class="required" id="kaiinId_lbl">
                                        <span>{{$t('pt400.labels.kaiinId')}}</span>
                                    </label>
                                </div>
                                <div class="input">
                                <template>
                                    <input-check type="text" id="kaiinId" class="kaiinIdInput code" @on-input-change="change()" name="kaiinId" maxlength="15" size="35" v-model="sh060Request.kokyakuCd"/>
                                    <!--重複チェックボタン-->
                                    <input v-if="pageType == PAGE_INSERT" id="nav-search-button" type="button" @click="check()" :value="$t('pt400.labels.duplicationcheck')">
                                        <span class="okMessage" v-if="sh060Request.kaiinCheck == 0">{{$t('pt400.labels.checkConfirm')}}</span>
                                        <span class="err" v-if="sh060Request.kaiinCheck == 1">{{$t('pt400.labels.checkConfirmErr')}}</span>
                                        <span class="checkNull" v-if="sh060Request.kaiinCheck == 2">{{$t('pt400.labels.checkCnfirmNull')}}</span>
                                </template>
                                <!--項目説明マスタ[24]-->
                                <div v-if="pageType == PAGE_INSERT" v-html="sh060Request.descriptionInfoRegister['24']"></div>
                                </div>
                            </div>
                            <div class="mailLine">
                                <div class="label">
                                    <label  class="required">
                                        <span id="mail_lbl">{{$t('common.labels.mailAddress')}}</span>
                                    </label>
                                </div>
                                <div class="input" >
                                    <input-check type="text" class="mailInput mode" @on-input-change="change()" id="mail" name="mail" maxlength="80" size="35" v-model="sh060Request.mail"/>
                                    <!--項目説明マスタ[4]-->
                                    <div v-html="sh060Request.descriptionInfoRegister['4']"></div>
                                </div>
                                <div class="input" >
                                    <span hidden  id="mail_confirm_lbl">{{$t('regist.labels.subMailAddress')}}</span>
                                    <!--項目説明マスタ[5]-->
                                    <div v-html="sh060Request.descriptionInfoRegister['5']"></div>
                                    <!--確認メールアドレス入力-->
                                    <input-check type="text" class="mailConfirmInput mode" @on-input-change="change()" id="mail_confirm" name="mail_confirm" maxlength="80" size="35" v-model="sh060Request.mail_confirm"/>
                                </div>
                            </div>
                            <div class="NewPassLine" >
                                <div class="label">
                                    <label :class="pageType == PAGE_INSERT?'required':'verticalAlignTop'">
                                        <span id="password_lbl">{{$t('pt400.labels.newPass')}}</span>
                                    </label>
                                </div>
                                <div class="input">
                                    <input-check type="password" name="password" size="20" class="passwordInput" @on-input-change="change()" maxlength="16" id="password" v-model="sh060Request.password" />
                                    <!--項目説明マスタ[7]-->
                                    <div v-html="sh060Request.descriptionInfoRegister['7']"></div>
                                </div>
                            </div>
                            <div class="confirmPassLine">
                                <div class="label">
                                    <label :class="pageType == PAGE_INSERT?'required':'verticalAlignTop'">
                                        <span id="passwordSub_lbl">{{$t('pt400.labels.passConfirm')}}</span>
                                    </label>
                                </div>
                                <div class="input">
                                    <!--項目説明マスタ[8]-->
                                    <div v-html="sh060Request.descriptionInfoRegister['8']"></div>
                                    <!--確認パスワード入力-->
                                    <input-check type="password" name="passwordSub" size="20" maxlength="16" class="passwordSubInput" @on-input-change="change()" id="passwordSub" v-model="sh060Request.passwordSub" />
                                </div>
                            </div>
                        </div>
                        <!--会員規約-->
                        <div class="membership">
                            <div class="membershipAgreement">{{$t('pt400.labels.membership')}}</div>
                            <div class="membershipDescription" v-html="sh060Request.descriptionInfoRegister['40']"></div>
                            <div class="AgreeFlag">
                                <!--同意する-->
                                <input type="radio" id="AgreeFlag1" name="AgreeFlag" value="1" class="AgreeFlag1Input" v-model="sh060Request.agreeFlag">
                                <label for="AgreeFlag1">{{$t('pt400.labels.agreeItems')}}</label>
                                <!-- 規約に同意しない -->
                                <input type="radio" id="AgreeFlag0" name="AgreeFlag" value="0" class="AgreeFlag0Input" v-model="sh060Request.agreeFlag">
                                <label for="AgreeFlag0">{{$t('pt400.labels.dontAgree')}}</label>
                            </div>
                        </div>
                        <!--プライバシーポリシーリンク-->
                        <p class="noteLink">
                            <span v-html="sh060Request.descriptionInfoRegister['21']"></span>
                            <router-link class="blank" target="_blank" :to="{ name: SiteConstants.PG010MAIN, query:{ pageNo:70}}">
                                {{$t('common.labels.noteLink')}}
                            </router-link>
                            <span v-html="sh060Request.descriptionInfoRegister['22']"></span>
                        </p>
                    </div>
                </div>
            </div>

            <form v-if="sh060Init.kessaiCd == Constants.KESSAI_GMO_DPAY" ref="formDocomoStartCall" name="formDocomoStartCall" id="formDocomoStartCall" method="POST" :action='gmoDPayStartURL'>
                <input type="hidden" name="AccessID" :value="gmoDPayAccessID">
                <input type="hidden" name="Token"  :value="gmoDPayToken">
            </form>

            <br>
            <!-- ASUKA準備完了までのメッセージ -->
            <ul class="loadingAsukaMessage text-danger mt-3 mb-3" style="text-align: center;">
                <li v-if="sh060Init.asukaOptionFlg == 1 && !isAsukaReadyToScore">
                    {{$t('common.messages.loadingAsuka')}}
                </li>
            </ul>
            <!-- 自動発注不可の場合のメッセージ -->
            <ul class="loadingAsukaMessage text-danger mt-3 mb-3" style="text-align: center;">
                <li v-if="!isHatchuShow">
                    {{$t('common.messages.autoHatchuNg')}}
                </li>
            </ul>
            <ul class="button-column">
                <li>
                    <input class="submit-button back-btn" type="submit"  @click="doPageBack()" :value="$t('sh060.buttons.backtothepreviouspage')">
                </li>
                <template v-if="isSubmitButton && isHatchuShow">
                    <li v-if="doQuotationFlg == 1">
                        <!--見積書出力-->
                        <input class="submit-button decision" type="submit"  @click="doOutPutConfirm()" :value="$t('sh060.buttons.outputQuotation')">
                    </li>
                    <li v-else-if="sh060Init.teikiAddFlg == '1'">
                        <input class="submit-button decision" type="submit"  @click="doOrder()" :value="$t('sh060.buttons.teikiAddOrder')">
                    </li>
                    <li v-else>
                        <div @click="doSubmit()" v-if="sh060Init.kessaiCd == Constants.KESSAI_AMAZONPAY && sh060Request.amazonCheckoutSessionId == null && sh060Init.teikiFlg == '1' && sh060Init.teikiKbn == '2'  && !sh060Init.errList" style="margin-top:12px;" id="AmazonPayButton" v-show="isDisplayAmazon == 1" />
                        <div v-if="sh060Init.kessaiCd == Constants.KESSAI_AMAZONPAY && sh060Request.amazonCheckoutSessionId == null && sh060Init.teikiFlg == '1' && sh060Init.teikiKbn == '2'  && !sh060Init.errList" style="margin-top:12px;" id="AmazonPayButton1"/>
                        <div v-if="sh060Init.kessaiCd == Constants.KESSAI_AMAZONPAY && sh060Request.amazonCheckoutSessionId == null && sh060Init.teikiFlg == '1' && sh060Init.teikiKbn != '2'  && !sh060Init.errList" style="margin-top:12px;" id="AmazonPayButton3"/>
                        <div v-if="sh060Init.kessaiCd == Constants.KESSAI_AMAZONPAY && sh060Request.amazonCheckoutSessionId == null && sh060Init.teikiFlg != '1' && !sh060Init.errList" style="margin-top:12px;" id="AmazonPayButton2"/>
                        <input v-else-if="(sh060Init.kessaiCd != Constants.KESSAI_AMAZONPAY || (sh060Request.amazonCheckoutSessionId != null && sh060Init.kessaiCd == Constants.KESSAI_AMAZONPAY)) && orderButtonFlg" class="submit-button decision" type="submit"  @click="doSubmit()" :value="$t(security3DFlg == 1 || securityGmo3DFlg == 1 ? 'sh060.buttons.confirmyourorder3' : 'sh060.buttons.confirmyourorder')">
                    </li>
                </template>
            </ul>
            <!-- 与信限度額に関するメッセージ -->
            <ul class="kakeLimitMessage mt-3" style="text-align: center;" v-if="sh060Init.kessaiCd == '6' && orderButtonFlg">
                <li v-if="doYoshinLimitCheck() == 1">
                    <span v-html="descriptionInfo['17']"></span>
                </li>
                <li v-else-if="doYoshinLimitCheck() == 2">
                    <span v-html="descriptionInfo['18']"></span>
                </li>
            </ul>

            <!-- modal confirm area -->
            <alert-confirm 
                v-if="isModalShow"
                :msgConfirm="msgConfirm"
                :isButtonCancel="isButtonCancel">
            </alert-confirm>

            <alert-confirm
                v-if="isErrorAlert"
                :msgConfirm="errorMsg"
                :isButtonCancel="false"
                @closedModal="isErrorAlert=false"
                size="md"
            ></alert-confirm>

            <alert-confirm 
                v-if="isModalAreaCheckShow"
                :msgConfirm="msgConfirmAreaCheck"
                @closedModal="isModalAreaCheckShow = false"
                :size="'lg'"
                :isButtonOK="false"
                :isHideFooter="true"  
                :isHideHeader="true"  
                :isCloseBackdrop="false"
                :isButtonCancel="isButtonCancelAreaCheck">
            </alert-confirm>

            <!-- 値引き総額が商品合計金額を上回っています。値引き額は商品合計金額に相当する金額分のみ適用されます。よろしいですか？ -->
            <alert-confirm
                v-if="isShowNebikiAlert"
                :msgConfirm="outputMsgConfirm"
                :okAction="doSubmit"
                :cancelAction="()=>{isShowNebikiAlert = false;}"
                @closedModal="isShowNebikiAlert = false"
                size="md"
            />

            <!-- 限度額を超過しており出荷が遅れますが注文を確定して宜しいですか？ -->
            <alert-confirm
                v-if="isYoshinLimitAlert"
                :msgConfirm="descriptionInfo['19']"
                :okAction="doSubmit"
                :cancelAction="()=>{isYoshinLimitAlert = false;}"
                @closedModal="isYoshinLimitAlert = false"
                size="md"
            />

            <!-- 見積保存件数({0}件)の上限に達しています。<br>古い見積書を削除し、新しい見積書を作成します。よろしいでしょうか？ -->
            <alert-confirm
                v-if="isShowOutputAlert"
                :msgConfirm="outputMsgConfirm"
                :okAction="doOutPut"
                :cancelAction="()=>{isShowOutputAlert = false;}"
                @closedModal="isShowOutputAlert = false"
                size="md"
            />

            <!-- 遠鉄ポイント確認。よろしいですか？ -->
            <alert-confirm
                v-if="isShowEntetsuAlert"
                :msgConfirm="outputMsgConfirm"
                :okAction="doSubmit"
                :cancelAction="()=>{isShowEntetsuAlert = false;}"
                @closedModal="isShowEntetsuAlert = false"
                size="md"
            />

            <!-- この配送ギフト設定をすべてに反映します。よろしいですか？ -->
            <alert-confirm
                v-if="isShowGiftSettingCopyAlert"
                :msgConfirm="outputMsgConfirm"
                :okAction="doCopyTdkGiftSetting"
                :cancelAction="()=>{isShowGiftSettingCopyAlert = false;}"
                @closedModal="isShowGiftSettingCopyAlert = false"
                size="md"
            />

            <div v-if="is3DLoding" tabindex="0" aria-busy="true" aria-label="Loading" class="vld-overlay is-active is-full-page">
                <div class="vld-background" style="opacity:1"></div>
                <div class="vld-icon">
                    <table width='45%' height='100%' align='center' style="border:0px">
                        <tr>
                            <td id="tdStyle" style="border:0px">
                                <b>
                                    <big>処理中です。</big>
                                </b><br>
                                <b>
                                    <big>処理に時間がかかる場合があります。</big>
                                </b><br>
                                <b>
                                    <big>「戻る」ボタンや「更新」ボタンは</big>
                                </b>
                                <font color='#FF0000'>
                                    <b>
                                        <big>絶対に押さないでください。</big>
                                    </b>
                                </font>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
        <SH063 v-if="showSh063Flg" :data="dataSh063" @data-selected="setDataSh063"></SH063>
    </div>
</template>

<script>
/* eslint-disable */
/*
* Import libs and componnents
*/
import $ from 'jquery';
import axios from "assets/js/request";
import DataTable from 'components/Datatable';
import common from 'assets/js/common';
import BackButton from 'components/BackButton';
import EventBus from 'assets/js/eventBus';
import Message from 'components/MessageEcSite';
import Loading from 'vue-loading-overlay';
import InputCheck from 'components/InputCheck.vue';
import DownloadFile from 'components/DownloadFile';
import AlertConfirm from 'components/AlertConfirm';
import SiteConstants from 'assets/const/SiteConstants.json';
import Constants from 'assets/const/Constants.json';
import InputNumber from 'components/InputNumber';
import SH063 from '../popup/SH063TdkHopeDateGiftSetting.vue';

import toastr from "toastr/toastr.js";
import "toastr/build/toastr.min.css";

import entetsu from "assets/js/entetsu";

toastr.options = {
  closeButton: true,
  positionClass: "toast-top-right",
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "2000",
};

export default {
    /*
    * Name of component
    */
    name: "SH060",
    /*
    * Declare components
    */
    components: {
        DataTable,
        BackButton,
        Message: Message,
        Loading,
        InputCheck,
        DownloadFile,
        AlertConfirm,
        toastr,
        InputNumber,
        SH063
    },
    /*
    * Declare props
    */
    props: {
        ptPageNo: {
            type: [Number,String]
        },
        ptPageSize: {
            type: [Number,String]
        },
        ptOrderByType: {
            type: [Number,String]
        },
        categoryCd:  {
            type: String
        },
        evtChangeCategoryFlg: {
            type: Boolean,
            default: false,
        },
        evtChangeSearchFlg: {
            type: Boolean,
            default: false,
        },
        searchNm : {
            type: String
        },
        ptInitData: {
            type: Object,
            default: null,
        },
    },
    /*
    * Declare variable and set default value
    */
    data: function() {
        return {
            is3DLoding: false,
            checkRegister: false,
            doQuotationFlg:0,
            SH060_PART: "sh060",
            listMessValid:[],
            mapMessValid:[],
            isLoading: false,
            isDisplay: false,
            isDisplayAmazon: 1,
            loginPage: 0,
            isSubmitting: false,
            sh060Init: {
                orderInfo:{},
                descriptionInfo:{},
                realAuthoriFlg: 1,
                creditInpNumOption: 0,
            },
            showNowCardFlg: 1,
            sh060Request: {
                cardSaveFlg: 0,
                agreeFlag:0,
                hopeDayList:[],
                hopeDayCntList:[],
                hopeDay:'',
                hopeDayCnt:'',
                cardFlg:0,
                biko: '',
                giftCd: '0',
                sagyoKanriKomokuCd: '',
                sagyoKanriKomokuCd2: '',
                noshiNaire1: '',
                noshiNaire2: ''
            },
            dataSh063:{},
            showSh063Flg:false,
            isButtonCancel: true,
            isButtonCancelAreaCheck: true,
            actionFlg:0,
            zeiKbnNm:'',
            isModalShow:false,
            isErrorAlert:false,
            isModalAreaCheckShow:false,
            isShowOutputAlert:false,
            isShowNebikiAlert:false,
            isYoshinLimitAlert:false,
            isBunkatuFlg:false,
            outputMsgConfirm:'',
            listIdErr:[],
            descriptionInfo:[],
            SiteConstants: SiteConstants,
            Constants: Constants,
            NO_CART_ERR : "001",
            CART_INFO_INVALID_ERR : "002",
            SHOW_ERR_PAGE : "003",
            BESE_KIN_ERR : "004",
            LEAD_DAY_ERR : "005",
            noCartErrFlg : 0,
            site: "",
            pageNo:"",
            tdkSkipFlg : false,
            paySkipFlg : false,
            confirmFlg : false,
            completeFlg : false,
            creditFlg : false,
            conveniFlg : false,
            orderButtonFlg : true,
            isScroll: false,
            isUpperPartButtonFlg: false,
            styleObject: {
                'overflow-y':'scroll',
                'max-height':'350px'
            },
            timer: '',
            currPageNo:"",
            curPage: window.location.origin + window.location.pathname,
            security3DFlg: 0,
            securityGmo3DFlg: 0,
            securitySps3DFlg: 0,
            resGmoVer2ACS: "",
            resGmoVer2RedirectUrl: "",
            gmo2AuthAccessID: "",
            securitySbp3DFlg: 0,
            sbpTdsAuthenticationId: '',
            sbpEmv3dsStatus: '',
            sbpErrorCode: '',

            jcsMemberType: '',
            jasApiSeqNo: '',
            jasApiResult:{},
            jasNewCardTaking: {
                memberType: '',
                tourokuKbn: '',
                merchantId: '',
                senddate: '',
                sendtime: '',
                pan: '',
                expiryDate: '',
                cardKbn: '',
                backUrl: '',
                resultUrl: '',
                optionalAreaName1: '',
                optionalAreaValue1: '',
                optionalAreaName2: '',
                optionalAreaValue2: '',
                optionalAreaName3: '',
                optionalAreaValue3: '',
                optionalAreaName4: '',
                optionalAreaValue4: '',
                optionalAreaName5: '',
                optionalAreaValue5: '',
                optionalAreaName6: '',
                optionalAreaValue6: '',
                optionalAreaName7: '',
                optionalAreaValue7: '',
                optionalAreaName8: '',
                optionalAreaValue8: '',
                optionalAreaName9: '',
                optionalAreaValue9: '',
                optionalAreaName10: '',
                optionalAreaValue10: '',
                shopID: '',
                msgDigest: ''
            },
            jasNewCard3D: {
                memberType: '',
                tourokuKbn: '',
                merchantId: '',
                cardPassword: '',
                dbKey1: '',
                orderNum: '',
                amount: '',
                taxAndDeliCharge: '',
                backUrl: '',
                resultUrl: '',
                optionalAreaName1: '',
                optionalAreaValue1: '',
                optionalAreaName2: '',
                optionalAreaValue2: '',
                optionalAreaName3: '',
                optionalAreaValue3: '',
                optionalAreaName4: '',
                optionalAreaValue4: '',
                optionalAreaName5: '',
                optionalAreaValue5: '',
                optionalAreaName6: '',
                optionalAreaValue6: '',
                optionalAreaName7: '',
                optionalAreaValue7: '',
                optionalAreaName8: '',
                optionalAreaValue8: '',
                optionalAreaName9: '',
                optionalAreaValue9: '',
                optionalAreaName10: '',
                optionalAreaValue10: '',
                shopID: '',
                accountMethod: '',
                msgDigest: '',
                teikiFlg: '',
                authenticationInd: '',
                threeDSReqAuthMethod: '',
                threeDSReqAuthTimestamp: '',
                challengeInd: '',
                acctType: '',
                merchantName: '',
                chAccAgeInd: '',
                chAccChange: '',
                chAccChangeInd: '',
                chAccDate: '',
                chAccPwChange: '',
                chAccPwChangeInd: '',
                nbPurchaseAccount: '',
                provisionAttemptsDay: '',
                txnActivityDay: '',
                txnActivityYear: '',
                paymentAccAge: '',
                paymentAccInd: '',
                shipAddressUsage: '',
                shipAddressUsageInd: '',
                shipNameIndicator: '',
                suspiciousAccActivity: '',
                addrMatch: '',
                billAddrCity: '',
                billAddrCountry: '',
                billAddrLine1: '',
                billAddrLine2: '',
                billAddrLine3: '',
                billAddrPostCode: '',
                billAddrState: '',
                email: '',
                homePhoneCc: '',
                homePhoneSubscriber: '',
                mobilePhoneCc: '',
                mobilePhoneSubscriber: '',
                cardholderName: '',
                shipAddrCity: '',
                shipAddrCountry: '',
                shipAddrLine1: '',
                shipAddrLine2: '',
                shipAddrLine3: '',
                shipAddrPostCode: '',
                shipAddrState: '',
                workPhoneCc: '',
                workPhoneSubscriber: '',
                purchaseInstalData: '',
                deliveryEmailAddress: '',
                deliveryTimeframe: '',
                giftCardAmount: '',
                giftCardCount: '',
                giftCardCurr: '',
                preOrderDate: '',
                preOrderPurchaseInd: '',
                reorderItemsInd: '',
                shipIndicator: '',
                messageCategory: '',
                recurringExpiry: '',
                recurringFrequency: '',
                transType: "",
                priorTransID: '',
                msgDigest2: ''
            },
            //epsOsori: {
            //    epsPublicAPIKey:'',
            //    epsId:'',
            //    epsAccessId:'',
            //},
            epsCard: {
                card_no: '',
                expire: '',
                holder_name: '',
                security_code: ''
            },
            jasNewCardOsori: {
                memberType: '',
                tourokuKbn: '',
                merchantId: '',
                dbKey1: '',
                amount: '',
                taxAndDeliCharge: '',
                backUrl: '',
                orderNum: '',
                cardPassword: '',
                securityCode: '',
                resultUrl: '',
                optionalAreaName1: '',
                optionalAreaValue1: '',
                optionalAreaName2: '',
                optionalAreaValue2: '',
                optionalAreaName3: '',
                optionalAreaValue3: '',
                optionalAreaName4: '',
                optionalAreaValue4: '',
                optionalAreaName5: '',
                optionalAreaValue5: '',
                optionalAreaName6: '',
                optionalAreaValue6: '',
                optionalAreaName7: '',
                optionalAreaValue7: '',
                optionalAreaName8: '',
                optionalAreaValue8: '',
                optionalAreaName9: '',
                optionalAreaValue9: '',
                optionalAreaName10: '',
                optionalAreaValue10: '',
                msgVerNum: '',
                xid: '',
                xStatus: '',
                eci: '',
                cavv: '',
                cavvAlgorithm: '',
                paymentMode: '',
                startPayMonth: '',
                paymentCount: '',
                initialAmount: '',
                bonusMonth: '',
                bonusAmount: '',
                bonusCount: '',
                shopID: '',
                bgpasswd: '',
                accountMethod: '',
                msgDigest: ''
            },
            addCouponCd: '',
            doinitFlg:false,
            hatchuCnt: 0,
            hatchuKin: 0,
            autoHachuKessaiNgFlg: 0,
            reOrderFlg: 0,
            teikiMonths: [],
            teikiFirstDay: '',
            teikiNextDay: '',
            hopeDayCnt: '',
            teikiShipCheckErr: false,
            teikiShipInfo: false,
            teikiSeikyuEx: 0,
            teikiSeikyuIn: 0,
            teikiSeikyuTotalEx: 0,
            teikiSeikyuTotalIn: 0,
            teikiSeikyuNebiki: 0,
            teikiPoint: 0,
            sps3DSAuthori: {
                encValue: '',
                merchantId: '',
            },
            tranferdata:{},
            reqModel:{
                tdkNo:null,
                tdkSeq:null,
                tdkMSeq:null,
                tdkFlg:null,
                tdkYmd:null,
                tdkHmsKbn:null,
                tdkYmdHissuFlg:null,
                tdkYmdErrFlg:null,
                tdkHstmHissuFlg:null,
                tdkHstmHErrFlg:null,
                chakubiKbn:null,
                updChakubiKbn:null,
            },

            isSubmitButton: false,
            isAsukaReadyToScore: false,
            isHatchuShow: false,
            kakeLimitMessageType: 0,

            gmoDPayAccessID: '',
            gmoDPayToken: '',
            gmoDPayStartURL: '',
            gmoDPayOrderID: '',
            gmoDPayStatus: '',
            gmodpaySeqNo: '',

            copyRequestModel: {
                tdkSeq:null,
                tdkNo:null,
            },

            pointChangeFlg: 1,
            entetsuPoint: 0,
            entetsuPointPlusFlg: 0,
            entetsuPointRiyoFlg: 0,
            entetsuKainInfo: {},
            isShowEntetsuAlert:false,
            isShowGiftSettingCopyAlert:false,
        }
    },
    /*
    * Initialize
    */
    mounted: function() {
        var tranferdata = {};
        if (sessionStorage['sh060TranferData']) {
            tranferdata = JSON.parse(sessionStorage['sh060TranferData']);
            this.tranferdata = JSON.parse(sessionStorage['sh060TranferData']);
            sessionStorage.removeItem('sh060TranferData');
        }

        window.addEventListener('as-readytoscore', function() {
            _this.isAsukaReadyToScore = true;
        });

        this.doInit();
        if (this.loginPage == 1) {
           return;
        }
        if (this.noCartErrFlg == 1) {
           return;
        }
        this.initTeikiMonths();
        this.checkTdkYmdNg();
        if (sessionStorage['hopeDay']) {
            this.sh060Request.hopeDay = sessionStorage['hopeDay'];
        } else {
            if (this.sh060Init.tdkYmdList){
                this.sh060Request.hopeDay = this.sh060Init.tdkYmdList[0].KEY;
            }
        }
        if (sessionStorage['hopeDayCnt']) {
            this.sh060Request.hopeDayCnt = sessionStorage['hopeDayCnt'];
        }  else {
            if (this.sh060Init.hopeDayCntList){
                this.sh060Request.hopeDayCnt = this.sh060Init.hopeDayCntList[0].KEY;
            }
        }

        // 定期請求情報用
        if (this.sh060Init.teikiEx > 0 || this.sh060Init.teikiIn > 0) {
            this.teikiSeikyuEx = parseInt(this.sh060Init.teikiEx)
                                 + parseInt(this.sh060Init.soryoTotal)
                                 + parseInt(this.sh060Init.daiTesuuKinTotal)
                                 + parseInt(this.sh060Init.sonotaTesuuKDinTotal1)
                                 + parseInt(this.sh060Init.kessaiTesuKinTotal)
                                 + parseInt(this.sh060Init.sonotaTesuuKDinTotal2)
                                 + parseInt(this.sh060Init.teikiZei);
            this.teikiSeikyuIn = parseInt(this.sh060Init.teikiIn)
                                 + parseInt(this.sh060Init.soryoTotal)
                                 + parseInt(this.sh060Init.daiTesuuKinTotal)
                                 + parseInt(this.sh060Init.sonotaTesuuKDinTotal1)
                                 + parseInt(this.sh060Init.kessaiTesuKinTotal)
                                 + parseInt(this.sh060Init.sonotaTesuuKDinTotal2);

            this.teikiSeikyuTotalEx = parseInt(this.sh060Init.teikiTotalEx)
                                     + parseInt(this.sh060Init.teikiSoryoKin)
                                     + parseInt(this.sh060Init.teikiDaiTesuKin)
                                     + parseInt(this.sh060Init.teikiHaraiTesuKin)
                                     + parseInt(this.sh060Init.teikiKessaiTesuKin)
                                     + parseInt(this.sh060Init.teikiUketoriTesuKin)
                                     + parseInt(this.sh060Init.teikiTotalZei);
            this.teikiSeikyuTotalIn = parseInt(this.sh060Init.teikiTotalIn)
                                     + parseInt(this.sh060Init.teikiSoryoKin)
                                     + parseInt(this.sh060Init.teikiDaiTesuKin)
                                     + parseInt(this.sh060Init.teikiHaraiTesuKin)
                                     + parseInt(this.sh060Init.teikiKessaiTesuKin)
                                     + parseInt(this.sh060Init.teikiUketoriTesuKin);

            this.teikiSeikyuNebiki = parseInt(this.sh060Init.cupponNebikiKin)
                                    + parseInt(this.sh060Init.promoKin)
                                    + parseInt(this.sh060Init.matomeWaribikiKin);
            if (this.sh060Init.pointKin > this.teikiSeikyuIn - this.teikiSeikyuNebiki) {
                this.teikiPoint = this.teikiSeikyuIn
                                 - parseInt(this.sh060Init.cupponNebikiKin)
                                 - parseInt(this.sh060Init.promoKin)
                                 - parseInt(this.sh060Init.matomeWaribikiKin);
            } else {
                this.teikiPoint = this.sh060Init.pointKin;
            }
            this.teikiSeikyuNebiki = this.teikiSeikyuNebiki + parseInt(this.teikiPoint);
        }

        // 自動発注情報用
        if (this.hatchuCnt > 0) {
            this.hatchuKin = parseInt(this.sh060Init.orderInfo['ITEMSUM_TAX_IN'])
                                + parseInt(this.sh060Init.soryoTotal)
                                + parseInt(this.sh060Init.daiTesuuKinTotal)
                                + parseInt(this.sh060Init.sonotaTesuuKDinTotal1)
                                + parseInt(this.sh060Init.kessaiTesuKinTotal)
                                + parseInt(this.sh060Init.sonotaTesuuKDinTotal2)
                                - parseInt(this.sh060Init.promoKin)
                                - parseInt(this.sh060Init.matomeWaribikiKin)
                                - parseInt(this.sh060Init.cupponNebikiKin);
        }
        
        if (tranferdata) {
            this.sh060Request = Object.assign(this.sh060Request, tranferdata.sh060Request);
            this.sh060Request.biko = tranferdata.biko;
            this.sh060Request.giftCd = this.sh060Request.hidGiftCd;
            this.sh060Request.sagyoKanriKomokuCd=tranferdata.sagyoKanriKomokuCd;
            this.sh060Request.sagyoKanriKomokuCd2=tranferdata.sagyoKanriKomokuCd2;
            this.sh060Request.noshiNaire1=tranferdata.noshiNaire1;
            this.sh060Request.noshiNaire2=tranferdata.noshiNaire2;
        }
        
    },
    /*
    * Methods
    */
    methods: {

        doInit() {
            var _this = this;
            _this.isLoading = false;
            _this.doQuotationFlg=sessionStorage['doQuotation'];
            var amazonCheckoutSessionId = _this.$router.history.current.fullPath.split("amazonCheckoutSessionId=")[1];
            var actionId = _this.$router.history.current.fullPath.split("actionId=22")[1];
            if  (amazonCheckoutSessionId != null && actionId != null) {
                _this.$emit("event-loading-message", true, "処理中です。そのままお待ちください。");
            } else {
                _this.$emit("event-loading", true);
            }
            if  (amazonCheckoutSessionId != null && actionId != null) {
               
                _this.$emit("event-loading", true);
                if (_this.tranferdata) {
                    _this.sh060Request.biko = _this.tranferdata.biko;
                    _this.sh060Request.giftCd = _this.tranferdata.giftCd;
                    _this.sh060Request.sagyoKanriKomokuCd= _this.tranferdata.sagyoKanriKomokuCd;
                    _this.sh060Request.sagyoKanriKomokuCd2= _this.tranferdata.sagyoKanriKomokuCd2;
                    _this.sh060Request.noshiNaire1= _this.tranferdata.noshiNaire1;
                    _this.sh060Request.noshiNaire2= _this.tranferdata.noshiNaire2;
                }
                _this.sh060Request.amazonCheckoutSessionId = amazonCheckoutSessionId;
                _this.setHopeDayList();
                _this.sh060Request.hopeDayCnt = sessionStorage['hopeDayCnt'];
                _this.sh060Request.hopeDay = sessionStorage['hopeDay'];
                axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.SH060 + "/doOrderAmazonPay", _this.sh060Request).then(function(response) {
                    if(response.data.status == 'OK'){
                        var message = "";
                        var orderCd = "";
                        if(response.data.response) {
                            message = response.data.response.message;
                            orderCd = response.data.response.orderCd;
                        }
                        sessionStorage.removeItem('hopeDayList');
                        sessionStorage.removeItem('totalPointKin');
                        sessionStorage.removeItem('amazonPayInfo');
                        sessionStorage.removeItem('amazonCheckoutSessionId');
                        sessionStorage.removeItem('hopeDay');
                        sessionStorage.removeItem('hopeDayCnt');
                        sessionStorage.removeItem('sh060TranferData');
                        _this.$router.push({ name: _this.SiteConstants.PG010MAIN, params:{message:message,orderCd:orderCd}, query: {pageNo: 23}});
                    }  else {
                        sessionStorage.removeItem('amazonPayInfo');
                        sessionStorage.removeItem('amazonCheckoutSessionId');
                        _this.listMessValid = [];
                        _this.sh060Init = _this.ptInitData;
                        _this.sh060Init.kessaiCd = "";
                        _this.sh060Init.orderInfo['SIHARAI_HOHO_KBN_NM'] = "指定なし";
                        // 決済処理時にエラーが発生しました。入力内容をご確認の上、再度ご入力いただくか、決済方法を変更してください。
                        _this.listMessValid.push("Amazon Pay での決済に失敗しました。お支払方法にて別の決済方法をご選択頂くか、もしくは、お時間をあけて再度お試し下さい。");
                        sessionStorage.removeItem('amazonPayInfo');
                        sessionStorage.removeItem('amazonCheckoutSessionId');
                        _this.sh060Request.amazonCheckoutSessionId = null;
                        EventBus.$emit('message', {});
                        if (_this.isScroll == '0') {
                            _this.styleObject = '';
                        }else if (_this.isScroll == ''){
                            _this.styleObject = '';
                        }
                        // 画面上部に注文確定ボタンを表示(0だったら非表示)
                        if (_this.sh060Init.upperPartButtonFlg == '1') {
                            _this.isUpperPartButtonFlg = true;
                        }else if (_this.sh060Init.upperPartButtonFlg == '0') {
                            _this.isUpperPartButtonFlg = false;
                        }else if (_this.sh060Init.upperPartButtonFlg == ''){
                            _this.isUpperPartButtonFlg = false;
                        }

                        // 届先指定画面スキップフラグ
                        if (_this.sh060Init.tdkInfoFlg == '0') {
                            _this.tdkSkipFlg = true;
                        }

                        // 定期請求情報用
                        if (_this.sh060Init.teikiEx > 0 || _this.sh060Init.teikiIn > 0) {
                            _this.teikiSeikyuEx = parseInt(_this.sh060Init.teikiEx)
                                                + parseInt(_this.sh060Init.soryoTotal)
                                                + parseInt(_this.sh060Init.daiTesuuKinTotal)
                                                + parseInt(_this.sh060Init.sonotaTesuuKDinTotal1)
                                                + parseInt(_this.sh060Init.kessaiTesuKinTotal)
                                                + parseInt(_this.sh060Init.sonotaTesuuKDinTotal2)
                                                + parseInt(_this.sh060Init.teikiZei);
                                                _this.teikiSeikyuIn = parseInt(_this.sh060Init.teikiIn)
                                                + parseInt(_this.sh060Init.soryoTotal)
                                                + parseInt(_this.sh060Init.daiTesuuKinTotal)
                                                + parseInt(_this.sh060Init.sonotaTesuuKDinTotal1)
                                                + parseInt(_this.sh060Init.kessaiTesuKinTotal)
                                                + parseInt(_this.sh060Init.sonotaTesuuKDinTotal2);
                            
                            if (_this.sh060Init.pointKin > _this.teikiSeikyuIn) {
                                _this.teikiPoint = _this.teikiSeikyuIn
                                                - parseInt(_this.sh060Init.cupponNebikiKin)
                                                - parseInt(_this.sh060Init.promoKin)
                                                - parseInt(_this.sh060Init.matomeWaribikiKin);
                            } else {
                                _this.teikiPoint = _this.sh060Init.pointKin;
                            }

                            _this.teikiSeikyuNebiki = parseInt(_this.sh060Init.cupponNebikiKin)
                                                    + parseInt(_this.sh060Init.promoKin)
                                                    + parseInt(_this.sh060Init.matomeWaribikiKin)
                                                    + parseInt(_this.teikiPoint);
                        }

                        // 支払い方法スキップフラグ
                        if (_this.sh060Init.paySkipFlg == '0') {
                            _this.paySkipFlg = true;
                        }
                        _this.confirmFlg = true;
                        _this.completeFlg = true;
                        // 定期商品フラグ || 通常商品の場合かつ現在契約中の定期がある場合
                        if (_this.sh060Init.teikiFlg == 1 || (_this.sh060Init.generalFlg == 1 && _this.sh060Init.fea042TeikiFlg == 1)) {
                            // クレジットの場合
                            if (_this.sh060Init.realAuthoriFlg == '1') {
                                _this.sh060Request.cardSaveFlg = 1;
                            } else {
                                _this.sh060Request.cardSaveFlg = 0;
                            }
                        }

                        _this.descriptionInfo = _this.sh060Init.descriptionInfo;

                        if(response.data.respCode == _this.NO_CART_ERR){
                            _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 16}});
                            _this.noCartErrFlg = 1;
                            return;
                        }

                        if(response.data.respCode == _this.CART_INFO_INVALID_ERR){
                            _this.$router.push({ name: 'Warning'});
                            return;
                        }
                        
                        if (response.data.respCode == _this.BESE_KIN_ERR) {
                            alert("最大購入金額は" + _this.sh060Init.baseKin + "円です。");
                            _this.orderButtonFlg = false;
                        }
                        
                        if(response.data.errList != null && response.data.errList.length > 0){
                            _this.displayWarning(response.data.errList);
                        }

                        // 自動発注可否チェック
                        _this.isHatchuShowCheck();

                        // ASUKAチェック
                        if (_this.sh060Init.asukaOptionFlg == 1) {
                            // ASUKAを使用している場合、準備ができていればtrueにする
                            if (_this.isAsukaReadyToScore || window.asukaAlready) {
                                _this.isSubmitButton = true;
                                _this.isAsukaReadyToScore = true;
                            } else {
                                _this.reCheckAsukaReadyToScore();
                            }
                        } else {
                            // ASUKAを使用していない場合はtrueにする
                            _this.isSubmitButton = true;
                        }

                        if (_this.stringNvl(_this.sh060Init.cardNoDisp) != '') {
                            _this.showNowCardFlg = 0;
                        } else {
                            _this.showNowCardFlg = 1;
                        }

                        _this.setHopeDayList();
                    }
                }).catch(function(error) {
                    // eslint-disable-next-line
                    _this.is3DLoding = false;
                    _this.isLoading = false;
                    sessionStorage.removeItem('amazonPayInfo');
                    sessionStorage.removeItem('amazonCheckoutSessionId');
                    _this.listMessValid = [];
                    _this.sh060Init = _this.ptInitData;
                    _this.sh060Init.kessaiCd = "";
                    _this.sh060Init.orderInfo['SIHARAI_HOHO_KBN_NM'] = "指定なし";
                    // 決済処理時にエラーが発生しました。入力内容をご確認の上、再度ご入力いただくか、決済方法を変更してください。
                    _this.listMessValid.push("Amazon Pay での決済に失敗しました。お支払方法にて別の決済方法をご選択頂くか、もしくは、お時間をあけて再度お試し下さい。");
                    sessionStorage.removeItem('amazonPayInfo');
                    sessionStorage.removeItem('amazonCheckoutSessionId');
                    _this.sh060Request.amazonCheckoutSessionId = null;
                    EventBus.$emit('message', {});
                    if (_this.isScroll == '0') {
                        _this.styleObject = '';
                    }else if (_this.isScroll == ''){
                        _this.styleObject = '';
                    }
                    // 画面上部に注文確定ボタンを表示(0だったら非表示)
                    if (_this.sh060Init.upperPartButtonFlg == '1') {
                        _this.isUpperPartButtonFlg = true;
                    }else if (_this.sh060Init.upperPartButtonFlg == '0') {
                        _this.isUpperPartButtonFlg = false;
                    }else if (_this.sh060Init.upperPartButtonFlg == ''){
                        _this.isUpperPartButtonFlg = false;
                    }

                    // 届先指定画面スキップフラグ
                    if (_this.sh060Init.tdkInfoFlg == '0') {
                        _this.tdkSkipFlg = true;
                    }

                    // 定期請求情報用
                    if (_this.sh060Init.teikiEx > 0 || _this.sh060Init.teikiIn > 0) {
                        _this.teikiSeikyuEx = parseInt(_this.sh060Init.teikiEx)
                                            + parseInt(_this.sh060Init.soryoTotal)
                                            + parseInt(_this.sh060Init.daiTesuuKinTotal)
                                            + parseInt(_this.sh060Init.sonotaTesuuKDinTotal1)
                                            + parseInt(_this.sh060Init.kessaiTesuKinTotal)
                                            + parseInt(_this.sh060Init.sonotaTesuuKDinTotal2)
                                            + parseInt(_this.sh060Init.teikiZei);
                                            
                        _this.teikiSeikyuIn = parseInt(_this.sh060Init.teikiIn)
                                            + parseInt(_this.sh060Init.soryoTotal)
                                            + parseInt(_this.sh060Init.daiTesuuKinTotal)
                                            + parseInt(_this.sh060Init.sonotaTesuuKDinTotal1)
                                            + parseInt(_this.sh060Init.kessaiTesuKinTotal)
                                            + parseInt(_this.sh060Init.sonotaTesuuKDinTotal2);
                        
                        if (_this.sh060Init.pointKin > _this.teikiSeikyuIn) {
                            _this.teikiPoint = _this.teikiSeikyuIn
                                            - parseInt(_this.sh060Init.cupponNebikiKin)
                                            - parseInt(_this.sh060Init.promoKin)
                                            - parseInt(_this.sh060Init.matomeWaribikiKin);
                        } else {
                            _this.teikiPoint = _this.sh060Init.pointKin;
                        }

                        _this.teikiSeikyuNebiki = parseInt(_this.sh060Init.cupponNebikiKin)
                                                + parseInt(_this.sh060Init.promoKin)
                                                + parseInt(_this.sh060Init.matomeWaribikiKin)
                                                + parseInt(_this.teikiPoint);
                    }

                    // 支払い方法スキップフラグ
                    if (_this.sh060Init.paySkipFlg == '0') {
                        _this.paySkipFlg = true;
                    }
                    _this.confirmFlg = true;
                    _this.completeFlg = true;
                    // 定期商品フラグ || 通常商品の場合かつ現在契約中の定期がある場合
                    if (_this.sh060Init.teikiFlg == 1 || (_this.sh060Init.generalFlg == 1 && _this.sh060Init.fea042TeikiFlg == 1)) {
                        // クレジットの場合
                        if (_this.sh060Init.realAuthoriFlg == '1') {
                            _this.sh060Request.cardSaveFlg = 1;
                        } else {
                            _this.sh060Request.cardSaveFlg = 0;
                        }
                    }

                    _this.descriptionInfo = _this.sh060Init.descriptionInfo;


                    if(error.response != null && error.response != undefined){
                        if(error.response.data.respCode == _this.NO_CART_ERR){
                            _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 16}});
                            _this.noCartErrFlg = 1;
                            return;
                        }
                    }

                    if(error.response != null && error.response != undefined){
                        if(error.response.data.respCode == _this.CART_INFO_INVALID_ERR){
                            _this.$router.push({ name: 'Warning'});
                            return;
                        }
                    }
                    
                    if(error.response != null && error.response != undefined){
                        if (error.response.data.respCode == _this.BESE_KIN_ERR) {
                            alert("最大購入金額は" + _this.sh060Init.baseKin + "円です。");
                            _this.orderButtonFlg = false;
                        }
                    }
                    
                    if(error.response != null && error.response != undefined){
                        if(error.response.data.errList != null && error.response.data.errList.length > 0){
                            _this.displayWarning(error.response.data.errList);
                        }
                    }

                    // 自動発注可否チェック
                    _this.isHatchuShowCheck();

                    // ASUKAチェック
                    if (_this.sh060Init.asukaOptionFlg == 1) {
                        // ASUKAを使用している場合、準備ができていればtrueにする
                        if (_this.isAsukaReadyToScore || window.asukaAlready) {
                            _this.isSubmitButton = true;
                            _this.isAsukaReadyToScore = true;
                        } else {
                            _this.reCheckAsukaReadyToScore();
                        }
                    } else {
                        // ASUKAを使用していない場合はtrueにする
                        _this.isSubmitButton = true;
                    }

                    if (_this.stringNvl(_this.sh060Init.cardNoDisp) != '') {
                        _this.showNowCardFlg = 0;
                    } else {
                        _this.showNowCardFlg = 1;
                    }

                    _this.setHopeDayList();
                    if(error) {
                        if(error.response) {
                            if(406 == error.response.status) {
                                var resultValid = common.excuteValidationEcSite(error, _this.SH060_PART);
                                if(resultValid) {
                                    if (resultValid.mapMsg[0].key == "zaiko_busoku") {
                                        // オンライン同時購入在庫不足
                                        _this.listMessValid.push(resultValid.mapMsg[0].mess);
                                    }
                                    _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                    _this.listMessValid = resultValid.msgList;
                                    _this.mapMessValid = resultValid.mapMsg;
                                }
                                common.scrollTop();
                            } else {
                                common.errorAPI(error);
                            }
                        }
                    }
                    
                }).finally(function() {
                    _this.$emit("event-loading", false);
                    //_this.is3DLoding = false;
                });
            } else {
                if  (amazonCheckoutSessionId != null) {
                    sessionStorage['amazonCheckoutSessionId'] = amazonCheckoutSessionId;
                } else if (amazonCheckoutSessionId == null && sessionStorage['amazonCheckoutSessionId'] != null) {
                    amazonCheckoutSessionId =  sessionStorage['amazonCheckoutSessionId'];
                }
                if (sessionStorage['amazonCheckoutSessionId'] != null) {
                    const script = document.createElement('script');
                    script.src = 'https://static-fe.payments-amazon.com/checkout.js';
                    script.async = true;
                    document.head.appendChild(script);
                    // Wait for the script to be loaded before rendering the button
                    script.onload = () => {
                        amazon.Pay.bindChangeAction('#changeButton1', {
                            amazonCheckoutSessionId: sessionStorage['amazonCheckoutSessionId'],
                            changeAction: 'changeAddress'
                        });
                    }
                }
                if (sessionStorage['amazonCheckoutSessionId'] != null) {
                    const script = document.createElement('script');
                    script.src = 'https://static-fe.payments-amazon.com/checkout.js';
                    script.async = true;
                    document.head.appendChild(script);
                    // Wait for the script to be loaded before rendering the button
                    script.onload = () => {
                        amazon.Pay.bindChangeAction('#changeButton2', {
                            amazonCheckoutSessionId: sessionStorage['amazonCheckoutSessionId'],
                            changeAction: 'changeAddress'
                        });
                    }
                }
                if(amazonCheckoutSessionId != null && _this.ptInitData && _this.doinitFlg) {
                    _this.doinitFlg = false;
                }
                if(sessionStorage['amazonCheckoutSessionId'] == null && _this.ptInitData && _this.ptInitData.kessaiCd ==  _this.Constants.KESSAI_AMAZONPAY) {
                    // 画面上部にAmazonPayボタンを表示(0だったら非表示)
                    // Dynamically load the Amazon Pay SDK script
                    const script = document.createElement('script');
                    script.src = 'https://static-fe.payments-amazon.com/checkout.js';
                    script.async = true;
                    document.head.appendChild(script);
                    // Wait for the script to be loaded before rendering the button
                    script.onload = () => {
                        // Check if the AmazonPay object is available
                        amazon.Pay.renderButton('#AmazonPayButton', {
                            // set checkout environment
                            merchantId: _this.ptInitData.merchantId,
                            ledgerCurrency: 'JPY',           
                            // customize the buyer experience
                            checkoutLanguage: 'ja_JP',
                            productType: 'PayAndShip',
                            placement: 'Checkout',
                            buttonColor: 'Gold'
                        });
                    };
                }
                if(sessionStorage['amazonCheckoutSessionId'] == null && _this.ptInitData && _this.ptInitData.kessaiCd ==  _this.Constants.KESSAI_AMAZONPAY) {
                    // 画面上部にAmazonPayボタンを表示(0だったら非表示)
                    // Dynamically load the Amazon Pay SDK script
                    const script = document.createElement('script');
                    script.acceptCharset ="utf-8";
                    script.type = "text/javascript";
                    script.src = 'https://static-fe.payments-amazon.com/checkout.js';
                    script.async = true;
                    document.head.appendChild(script);
                    // Wait for the script to be loaded before rendering the button
                    script.onload = () => {
                        // Check if the AmazonPay object is available
                        amazon.Pay.renderButton('#AmazonPayButton3', {
                            // set checkout environment
                            merchantId: _this.ptInitData.merchantId,
                            ledgerCurrency: 'JPY',         
                            // customize the buyer experience
                            checkoutLanguage: 'ja_JP',
                            productType: 'PayAndShip',
                            placement: 'Checkout',
                            buttonColor: 'Gold',
                            // configure Create Checkout Session request
                            createCheckoutSessionConfig: {        
                                payloadJSON: _this.ptInitData.payloadJson,
                                signature: _this.ptInitData.signature, 
                                publicKeyId: _this.ptInitData.publicKeyId
                            }
                        });
                    };
                }
                if(sessionStorage['amazonCheckoutSessionId'] == null && _this.ptInitData && _this.ptInitData.kessaiCd ==  _this.Constants.KESSAI_AMAZONPAY) {
                    // 画面上部にAmazonPayボタンを表示(0だったら非表示)
                    // Dynamically load the Amazon Pay SDK script
                    const script = document.createElement('script');
                    script.acceptCharset ="utf-8";
                    script.type = "text/javascript";
                    script.src = 'https://static-fe.payments-amazon.com/checkout.js';
                    script.async = true;
                    document.head.appendChild(script);
                    // Wait for the script to be loaded before rendering the button
                    script.onload = () => {
                        // Check if the AmazonPay object is available
                        amazon.Pay.renderButton('#AmazonPayButton2', {
                            // set checkout environment
                            merchantId: _this.ptInitData.merchantId,
                            ledgerCurrency: 'JPY', 
                            // customize the buyer experience
                            checkoutLanguage: 'ja_JP',
                            productType: 'PayAndShip',
                            placement: 'Checkout',
                            buttonColor: 'Gold',
                            // configure Create Checkout Session request
                            createCheckoutSessionConfig: {        
                                payloadJSON: _this.ptInitData.payloadJson,
                                signature: _this.ptInitData.signature, 
                                publicKeyId: _this.ptInitData.publicKeyId
                            }
                        });
                        
                    };
                }
                if (_this.ptInitData && !_this.doinitFlg) {
                    _this.sh060Init = _this.ptInitData;

                    //遠鉄
                    if (_this.sh060Init.entetsuFlg == 1 && _this.sh060Init.entetsuAutoLoginFlg == 1){
                        //kainInfo存在は遠鉄個人です
                        if (sessionStorage.getItem('kainInfo')){
                            _this.entetsuKainInfo = JSON.parse(sessionStorage.getItem('kainInfo'));
                            _this.entetsuPoint = _this.entetsuKainInfo.kanouPoint;
                            //遠鉄個人ポイント付与数 表示
                            _this.entetsuPointPlusFlg = _this.entetsuKainInfo.pointPlusFlg;
                            _this.entetsuPointRiyoFlg = _this.entetsuKainInfo.pointRiyoFlg;

                            _this.sh060Request.entetsuFlg = _this.sh060Init.entetsuFlg;
                            _this.sh060Request.kaiNo = _this.entetsuKainInfo.kaiNo;
                            _this.sh060Request.sesId = _this.entetsuKainInfo.sesId;
                            _this.sh060Request.entetsuPointRiyoFlg = _this.entetsuKainInfo.pointRiyoFlg;
                            _this.sh060Request.entetsuPointPlusFlg = _this.entetsuKainInfo.pointPlusFlg;
                            _this.sh060Request.entetsuPoint = _this.entetsuPoint;
                            _this.sh060Request.entetsuKokyakuKbn = _this.entetsuKainInfo.RankKbn;

                            _this.sh060Init.givenPointFlg = _this.entetsuPointPlusFlg;
                            _this.sh060Init.totalPoint = _this.entetsuPoint;
                            if (_this.sh060Init.entetsuFlg == 1 && _this.sh060Init.entetsuAutoLoginFlg == 1 && _this.entetsuPointRiyoFlg == 0){
                                _this.pointChangeFlg = 0;
                            }
                        }
                    }
                    
                    if  (amazonCheckoutSessionId != null && _this.sh060Init.kessaiCd != "83") {
                        _this.$emit("event-loading-message", true, "処理中です。そのままお待ちください。");
                    }
                    _this.setGiftKbn();
                    sessionStorage.setItem('oldOrderCd', _this.sh060Init.oldOrderCd);
                    _this.security3DFlg = _this.ptInitData.security3DFlg;
                    _this.securityGmo3DFlg = _this.ptInitData.securityGmo3DFlg;//gmo
                    _this.securitySps3DFlg = _this.ptInitData.securitySps3DFlg;//sps
                    _this.securitySbp3DFlg = _this.ptInitData.securitySbp3DFlg;//sbp
                    _this.sh060Request = Object.assign({}, _this.sh060Request, _this.ptInitData);
                    _this.sh060Request.amazonCheckoutSessionId = amazonCheckoutSessionId;
                    _this.sh060Request.teikiAddFlg = _this.sh060Init.teikiAddFlg;
                    _this.sh060Request.teikiTdkYmd = _this.sh060Init.teikiTdkYmd;
                    _this.sh060Request.birthdayFlg = _this.sh060Init.birthdayFlg;
                    _this.sh060Request.birthDayYYYY = _this.sh060Init.birthDayYYYY;
                    _this.sh060Request.birthDayMM   = _this.sh060Init.birthDayMM;
                    _this.sh060Request.birthDayDD   = _this.sh060Init.birthDayDD;
                    _this.isScroll = _this.sh060Init.scrollFlg;
                    if (_this.sh060Init.errList && _this.sh060Init.errList.length > 0) {
                        for (var i = 0; i < _this.sh060Init.errList.length; i++) {
                            for (var j = 0; j < _this.sh060Init.errList[i].messageList.length; j++) {
                                _this.listMessValid.push(_this.sh060Init.errList[i].messageList[j].message);
                            }
                        }
                    }
                    if(amazonCheckoutSessionId != null && (_this.sh060Init.kokyakuNo == null || _this.sh060Init.kokyakuNo == '999999999') && _this.sh060Init.orderInfo == null) {
                        // 非ログインの場合ログイン画面へ
                        _this.loginPage = 1;
                        _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 18, returnFlg:1, fromCart:1, amazonCheckoutSessionId:amazonCheckoutSessionId}});
                       return;
                    } else if(amazonCheckoutSessionId != null) {
                        axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.SH060 + _this.$UrlConstants.DO_INIT_AMAZONPAY, _this.sh060Request).then(function(response) {
                            _this.sh060Init.kokyakuNm1 = response.data.orderInfo['KOKYAKU_NM1'];
                            _this.sh060Init.kokyakuNm2 = response.data.orderInfo['KOKYAKU_NM2'];
                            _this.sh060Init.kokyakuNm3 = "";
                            _this.sh060Init.orderInfo['KOKYAKU_ZIP'] = response.data.orderInfo['KOKYAKU_ZIP'];
                            _this.sh060Init.orderInfo['KOKYAKU_ADDR1'] = response.data.orderInfo['KOKYAKU_ADDR1'];
                            _this.sh060Init.orderInfo['KOKYAKU_ADDR2'] = response.data.orderInfo['KOKYAKU_ADDR2'];
                            _this.sh060Init.orderInfo['KOKYAKU_ADDR3'] = response.data.orderInfo['KOKYAKU_ADDR3'];
                            _this.sh060Init.orderInfo['AMAZON_PAY_INFO'] = response.data.orderInfo['AMAZON_PAY_INFO'];
                            if (_this.sh060Init.kessaiCd != response.data.orderInfo['KESSAI_CD']) {
                                _this.sh060Init.kessaiCd = response.data.orderInfo['KESSAI_CD'];
                                window.location.replace(window.location.href);
                            }
                        }).catch(function(error) {
                            _this.is3DLoding = false;
                            common.errorAPI(error);
                        }).finally(function() {
                            _this.$emit("event-loading", false);
                        });
                    }
                    // スクロールバー表示(0だったら非表示)
                    if (_this.isScroll == '0') {
                        _this.styleObject = '';
                    }else if (_this.isScroll == ''){
                        _this.styleObject = '';
                    }

                    // 画面上部に注文確定ボタンを表示(0だったら非表示)
                    if (_this.sh060Init.upperPartButtonFlg == '1') {
                        _this.isUpperPartButtonFlg = true;
                    }else if (_this.sh060Init.upperPartButtonFlg == '0') {
                        _this.isUpperPartButtonFlg = false;
                    }else if (_this.sh060Init.upperPartButtonFlg == ''){
                        _this.isUpperPartButtonFlg = false;
                    }

                    // 届先指定画面スキップフラグ
                    if (_this.sh060Init.tdkInfoFlg == '0') {
                        _this.tdkSkipFlg = true;
                    }
                    // 支払い方法スキップフラグ
                    if (_this.sh060Init.paySkipFlg == '0') {
                        _this.paySkipFlg = true;
                    }
                    _this.confirmFlg = true;
                    _this.completeFlg = true;
                    // クレジットフラグ
                    if (_this.sh060Init.realAuthoriFlg == '1') {
                        _this.creditFlg = true;
                        _this.sh060Request.cardSaveFlg = 1;
                        if (_this.sh060Init.payCntList.length > 0) {
                            _this.sh060Request.cardPayCnt = _this.sh060Init.payCntList[0]['KEY'];
                            _this.sh060Request.lastCardPayCnt = _this.sh060Init.payCntList[0]['KEY'];
                        }
                        if (_this.sh060Init.cardNoDisp) {
                            _this.sh060Request.cardFlg = "1";
                        }
                    // コンビニフラグ
                    } else if (_this.sh060Init.realAuthoriFlg == '2') {
                        _this.conveniFlg = true;
                    }
                    // 定期商品フラグ || 通常商品の場合かつ現在契約中の定期がある場合
                    if (_this.sh060Init.teikiFlg == 1 || (_this.sh060Init.generalFlg == '1' && _this.sh060Init.fea042TeikiFlg == '1')) {
                        // クレジットの場合
                        if (_this.sh060Init.realAuthoriFlg == '1') {
                            _this.sh060Request.cardSaveFlg = 1;
                        } else {
                            _this.sh060Request.cardSaveFlg = 0;
                        }
                    }

                    _this.descriptionInfo = _this.sh060Init.descriptionInfo;

                    if(_this.ptInitData.respCode == _this.NO_CART_ERR){
                        _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 16}});
                        _this.noCartErrFlg = 1;
                        return;
                    }
                    if(_this.ptInitData.respCode == _this.CART_INFO_INVALID_ERR){
                        _this.$router.push({ name: 'Warning'});
                        return;
                    }
                    if (_this.ptInitData.respCode == _this.BESE_KIN_ERR) {
                        alert("最大購入金額は" + _this.sh060Init.baseKin + "円です。");
                        _this.orderButtonFlg = false;
                    }

                    if(_this.ptInitData.errList != null && _this.ptInitData.errList.length > 0){
                        _this.displayWarning(_this.ptInitData.errList);
                    }

                    // 自動発注可否チェック
                    _this.isHatchuShowCheck();

                    // ASUKAチェック
                    if (_this.sh060Init.asukaOptionFlg == 1) {
                        // ASUKAを使用している場合、準備ができていればtrueにする
                        if (_this.isAsukaReadyToScore || window.asukaAlready) {
                            _this.isSubmitButton = true;
                            _this.isAsukaReadyToScore = true;
                        } else {
                            _this.reCheckAsukaReadyToScore();
                        }
                    } else {
                        // ASUKAを使用していない場合はtrueにする
                        _this.isSubmitButton = true;
                    }

                    //jas 3d
                    if (_this.jasApiSeqNo){
                        _this.is3DLoding = true;
                        _this.getJasApiInfo();
                    }
                    
                    //gmo 3d
                    if (_this.gmo2AuthAccessID){
                        _this.is3DLoding = true;
                        _this.doGmo2Order();
                    }

                    //sps 3d
                    if (_this.spsResultId) {
                        _this.is3DLoding = true;
                        _this.doSps2Order();
                    }

                    //sbp 3d
                    if (_this.sbpEmv3dsStatus) {
                        if (sessionStorage['sbp_ccdd']){
                            _this.sh060Request.resSbpCustId = sessionStorage['sbp_ccdd'];
                        }
                        sessionStorage.removeItem('sbp_ccdd');

                        if (_this.sbpEmv3dsStatus == 'ok' && _this.sbpTdsAuthenticationId){
                            _this.is3DLoding = true;
                          
                            _this.sh060Request.cardFlg = sessionStorage['sbpCardFlg'];
                            _this.sh060Request.cardSaveFlg = sessionStorage['sbpCardSaveFlg'];
                            _this.sh060Request.limitYear = sessionStorage['sbpLimitYear'];
                            _this.sh060Request.limitMonth = sessionStorage['sbpLimitMonth'];
                            _this.sh060Request.cardPayCnt = sessionStorage['sbpCardPayCnt'];
                            if (sessionStorage['sbpBunkatuKaisu']){
                                _this.sh060Request.bunkatuKaisu = sessionStorage['sbpBunkatuKaisu'];
                            }

                            if (_this.sh060Request.cardFlg == undefined || _this.sh060Request.cardFlg == '0'){
                                _this.sh060Request.securityCode = sessionStorage['sbpSecurityCode'];
                            }else{
                                _this.sh060Request.cardSecurity = sessionStorage['sbpSecurityCode'];
                            }
                            
                            sessionStorage.removeItem('sbpCardFlg');
                            sessionStorage.removeItem('sbpCardSaveFlg');
                            sessionStorage.removeItem('sbpLimitYear');
                            sessionStorage.removeItem('sbpLimitMonth');
                            sessionStorage.removeItem('sbpCardPayCnt');
                            sessionStorage.removeItem('sbpBunkatuKaisu');
                            sessionStorage.removeItem('sbpSecurityCode');

                            _this.doSbp2Order();
                        }else{
                            //SBペイメントの3DS認証要求NG
                            if (_this.sbpEmv3dsStatus == 'ng'){
                                _this.is3DLoding = true;

                                _this.listMessValid.push(_this.$i18n.t('sh060.messages.sbp3dsNgMsg'));
                                EventBus.$emit('message', {});
                                common.scrollTop();
 
                            }
                           _this.is3DLoding = false; 
                        }
                         _this.sbpEmv3dsStatus = '';
                    }

                    //GMO d払い
                    if (_this.gmodpaySeqNo){
                        _this.is3DLoding = true;
                        _this.doGmoDpayOrder();
                    }

                    if (_this.stringNvl(_this.sh060Init.cardNoDisp) != '') {
                        _this.showNowCardFlg = 0;
                    } else {
                        _this.showNowCardFlg = 1;
                    }
                    if (sessionStorage['hopeDay'] != null) {
                        _this.sh060Request.hopeDay = sessionStorage['hopeDay'];
                    }
                    if (sessionStorage['hopeDayCnt'] != null) {
                        _this.sh060Request.hopeDayCnt = sessionStorage['hopeDayCnt'];
                    }
                    _this.teikiShipCheck();
                    _this.setHopeDayList();

                    _this.$emit("event-loading", false);
                    return;
                } 
                _this.doinitFlg = false;
                _this.site = _this.$router.history.current.fullPath.split("/")[1];
                var host = window.location.protocol + "//" + window.location.host;
                let request = { clientHost: host, gmo2AuthAccessID: _this.gmo2AuthAccessID};
                if (amazonCheckoutSessionId != null) {
                    request.amazonCheckoutSessionId = amazonCheckoutSessionId;
                }
                request.reOrderFlg = _this.reOrderFlg;
                axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.SH060 + _this.$UrlConstants.DO_INIT, request).then(function(response) {
                    _this.sh060Init = response.data;

                    //遠鉄
                    if (_this.sh060Init.entetsuFlg == 1 && _this.sh060Init.entetsuAutoLoginFlg == 1){
                        //kainInfo存在は遠鉄個人です
                        if (sessionStorage.getItem('kainInfo')){
                            _this.entetsuKainInfo = JSON.parse(sessionStorage.getItem('kainInfo'));
                            _this.entetsuPoint = _this.entetsuKainInfo.kanouPoint;
                            //遠鉄個人ポイント付与数 表示
                            _this.entetsuPointPlusFlg = _this.entetsuKainInfo.pointPlusFlg;
                            _this.entetsuPointRiyoFlg = _this.entetsuKainInfo.pointRiyoFlg;

                            _this.sh060Request.entetsuFlg = _this.sh060Init.entetsuFlg;
                            _this.sh060Request.kaiNo = _this.entetsuKainInfo.kaiNo;
                            _this.sh060Request.sesId = _this.entetsuKainInfo.sesId;
                            _this.sh060Request.entetsuPointRiyoFlg = _this.entetsuKainInfo.pointRiyoFlg;
                            _this.sh060Request.entetsuPointPlusFlg = _this.entetsuKainInfo.pointPlusFlg;
                            _this.sh060Request.entetsuPoint = _this.entetsuPoint;
                            _this.sh060Request.entetsuKokyakuKbn = _this.entetsuKainInfo.RankKbn;

                            _this.sh060Init.givenPointFlg = _this.entetsuPointPlusFlg;
                            _this.sh060Init.totalPoint = _this.entetsuPoint;
                            if (_this.sh060Init.entetsuFlg == 1 && _this.sh060Init.entetsuAutoLoginFlg == 1 && _this.entetsuPointRiyoFlg == 0){
                                _this.pointChangeFlg = 0;
                            }
                        }
                    }
                    _this.setGiftKbn();
                    sessionStorage.setItem('oldOrderCd', _this.sh060Init.oldOrderCd);
                    _this.security3DFlg = response.data.security3DFlg;
                    _this.securityGmo3DFlg = response.data.securityGmo3DFlg;//gmo
                    _this.securitySbp3DFlg = response.data.securitySbp3DFlg;//sbp
                    _this.sh060Request = Object.assign({}, _this.sh060Request, response.data.reqModel);
                    _this.sh060Request.teikiAddFlg = _this.sh060Init.teikiAddFlg;
                    _this.sh060Request.teikiTdkYmd = _this.sh060Init.teikiTdkYmd;
                    _this.sh060Request.birthdayFlg = _this.sh060Init.birthdayFlg;
                    _this.sh060Request.birthDayYYYY = _this.sh060Init.birthDayYYYY;
                    _this.sh060Request.birthDayMM   = _this.sh060Init.birthDayMM;
                    _this.sh060Request.birthDayDD   = _this.sh060Init.birthDayDD;
                    _this.isScroll = _this.sh060Init.scrollFlg;
                    if(amazonCheckoutSessionId != null && (_this.sh060Init.kokyakuNo == null || _this.sh060Init.kokyakuNo == '999999999') && actionId == null) {
                        _this.loginPage = 1;
                        // 非ログインの場合ログイン画面へ
                        _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 18, returnFlg:1, fromCart:1, amazonCheckoutSessionId:amazonCheckoutSessionId}});
                        return;
                    }  
                    // スクロールバー表示(0だったら非表示)
                    if (_this.isScroll == '0') {
                        _this.styleObject = '';
                    }else if (_this.isScroll == ''){
                        _this.styleObject = '';
                    }

                    // 画面上部に注文確定ボタンを表示(0だったら非表示)
                    if (_this.sh060Init.upperPartButtonFlg == '1') {
                        _this.isUpperPartButtonFlg = true;
                    }else if (_this.sh060Init.upperPartButtonFlg == '0') {
                        _this.isUpperPartButtonFlg = false;
                    }else if (_this.sh060Init.upperPartButtonFlg == ''){
                        _this.isUpperPartButtonFlg = false;
                    }

                    // 届先指定画面スキップフラグ
                    if (_this.sh060Init.tdkInfoFlg == '0') {
                        _this.tdkSkipFlg = true;
                    }
                    // 支払い方法スキップフラグ
                    if (_this.sh060Init.paySkipFlg == '0') {
                        _this.paySkipFlg = true;
                    }
                    _this.confirmFlg = true;
                    _this.completeFlg = true;
                    // クレジットフラグ
                    if (_this.sh060Init.realAuthoriFlg == '1') {
                        _this.creditFlg = true;
                        _this.sh060Request.cardSaveFlg = 1;
                        if (_this.sh060Init.payCntList.length > 0) {
                            _this.sh060Request.cardPayCnt = _this.sh060Init.payCntList[0]['KEY'];
                            _this.sh060Request.lastCardPayCnt = _this.sh060Init.payCntList[0]['KEY'];
                        }
                        if (_this.sh060Init.cardNoDisp) {
                            _this.sh060Request.cardFlg = "1";
                        }
                    // コンビニフラグ
                    } else if (_this.sh060Init.realAuthoriFlg == '2') {
                        _this.conveniFlg = true;
                    }
                    // 定期商品フラグ || 通常商品の場合かつ現在契約中の定期がある場合
                    if (_this.sh060Init.teikiFlg == 1 || (_this.sh060Init.generalFlg == '1' && _this.sh060Init.fea042TeikiFlg == '1')) {
                        // クレジットの場合
                        if (_this.sh060Init.realAuthoriFlg == '1') {
                            _this.sh060Request.cardSaveFlg = 1;
                        } else {
                            _this.sh060Request.cardSaveFlg = 0;
                        }
                    }

                    _this.descriptionInfo = _this.sh060Init.descriptionInfo;

                    if(response.data.respCode == _this.NO_CART_ERR){
                        _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 16}});
                        _this.noCartErrFlg = 1;
                        return;
                    }
                    if(response.data.respCode == _this.CART_INFO_INVALID_ERR){
                        _this.$router.push({ name: 'Warning'});
                        return;
                    }
                    if (response.data.respCode == _this.BESE_KIN_ERR) {
                        alert("最大購入金額は" + _this.sh060Init.baseKin + "円です。");
                        _this.orderButtonFlg = false;
                    }
                    
                    if(response.data.errList != null && response.data.errList.length > 0){
                        _this.displayWarning(response.data.errList);
                    }

                    // 自動発注可否チェック
                    _this.isHatchuShowCheck();

                    // ASUKAチェック
                    if (_this.sh060Init.asukaOptionFlg == 1) {
                        // ASUKAを使用している場合、準備ができていればtrueにする
                        if (_this.isAsukaReadyToScore || window.asukaAlready) {
                            _this.isSubmitButton = true;
                            _this.isAsukaReadyToScore = true;
                        } else {
                            _this.reCheckAsukaReadyToScore();
                        }
                    } else {
                        // ASUKAを使用していない場合はtrueにする
                        _this.isSubmitButton = true;
                    }

                    //jas 3d
                    if (_this.jasApiSeqNo){
                        _this.is3DLoding = true;
                        _this.getJasApiInfo();
                    }
                    
                    //gmo 3d
                    if (_this.gmo2AuthAccessID){
                        _this.is3DLoding = true;
                        _this.doGmo2Order();
                    }

                    //sps 3d
                    if (_this.spsResultId) {
                        _this.is3DLoding = true;
                        _this.doSps2Order();
                    }

                    //sbp 3d
                    if (_this.sbpEmv3dsStatus) {
                        if (sessionStorage['sbp_ccdd']){
                            _this.sh060Request.resSbpCustId = sessionStorage['sbp_ccdd'];
                        }
                        sessionStorage.removeItem('sbp_ccdd');
                        
                        if (_this.sbpEmv3dsStatus == 'ok' && _this.sbpTdsAuthenticationId){
                            _this.is3DLoding = true;

                            _this.sh060Request.cardFlg = sessionStorage['sbpCardFlg'];
                            _this.sh060Request.cardSaveFlg = sessionStorage['sbpCardSaveFlg'];
                            _this.sh060Request.limitYear = sessionStorage['sbpLimitYear'];
                            _this.sh060Request.limitMonth = sessionStorage['sbpLimitMonth'];
                            _this.sh060Request.cardPayCnt = sessionStorage['sbpCardPayCnt'];
                            if (sessionStorage['sbpBunkatuKaisu']){
                                _this.sh060Request.bunkatuKaisu = sessionStorage['sbpBunkatuKaisu'];
                            }
                            if (_this.sh060Request.cardFlg == undefined || _this.sh060Request.cardFlg == '0'){
                                _this.sh060Request.securityCode = sessionStorage['sbpSecurityCode'];
                            }else{
                                _this.sh060Request.cardSecurity = sessionStorage['sbpSecurityCode'];
                            }
                            
                            sessionStorage.removeItem('sbpCardFlg');
                            sessionStorage.removeItem('sbpCardSaveFlg');
                            sessionStorage.removeItem('sbpLimitYear');
                            sessionStorage.removeItem('sbpLimitMonth');
                            sessionStorage.removeItem('sbpCardPayCnt');
                            sessionStorage.removeItem('sbpBunkatuKaisu');
                            sessionStorage.removeItem('sbpSecurityCode');

                            _this.doSbp2Order();
                        }else{
                            //SBペイメントの3DS認証要求NG
                            if (_this.sbpEmv3dsStatus == 'ng'){
                                _this.is3DLoding = true;

                                _this.listMessValid.push(_this.$i18n.t('sh060.messages.sbp3dsNgMsg'));
                                EventBus.$emit('message', {});
                                common.scrollTop();
                            }
                           _this.is3DLoding = false; 
                        }
                         _this.sbpEmv3dsStatus = '';
                     }

                    if (_this.stringNvl(_this.sh060Init.cardNoDisp) != '') {
                        _this.showNowCardFlg = 0;
                    } else {
                        _this.showNowCardFlg = 1;
                    }
                    if (sessionStorage['hopeDay'] != null) {
                        _this.sh060Request.hopeDay = sessionStorage['hopeDay'];
                    }
                    if (sessionStorage['hopeDayCnt'] != null) {
                        _this.sh060Request.hopeDayCnt = sessionStorage['hopeDayCnt'];
                    }
                    _this.teikiShipCheck();
                    _this.setHopeDayList();

                }).catch(function(error) {
                    _this.is3DLoding = false;
                    if (_this.sbpTdsAuthenticationId) {
                        _this.sbpTdsAuthenticationId = '';
                        sessionStorage.removeItem('sbpLimitYear');
                        sessionStorage.removeItem('sbpLimitMonth');
                        sessionStorage.removeItem('sbpCardPayCnt');
                        sessionStorage.removeItem('sbpBunkatuKaisu');
                        sessionStorage.removeItem('sbpSecurityCode');
                    }
                    common.errorAPI(error);
                }).finally(function() {
                    _this.$emit("event-loading", false);
                });
            }
        },
        // 配送希望日選択時 data:1 指定なし  data2 指定あり
		hopeDayRadio:function(data,tdkIdx){
            var _this = this;
            // 指定なしの場合
            if (data != 2) {
                // 指定日をリセット
                _this.sh060Request.hopeDay = "";
                // 定期商品リストを非表示
                _this.showTeikiFlg = false;
                // 定期フラグをリセット
                _this.reqModel.teikiFlg = 0;
            }
            _this.$forceUpdate();
        },
        setHopeDayList() {
            let _this = this;
            let pointKin = parseInt(common.numberNvl(_this.sh060Init.pointKin), 10);
            let points = [pointKin];
            if(sessionStorage['hopeDayList']) {
                _this.sh060Request.hopeDayList = JSON.parse(sessionStorage['hopeDayList']); 
                _this.hatchuCnt = _this.sh060Request.hopeDayList.length;

                let totalPoint = parseInt(common.numberNvl(sessionStorage['totalPointKin']), 10);
                points = Array.from({length: _this.hatchuCnt}, (v, k) => {
                    let currentPoint = _this.sh060Init.zengakuPointCnt == 0 || _this.sh060Init.zengakuPointCnt > k 
                        ? (k > 0 ? (_this.sh060Init.seikyuuKin + pointKin + _this.sh060Init.oneTimeCupponKin) : _this.sh060Init.seikyuuKin + pointKin) 
                        : (k > 0 ? (_this.sh060Init.motoSeikyuKin + _this.sh060Init.oneTimeCupponKin) : _this.sh060Init.motoSeikyuKin);
                    let point = totalPoint > currentPoint ? currentPoint : totalPoint;
                    totalPoint -= point;
                    return point;
                });
            }else {
                _this.sh060Request.hopeDayList = [];
                _this.hatchuCnt = 0;
            }
            _this.sh060Request.pointKins = points;
        },

        getJasApiInfo: function(){
            let _this = this;
            _this.is3DLoding = true;

            let apiRequest = {
                seqNo: _this.jasApiSeqNo
            }
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.SH060 + _this.$UrlConstants.DO_GET_JCS_NEW_CARD_API_INFO, apiRequest).then(function(response) {
                _this.jasApiResult = response.data;
                if (_this.jasApiResult){
                    _this.jcsMemberType = _this.jasApiResult.apiType;
                    let tourokuKbn = _this.jasApiResult.tourokuKbn;

                    //データを戻る
                    _this.sh060Request.cardFlg = _this.jasApiResult.cardFlg;
                    _this.sh060Request.cardSaveFlg = _this.jasApiResult.cardSaveFlg;

                    _this.$nextTick(() => {
                        if (_this.sh060Request.cardSaveFlg == '1'){
                            $('#_card_save_flg').prop('checked',true);
                        }else{
                            $('#_card_save_flg').prop('checked',false);
                        };

                        if (_this.sh060Request.cardFlg == '1'){
                            $('#card_flg1').prop('checked',true);
                            $('#card_flg1').focus();
                        }else{
                            $('#card_flg0').prop('checked',true);
                            $('#card_flg0').focus();
                        };
                    });

                    _this.sh060Request.approvalCode = _this.jasApiResult.approvalCode;
                    _this.sh060Request.acqCode = _this.jasApiResult.acqCode;
                    if (_this.jasApiResult.apiType == "2"){
                        //【既存会員・登録済み】場合
                        _this.sh060Request.cardSecurity = _this.jasApiResult.securityCode;
                        _this.sh060Request.lastCardPayCnt = _this.jasApiResult.cardPayCnt;
                        _this.sh060Request.lastBunkatuKaisu = _this.jasApiResult.bunkatuKaisu;
                        _this.sh060Request.jaccs3DVer2NewFlg = 0;
                    }
                    else{
                        //【新規会員】場合
                        _this.sh060Request.securityCode = "";
                        _this.sh060Request.cardPayCnt = "";
                        _this.sh060Request.bunkatuKaisu = "";
                        _this.sh060Request.jaccs3DVer2NewFlg = 1;
                    }

                    if (_this.jasApiResult.errCode == "OLM-IT00000000"){
                        //要求処理（3D セキュア認証）
                        if (tourokuKbn == "p"){
                            _this.doJacCardInfo3D(_this.jcsMemberType);
                        
                        //要求処理（都度購入）
                        }else if (tourokuKbn == "o" || tourokuKbn == "8" ){

                            _this.doJacCardInfoOsori(_this.jcsMemberType);
                        
                        //要求処理（都度購入）後
                        }else if (tourokuKbn == "k" || tourokuKbn == "n" || tourokuKbn == "W"){
                            if (tourokuKbn == "k" || tourokuKbn == "n"){
                                _this.orderSuccJas3D(_this.jasApiResult);
                            }else{
                                // 注文確定処理
                                _this.orderSuccJas3D(_this.jasApiResult);
                            }

                        }
                    }else{
                        //BlueGateエラーコードだったら、既存のオーソリ処理
                        let blueGateErrorList = new Array("S102000E", "S102000F", "S102000W", "S2023DA0");
                        if (blueGateErrorList.indexOf(_this.jasApiResult.bgErrCode) >= 0){
                            _this.security3DFlg = 0;
                            //【既存会員・登録済み】場合
                            if (_this.jasApiResult.apiType == "2"){
                                _this.sh060Request.cardSecurity = _this.jasApiResult.securityCode;
                                _this.sh060Request.lastCardPayCnt = _this.jasApiResult.cardPayCnt;
                                _this.sh060Request.lastBunkatuKaisu = _this.jasApiResult.bunkatuKaisu;

                                _this.sh060Request.securityCode = "";
                                _this.sh060Request.cardPayCnt   = "";
                                _this.sh060Request.bunkatuKaisu = "";

                                if (_this.sh060Init.teikiAddFlg == '1'){
                                    _this.doOrder();
                                }else{
                                    _this.doSubmit();
                                }
                            }else{
                                _this.listMessValid = [];
                                _this.listMessValid.push(_this.$i18n.t('sh060.messages.jcsApiToOldError'));
                                if(_this.listMessValid.length > 0) {
                                    _this.is3DLoding = false;
                                    EventBus.$emit('message', {});
                                    common.scrollTop();
                                }
                            }
                        }else{
                            _this.listMessValid = [];
                            // 決済処理時にエラーが発生しました。入力内容をご確認の上、再度ご入力いただくか、決済方法を変更してください。
                            _this.listMessValid.push(_this.sh060Init.jcsKessaiErrMsg);
                            if(_this.listMessValid.length > 0) {
                                _this.is3DLoding = false;
                                EventBus.$emit('message', {});
                                common.scrollTop();
                            }
                        }
                    }
                }    
            }).catch(function(error) {
                _this.is3DLoding = false;
                common.errorAPI(error);
            }).finally(function() {
            });
        },

        sendDateJas: function() {
            var date = new Date();
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            var strDate = date.getDate();
            if (month >= 1 && month <= 9) {
                month = "0" + month;
            }
            if (strDate >= 0 && strDate <= 9) {
                strDate = "0" + strDate;
            }
            var currentdate = year.toString() + month.toString() + strDate.toString();
            return currentdate;
        },
        sendTimeJas: function() {
            var date = new Date();
            var hh = date.getHours();
            var mm = date.getMinutes();
            var ss = date.getSeconds();
            if (hh >= 0 && hh <= 9) {
                hh = "0" + hh;
            }
            if (mm >= 0 && mm <= 9) {
                mm = "0" + mm;
            }
            if (ss >= 0 && ss <= 9) {
                ss = "0" + ss;
            }
            var currentTime = hh.toString() + mm.toString() + ss.toString();
            return currentTime;
        },
        panJas: function () {
            var cardNo;
            if (this.sh060Request.cardFlg == '1'){
                return this.sh060Init.cardNoDisp;
            }else{
                if (this.sh060Init.creditInpNumOption == 1) {
                    cardNo = this.sh060Request.cardNoDisp;
                    if (cardNo != undefined) {
                        cardNo = cardNo.replaceAll(' ','');
                    }
                    return cardNo;
                } else {
                    cardNo = this.sh060Request.cardNoDisp1 + this.sh060Request.cardNoDisp2 + this.sh060Request.cardNoDisp3 + this.sh060Request.cardNoDisp4
                    return cardNo;
                }
            }
        },       
        expiryDateJas: function() {
            if (this.sh060Request.cardFlg == '1'){
                return this.sh060Init.cardLimit;
            }else{
                return this.sh060Request.limitMonth + this.sh060Request.limitYear;
            }
        },
        securityCodeJas: function() {
            if (this.sh060Request.cardFlg == 1) {
                return this.sh060Request.cardSecurity;
            } else {
                if (this.sh060Init.securityCodeUseFlg){
                    return this.sh060Request.securityCode;
                }
            }
        },
        cardPayCntJas: function(){
            if (this.sh060Request.cardFlg == 1) {
                return this.sh060Request.lastCardPayCnt;
            } else {
                return this.sh060Request.cardPayCnt;
            }
        },
        bunkatuKaisuJas: function(){
            if (this.sh060Request.cardFlg == 1) {
                return this.sh060Request.lastBunkatuKaisu;
            } else {
                return this.sh060Request.bunkatuKaisu;
            }
        },
        showCloseNewCardArea: function (cardFlg) {
            this.showNowCardFlg = cardFlg;
        },
        /*
        * 3D カード情報タンキング
        */
        doJasNewCardTaking: function(apiType){
            let _this = this;
            let tourokuKbn = "p";
            _this.is3DLoding = true;
            //_this.$emit("event-loading", true);

            //【新規会員・登録なし】
            if (apiType == '0'){
                tourokuKbn = "p";
            //【新規会員・登録あり】
            }else if (apiType == '1'){
                tourokuKbn = "p";
            };
            _this.jasNewCardTaking.memberType = apiType;
            _this.jasNewCardTaking.tourokuKbn = tourokuKbn;
            _this.jasNewCardTaking.merchantId = _this.sh060Init.merchantId;
            _this.jasNewCardTaking.senddate = _this.sendDateJas();
            _this.jasNewCardTaking.sendtime = _this.sendTimeJas();
            _this.jasNewCardTaking.pan = _this.panJas();
            _this.jasNewCardTaking.expiryDate = _this.expiryDateJas();
            _this.jasNewCardTaking.cardKbn = "9";
            //_this.jasNewCardTaking.backUrl = process.env.VUE_APP_API_URL + _this.$UrlConstants.ECSITE + _this.$UrlConstants.SH060 + _this.$UrlConstants.DO_JCS_3D_POST_BACK;
            _this.jasNewCardTaking.backUrl = _this.sh060Init.back3DUrl;
            _this.jasNewCardTaking.resultUrl = "";
            _this.jasNewCardTaking.optionalAreaName1 = "coNo";
            _this.jasNewCardTaking.optionalAreaValue1 = _this.sh060Init.coNo;
            _this.jasNewCardTaking.optionalAreaName2 = "kessaiCd";
            _this.jasNewCardTaking.optionalAreaValue2 = _this.sh060Init.kessaiCd;
            _this.jasNewCardTaking.optionalAreaName3 = "apiType";
            _this.jasNewCardTaking.optionalAreaValue3 = apiType;
            _this.jasNewCardTaking.optionalAreaName4 = "pageNo";
            _this.jasNewCardTaking.optionalAreaValue4 = _this.curPage + "?pageNo=" +  this.currPageNo;

            _this.jasNewCardTaking.optionalAreaName5 = "securityCode";
            _this.jasNewCardTaking.optionalAreaValue5 = _this.securityCodeJas();
            _this.jasNewCardTaking.optionalAreaName6 = "cardPayCnt";
            _this.jasNewCardTaking.optionalAreaValue6 = _this.cardPayCntJas();
            _this.jasNewCardTaking.optionalAreaName7 = "bunkatuKaisu";
            _this.jasNewCardTaking.optionalAreaValue7 = _this.bunkatuKaisuJas();
            _this.jasNewCardTaking.optionalAreaName8 = "cardFlg";
            _this.jasNewCardTaking.optionalAreaValue8 = _this.sh060Request.cardFlg;
            _this.jasNewCardTaking.optionalAreaName9 = "cardSaveFlg";
            _this.jasNewCardTaking.optionalAreaValue9 = _this.sh060Request.cardSaveFlg;
            _this.jasNewCardTaking.optionalAreaName10 = "expiryDate";
            _this.jasNewCardTaking.optionalAreaValue10 = _this.expiryDateJas();
            

            _this.jasNewCardTaking.shopID = _this.sh060Init.bgShopId;
            _this.jasNewCardTaking.msgDigest = "";

            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.SH060 + _this.$UrlConstants.DO_NEW_CARD_INFO_TAKING_MSGDIGEST, _this.jasNewCardTaking).then(function(response) {
                _this.jasNewCardTaking.msgDigest = response.data;
                _this.$refs.formJasTaking.msgDigest.value = _this.jasNewCardTaking.msgDigest;

                //post
                _this.$refs.formJasTaking.submit();
                
            }).catch(function(error) {
                _this.msgConfirm = _this.$i18n.t('sh060.messages.sessionErr');
                _this.isModalShow = true;
                _this.isButtonCancel = false;
                _this.is3DLoding = false;
                EventBus.$on('evtClickOk', function() {
                    common.errorAPI(error);
                });
            }).finally(function() {
               //_this.$emit("event-loading", true);
            });;
        },

        /*
        * 3D セキュア認証
        */
        doJacCardInfo3D: function(apiType){
            let _this = this;
            let tourokuKbn = "";
            let merchantId = "";
            let cardPassword = "";
            let dbKey1 = "";
            _this.is3DLoding = true;

            //【新規会員・登録なし】
            if (apiType == '0'){
                tourokuKbn = "o";
                merchantId = _this.jasApiResult.merchantId;
                cardPassword =  _this.jasApiResult.cardPassword;
                dbKey1 = _this.jasApiResult.dbKey1;

            //【新規会員・登録あり】
            }else if (apiType == '1'){
                tourokuKbn = "o";
                merchantId = _this.jasApiResult.merchantId;
                cardPassword =  _this.jasApiResult.cardPassword;
                dbKey1 = _this.jasApiResult.dbKey1;

            //【既存会員・登録済み】 
            }else if (apiType == '2'){
                tourokuKbn = "8";
                merchantId = _this.sh060Init.merchantId;
                cardPassword =  _this.sh060Init.cardPassword;
                dbKey1 = _this.sh060Init.oldDbKey;
            };

            _this.jasNewCard3D.memberType = apiType;
            _this.jasNewCard3D.tourokuKbn =  tourokuKbn;
            _this.jasNewCard3D.merchantId =  merchantId;
            _this.jasNewCard3D.cardPassword = cardPassword;
            _this.jasNewCard3D.dbKey1 = dbKey1;
            _this.jasNewCard3D.orderNum =  _this.sh060Init.orderNum;
            _this.jasNewCard3D.amount =  _this.sh060Init.seikyuuKin;
            if (_this.sh060Init.orderInfo['TOTAL_SEIKYU_TAX']){
                _this.jasNewCard3D.amount =  _this.sh060Init.seikyuuKin - _this.sh060Init.orderInfo['TOTAL_SEIKYU_TAX'];
            }
            _this.jasNewCard3D.taxAndDeliCharge =  _this.sh060Init.orderInfo['TOTAL_SEIKYU_TAX'];
            //_this.jasNewCard3D.backUrl =  process.env.VUE_APP_API_URL + _this.$UrlConstants.ECSITE + _this.$UrlConstants.SH060 + _this.$UrlConstants.DO_JCS_3D_POST_BACK;
            _this.jasNewCard3D.backUrl = _this.sh060Init.back3DUrl;
            _this.jasNewCard3D.resultUrl =  "";
            _this.jasNewCard3D.optionalAreaName1 =  "coNo";
            _this.jasNewCard3D.optionalAreaValue1 =  _this.sh060Init.coNo;
            _this.jasNewCard3D.optionalAreaName2 =  "kessaiCd";
            _this.jasNewCard3D.optionalAreaValue2 =  _this.sh060Init.kessaiCd;
            _this.jasNewCard3D.optionalAreaName3 = "apiType";
            _this.jasNewCard3D.optionalAreaValue3 = apiType;
            _this.jasNewCard3D.optionalAreaName4 = "pageNo";
            _this.jasNewCard3D.optionalAreaValue4 = _this.curPage + "?pageNo=" +  this.currPageNo;

            if (apiType == '2'){
                _this.jasNewCard3D.optionalAreaName5 = "securityCode";
                _this.jasNewCard3D.optionalAreaValue5 = _this.securityCodeJas();
                _this.jasNewCard3D.optionalAreaName6 = "cardPayCnt";
                _this.jasNewCard3D.optionalAreaValue6 = _this.cardPayCntJas();
                _this.jasNewCard3D.optionalAreaName7 = "bunkatuKaisu";
                _this.jasNewCard3D.optionalAreaValue7 = _this.bunkatuKaisuJas();
                _this.jasNewCard3D.optionalAreaName8 = "cardFlg";
                _this.jasNewCard3D.optionalAreaValue8 = _this.sh060Request.cardFlg;
                _this.jasNewCard3D.optionalAreaName9 = "cardSaveFlg";
                _this.jasNewCard3D.optionalAreaValue9 = _this.sh060Request.cardSaveFlg;
                _this.jasNewCardTaking.optionalAreaName10 = "expiryDate";
                _this.jasNewCardTaking.optionalAreaValue10 = _this.expiryDateJas();
            }else{
                _this.jasNewCard3D.optionalAreaName5 = "securityCode";
                _this.jasNewCard3D.optionalAreaValue5 = _this.jasApiResult.securityCode;
                _this.jasNewCard3D.optionalAreaName6 = "cardPayCnt";
                _this.jasNewCard3D.optionalAreaValue6 = _this.jasApiResult.cardPayCnt;
                _this.jasNewCard3D.optionalAreaName7 = "bunkatuKaisu";
                _this.jasNewCard3D.optionalAreaValue7 = _this.jasApiResult.bunkatuKaisu;
                _this.jasNewCard3D.optionalAreaName8 = "cardFlg";
                _this.jasNewCard3D.optionalAreaValue8 = _this.jasApiResult.cardFlg;
                _this.jasNewCard3D.optionalAreaName9 = "cardSaveFlg";
                _this.jasNewCard3D.optionalAreaValue9 = _this.jasApiResult.cardSaveFlg;
                _this.jasNewCard3D.optionalAreaName10 = "expiryDate";
                _this.jasNewCard3D.optionalAreaValue10 = _this.jasApiResult.optionalareaValue10;
            }

            _this.jasNewCard3D.shopID = _this.sh060Init.bgShopId;
            _this.jasNewCard3D.accountMethod = '';
            _this.jasNewCard3D.msgDigest = "";
            _this.jasNewCard3D.teikiFlg = _this.sh060Init.teikiFlg;
            if (_this.jasNewCard3D.optionalAreaValue6 == '61'){
                _this.jasNewCard3D.teikiFlg = 0;
            }

            if (_this.sh060Init.securityCodeUseFlg) {
                if (!_this.jasNewCard3D.optionalAreaValue5) {
                    // セキュリティコードを入力してください。
                    this.listMessValid.push(_this.$i18n.t('sh060.messages.secMust'));
                    _this.is3DLoding = false;
                    EventBus.$emit('message', {});
                    common.scrollTop();
                    return false;
                }
            }

            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.SH060 +  _this.$UrlConstants.DO_NEW_CARD_INFO_3D_MSGDIGEST, _this.jasNewCard3D).then(function(res) {
                _this.jasNewCard3D = res.data;
                _this.$refs.formJas3D.msgDigest.value = _this.jasNewCard3D.msgDigest;
                
                _this.$nextTick(() => {
                    _this.$refs.formJas3D.submit();
                });

            }).catch(function(error) {
                _this.msgConfirm = _this.$i18n.t('sh060.messages.sessionErr');
                _this.isModalShow = true;
                _this.isButtonCancel = false;
                _this.is3DLoding = false;
                EventBus.$on('evtClickOk', function() {
                    common.errorAPI(error);
                });
            }).finally(function() {
            });
        },
        /*
        * 登録チェックボックス
        */ 
        checkRegisterFun: function (chck) {
            var _this = this;
            if (chck) {
                _this.checkRegister = true;
            } else {
                _this.checkRegister = false;
            }
        },
        /*
        * チェックが付いたら重複チェックを行う
        */
        check: function() {
            var _this = this;
            _this.$emit("event-loading", true);
            //clear msg valid
            _this.listMessValid = [];
            _this.mapMessValid = [];
            common.clearMessageEcSite(_this.listIdErr, _this.SH060_PART);
            if(_this.sh060Request.kokyakuCd == null || _this.sh060Request.kokyakuCd == undefined || _this.sh060Request.kokyakuCd == ''){
                _this.sh060Request.kaiinCheck = 2;
                _this.$emit("event-loading", !true);
            } else {
                axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.SH060 + _this.$UrlConstants.DO_CHECK, _this.sh060Request).then(function(response) {
                    _this.sh060Request.kaiinCheck = response.data;
                    // エラーがあった場合
                    if(response.data.errList != null && response.data.errList.length > 0){
                        _this.displayWaring(response.data.errList);
                    }
                    _this.$emit("event-loading", !true);
                }).catch(function(error) {
                    _this.$emit("event-loading", !true);
                    if(error != null && error != undefined){
                        if(error.response != null && error.response != undefined){
                            if(406 == error.response.status){
                                var resultValid = common.excuteValidationEcSite(error, _this.SH060_PART);
                                if(resultValid){
                                    _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                    _this.listMessValid = resultValid.msgList;
                                    _this.mapMessValid = resultValid.mapMsg;
                                    _this.sh060Request.kaiinCheck = 1;
                                }
                                common.scrollTop();
                            }else{
                                common.errorAPI(error);
                            }
                        }
                    }
                });
            }
        },
        /*
        * 3D都度購入(オーソリ)機能
        */
        doJacCardInfoOsori: function(apiType){
            let _this = this;
            let tourokuKbn = "";
            _this.is3DLoding = true;
            //【新規会員・登録なし】
            if (apiType == '0'){
                tourokuKbn = "k";

            //【新規会員・登録あり】
            }else if (apiType == '1'){
                tourokuKbn = "n";

            //【既存会員・登録済み】 
            }else if (apiType == '2'){
                tourokuKbn = "W";
            };

            _this.jasNewCardOsori.memberType = apiType;
            _this.jasNewCardOsori.tourokuKbn = tourokuKbn;
            _this.jasNewCardOsori.merchantId = _this.jasApiResult.merchantId;
            _this.jasNewCardOsori.dbKey1 = _this.jasApiResult.dbKey1;
            _this.jasNewCardOsori.amount = _this.sh060Init.seikyuuKin;
            _this.jasNewCardOsori.taxAndDeliCharge = "";
            //_this.jasNewCardOsori.backUrl = process.env.VUE_APP_API_URL + _this.$UrlConstants.ECSITE + _this.$UrlConstants.SH060 + _this.$UrlConstants.DO_JCS_3D_POST_BACK;
            _this.jasNewCardOsori.backUrl = _this.sh060Init.back3DUrl;
            _this.jasNewCardOsori.orderNum = _this.jasApiResult.orderNum;
            _this.jasNewCardOsori.cardPassword = _this.jasApiResult.cardPassword;
            _this.jasNewCardOsori.securityCode = _this.jasApiResult.securityCode;
            _this.jasNewCardOsori.resultUrl = "";

            _this.jasNewCardOsori.optionalAreaName1 = "coNo";
            _this.jasNewCardOsori.optionalAreaValue1 = _this.sh060Init.coNo;
            _this.jasNewCardOsori.optionalAreaName2 = "kessaiCd";
            _this.jasNewCardOsori.optionalAreaValue2 = _this.sh060Init.kessaiCd;
            _this.jasNewCardOsori.optionalAreaName3 = "apiType";
            _this.jasNewCardOsori.optionalAreaValue3 = apiType;
            _this.jasNewCardOsori.optionalAreaName4 = "pageNo";
            _this.jasNewCardOsori.optionalAreaValue4 = _this.curPage + "?pageNo=" +  this.currPageNo;

            _this.jasNewCardOsori.optionalAreaName5 = "securityCode";
            _this.jasNewCardOsori.optionalAreaValue5 = _this.jasApiResult.securityCode;
            _this.jasNewCardOsori.optionalAreaName6 = "cardPayCnt";
            _this.jasNewCardOsori.optionalAreaValue6 = _this.jasApiResult.cardPayCnt;
            _this.jasNewCardOsori.optionalAreaName7 = "bunkatuKaisu";
            _this.jasNewCardOsori.optionalAreaValue7 = _this.jasApiResult.bunkatuKaisu;
            _this.jasNewCardOsori.optionalAreaName8 = "cardFlg";
            _this.jasNewCardOsori.optionalAreaValue8 = _this.jasApiResult.cardFlg;
            _this.jasNewCardOsori.optionalAreaName9 = "cardSaveFlg";
            _this.jasNewCardOsori.optionalAreaValue9 = _this.jasApiResult.cardSaveFlg;
            _this.jasNewCardOsori.optionalAreaName10 = "expiryDate";
            _this.jasNewCardOsori.optionalAreaValue10 = _this.jasApiResult.optionalareaValue10;

            _this.jasNewCardOsori.msgVerNum = _this.jasApiResult.msgverNum;
            _this.jasNewCardOsori.xid = _this.jasApiResult.xID;
            _this.jasNewCardOsori.xStatus = _this.jasApiResult.xStatus;
            _this.jasNewCardOsori.eci = _this.jasApiResult.eci;
            _this.jasNewCardOsori.cavv = _this.jasApiResult.cavv;
            _this.jasNewCardOsori.cavvAlgorithm = _this.jasApiResult.cavvAlgorithm;

            _this.jasNewCardOsori.paymentMode = _this.jasApiResult.cardPayCnt;
            _this.jasNewCardOsori.paymentCount = _this.jasApiResult.bunkatuKaisu;
            _this.jasNewCardOsori.initialAmount = "";
            _this.jasNewCardOsori.bonusMonth = "";
            _this.jasNewCardOsori.bonusAmount = "";
            _this.jasNewCardOsori.bonusCount = "";
            _this.jasNewCardOsori.msgDigest = "";

            //【新規会員・登録なし】【新規会員・登録あり】
            if (apiType == '0' || apiType == '1'){
                axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.SH060 + _this.$UrlConstants.DO_NEW_CARD_INFO_OSORI_MSGDIGEST, _this.jasNewCardOsori).then(function(res) {
                    let msgDigest = res.data;
                    _this.jasNewCardOsori.msgDigest = msgDigest;
                    _this.$refs.formJasOsori.msgDigest.value = _this.jasNewCardOsori.msgDigest;
                    //post
                    _this.$refs.formJasOsori.submit();
                }).catch(function(error) {
                    _this.msgConfirm = _this.$i18n.t('sh060.messages.sessionErr');
                    _this.isModalShow = true;
                    _this.isButtonCancel = false;
                    _this.is3DLoding = false;
                    EventBus.$on('evtClickOk', function() {
                        common.errorAPI(error);
                    });
                }).finally(function() {
                });
            
            //【既存会員・登録済み】 
            }else if (apiType == '2'){
                _this.orderSuccJas3D(_this.jasApiResult);
            }
        },
        saveSessionSh060:function(){
            var tranferdata = {}; 

            tranferdata.biko=this.sh060Request.biko;
            tranferdata.giftCd=this.sh060Request.giftCd;
            tranferdata.sagyoKanriKomokuCd=this.sh060Request.sagyoKanriKomokuCd;
            tranferdata.sagyoKanriKomokuCd2=this.sh060Request.sagyoKanriKomokuCd2;
            tranferdata.noshiNaire1 = this.sh060Request.noshiNaire1;
            tranferdata.noshiNaire2 = this.sh060Request.noshiNaire2;
            sessionStorage['sh060TranferData'] = JSON.stringify(tranferdata);
        },
        /*
        * 見積書出力ボタン押下処理
        */
        doOutPutConfirm: function() {
            if(this.sh060Init.quotationCnt>0){
                this.outputMsgConfirm = this.$i18n.t('sh060.messages.confirmOutput').replace("{0}",this.sh060Init.quotationCnt);
                this.isShowOutputAlert = true;
                return;
            }
            this.doOutPut();
        },
        doOutPut: function(){
            this.isShowOutputAlert = false;
            // カード保存フラグのセット
            this.setCardSaveFlg();
            // 注文確定処理
            var _this = this;
            _this.$emit("event-loading", true);

            //clear msg valid
            _this.listMessValid = [];
            _this.mapMessValid = [];
            common.clearMessageEcSite(_this.listIdErr, _this.SH060_PART);

            var printData = {};
            let appPath = process.env.VUE_APP_PUBLIC_PATH;
            if(appPath.endsWith('/')) {
                appPath = appPath.slice(0, -1);
            }
            if(appPath.startsWith('/')) {
                appPath = appPath.slice(1);
            }
            printData.wfrBasePath = window.location.protocol + "//" + window.location.host + "/" +appPath;//fullPath.substring(0, fullPath.lastIndexOf('/'));

            axios({
                url: _this.$UrlConstants.ECSITE + _this.$UrlConstants.SH060 + _this.$UrlConstants.DO_PRINT,
                method: "POST",
                responseType: "blob", // important
                data: printData
            }).then(function(response) {
                var fileName = "";
                var disposition = response.headers["content-disposition"];
                if (disposition && disposition.indexOf("attachment") !== -1) {
                    var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                    var matches = filenameRegex.exec(disposition);
                    if (matches != null && matches[1]) {
                    fileName = matches[1].replace(/['"]/g, "");
                    }
                }
                if (/*@cc_on!@*/ false || !!document.documentMode) {
                    window.navigator.msSaveBlob(new Blob([response.data]), fileName);
                } else {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", fileName);
                    document.body.appendChild(link);
                    link.click();
                }
                
                _this.$emit("event-loading", false);

                _this.msgConfirm = _this.$i18n.t("pt415.messages.outputPdf");
                toastr.success(_this.msgConfirm);
                sessionStorage.removeItem('doQuotation');
                // 見積書一覧画面へ遷移
                _this.saveSessionSh060();
                _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 104}});
            }).catch(async function(error) {
                // eslint-disable-next-line
                _this.is3DLoding = false
                if(error != null && error != undefined){
                    if(error.response != null && error.response != undefined){
                        if(406 == error.response.status){
                            if (error.request.responseType === "blob") {
                                let responseObj = await error.response.data.text();
                                error.response.data = JSON.parse(responseObj);
                            }
                            var resultValid = common.excuteValidationEcSite(error, _this.SH060_PART);
                            if(resultValid){
                                _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                _this.listMessValid = resultValid.msgList;
                                _this.mapMessValid = resultValid.mapMsg;
                            }
                            common.scrollTop();
                        }
                    }
                }
                _this.$emit("event-loading", false);
            });

            
        },
        /*
        * ASUKAシステム利用時ファンクション
        */
        scoring: function() {
            var _this = this;
            // クレジットカード決済の場合でかつ新規クレジットカード
            if (this.sh060Init.realAuthoriFlg == '1' && this.sh060Request.cardFlg == '0') {
                if (typeof aerosmith === 'undefined') {
                    alert(_this.$i18n.t('sh060.messages.kessaiErr'));
                    return '0';
                } else {
                    aerosmith.checkScore((reason) => {
                        console.log(reason);
                        switch (reason) {
                            case 'LRT':
                            case 'BIAT':
                            case 'MM':
                            return '1';
                            default:
                                console.log('NG');
                                alert(_this.$i18n.t('sh060.messages.kessaiErr'));
                                return '0';
                        }
                    },
                    (reason) => {
                        console.log(reason);
                        return '0';
                    });
                }
            } else {
                return '1';
            }
           
        },
        /*
        * 自動発注可否チェック
        */
        isHatchuShowCheck: function() {
            var _this = this;
            var hopeDayList = [];
            // 配達希望日リストを取得
            if(sessionStorage['hopeDayList']) {
                hopeDayList = JSON.parse(sessionStorage['hopeDayList']);
            }

            // 自動発注かどうかの判定
            if (hopeDayList.length > 0) {
                // 決済方法がクレジット、掛払、代引き and 届先数が1以下のときのみ注文可能
                if (['1', '2', '82' , '6'].includes(_this.sh060Init.kessaiCd) && _this.sh060Init.tdkInfo.length <= 1) {
                    _this.isHatchuShow = true;
                } else {
                    _this.isHatchuShow = false;
                }
            } else {
                // 自動発注でなければ注文可能
                _this.isHatchuShow = true;
            }
        },
        /*
        * ASKUA準備完了チェック
        */
        reCheckAsukaReadyToScore: function() {
            var _this = this;

            if (_this.isAsukaReadyToScore || window.asukaAlready) {
                _this.isSubmitButton = true;
                _this.isAsukaReadyToScore = true;
            } else {
                window.setTimeout(function(){
                    _this.reCheckAsukaReadyToScore();
                }, 500);
            }
        },
        /*
        * カード情報チェック
        */
       cardCheck: function() {
            var _this = this;
            // クレジットカード決済の場合でかつ新規クレジットカード
            if (_this.sh060Init.realAuthoriFlg == '1' && _this.sh060Request.cardFlg == '0') {
                var cardNo = "";
                var cardYear = "";
                var cardMonth = "";
                var securitycode = "";

                cardYear = _this.sh060Request.limitYear;
                cardMonth = _this.sh060Request.limitMonth;
                securitycode = _this.sh060Request.securityCode;

                if (_this.sh060Init.creditInpNumOption == 1) {
                    cardNo = _this.sh060Request.cardNoDisp;
                    if (cardNo != undefined) {
                        cardNo = cardNo.replaceAll(' ','');
                    }
                } else {
                    cardNo = _this.sh060Request.cardNoDisp1 + _this.sh060Request.cardNoDisp2 + _this.sh060Request.cardNoDisp3 + _this.sh060Request.cardNoDisp4;
                }
                // カード番号必須チェック
                if (cardNo == null || cardNo == undefined || cardNo == '' || Number.isNaN(cardNo) || cardNo.length < 14 || cardNo.length > 16) {
                    // カード番号を入力してください。
                    _this.listMessValid.push(_this.$i18n.t('sh060.messages.cardNoMust'));
                }
                // 有効期限必須チェック
                if ((cardYear == null || cardYear == undefined) || (cardMonth == null || cardMonth == undefined)) {
                    // 有効期限を入力してください。
                    _this.listMessValid.push(_this.$i18n.t('sh060.messages.expiryDateMust'));
                }
                if (_this.sh060Init.cardNameOption == 1) {
                    // 名義人必須チェック
                    if(!_this.sh060Request.cardNameMyouji || !_this.sh060Request.cardNameNamae) {
                        _this.listMessValid.push(_this.$i18n.t('sh060.labels.holdernameMustErr'));
                    }
                } else {
                    // 名義人必須チェック
                    if(!_this.sh060Request.cardUserNm) {
                        _this.listMessValid.push(_this.$i18n.t('sh060.labels.holdernameMustErr'));
                    }
                }
                // セキュリティコード必須チェック
                if (_this.sh060Init.securityCodeUseFlg) {
                    if (!securitycode) {
                        // セキュリティコードを入力してください。
                        this.listMessValid.push(_this.$i18n.t('sh060.messages.secMust'));
                    }
                }

                // エラーがある場合
                if(_this.listMessValid.length > 0) {
                    EventBus.$emit('message', {});
                    common.scrollTop();
                    return false;
                }
            }
            return true;
       },
        /*
        * 注文確定ボタン押下処理
        */
        doSubmit: function(){
            this.listMessValid = [];
            if (this.sh060Init != null && this.sh060Init.kessaiCd != null && this.sh060Init.kessaiCd == Constants.KESSAI_AMAZONPAY && this.isSubmitting) return;
            // 値引きチェック
            if (!this.isShowNebikiAlert) {
                if (!this.doNebikiCheck()) {
                    return;
                }
            }

            //遠鉄チェック
            if (this.sh060Init.entetsuFlg == 1 && this.sh060Init.entetsuAutoLoginFlg == 1){
                if (!this.isShowEntetsuAlert) {
                    if (!this.doEntetusPointCheck()) {
                        return;
                    }
                }
                this.isShowEntetsuAlert = false;
            }

            if(!this.sh060Init.tdkYmdList || !this.sh060Init.tdkYmdList[1] || !this.sh060Init.tdkYmdList[1]['KEY']) {
                this.errorMsg = this.$i18n.t('sh030.messages.haitatsuKiboubiLstNull');
                this.isErrorAlert = true;
                return;
            }
            if(this.sh060Init.displayHanbaiSuuFlg && this.sh060Init.displayHanbaiSuuFlg != 0) {
                for(var i=0; i<this.sh060Init.tdkInfo.length; i++){
                    var tdkYmd = '';
                    // カート分割対応
                    if(this.sh060Init.cartSplitUseFlg == 1){
                        // カート分割する場合
                        if(this.sh060Init.tdkInfo[i]['TDK_HAISOU_LIST'] != null){
                            for(var j=0; j<this.sh060Init.tdkInfo[i]['TDK_HAISOU_LIST'].length; j++){
                                tdkYmd = this.sh060Init.tdkInfo[i]['TDK_HAISOU_LIST'][j]['TDK_YMD'];
                                //console.log("this.sh060Init.tdkInfo[i]['TDK_HAISOU_LIST'][j]['TDK_YMD'] : "
                                //    +this.sh060Init.tdkInfo[i]['TDK_HAISOU_LIST'][j]['TDK_YMD']);
                                //console.log("this.sh060Init.tdkInfo[i]['TDK_HAISOU_LIST'][j]['TDK_YMD'] : "
                                //    +this.sh060Init.tdkInfo[i]['TDK_HAISOU_LIST'][j]['TDK_YMD']);                                
                                if(common.stringNvl(this.sh060Init.tdkInfo[i]['TDK_HAISOU_LIST'][j]['TDK_YMD_HISSU_FLG'])=='1'){//着日必須
                                    // 配達希望日が指定されてない場合
                                    if (!tdkYmd){
                                        this.errorMsg = this.$i18n.t('sh030.messages.haitatsuKiboubiSetting') 
                                            + '<br>' + '届先：'+ (i+1) + '件目 <br> 配送：'+ (j+1) + '件目';
                                        this.isErrorAlert = true;
                                        return;
                                    }    
                                } else if (common.stringNvl(this.sh060Init.tdkInfo[i]['TDK_HAISOU_LIST'][j]['TDK_YMD_ERR_FLG'])=='1'){//着日指定不可
                                    // 配達希望日が指定されている場合
                                    if (tdkYmd){
                                        this.errorMsg = this.$i18n.t('sh030.messages.haitatsuKiboubiSettingNg') 
                                            + '<br>' + '届先：'+ (i+1) + '件目 <br> 配送：'+ (j+1) + '件目';
                                        this.isErrorAlert = true;
                                        return;
                                    }    
                                }
                            }
                        }
                    } else {
                        // カート分割しない場合
                        tdkYmd = this.sh060Init.tdkInfo[i]['TDK_YMD'];
                        // 配達希望日が指定されてない場合
                        if (!tdkYmd){
                            this.errorMsg = this.$i18n.t('sh030.messages.haitatsuKiboubiSetting');
                            this.isErrorAlert = true;
                            return;
                        }
                    }
                }
                
            }
            if(this.sh060Init.takuhaiUseFlg == 1 && this.sh060Init.tdkkibouFlg == 1 && this.sh060Init.tdkTimeFlg == 1) {
                for(var i=0; i<this.sh060Init.tdkInfo.length; i++){
                    var tdkYmd = this.sh060Init.tdkInfo[i]['TDK_YMD'];
                    var tdkHmsKbn = this.sh060Init.tdkInfo[i]['TDK_HMS_KBN_NM'];
                    var errMsg = "";
                    
                    // カート分割対応
                    //配達希望日表示フラグ:50504(配送指定日利用オプション) tdkkibouFlg
                    //配達希望日表示フラグ:50505(配送希望時間利用オプション) tdkTimeFlg
                    if(this.sh060Init.cartSplitUseFlg == 1){
                        // カート分割する場合
                        if(this.sh060Init.tdkInfo[i]['TDK_HAISOU_LIST'] != null){
                            for(var j=0; j<this.sh060Init.tdkInfo[i]['TDK_HAISOU_LIST'].length; j++){
                                tdkYmd = this.sh060Init.tdkInfo[i]['TDK_HAISOU_LIST'][j]['TDK_YMD'];
                                //console.log("this.sh060Init.tdkInfo[i]['TDK_HAISOU_LIST'][j]['TDK_YMD'] : "
                                //    +this.sh060Init.tdkInfo[i]['TDK_HAISOU_LIST'][j]['TDK_YMD']);
                                //console.log("this.sh060Init.tdkInfo[i]['TDK_HAISOU_LIST'][j]['TDK_HMS_KBN_NM'] : "
                                //    +this.sh060Init.tdkInfo[i]['TDK_HAISOU_LIST'][j]['TDK_HMS_KBN_NM']);
                                if(common.stringNvl(this.sh060Init.tdkInfo[i]['TDK_HAISOU_LIST'][j]['TDK_YMD_HISSU_FLG'])=='1'){//着日必須
                                    // 配達希望日が指定されてない場合
                                    if (!tdkYmd){
                                        errMsg = this.$i18n.t('sh030.messages.haitatsuKiboubiSetting');
                                    }
                                } else if (common.stringNvl(this.sh060Init.tdkInfo[i]['TDK_HAISOU_LIST'][j]['TDK_YMD_ERR_FLG'])=='1'){//着日指定不可
                                    // 配達希望日が指定されている場合
                                    if (tdkYmd){
                                        errMsg = this.$i18n.t('sh030.messages.haitatsuKiboubiSettingNg');
                                    }    
                                }
                                if(common.stringNvl(this.sh060Init.tdkInfo[i]['TDK_HAISOU_LIST'][j]['TDK_HSTM_ERR_FLG'])=='1'){//配達希望時間必須
                                    tdkHmsKbn = this.sh060Init.tdkInfo[i]['TDK_HAISOU_LIST'][j]['TDK_HMS_KBN_NM'];
                                    // 配達希望時間が指定されてない場合
                                    if (!tdkHmsKbn || tdkHmsKbn == "指定なし"){
                                        errMsg = errMsg + this.$i18n.t('sh030.messages.haitatsuKibouTimeSetting');                       
                                    }
                                } else if (common.stringNvl(this.sh060Init.tdkInfo[i]['TDK_HAISOU_LIST'][j]['TDK_HSTM_ERR_FLG'])=='1'){//配達希望時間指定不可
                                    if (tdkHmsKbn && tdkHmsKbn != "指定なし"){
                                        errMsg = this.$i18n.t('sh030.messages.haitatsuKibouTimeSettingNg');
                                    }    
                                }
                                if(errMsg != ""){
                                    errMsg = errMsg +  '<br>' + '届先：'+ (i+1) + '件目 <br> 配送：'+ (j+1) + '件目';
                                }
                                if(errMsg != ""){
                                    this.errorMsg = errMsg;
                                    this.isErrorAlert = true;
                                    return;
                                }
                            }
                        }
                    } else {// カート分割しない場合
                        // 配達希望日が指定されてない場合
                        if (!tdkYmd){
                            errMsg = this.$i18n.t('sh030.messages.haitatsuKiboubiSetting');                       
                        }
                        // 配達希望時間が指定されてない場合
                        if (!tdkHmsKbn || tdkHmsKbn == "指定なし"){
                            errMsg = errMsg + this.$i18n.t('sh030.messages.haitatsuKibouTimeSetting');                       
                        }
                        if(errMsg != ""){
                            this.errorMsg = errMsg;
                            this.isErrorAlert = true;
                            return;
                        }
                    }
                }
                
            }
            this.isShowNebikiAlert = false;

            // 与信限度額チェック
            if (!this.isYoshinLimitAlert) {
                if (this.doYoshinLimitCheck() == 1) {
                    this.isYoshinLimitAlert = true;
                    return;
                }
            }
            this.isYoshinLimitAlert = false;

            //振分数量チェック
            for(var i=0;i<this.sh060Init.cartInfo.length;i++){
                var itemNo = this.sh060Init.cartInfo[i].ITEM_NO;
                var itemQty = this.sh060Init.cartInfo[i].QTY;
                var itemSeq = this.sh060Init.cartInfo[i].SEQ;
                var tdkItemQty =0;
                for(var j=0;j<this.sh060Init.tdkInfo.length;j++){
                    var tdkInfo = this.sh060Init.tdkInfo[j];
                    
                    // カート分割対応
                    if(this.sh060Init.cartSplitUseFlg == 1){
                        if(tdkInfo['TDK_HAISOU_LIST'] != null){
                            for(var m=0; m<tdkInfo['TDK_HAISOU_LIST'].length; m++){
                                for(var k=0;k<tdkInfo['TDK_HAISOU_LIST'][m]['TDK_ITEM_LIST'].length;k++){
                                    var tdkItem = tdkInfo['TDK_HAISOU_LIST'][m]['TDK_ITEM_LIST'][k];
                                    if(tdkItem.ITEM_NO == itemNo && tdkItem.SEQ == itemSeq){
                                        tdkItemQty = tdkItemQty + parseInt(tdkItem.QTY);
                                        break;
                                    }
                                }
                            }
                        }
                    } else {
                        for(var k=0;k<tdkInfo['TDK_ITEM_LIST'].length;k++){
                            var tdkItem = tdkInfo['TDK_ITEM_LIST'][k];
                            if(tdkItem.ITEM_CD == itemNo && tdkItem.SEQ == itemSeq){
                                tdkItemQty = tdkItemQty + parseInt(tdkItem.QTY);
                                break;
                            }
                        }
                    }
                }
                if(tdkItemQty != itemQty){
                    this.errorMsg = this.$i18n.t('sh041.messages.furiwakeQtyError');
                    this.isErrorAlert = true;
                    return;
                }
            }

            this.gmo2AuthAccessID = "";
            if (this.sh060Request.gmo2AuthAccessID){
                this.sh060Request.gmo2AuthAccessID = "";
            }
            this.spsResultId = null;
            if (this.sh060Request.spsResultId) {
                this.sh060Request.spsResultId = null;
            }
            
            this.sbpTdsAuthenticationId = null;
            if (this.sh060Request.tdsAuthenticationId) {
                this.sh060Request.sbp3DVerFlg = 0;
                this.sh060Request.tdsAuthenticationId = null;
            }

            this.gmodpaySeqNo = '';
            this.gmoDPayAccessID = '';
            this.sh060Request.gmodpaySeqNo = '';
            this.sh060Request.gmoDPayAccessID = '';

            // カード情報チェック
            if(!this.cardCheck()) {
                return;
            }
            // カード保存フラグのセット
            this.setCardSaveFlg();
            // クレジットでかつASUKAオプションの場合
            if (this.sh060Init.realAuthoriFlg == '1' && this.sh060Init.asukaOptionFlg == 1) {
                if("0" == this.scoring()){
                    return;
                }
            }
            if(this.sh060Init.realAuthoriFlg == '1' && this.sh060Init.kessaiCompKbn == 'JPF'){
                //Multipayment: call use api for pay method
                var cardNoDisp = this.stringNvl(this.sh060Init.cardNoDisp,'');
                var creditUser ='';
                var cardNo = "";
                var cardYm = "";
                var cardSecurity = "";
                if(cardNoDisp != "") {
                    cardNo = this.sh060Init.cardNoDisp;
                    cardYm = this.sh060Init.cardLimit;
                    creditUser = this.sh060Init.cardName;
                    cardSecurity = this.sh060Request.cardSecurity;
                }else{
                    if (this.sh060Init.creditInpNumOption == 1) {
                        cardNo = this.sh060Request.cardNoDisp;
                        if (cardNo != undefined) {
                            cardNo = cardNo.replaceAll(' ','');
                        }
                    } else {
                        cardNo = this.sh060Request.cardNoDisp1 + this.sh060Request.cardNoDisp2 + this.sh060Request.cardNoDisp3 + this.sh060Request.cardNoDisp4;
                    }
                    cardYm = this.sh060Request.limitYear + this.sh060Request.limitMonth;
                    cardYm = this.sh060Request.limitYear + this.sh060Request.limitMonth;
                    if (this.sh060Init.cardNameOption == 1) {
                        creditUser = this.sh060Request.cardNameNamae + this.sh060Request.cardNameMyouji;
                    } else {
                        creditUser = this.sh060Request.cardUserNm;
                    }
                    cardSecurity = this.sh060Request.securityCode;
                }

                if(this.sh060Init.securityCodeUseFlg) {
                    if(!cardSecurity) {
                        // セキュリティコードを入力してください。
                        this.listMessValid.push(this.$i18n.t('sh060.messages.secMust'));
                        this.is3DLoding = false;
                        EventBus.$emit('message', {});
                        common.scrollTop();
                        return false;
                    }
                }
                // URL get from database
                var apiUrl =  this.sh060Init.tokenUrl;
                this.$loadScript(apiUrl) .then(() => {
                    Multipayment.init(this.sh060Init.shopId);
                    Multipayment.getToken({
                            cardno: cardNo,
                            expire: cardYm,
                            securitycode:cardSecurity,
                            holdername:creditUser
                        }, function(response){
                            this.someCallbackFunction(response);
                        }
                    );
                })
                .catch(function(error) {
                    console.log(error);
                });
            // GMOクレジットの場合  
            } else if (this.sh060Init.realAuthoriFlg == '1' && (this.sh060Init.kessaiCompKbn == 'GMO' || this.sh060Init.kessaiCompKbn == "SGP") ) {
                this.doPurchase();
            // SMBCクレジットの場合
            } else if (this.sh060Init.realAuthoriFlg == '1' && this.sh060Init.kessaiCompKbn == 'SMBC') {
                this.doSmbc();
            } else if (this.sh060Init.realAuthoriFlg == '1' && this.sh060Init.kessaiCompKbn == 'EPS') {
                this.doEps();
            // JCSクレジットの新規カードの場合
            } else if (this.sh060Init.realAuthoriFlg == '1' && this.sh060Request.cardFlg != '1' && this.sh060Init.kessaiCompKbn == 'JCS') {

                let _this = this;
                
                //セキュリティ3D 使用
                if (_this.security3DFlg == 1){

                    let check = _this.doJac3DCheck();
                    if (check){
                        _this.is3DLoding = false;
                        return false;
                    }

                    if (_this.sh060Request.cardFlg == '1'){
                        //【既存会員・登録済み】 
                        _this.jcsMemberType = "2";
                    }else{
                        if (_this.sh060Request.cardSaveFlg == '1'){
                            // 【新規会員・登録あり】 
                            _this.jcsMemberType = "1";
                        }else if (_this.sh060Request.cardSaveFlg == '0'){
                            // 【新規会員・登録なし】
                            _this.jcsMemberType = "0";
                        }
                    }
                    //要求処理（カード情報タンキング）
                    _this.doJasNewCardTaking(_this.jcsMemberType);
                }else{
                    // セッションの確認
                    axios.get(_this.$UrlConstants.ECSITE + _this.$UrlConstants.SH060 + _this.$UrlConstants.DO_CHECK).then(function(response) {
                        if(response.data.status === 'OK') {
                            _this.doJac();
                        } else {
                            //router to top page
                            _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query:{pageNo:1}});
                        }
                    }).catch(function(error) {
                        _this.msgConfirm = _this.$i18n.t('sh060.messages.sessionErr');
                        _this.isModalShow = true;
                        _this.isButtonCancel = false;

                        EventBus.$on('evtClickOk', function() {
                            common.errorAPI(error);
                        });
                    });
                }

             // JCSクレジットの前回と同じカードを使う
            } else if (this.sh060Init.realAuthoriFlg == '1' && this.sh060Request.cardFlg == '1' && this.sh060Init.kessaiCompKbn == 'JCS') {
                let _this = this;

                //セキュリティ3D 使用
                if (_this.security3DFlg == 1){
                    //【既存会員・登録済み】 
                    _this.jcsMemberType = "2";

                    _this.doJacCardInfo3D(_this.jcsMemberType);
                }else{
                     // 注文確定処理
                    _this.doOrder();
                }

            // SBPクレジットの場合
            } else if (this.sh060Init.realAuthoriFlg == '1' && this.sh060Init.kessaiCompKbn == 'SBP') {
                this.doSbp();
            } else if (this.sh060Init.realAuthoriFlg == '1' && this.sh060Request.cardFlg != '1' && this.sh060Init.kessaiCompKbn == 'PAY') {
                this.doPayG();
            } else if (this.sh060Init.realAuthoriFlg == '1' && this.sh060Init.kessaiCompKbn == 'SPS') {
                this.doSps();
            // クレジット以外の場合orderSucc
            } else {
                // 注文確定処理
                this.doOrder();
            }
            if (this.sh060Init != null && this.sh060Init.kessaiCd != null && this.sh060Init.kessaiCd == Constants.KESSAI_AMAZONPAY) {
                this.isSubmitting = true;
            }
        },
        doConfirm(resp) {
            let _this = this;
            if (resp.indexOf(_this.sh060Init.orderNum) !== -1 && resp.indexOf('OLM-IT00000000') !== -1) {
                _this.orderSucc();
            } else {
                /*
                * JCS取引状況再確認
                */
                let request = {
                    kessaiCompKbn: _this.sh060Init.kessaiCompKbn,
                    siharaiHohoKbn: _this.sh060Init.kessaiCd,
                    orderId: _this.sh060Init.orderNum,
                    kokyakuNo: _this.sh060Init.KokyakuNo
                };
                axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.SH060 + _this.$UrlConstants.DO_CONFIRM, request).then(function(response) {
                    if(response.data.status === 'OK') {
                         _this.orderSucc();
                    } else {
                        _this.$emit("event-loading", false);
                        _this.listMessValid = [];
                        // 決済処理時にエラーが発生しました。入力内容をご確認の上、再度ご入力いただくか、決済方法を変更してください。
                        _this.listMessValid.push(_this.sh060Init.jcsKessaiErrMsg);
                        EventBus.$emit('message', {});
                        common.scrollTop();
                        _this.doInit();
                    }

                }).catch(function(error) {
                    _this.$emit("event-loading", false);
                    common.errorAPI(error);
                })
            }
        },
        
        /*
        * JCS 3Dクレジットカード決済成功後の注文情報生成
        */
        orderSuccJas3D(apiInfo) {
            let _this = this;
            _this.is3DLoding = true;
            _this.$emit("event-loading", true);

            //_this.sh060Request.orderNum = _this.sh060Init.orderNum;
            _this.sh060Request.orderNum = apiInfo.orderNum;
            _this.sh060Request.teikiAddFlg= _this.sh060Init.teikiAddFlg;
            if (apiInfo.apiType == "0"){
                _this.sh060Request.bgDbKey = "";
            }else{
                _this.sh060Request.bgDbKey = apiInfo.dbKey1;
            }

            _this.sh060Request.cardFlg = apiInfo.cardFlg;
            _this.sh060Request.cardSaveFlg = apiInfo.cardSaveFlg;
            if (apiInfo.expiryDate){
                _this.sh060Request.limitMonth = apiInfo.expiryDate.substring(0,2);
                _this.sh060Request.limitYear = apiInfo.substring(2);
            }
            if (apiInfo.apiType == "2"){
                _this.sh060Request.cardSecurity = apiInfo.securityCode;
            }else{
                _this.sh060Request.securityCode = apiInfo.securityCode;
            }
            _this.sh060Request.cardPayCnt = apiInfo.cardPayCnt;
            _this.sh060Request.bunkatuKaisu = apiInfo.bunkatuKaisu;
            _this.sh060Request.lastCardPayCnt = apiInfo.cardPayCnt;
            _this.sh060Request.lastBunkatuKaisu = apiInfo.bunkatuKaisu;
            _this.sh060Request.cardFlg = apiInfo.cardFlg;
            _this.sh060Request.cardSaveFlg = apiInfo.cardSaveFlg;

            //【既存会員・登録済み】
            if (apiInfo.apiType == "2"){
                //JACCS 3D 2.0 セキュア フラグ
                _this.sh060Request.jaccs3DVer2Flg = 1;
                _this.sh060Request.msgVerNum = apiInfo.msgverNum;
                _this.sh060Request.xid = apiInfo.xID;
                _this.sh060Request.xStatus = apiInfo.xStatus;
                _this.sh060Request.eci = apiInfo.eci;
                _this.sh060Request.cavv = apiInfo.cavv;
                _this.sh060Request.cavvAlgorithm = apiInfo.cavvAlgorithm;
            }else{
            //【新規会員・登録あり】
                _this.sh060Request.jaccs3DVer2Flg = 0;
                _this.sh060Request.msgVerNum = "";
                _this.sh060Request.xid = "";
                _this.sh060Request.xStatus = "";
                _this.sh060Request.eci = "";
                _this.sh060Request.cavv = "";
                _this.sh060Request.cavvAlgorithm = "";
            }

            _this.sh060Request.seikyuuKin = _this.sh060Init.seikyuuKin;
            if(_this.hatchuCnt > 0) {
                _this.sh060Request.seikyuuKin = _this.totalSeikyuKin;
            }
            
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.SH060 + _this.$UrlConstants.DO_ORDER, _this.sh060Request).then(function(response) {
                if(response.data.respCode == _this.SHOW_ERR_PAGE) {
                    _this.$router.push({ name: "SH060ShopperInfoConfirmError"});
                    _this.is3DLoding = false;
                    return;
                }
                if (response.data.respCode == _this.LEAD_DAY_ERR) {
                    _this.$emit("event-loading", false);
                    _this.msgConfirmAreaCheck = _this.descriptionInfo[8];
                    _this.isModalAreaCheckShow = true;
                    _this.isButtonCancelAreaCheck = false;
                    EventBus.$on('evtClickOk', function() {
                        _this.isModalAreaCheckShow = false;
                    });
                    EventBus.$on('closed', () => {
                        _this.isModalAreaCheckShow = false;
                    });
                    _this.is3DLoding = false;
                    return;
                }
                if(response.data.status == 'OK') {
                    var message = "";
                    var orderCd = "";
                    if(response.data.response) {
                        message = response.data.response.message;
                        orderCd = response.data.response.orderCd;
                    }
                    sessionStorage.removeItem('hopeDayList');
                    sessionStorage.removeItem('totalPointKin');
                    _this.$router.push({ name: _this.SiteConstants.PG010MAIN, params: {message:message, orderCd: orderCd}, query: {pageNo: 23}});
                }else{
                    _this.is3DLoding = false;
                    _this.clearForm();
                }
                
            }).catch(function(error) {
                // eslint-disable-next-line
                _this.is3DLoding = false;
                if(error) {
                    if(error.response) {
                        if(406 == error.response.status) {
                            var resultValid = common.excuteValidationEcSite(error, _this.SH060_PART);
                            if(resultValid) {
                                _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                _this.listMessValid = resultValid.msgList;
                                _this.mapMessValid = resultValid.mapMsg;
                            }
                            common.scrollTop();
                        } else {
                            common.errorAPI(error);
                        }
                    }
                }
                
            }).finally(function() {
                _this.$emit("event-loading", false);
                //_this.is3DLoding = false;
            });
        },

        /*
        * JCSクレジットカード決済成功後の注文情報生成
        */
        orderSucc() {
            let _this = this;
            _this.sh060Request.orderNum = _this.sh060Init.orderNum;
            _this.sh060Request.bgDbKey = _this.sh060Init.newDbKey;
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.SH060 + _this.$UrlConstants.DO_ORDER, _this.sh060Request).then(function(response) {
                if(response.data.respCode == _this.SHOW_ERR_PAGE) {
                    _this.$router.push({ name: "SH060ShopperInfoConfirmError"});
                    _this.is3DLoding = false
                    return;
                }
                
                if (response.data.respCode == _this.LEAD_DAY_ERR) {
                    _this.$emit("event-loading", false);
                    _this.msgConfirmAreaCheck = _this.descriptionInfo[8];
                    _this.isModalAreaCheckShow = true;
                    _this.isButtonCancelAreaCheck = false;
                    EventBus.$on('evtClickOk', function() {
                        _this.isModalAreaCheckShow = false;
                    });
                    EventBus.$on('closed', () => {
                        _this.isModalAreaCheckShow = false;
                    });
                    _this.is3DLoding = false;
                    return;
                }
                if(response.data.status == 'OK') {
                    var message = "";
                    var orderCd = "";
                    if(response.data.response) {
                        message = response.data.response.message;
                        orderCd = response.data.response.orderCd;
                    }
                    sessionStorage.removeItem('hopeDayList');
                    sessionStorage.removeItem('hopeDay');
                    sessionStorage.removeItem('hopeDayCnt');
                    sessionStorage.removeItem('totalPointKin');
                    sessionStorage.removeItem('sh060TranferData');
                    _this.$router.push({ name: _this.SiteConstants.PG010MAIN, params: {message:message, orderCd: orderCd}, query: {pageNo: 23}});
                }
                
            }).catch(function(error) {
                // eslint-disable-next-line
                _this.is3DLoding = false
                if(error) {
                    if(error.response) {
                        if(406 == error.response.status) {
                            var resultValid = common.excuteValidationEcSite(error, _this.SH060_PART);
                            if(resultValid) {
                                _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                _this.listMessValid = resultValid.msgList;
                                _this.mapMessValid = resultValid.mapMsg;
                            }
                            common.scrollTop();
                        } else {
                            common.errorAPI(error);
                        }
                    }
                }
                
            }).finally(function() {
                _this.$emit("event-loading", false);
            });
        },

        /*
        * フォームをクリアする
        */
        clearForm() {
            // カード番号
            this.sh060Request.cardNoDisp = "";
            this.sh060Request.cardNoDisp1 = "";
            this.sh060Request.cardNoDisp2 = "";
            this.sh060Request.cardNoDisp3 = "";
            this.sh060Request.cardNoDisp4 = "";
            // セキュリティコード
            this.sh060Request.cardSecurity = "";
            this.sh060Request.securityCode = "";
            // 名義人
            this.sh060Request.cardNameMyouji = "";
            this.sh060Request.cardNameNamae = "";
            this.sh060Request.cardUserNm = "";
            // 有効期限
            this.sh060Request.limitYear = "";
            this.sh060Request.limitMonth = "";
        },

        doJac3DCheck: function(){
            let _this = this;

            _this.listMessValid = [];
            if(!_this.pan) {
                // カード番号を入力してください。
                _this.listMessValid.push(_this.$i18n.t('sh060.messages.cardNoMust'));
            } else if (_this.pan.length < 14 ) {
                // カード番号の入力値に誤りがあります。14桁以上16桁以内の数字で入力してください。
                _this.listMessValid.push(_this.$i18n.t('sh060.messages.cardNoInputErr'));
            }
            if(!_this.expiryDate) {
                // カード有効期限を入力してください。
                _this.listMessValid.push(_this.$i18n.t('sh060.messages.expiryDateMust'));
            } else if (_this.expiryDate.length < 4 ) {
                // カード有効期限の入力値に誤りがあります。半角数値（「月/年」）で入力してください。
                _this.listMessValid.push(_this.$i18n.t('sh060.messages.expiryDateInputErr'));
            }
            if(_this.sh060Init.securityCodeUseFlg) {
                if(!_this.sh060Request.securityCode) {
                    // セキュリティコードを入力してください。
                    _this.listMessValid.push(_this.$i18n.t('sh060.messages.secMust'));
                }
            }

            if(_this.listMessValid.length > 0) {
                _this.is3DLoding = false;
                EventBus.$emit('message', {});
                common.scrollTop();
                return true;
            }

            return false;
        },

        /*
        * JCS会員登録
        */
        doJac: function() {
            let _this = this;

            _this.listMessValid = [];
            if(!_this.pan) {
                // カード番号を入力してください。
                _this.listMessValid.push(_this.$i18n.t('sh060.messages.cardNoMust'));
            } else if (_this.pan.length < 14 ) {
                // カード番号の入力値に誤りがあります。14桁以上16桁以内の数字で入力してください。
                _this.listMessValid.push(_this.$i18n.t('sh060.messages.cardNoInputErr'));
            }
            if(!_this.expiryDate) {
                // カード有効期限を入力してください。
                _this.listMessValid.push(_this.$i18n.t('sh060.messages.expiryDateMust'));
            } else if (_this.expiryDate.length < 4 ) {
                // カード有効期限の入力値に誤りがあります。半角数値（「月/年」）で入力してください。
                _this.listMessValid.push(_this.$i18n.t('sh060.messages.expiryDateInputErr'));
            }
            if(_this.sh060Init.securityCodeUseFlg) {
                if(!_this.sh060Request.securityCode) {
                    // セキュリティコードを入力してください。
                    _this.listMessValid.push(_this.$i18n.t('sh060.messages.secMust'));
                }
            }

            if(_this.listMessValid.length > 0) {
                EventBus.$emit('message', {});
                common.scrollTop();
                return;
            }

            _this.$refs.form.submit();

            _this.clearForm();

            _this.$emit("event-loading", true);

            var startTime = new Date().getTime();
            var waitTime = parseInt(_this.sh060Init.jcsWaitTime, 10); 
            _this.timer = setInterval(function() {
                if((new Date().getTime() - startTime) > (waitTime * 1000)) {
                    clearInterval(_this.timer);
                    _this.doConfirm('');
                } else {
                    let resp = _this.$refs['dummyframe'].contentWindow.document.body.innerHTML;
                    if(resp && resp.indexOf('bgErrCode') !== -1) {
                        clearInterval(_this.timer);
                        _this.doConfirm(resp);
                    }
                }
                
            }, 1000);
        },
        /*
        *SMBCトークン取得
        */
        doSmbc : function() {
            var _this = this;
            var cardno;
            var cardFlg = _this.sh060Request.cardFlg;
            // トークン取得のURL
            var apiUrl = _this.sh060Init.tokenUrl;
            // 契約コード
            var shopId = _this.sh060Init.shopId;
            // 収納企業コード
            var syunoCoCd = _this.sh060Init.confText1;
            // トークン変換キー
            var apiPass2 = _this.sh060Init.apiPass2;
            // 発行されたトークン
            var token;
            // エラーメッセージ
            var errMsg;
            // レスポンス
            var resp;
            // カード番号をまとめてセット
            if (_this.sh060Init.creditInpNumOption == 1) {
                cardno = this.sh060Request.cardNoDisp;
                if (cardno != undefined) {
                    cardno = cardno.replaceAll(' ','');
                }
            } else {
                cardno = this.sh060Request.cardNoDisp1 + this.sh060Request.cardNoDisp2 + this.sh060Request.cardNoDisp3 + this.sh060Request.cardNoDisp4;
            }
            document.getElementById('cardNoDisp').value = cardno;

            // 前回カードの場合
            if (cardFlg == '1') {
                _this.sh060Request.token = "dummy";
                _this.doOrder();
                return true;
            }

            if (_this.sh060Init.securityCodeUseFlg) {
                if (!this.sh060Request.securityCode) {
                    // セキュリティコードを入力してください。
                    this.listMessValid.push(_this.$i18n.t('sh060.messages.secMust'));
                    _this.is3DLoding = false;
                    EventBus.$emit('message', {});
                    common.scrollTop();
                    return false;
                }
            }

            this.$loadScript(apiUrl).then(() => {

                Fstokenizer().setConfig( {
                    shop_cd : shopId,
                    syuno_co_cd: syunoCoCd,
                    token: {
                        api_key: apiPass2,
                        mode: 'S',
                        usecvv: true
                    },
                    elems: {
                        card: 'cardNoDisp',
                        yy: 'limitYear',
                        mm: 'limitMonth',
                        cvv: 'cardSecurity',
                        token: 'card_token',
                        error: 'fsjs_error'
                    }
                });
                resp = Fstokenizer().getToken();
                // 結果true
                if (resp) {
                    token = document.getElementById('card_token');
                    _this.sh060Request.token = token.value;
                    _this.doOrder();
                    return true;
                // 結果false
                } else {
                    errMsg = document.getElementById('fsjs_error');
                    alert(errMsg.textContent);
                    common.scrollTop();
                }
            })
            .catch(function(error) {
                console.log(error);
            });
        },

        /*
        *EPS イプシロン
        */
        doEps : function() {
            var _this = this;
            var cardno;
            var cardFlg = _this.sh060Request.cardFlg;
            // トークン取得のURL
            var apiUrl = _this.sh060Init.tokenUrl;
            // トークン変換キー
            var publicApiKey = _this.sh060Init.apiPass2;
            // 発行されたトークン
            var token;
            // エラーメッセージ
            var errMsg;
            // レスポンス
            var resp;
            // カード番号をまとめてセット
            if (_this.sh060Init.creditInpNumOption == 1) {
                cardno = this.sh060Request.cardNoDisp;
                if (cardno != undefined) {
                    cardno = cardno.replaceAll(' ','');
                }
            } else {
                cardno = this.sh060Request.cardNoDisp1 + this.sh060Request.cardNoDisp2 + this.sh060Request.cardNoDisp3 + this.sh060Request.cardNoDisp4;
            }
            document.getElementById('cardNoDisp').value = cardno;

            // 前回カードの場合
            if (cardFlg == '1') {
                _this.sh060Request.token = "dummy";
                _this.doOrder();
                return true;
            }

            if (_this.sh060Init.securityCodeUseFlg) {
                if (!_this.sh060Request.securityCode) {
                    // セキュリティコードを入力してください。
                    this.listMessValid.push(_this.$i18n.t('sh060.messages.secMust'));
                    _this.is3DLoding = false;
                    EventBus.$emit('message', {});
                    common.scrollTop();
                    return false;
                }
            }

            //カード情報
            _this.epsCard.card_no = cardno;
            _this.epsCard.expire = _this.sh060Request.limitYear + _this.sh060Request.limitMonth;
            _this.epsCard.security_code = _this.sh060Request.securityCode;
            if (_this.sh060Init.cardNameOption == 1) {
                _this.epsCard.holder_name = _this.sh060Request.cardNameNamae + _this.sh060Request.cardNameMyouji;
            } else {
                _this.epsCard.holder_name = _this.sh060Request.cardUserNm;
            }
            //axiosでリクエストデータ送信（①fincode決済登録呼び出しAPI）
            let request = { ajaxKbn:"1", kessaiCd:  _this.sh060Init.kessaiCd, amount: _this.sh060Init.seikyuuKin};
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.SH060 + _this.$UrlConstants.DO_AJAX, request
            ).then(function(response) {

                //決済登録APIのレスポンスを設定
                //_this.epsOsori.epsId = response.data.epsId;
                //_this.epsOsori.epsAccessId = response.data.epsAccessId;

                _this.sh060Request.epsId = response.data.epsId;
                _this.sh060Request.epsAccessId = response.data.epsAccessId;

                _this.$loadScript(apiUrl).then(() => {
                    let fincode = Fincode(publicApiKey);
                    //トークンJS実行
                    fincode.tokens(_this.epsCard,
                        (status, response) => {
                            if (200 === status) {
                                // トークンJS リクエスト正常時の処理

                                //_this.sh060Request.epsId = _this.epsOsori.epsId;
                                //_this.sh060Request.epsAccessId = _this.epsOsori.epsAccessId
                                _this.sh060Request.token = response.list[0].token, //トークンJSで取得した値
                                _this.sh060Request.epsPayMethod = (_this.isBunkatu(_this.sh060Request.cardPayCnt)? "2":"1");//決済実行:支払方法:1 - 一括; 2 - 分割
                                _this.doOrder();
                                return true;
                            } else {
                                // トークンJS リクエストエラー時の処理
                                response.errors.forEach(error => {
                                    alert(error.error_message + "(" + error.error_code + ")");
                                });
                            }
                        },
                        () => {
                        // トークンJS 通信エラー処理。
                        alert("通信エラーが発生しました。しばらく経ってから再度お試しください。");
                        }
                    );
                    // 結果true
                    if (resp) {
                        token = document.getElementById('card_token');
                        _this.sh060Request.token = token.value;
                        _this.doOrder();
                        return true;
                    // 結果false
                    } else {
                        errMsg = document.getElementById('fsjs_error');
                        alert(errMsg.textContent);
                        common.scrollTop();
                    }
                })
                .catch(function(error) {
                    console.log(error);
                    if(error != null && error != undefined){
                        if(error.response != null && error.response != undefined){
                            if(406 == error.response.status){
                                var resultValid = common.excuteValidationEcSite(error, _this.SH060_PART);
                                if(resultValid){
                                    _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                    _this.listMessValid = resultValid.msgList;
                                    _this.mapMessValid = resultValid.mapMsg;
                                }
                                common.scrollTop();
                            }else{
                                common.errorAPI(error);
                            }
                        }
                    }
                });
                

            }).catch(function(error) {
                _this.is3DLoding = false;
                if(error != null && error != undefined){
                    if(error.response != null && error.response != undefined){
                        if(406 == error.response.status){
                            var resultValid = common.excuteValidationEcSite(error, _this.SH060_PART);
                            if(resultValid){
                                _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                _this.listMessValid = resultValid.msgList;
                                _this.mapMessValid = resultValid.mapMsg;
                            }
                            common.scrollTop();
                        }else{
                            common.errorAPI(error);
                        }
                    }
                }
            }).finally(function() {
                _this.$emit("event-loading", false);
            });

            
        },
        /*
        * GMOトークン取得
        */
        doPurchase : function() {
            var _this = this;
            var cardFlg = _this.sh060Request.cardFlg;
            var cardNoDisp = _this.sh060Init.cardNoDisp;
            var cardno,expire,securitycode,holdername,tokennumber;
            // 前回カードの場合
            if (cardFlg == '1') {
                _this.sh060Request.token = "dummy";
                _this.doOrder();
                return true;
            }
            if (_this.sh060Init.creditInpNumOption == 1) {
                cardno = this.sh060Request.cardNoDisp;
                if (cardno != undefined) {
                    cardno = cardno.replaceAll(' ','');
                }
            } else {
                cardno = this.sh060Request.cardNoDisp1 + this.sh060Request.cardNoDisp2 + this.sh060Request.cardNoDisp3 + this.sh060Request.cardNoDisp4;
            }
            
            //名義人必須チェック
            if (_this.sh060Init.cardNameOption == 1) {
                if(_this.sh060Init.kessaiCompKbn == 'GMO' && (!_this.sh060Request.cardNameMyouji || !_this.sh060Request.cardNameNamae)){
                    _this.listMessValid.push(this.$i18n.t('sh060.labels.holdernameMustErr'));
                    _this.$emit("event-loading", false);
                    EventBus.$emit('message', {});
                    common.scrollTop();
                    return;
                }
            } else {
                if(_this.sh060Init.kessaiCompKbn == 'GMO' && (!_this.sh060Request.cardUserNm)){
                    _this.listMessValid.push(this.$i18n.t('sh060.labels.holdernameMustErr'));
                    _this.$emit("event-loading", false);
                    EventBus.$emit('message', {});
                    common.scrollTop();
                    return;
                }
            }
           

            expire = this.sh060Request.limitYear + this.sh060Request.limitMonth;
            securitycode = this.sh060Request.securityCode;
            holdername = this.sh060Request.cardUserNm;
            if (_this.sh060Init.cardNameOption == 1) {
                holdername = this.sh060Request.cardNameNamae + ' ' +  this.sh060Request.cardNameMyouji;
            }

            if (_this.sh060Init.securityCodeUseFlg) {
                if (!securitycode) {
                    // セキュリティコードを入力してください。
                    this.listMessValid.push(_this.$i18n.t('sh060.messages.secMust'));
                    _this.is3DLoding = false;
                    EventBus.$emit('message', {});
                    common.scrollTop();
                    return false;
                }
            }
            // 取得したいトークンの数
            tokennumber = '2';
            // トークン取得のURL
            var apiUrl = this.sh060Init.tokenUrl;
            var shopId = this.sh060Init.shopId;
            this.$loadScript(apiUrl) .then(() => {
                Multipayment.init(this.sh060Init.shopId);
                Multipayment.getToken(
                    {	cardno: cardno,
                        expire: expire,
                        securitycode: securitycode,
                        holdername: holdername,
                        tokennumber: tokennumber
                    },
                    function(response){
                        var errCode = response.resultCode;
                        if( errCode != '000' ){
                            if (errCode == '100') {
                                alert('カード番号は必須です。');
                            } else if (errCode == '101') {
                                alert('カード番号の値が不正です。');
                            } else if (errCode == '102') {
                                alert('カード番号の桁数に誤りがあります。');
                            } else if (errCode == '110') {
                                alert('有効期限は必須です。');
                            } else if (errCode == '111') {
                                alert('有効期限の値が不正です。');
                            } else if (errCode == '112') {
                                alert('有効期限の桁数に誤りがあります。');
                            } else if (errCode == '113') {
                                alert('有効期限の値が不正です。');
                            } else if (errCode == '121') {
                                alert('セキュリティコードの値が不正です。');
                            } else if (errCode == '122') {
                                alert('セキュリティコードの桁数に誤りがあります。');
                            } else if (errCode == '131') {
                                alert('名義人の値が不正です。');
                            } else if (errCode == '132') {
                                alert('名義人の桁数に誤りがあります。');
                            } else {
                                alert('内部処理エラーが発生しました。');
                            }
                        } else {
                            for (var token = 0; token < response.tokenObject.token.length; token++) {
                                if (token == 0) {
                                    _this.sh060Request.token = response.tokenObject.token[token];
                                } else {
                                    _this.sh060Request.token = _this.sh060Request.token + "," + response.tokenObject.token[token];
                                }
                            }
                            // 注文確定処理
                            _this.doOrder();
                            return true;
                        }
                    }
                );
             })
            .catch(function(error) {
                console.log(error);
            });
        },
        /**
         * SBペイメントのトークン取得
         */
         doSbp: function() {
            const _this = this;

            // 前回カードの場合
            const cardFlg = _this.sh060Request.cardFlg;
            if (_this.securitySbp3DFlg == 0 && cardFlg == '1') {
                _this.doOrder();
                return true;
            }

            if(_this.sh060Init.securityCodeUseFlg) {
                let securityCode = "";
                if(_this.sh060Request.cardFlg == undefined || _this.sh060Request.cardFlg == '0') {
                    securityCode = _this.sh060Request.securityCode;
                }else if (_this.sh060Request.cardFlg == '1'){
                    securityCode =  _this.sh060Request.cardSecurity;
                }else{
                    securityCode = _this.sh060Request.securityCode;
                }

                if(!securityCode) {
                    // セキュリティコードを入力してください。
                    this.listMessValid.push(_this.$i18n.t('sh060.messages.secMust'));
                    _this.is3DLoding = false;
                    EventBus.$emit('message', {});
                    common.scrollTop();
                    return false;
                }
            }

            const cardno = _this.sh060Init.creditInpNumOption == 1
                ? _this.sh060Request.cardNoDisp
                : _this.sh060Request.cardNoDisp1
                    + _this.sh060Request.cardNoDisp2
                    + _this.sh060Request.cardNoDisp3
                    + _this.sh060Request.cardNoDisp4;
            const currentYear = new Date().getFullYear().toString();
            const expiration = 
                currentYear.substring(0, 2) + _this.sh060Request.limitYear + _this.sh060Request.limitMonth;

            // 取得
            if (_this.securitySbp3DFlg == 0){
                const apiUrl = _this.sh060Init.tokenUrl;
                _this.$loadScript(apiUrl).then(() => {
                    com_sbps_system.generateToken({
                        merchantId: _this.sh060Init.confText1,
                        serviceId: _this.sh060Init.confText2,
                        ccNumber: cardno ? cardno.replaceAll(' ','') : '',
                        ccExpiration: expiration,
                        securityCode: ((_this.sh060Request.cardFlg == undefined || _this.sh060Request.cardFlg == '0')?_this.sh060Request.securityCode:_this.sh060Request.cardSecurity)
                    }, (response) => {
                        if (response.errorCode) {
                            const itemCode = response.errorCode.substring(2);
                            if (itemCode === '003') {
                                alert('クレジット番号に誤りがあります。');
                            } else if (itemCode === '004') {
                                alert('クレジット有効期限に誤りがあります。');
                            } else if (itemCode === '005') {
                                alert('セキュリティコードに誤りがあります。');
                            } else {
                                alert('内部処理エラーが発生しました。');
                            }
                            return false;
                        }
                        if (response.result === "OK") {
                            _this.sh060Request.token = response.tokenResponse.token;
                            _this.sh060Request.tokenKey = response.tokenResponse.tokenKey;
                            _this.doOrder();
                            return true;
                        } else {
                            alert('トークン取得に失敗しました。');
                        }
                    });
                });
            }else{
                const tds2InfoTokenUrl = _this.sh060Init.tds2TokenUrl;
                _this.$loadScript(tds2InfoTokenUrl).then(() => {
                    com_sbps_system_tds2.generateToken({
                        merchantId: _this.sh060Init.confText1,
                        serviceId: _this.sh060Init.confText2,
                        billingLastName: _this.sh060Request.cardNameMyouji,
                        billingFirstName: _this.sh060Request.cardNameNamae,
                        billingPostalCode: _this.stringNvl(_this.sh060Init.orderInfo['KOKYAKU_ZIP']).replace("-", ""),
                        billingCity: _this.stringNvl(_this.sh060Init.orderInfo['KOKYAKU_KEN_NM'], ""),
                        billingAddress1: _this.stringNvl(_this.sh060Init.orderInfo['KOKYAKU_ADDR1'], "").replace(_this.stringNvl(_this.sh060Init.orderInfo['KOKYAKU_KEN_NM']), ""),
                        billingAddress2: _this.stringNvl(_this.sh060Init.orderInfo['KOKYAKU_ADDR2'], ""),
                        billingAddress3: _this.stringNvl(_this.sh060Init.orderInfo['KOKYAKU_ADDR3'], ""),
                        billingPhone: _this.stringNvl(_this.sh060Init.orderInfo['KOKYAKU_TEL1'], ""),
                        workPhone: "",
                        shippingPostalCode: _this.stringNvl(_this.sh060Init.orderInfo['TDK_ZIP'], "").replace("-", ""),
                        shippingCity: _this.stringNvl(_this.sh060Init.orderInfo['TDK_KEN_NM'], ""),
                        shippingAddress1: _this.stringNvl(_this.sh060Init.orderInfo['TDK_ADDR1'], "").replace(_this.stringNvl(_this.sh060Init.orderInfo['TDK_KEN_NM']), ""),
                        shippingAddress2: _this.stringNvl(_this.sh060Init.orderInfo['TDK_ADDR2'], ""),
                        shippingAddress3: _this.stringNvl(_this.sh060Init.orderInfo['TDK_ADDR3'], ""),
                        email: _this.stringNvl(_this.sh060Init.orderInfo['KOKYAKU_MAIL1'], "")
                    }, (tds2Response) => {
                        if (tds2Response.result === "NG"){
                            if (tds2Response.errorCode) {
                                const tds2ItemCode = tds2Response.errorCode.substring(2);
                                if (tds2ItemCode === '003') {
                                    //Last name of billing destination
                                    alert('カードの名義人に誤りがあります。');
                                } else if (tds2ItemCode === '004') {
                                    //First name of billing destination
                                    alert('カードの名義人に誤りがあります。');
                                } else if (tds2ItemCode === '005') {
                                    //Billing postal code
                                    alert('請求者の郵便番号に誤りがあります。');
                                } else if (tds2ItemCode === '006') {
                                    //Billing prefecture
                                    alert('請求者の住所に誤りがあります。');
                                } else if (tds2ItemCode === '007') {
                                    //Billing city/town
                                    alert('請求者の住所に誤りがあります。');
                                } else if (tds2ItemCode === '008') {
                                    //Billing street/number
                                    alert('請求者の住所に誤りがあります。');
                                } else if (tds2ItemCode === '009') {
                                    //Billing building name
                                    alert('請求者の住所に誤りがあります。');
                                } else if (tds2ItemCode === '010') {
                                    //Billing phone number
                                    alert('請求者の電話番号に誤りがあります。');
                                } else if (tds2ItemCode === '011') {
                                    //Contact phone number
                                    alert('請求者の電話番号に誤りがあります。');
                                } else if (tds2ItemCode === '012') {
                                    //Delivery postal code
                                    alert('お届先の郵便番号に誤りがあります。');
                                } else if (tds2ItemCode === '013') {
                                    //Delivery prefecture
                                    alert('お届先の住所に誤りがあります。');
                                } else if (tds2ItemCode === '014') {
                                    //Delivery city/town
                                    alert('お届先の住所に誤りがあります。');
                                } else if (tds2ItemCode === '015') {
                                    //Delivery street/number
                                    alert('お届先の住所に誤りがあります。');
                                } else if (tds2ItemCode === '016') {
                                    //Delivery building name
                                    alert('お届先の住所に誤りがあります。');
                                } else if (tds2ItemCode === '017') {
                                    //Email address
                                    alert('請求者のメールアドレスに誤りがあります。');
                                } else {
                                    alert('内部処理エラーが発生しました。');
                                }                           
                            }
                            return false;
                        } 

                        if (tds2Response.result === "OK") {
                            _this.sh060Request.tds2InfoToken = tds2Response.tokenResponse.tds2infoToken;
                            _this.sh060Request.tds2InfoTokenKey = tds2Response.tokenResponse.tds2infoTokenKey;

                            if (_this.sh060Request.cardFlg == undefined || _this.sh060Request.cardFlg == 0){
                                const apiUrl = _this.sh060Init.tokenUrl;
                                _this.$loadScript(apiUrl).then(() => {
                                    com_sbps_system.generateToken({
                                        merchantId: _this.sh060Init.confText1,
                                        serviceId: _this.sh060Init.confText2,
                                        ccNumber: cardno ? cardno.replaceAll(' ','') : '',
                                        ccExpiration: expiration,
                                        securityCode: ((_this.sh060Request.cardFlg == undefined || _this.sh060Request.cardFlg == '0')?_this.sh060Request.securityCode:_this.sh060Request.cardSecurity)
                                    }, (response) => {
                                        if (response.errorCode) {
                                            const itemCode = response.errorCode.substring(2);
                                            if (itemCode === '003') {
                                                alert('クレジット番号に誤りがあります。');
                                            } else if (itemCode === '004') {
                                                alert('クレジット有効期限に誤りがあります。');
                                            } else if (itemCode === '005') {
                                                alert('セキュリティコードに誤りがあります。');
                                            } else {
                                                alert('内部処理エラーが発生しました。');
                                            }
                                            return false;
                                        }
                                        if (response.result === "OK") {
                                            _this.sh060Request.token = response.tokenResponse.token;
                                            _this.sh060Request.tokenKey = response.tokenResponse.tokenKey;
                                            _this.doOrder();
                                            return true;
                                        } else {
                                            alert('トークン取得に失敗しました。');
                                        }
                                    });
                                });
                            }else{
                                _this.doOrder();
                                return true;
                            }

                            return true;
                        } else {
                            alert('カード利用者決済情報トークン取得に失敗しました。');
                            return false;
                        }
                    });
                });
            }
        },

        /**
         * SBペイメントの3DS認証要求NG後顧客決済情報の更新
         */
        updateForSbp3dsNg: function() {
            var _this = this;
			_this.listMessValid = [];
            _this.mapMessValid = [];
            common.clearMessageEcSite(_this.listIdErr, _this.SH060_PART);
			_this.$emit("event-loading", true);
            // 決済情報更新
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.SH060 + _this.$UrlConstants.DO_UPDATE_FOR_SBP_3DS_NG,_this.sh060Request).then(function(response) {
                _this.sbpEmv3dsStatus = '';
                _this.$emit("event-loading", false);
            }).catch(function(error) {
				_this.is3DLoding = false;
                    if(error != null && error != undefined){
                        _this.isModalShow = false;
                        if(error.response != null && error.response != undefined){
                            if(406 == error.response.status){
                                var resultValid = common.excuteValidationEcSite(error, _this.SH060_PART);
                                if(resultValid){
                                    _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                    _this.listMessValid = resultValid.msgList;
                                    _this.mapMessValid = resultValid.mapMsg;
                                }
                            }else{
                                common.errorAPI(error);
                            }
                        }
                    }
				common.scrollTop();
            }).finally(function() {
                _this.is3DLoding = false;
                _this.$emit("event-loading", false);
            })
        },

        /*
        * 注文確定処理(SBP 3DS2.0)
        */
        doSbp2Order: function(){
            var _this = this;
            //_this.$emit("event-loading", true);
            //clear msg valid
            _this.listMessValid = [];
            _this.mapMessValid = [];
            common.clearMessageEcSite(_this.listIdErr, _this.SH060_PART);
            if (_this.securitySbp3DFlg == 1){
                _this.sh060Request.sbp3DVerFlg = _this.securitySbp3DFlg;
                _this.sh060Request.tdsAuthenticationId = _this.sbpTdsAuthenticationId;
            }
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.SH060 + _this.$UrlConstants.DO_ORDER, _this.sh060Request).then(function(response) {
                if(response.data.status == 'OK'){
                    var message = "";
                    var orderCd = "";
                    if(response.data.response != null){
                        message = response.data.response.message;
                        orderCd = response.data.response.orderCd;
                    }
                    _this.$router.push({ name: _this.SiteConstants.PG010MAIN, params:{message:message,orderCd:orderCd}, query: {pageNo: 23}});
                }
            }).catch(function(error) {
                // eslint-disable-next-line
                _this.is3DLoding = false;
                if(error != null && error != undefined){
                    if(error.response != null && error.response != undefined){
                        if(406 == error.response.status){
                            var resultValid = common.excuteValidationEcSite(error, _this.SH060_PART);
                            if(resultValid){
                                _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                _this.listMessValid = resultValid.msgList;
                                _this.mapMessValid = resultValid.mapMsg;
                            }
                            common.scrollTop();
                        }else{
                            common.errorAPI(error);
                        }
                    }
                }
            }).finally(function() {
                _this.is3DLoding = false;
                _this.$emit("event-loading", false);
            });
        },

        /*
        *ペイジェントのトークン取得
        */
        doPayG: function(){
            var _this = this;
            var tokenUrl = _this.sh060Init.tokenUrl;
            // マーチャントID
            var machantoId = _this.sh060Init.confText1;
            // トークン生成鍵
            var tokunSeiseikagi = _this.sh060Init.apiPass2;
            var cardno = "";
            var cardSecurity = "";

            if (_this.sh060Init.creditInpNumOption == 1) {
                cardno = this.sh060Request.cardNoDisp;
                if (cardno != undefined) {
                    cardno = cardno.replaceAll(' ','');
                }
                cardSecurity = this.sh060Request.cardSecurity;
            } else {
                cardno = this.sh060Request.cardNoDisp1 + this.sh060Request.cardNoDisp2 + this.sh060Request.cardNoDisp3 + this.sh060Request.cardNoDisp4;
                cardSecurity = this.sh060Request.securityCode;
            }
            var holdername = this.sh060Request.cardUserNm;
            if (_this.sh060Init.cardNameOption == 1) {
                holdername = this.sh060Request.cardNameNamae + ' ' +  this.sh060Request.cardNameMyouji;
            }

            if(_this.sh060Init.securityCodeUseFlg) {
                if(!cardSecurity) {
                    // セキュリティコードを入力してください。
                    this.listMessValid.push(_this.$i18n.t('sh060.messages.secMust'));
                    _this.is3DLoding = false;
                    EventBus.$emit('message', {});
                    common.scrollTop();
                    return false;
                }
            }

            this.$loadScript(tokenUrl).then(() => {
                var paygentToken = new PaygentToken();
                paygentToken.createToken(
                    machantoId, //マーチャントID
                    tokunSeiseikagi, //トークン生成鍵
                    {
                    card_number:cardno, //クレジットカード番号
                    expire_year:this.sh060Request.limitYear, //有効期限-YY
                    expire_month: this.sh060Request.limitMonth, //有効期限-MM
                    cvc:cardSecurity, //セキュリティーコード
                    name:holdername //カード名義
                    },function(response){
                        //正常終了
                        if(response.result == '0000'){
                            //トークン
                            _this.sh060Request.token = response.tokenizedCardObject.token;
                            _this.doOrder();
                        //エラー
                        }else{
                            if(response.result == '1100'){
                                alert('マーチャントID - 必須エラー');
                            }else if(response.result == '1200'){
                                alert('トークン生成公開鍵 - 必須エラー');
                            }else if(response.result == '1200'){
                                alert('トークン生成公開鍵 - 必須エラー');
                            }else if(response.result == '1201'){
                                alert('トークン生成公開鍵 - 不正エラー');
                            }else if(response.result == '1300'){
                                alert('カード番号 - 必須チェックエラー');
                            }else if(response.result == '1301'){
                                alert('カード番号 - 書式チェックエラー');
                            }else if(response.result == '1400'){
                                alert('有効期限(年) - 必須チェックエラー');
                            }else if(response.result == '1401'){
                                alert('有効期限(年) - 書式チェックエラー');
                            }else if(response.result == '1500'){
                                alert('有効期限(月) - 必須チェックエラー');
                            }else if(response.result == '1501'){
                                alert('有効期限(月) - 書式チェックエラー');
                            }else if(response.result == '1502'){
                                alert('有効期限(年月)が不正です。');
                            }else if(response.result == '1600'){
                                alert('セキュリティコード - 書式チェックエラー');
                            }else if(response.result == '1601'){
                                alert('セキュリティコード - 必須エラー（セキュリティコードトークンの場合）');
                            }else if(response.result == '1700'){
                                alert('カード名義 - 書式チェックエラー');
                            }else if(response.result == '7000'){
                                alert('非対応のブラウザです。');
                            }else if(response.result == '7001'){
                                alert('ペイジェントとの通信に失敗しました。');
                            }else if(response.result == '8000'){
                                alert('システムメンテナンス中です。');
                            }else if(response.result == '9000'){
                                alert('ペイジェント決済システム内部エラー');
                            }
                        }

                    }
                );
            })
            .catch(function(error) {
                console.log(error);
            });
        },
        /**
         * ソニーペイメントのトークン取得
         */
        doSps: async function() {
            const _this = this;
            
            _this.sh060Request.spsResultId = null;
            _this.sh060Request.operateId = null;
            _this.sh060Request.sps3DVer2Flg = _this.securitySps3DFlg; //SPS 3D 2.0 セキュア利用フラグ
            _this.sh060Request.kaiinIdPassFlg = 0; // 会員連携フラグ

            if (_this.sh060Request.cardFlg == '0') {
                // バリデーション
                _this.listMessValid = [];
                let isError = false;
                if(!_this.pan) {
                    // カード番号を入力してください。
                    _this.listMessValid.push(_this.$i18n.t('sh060.messages.cardNoMust'));
                    isError = true;
                } else if (_this.pan.length < 14 ) {
                    // カード番号の入力値に誤りがあります。14桁以上16桁以内の数字で入力してください。
                    _this.listMessValid.push(_this.$i18n.t('sh060.messages.cardNoInputErr'));
                    isError = true;
                }
                if(!_this.expiryDate) {
                    // カード有効期限を入力してください。
                    _this.listMessValid.push(_this.$i18n.t('sh060.messages.expiryDateMust'));
                    isError = true;
                } else if (_this.expiryDate.length < 4 ) {
                    // カード有効期限の入力値に誤りがあります。半角数値（「月/年」）で入力してください。
                    _this.listMessValid.push(_this.$i18n.t('sh060.messages.expiryDateInputErr'));
                    isError = true;
                }
                if(_this.sh060Init.securityCodeUseFlg) {
                    if(!_this.sh060Request.securityCode) {
                        // セキュリティコードを入力してください。
                        _this.listMessValid.push(_this.$i18n.t('sh060.messages.secMust'));
                        isError = true;
                    }
                }

                if (isError) {
                    _this.is3DLoding = false;
                    EventBus.$emit('message', {});
                    common.scrollTop();
                    return true;
                }
            }
            
            // SPSトークン取得
            const loadScriptSps = (url) => {
                return new Promise((resolve, reject) => {
                    if (document.querySelector('script[src="' + url + '"]')) {
                        return resolve();
                    }

                    const script = document.createElement('script');
                    script.type = 'text/javascript';
                    script.async = true;
                    script.src = url;
                    script.setAttribute('callBackFunc', 'setToken');
                    script.setAttribute('class', 'spsvToken');
        
                    script.addEventListener('load', resolve);
                    script.addEventListener('error', reject);
                    script.addEventListener('abort', reject);
        
                    document.head.appendChild(script);
                });
            };

            // 前回カードの場合
            const cardFlg = _this.sh060Request.cardFlg;
            if (cardFlg == '1') {
                _this.doOrder();
                return true;
            }

            const cardno = _this.sh060Init.creditInpNumOption == 1
                ? _this.sh060Request.cardNoDisp
                : _this.sh060Request.cardNoDisp1
                    + _this.sh060Request.cardNoDisp2
                    + _this.sh060Request.cardNoDisp3
                    + _this.sh060Request.cardNoDisp4;
            const expirationYear = _this.sh060Request.limitYear;
            const expirationMonth =  _this.sh060Request.limitMonth

            const apiUrl = `${_this.sh060Init.tokenUrl}?k_TokenNinsyoCode=${_this.sh060Init.tokenNinsyoCode}`;
            await loadScriptSps(apiUrl);

            SpsvApi.spsvCreateToken(
                cardno ? cardno.replaceAll(' ','') : '', // 第１引数：カード番号
                expirationYear, // 第２引数：有効期限（年）
                expirationMonth, // 第３引数：有効期限（年）
                _this.sh060Request.securityCode, // 第４引数：セキュリティコード
                '', // 第６引数：生年月日（日）
                '', // 第７引数：電話番号
                '', // 第８引数：カナ氏名（姓）
                '', // 第９引数：カナ氏名（名）
            );

            // タイムアウト
            const timeId = setTimeout(() => {
                window.removeEventListener('message', handleMessage);
                alert('トークン取得に失敗しました。');
                return false;
            }, spsvGetParam('timeOut'));

            // メッセージイベントからトークンを取得する
            const handleMessage = (event) => {
                if (event.origin !== null && event.origin !== '' && event.origin !== undefined && event.origin != 'null') {
                    if (event.origin !== spsvGetParam('spsvOrigin')) {
                        if (event.origin.indexOf(spsvGetParam('spsvOrigin')) == -1) {
                            return;
                        }
                    }
                }
                try {
                    const message = JSON.parse(event.data);
                    if (
                        message.spsvOrigin !== null &&
                        message.spsvOrigin !== '' &&
                        message.spsvOrigin !== undefined &&
                        message.spsvOrigin != 'null'
                    ) {
                        if (message.spsvOrigin !== spsvGetParam('spsvOrigin')) {
                            return;
                        }
                        if (typeof message.tokenKbn == 'undefined' && message.token && message.token !== 'maked') {
                            clearTimeout(timeId);
                            window.removeEventListener('message', handleMessage);
                            _this.sh060Request.token = message.token;
                            _this.doOrder();
                            return true;
                        }
                    }
                } catch (e) {
                    return;
                }
            }
            window.addEventListener('message', handleMessage);
        },
        /**
         * ソニーペイメント3DS呼び出し
         */
        doSps3DS: function(response) {
            sessionStorage.setItem('giftCd', this.sh060Request.giftCd);
            this.sps3DSAuthori.merchantId = response.merchantId;
            this.sps3DSAuthori.encValue = response.encValue;
            
            this.$nextTick(() => this.$refs.formSps3D.submit()); 
        },
        doSps2Order: function() {
            var _this = this;
            _this.listMessValid = [];
            _this.mapMessValid = [];
            common.clearMessageEcSite(_this.listIdErr, _this.SH060_PART);
            _this.sh060Request.sps3DVer2Flg = 0; // SPS 3D 2.0 セキュア利用フラグ
            _this.sh060Request.spsResultId = _this.spsResultId; 
            _this.sh060Request.operateId = _this.operateId; 
            _this.sh060Request.hidGiftCd = sessionStorage['giftCd']; 
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.SH060 + _this.$UrlConstants.DO_ORDER, _this.sh060Request).then(function(response) {
                if (response.data.respCode == _this.LEAD_DAY_ERR) {
                    _this.$emit("event-loading", false);
                    _this.msgConfirmAreaCheck = _this.descriptionInfo[8];
                    _this.isModalAreaCheckShow = true;
                    _this.isButtonCancelAreaCheck = false;
                    EventBus.$on('evtClickOk', function() {
                        _this.isModalAreaCheckShow = false;
                    });
                    EventBus.$on('closed', () => {
                        _this.isModalAreaCheckShow = false;
                    });
                    _this.is3DLoding = false;
                    return;
                }
                if(response.data.status == 'OK') {
                    var message = "";
                    var orderCd = "";
                    if(response.data.response != null){
                        message = response.data.response.message;
                        orderCd = response.data.response.orderCd;
                    }
                    sessionStorage.removeItem('hopeDayList');
                    sessionStorage.removeItem('totalPointKin');
                    sessionStorage.removeItem('sh060TranferData');
                    _this.$router.push({ name: _this.SiteConstants.PG010MAIN, params:{message:message,orderCd:orderCd}, query: {pageNo: 23}});
                }
            }).catch(function(error) {
                _this.is3DLoding = false;
                if(error != null && error != undefined){
                    if(error.response != null && error.response != undefined){
                        if(406 == error.response.status){
                            var resultValid = common.excuteValidationEcSite(error, _this.SH060_PART);
                            if(resultValid){
                                _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                _this.listMessValid = resultValid.msgList;
                                _this.mapMessValid = resultValid.mapMsg;
                            }
                            common.scrollTop();
                        }else{
                            common.errorAPI(error);
                        }
                    }
                }
            }).finally(function() {
                _this.is3DLoding = false;
                _this.$emit("event-loading", false);
            });
        },

        doGmoDpayOrder: function() {
            var _this = this;

            if (!_this.gmodpaySeqNo){
                _this.is3DLoding = false;
                _this.$emit("event-loading", false);
                return;
            }

            if (!_this.gmoDPayAccessID){
                _this.is3DLoding = false;
                _this.$emit("event-loading", false);
                return;
            }

            _this.listMessValid = [];
            _this.mapMessValid = [];
            common.clearMessageEcSite(_this.listIdErr, _this.SH060_PART);
            _this.sh060Request.gmodpaySeqNo = _this.gmodpaySeqNo;
            _this.sh060Request.gmoDPayAccessID = _this.gmoDPayAccessID; 
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.SH060 + _this.$UrlConstants.DO_ORDER, _this.sh060Request).then(function(response) {
                if(response.data.status == 'OK') {
                    var message = "";
                    var orderCd = "";
                    if(response.data.response != null){
                        message = response.data.response.message;
                        orderCd = response.data.response.orderCd;
                    }
                    _this.$router.push({ name: _this.SiteConstants.PG010MAIN, params:{message:message,orderCd:orderCd}, query: {pageNo: 23}});
                }
            }).catch(function(error) {
                _this.is3DLoding = false;
                if(error != null && error != undefined){
                    if(error.response != null && error.response != undefined){
                        if(406 == error.response.status){
                            var resultValid = common.excuteValidationEcSite(error, _this.SH060_PART);
                            if(resultValid){
                                _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                _this.listMessValid = resultValid.msgList;
                                _this.mapMessValid = resultValid.mapMsg;
                            }
                            common.scrollTop();
                        }else{
                            common.errorAPI(error);
                        }
                    }
                }
            }).finally(function() {
                _this.is3DLoding = false;
                _this.$emit("event-loading", false);
            });
        },

        /* 
        * method callback from api payment
        */
        someCallbackFunction: function(response){
            var _this = this;
            _this.isLoading = true;
            
            if( response.resultCode != "000" ){ 
                _this.msgConfirm = this.$i18n.t('sh060.labels.erMessg');
                _this.isModalShow = true;
                _this.isButtonCancel = false;
                return;
            }else{
                if(response.resultCode = "000"){
                    //予め購入フォームに用意した token フィールドに、値を設定
                    _this.sh060Request.token = response.tokenObject.token;
                    _this.doOrder();
                    return true;
                }else if(response.resultCode = 500){
                    document.getElementById("button").disabled ='';
                }
            }
        },
        /*
        * 注文確定処理(GMO 3DS2.0)
        */
        doGmo2Order: function(){
            var _this = this;
            //_this.$emit("event-loading", true);
            //clear msg valid
            _this.listMessValid = [];
            _this.mapMessValid = [];
            common.clearMessageEcSite(_this.listIdErr, _this.SH060_PART);
            _this.sh060Request.gmo3DVer2Flg = _this.securityGmo3DFlg; //GMO 3D 2.0 セキュア利用フラグ
            _this.sh060Request.gmo2AuthAccessID = _this.gmo2AuthAccessID;
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.SH060 + _this.$UrlConstants.DO_ORDER, _this.sh060Request).then(function(response) {
                if(response.data.respCode == _this.SHOW_ERR_PAGE){
                    _this.$router.push({ name: "SH060ShopperInfoConfirmError"});
                    _this.is3DLoding = false
                    return;
                }
                if (response.data.respCode == _this.LEAD_DAY_ERR) {
                    _this.$emit("event-loading", false);
                    _this.msgConfirmAreaCheck = _this.descriptionInfo[8];
                    _this.isModalAreaCheckShow = true;
                    _this.isButtonCancelAreaCheck = false;
                    EventBus.$on('evtClickOk', function() {
                        _this.isModalAreaCheckShow = false;
                    });
                    EventBus.$on('closed', () => {
                        _this.isModalAreaCheckShow = false;
                    });
                    _this.is3DLoding = false;
                    return;
                }
                if(response.data.status == 'OK'){
                    var message = "";
                    var orderCd = "";
                    if(response.data.response != null){
                        message = response.data.response.message;
                        orderCd = response.data.response.orderCd;
                    }
                    sessionStorage.removeItem('hopeDayList');
                    sessionStorage.removeItem('hopeDay');
                    sessionStorage.removeItem('hopeDayCnt');
                    sessionStorage.removeItem('totalPointKin');
                    sessionStorage.removeItem('sh060TranferData');
                    _this.$router.push({ name: _this.SiteConstants.PG010MAIN, params:{message:message,orderCd:orderCd}, query: {pageNo: 23}});
                }
            }).catch(function(error) {
                // eslint-disable-next-line
                _this.is3DLoding = false;
                if(error != null && error != undefined){
                    if(error.response != null && error.response != undefined){
                        if(406 == error.response.status){
                            var resultValid = common.excuteValidationEcSite(error, _this.SH060_PART);
                            if(resultValid){
                                _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                _this.listMessValid = resultValid.msgList;
                                _this.mapMessValid = resultValid.mapMsg;
                            }
                            common.scrollTop();
                        }else{
                            common.errorAPI(error);
                        }
                    }
                }
            }).finally(function() {
                _this.is3DLoding = false;
                _this.$emit("event-loading", false);
            });
        },

        gotoSettingPage : function(nextPageId) {
            if (nextPageId == 21) {
                var _this = this;
                if (_this.sh060Request.orderInfo != null && _this.sh060Request.orderInfo['AMAZON_PAY_INFO'] != null && _this.sh060Request.orderInfo['AMAZON_PAY_INFO'] != "undefined") {
                    sessionStorage['amazonPayInfo'] = _this.sh060Request.orderInfo['AMAZON_PAY_INFO'];
                }
            }
            this.saveSessionSh060();
            this.$router.push({ name: this.SiteConstants.PG010MAIN, query: {pageNo: nextPageId, modeKbn:1, orderConfirmFlg: 1}});
        },

        gotoSettingPageForTdk : function(nextPageId,tdkSeq,scrollId) {
            //ゲスト購入の場合、複数届けではないため、複数届け先振り分け設定画面へ遷移しないように改修。
            if(this.sh060Init.kokyakuNo != null && this.sh060Init.kokyakuNo != '999999999' && this.sh060Init.tdkInfo && this.sh060Init.tdkInfo.length > 1){
                nextPageId = 28;//複数届け先振り分け設定画面へ
            }
            this.saveSessionSh060();
            this.$router.push({ name: this.SiteConstants.PG010MAIN, query: {pageNo: nextPageId, modeKbn:1,tdkSeq:tdkSeq,scrollId:scrollId, orderConfirmFlg: 1, teikiFlg: this.sh060Init.teikiFlg}});
        },

        gotoCouponPage : function(nextPageId) {
            this.saveSessionSh060();
            this.$router.push({ name: this.SiteConstants.PG010MAIN, query: {pageNo: nextPageId, modeKbn: 1}});
        },
        /*
        *   値引きチェック
        */
        doNebikiCheck:function(){
            var _this = this;
            if (_this.sh060Init.nebikiSumMoto > _this.sh060Init.itemSumKin) {
                _this.outputMsgConfirm = _this.$i18n.t('sh060.messages.nebikiCheck');
                _this.isShowNebikiAlert = true;
                return false;
            }
            return true;
        },
        /*
        *   えんてつきチェック
        */
        doEntetusPointCheck:function(){
            var _this = this;
            //遠鉄個人時はチェックを実行する
            if (_this.sh060Init.entetsuFlg == 1 && _this.sh060Init.entetsuAutoLoginFlg == 1) {
                if (_this.entetsuKainInfo.cardType == 3){
                    _this.outputMsgConfirm = _this.$i18n.t('entetsu.messages.cardStatusUnknown') + _this.$i18n.t('entetsu.messages.cardConfirm');
                    _this.isShowEntetsuAlert = true;
                    return false;
                }else{
                    if (_this.entetsuKainInfo.pointRiyoFlg == 0){
                        if (_this.entetsuKainInfo.expiredFlg == 1){
                            _this.outputMsgConfirm = _this.$i18n.t('entetsu.messages.cardExpired') + _this.$i18n.t('entetsu.messages.cardConfirm');
                        }else if (_this.entetsuKainInfo.stopFlg == 1){
                            _this.outputMsgConfirm = _this.$i18n.t('entetsu.messages.cardStop') + _this.$i18n.t('entetsu.messages.cardConfirm');
                        }else{
                             _this.outputMsgConfirm = _this.$i18n.t('entetsu.messages.cardMaintenance') + _this.$i18n.t('entetsu.messages.cardConfirm');
                        }
                        _this.isShowEntetsuAlert = true;
                        return false;
                    }
                }

            }
            return true;
        },

        /*
        * 注文確定処理
        */
        doOrder: function(){
            var _this = this;

            var sbpCardFlg = _this.sh060Request.cardFlg;
            var sbpCardSaveFlg = _this.sh060Request.cardSaveFlg;
            var sbpLimitYear = _this.sh060Request.limitYear;
            var sbpLimitMonth = _this.sh060Request.limitMonth;
            var sbpCardPayCnt = _this.sh060Request.cardPayCnt;
            var sbpBunkatuKaisu = _this.sh060Request.bunkatuKaisu;
            var sbpSecurityCode = ((_this.sh060Request.cardFlg == undefined || _this.sh060Request.cardFlg == '0')?_this.sh060Request.securityCode:_this.sh060Request.cardSecurity);

            _this.listMessValid = [];
            // クレジットカードのセキュリティコード利用で既存カードの場合(定期注文追加の場合、チェックしない)
            if(_this.creditFlg && _this.sh060Init.securityCodeUseFlg) {
                if(!_this.sh060Request.cardSecurity && !_this.sh060Request.securityCode && _this.sh060Init.teikiAddFlg != 1) {
                    // セキュリティコードを入力してください。
                    _this.listMessValid.push(_this.$i18n.t('sh060.messages.secMust'));
                }
            }
            if(_this.sh060Init.teikiFlg == 1 && _this.sh060Init.teikiKbn == '2' && (_this.teikiFirstDay == '' || _this.teikiNextDay == '')) {
                // お届け日確認ボタンをクリックしてください。
                _this.listMessValid.push(_this.$i18n.t('sh060.messages.teikiTdkDayErr'));
            }
            if(_this.listMessValid.length > 0) {
                EventBus.$emit('message', {});
                common.scrollTop();
                _this.is3DLoding = false;
                _this.isSubmitting = false;
                return;
            }

            _this.$emit("event-loading", true);
            // クレジットカード情報のクリア（新規の場合）
            if (_this.sh060Init.realAuthoriFlg == '1' && _this.sh060Request.cardFlg == 0) {
                 // カード番号削除処理
                _this.cardNoDelete();
            }
            //clear msg valid
            _this.listMessValid = [];
            _this.mapMessValid = [];
            common.clearMessageEcSite(_this.listIdErr, _this.SH060_PART);
            _this.sh060Request.orderNum = _this.sh060Init.orderNum;
            _this.sh060Request.gmo3DVer2Flg = _this.securityGmo3DFlg; //GMO 3D 2.0 セキュア利用フラグ
            _this.sh060Request.gmo3DVer2BackUrl = window.location.origin + window.location.pathname + "?pageNo=" +  this.currPageNo;
            _this.sh060Request.pageNo = 22;

            if (_this.sh060Init.kessaiCd == Constants.KESSAI_GMO_DPAY){
                _this.sh060Request.gmoDPayBackRedirectUrl = window.location.origin + window.location.pathname + "?pageNo=" +  this.currPageNo;
            }
    
            if (_this.securitySbp3DFlg == 1){
                _this.sh060Request.sbp3DVerFlg = _this.securitySbp3DFlg;
                _this.sh060Request.sbp3DVerBackUrl = window.location.origin + window.location.pathname;// + "?pageNo=" +  this.currPageNo;
            }else{
                _this.sh060Request.sbp3DVerFlg = 0;
                _this.sh060Request.sbp3DVerBackUrl = "";
            }

            if (sessionStorage['amazonCheckoutSessionId'] != null) {
                _this.sh060Request.amazonCheckoutSessionId = sessionStorage['amazonCheckoutSessionId'];
                //POPUPを閉じるイベント
                EventBus.$on('closed', function() {
                    _this.isModalShow = false;
                });
                // 同意ラジオボタン
                if(_this.sh060Request.agreeFlag != 1 && _this.checkRegister == true){
                    // 規約に同意いただける場合のみ会員登録することができます。
                    _this.msgConfirm = _this.$i18n.t('pt400.labels.messg1')
                    _this.isModalShow = true;
                    _this.isButtonCancel = false;
                    _this.actionFlg = -1;
                    _this.$emit("event-loading", false); 
                    return;
                }
                _this.check();
            } else {
                if (_this.sh060Request != null && _this.sh060Request.amazonCheckoutSessionId != null && _this.sh060Init.orderInfo != null && _this.sh060Init.orderInfo['SIHARAI_HOHO_KBN_NM'] != "Amazon Pay"){
                    _this.sh060Request.amazonCheckoutSessionId = null;
                }
            }
            _this.isDisplayAmazon == 2;
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.SH060 + _this.$UrlConstants.DO_ORDER, _this.sh060Request).then(function(response) {
                if(_this.checkRegister == true){
                    _this.check();
                }
                if  (sessionStorage['amazonCheckoutSessionId'] != null) {
                    window.location.href = response.data.response;
                    return;
                }
                if(response.data.respCode == _this.SHOW_ERR_PAGE){
                    _this.$router.push({ name: "SH060ShopperInfoConfirmError"});
                    _this.is3DLoding = false
                    return;
                }
                
                if (response.data.respCode == _this.LEAD_DAY_ERR) {
                    _this.$emit("event-loading", false);
                    _this.msgConfirmAreaCheck = _this.descriptionInfo[8];
                    _this.isModalAreaCheckShow = true;
                    _this.isButtonCancelAreaCheck = false;
                    EventBus.$on('evtClickOk', function() {
                        _this.isModalAreaCheckShow = false;
                    });
                    EventBus.$on('closed', () => {
                        _this.isModalAreaCheckShow = false;
                    });
                    _this.is3DLoding = false;
                    return;
                }
                if(response.data.status == 'OK'){
                    var message = "";
                    var orderCd = "";
                    if(response.data.response != null){
                        message = response.data.response.message;
                        orderCd = response.data.response.orderCd;
                        if (_this.securityGmo3DFlg == 1){
                            _this.resGmoVer2ACS = response.data.response.resGmoVer2ACS;
                            _this.resGmoVer2RedirectUrl = response.data.response.resGmoVer2RedirectUrl;
                            if (_this.resGmoVer2ACS == '2'){
                                window.location.href = _this.resGmoVer2RedirectUrl;
                                return;
                            }
                        }
                        if (_this.securitySps3DFlg == 1) {
                            if (response.data.response.operateId == '4MemAdd' || response.data.response.operateId == '4MemChg') {
                                _this.sh060Request.sps3DVer2Flg = 1; // SPS 3D 2.0 セキュア利用フラグ
                                _this.sh060Request.kaiinIdPassFlg = 1; // 会員連携フラグ
                                _this.sh060Request.cardFlg = response.data.response.cardFlg;
                                _this.sh060Request.operateId = response.data.response.operateId;
                                _this.sh060Request.spsResultId = response.data.response.spsResultId;
                                _this.doSpsAuth();
                                return;
                            }else {
                                _this.doSps3DS(response.data.response);
                                return;
                            }
                        }
                        if (_this.securitySbp3DFlg == 1){
                            //apiResult apiErrCode apiRequestId tdsAuthenticationId redirectUrl 
                            let apiRequestId = response.data.response.apiRequestId;

                            if (apiRequestId == 'TA02-00101-101'){
                                let redirectUrl = '';
                                if (response.data.response.redirectUrl){
                                    redirectUrl = response.data.response.redirectUrl;
                                }

                                if (response.data.response.apiResult == "OK"){
                                    sessionStorage['sbp_ccdd'] = response.data.response.sbp_cust_cd;
                                    sessionStorage['sbpTdsAuthenticationId'] = response.data.response.tdsAuthenticationId;
                                    sessionStorage['sbpCardFlg'] = sbpCardFlg;
                                    sessionStorage['sbpCardSaveFlg'] = sbpCardSaveFlg;
                                    sessionStorage['sbpLimitYear'] = sbpLimitYear;
                                    sessionStorage['sbpLimitMonth'] = sbpLimitMonth;
                                    sessionStorage['sbpCardPayCnt'] = sbpCardPayCnt;
                                    if (sbpBunkatuKaisu){
                                        sessionStorage['sbpBunkatuKaisu'] = sbpBunkatuKaisu;
                                    }else{
                                        sessionStorage['sbpBunkatuKaisu'] = '';
                                    }
                                    sessionStorage['sbpSecurityCode'] = sbpSecurityCode;

                                    if (redirectUrl){
                                        window.location.href = redirectUrl;
                                    }
                                }else{
                                    sessionStorage['tdsAuthenticationId'] = '';
                                    console.log(response.data.response.apiErrCode);
                                    
                                }

                                _this.$emit("event-loading", false);
                                return; 
                            }
                        }

                        if (_this.sh060Init.kessaiCd == Constants.KESSAI_GMO_DPAY){
                            if (response.data.response.redirectUrl != ''){
                                sessionStorage['gmoDPayAccessID'] = response.data.response.gmoDPayAccessID;
                                
                                _this.gmoDPayAccessID = response.data.response.gmoDPayAccessID;
                                _this.gmoDPayToken = response.data.response.gmoDPayToken;
                                _this.gmoDPayStartURL = response.data.response.redirectUrl;
                                _this.$nextTick(() => _this.$refs.formDocomoStartCall.submit());

                                //let rUrl = response.data.response.redirectUrl ;
                                //rUrl = rUrl + "?AccessID=" + response.data.response.gmoDPayAccessID;
                                //rUrl = rUrl + "&Token=" + response.data.response.gmoDPayToken;
                                //window.location.href = rUrl;
                                
                                _this.$emit("event-loading", false);
                                return;
                            }
                        }
                    }
                    sessionStorage.removeItem('hopeDayList');
                    sessionStorage.removeItem('totalPointKin');
                    sessionStorage.removeItem('hopeDay');
                    sessionStorage.removeItem('hopeDayCnt');
                    sessionStorage.removeItem('sh060TranferData');
                    _this.$router.push({ name: _this.SiteConstants.PG010MAIN, params:{message:message,orderCd:orderCd}, query: {pageNo: 23}});
                }
                _this.$emit("event-loading", false);
            }).catch(function(error) {
                // eslint-disable-next-line
                _this.isSubmitting = false;
                _this.is3DLoding = false
                if(error != null && error != undefined){
                    if(error.response != null && error.response != undefined){
                        if(406 == error.response.status){
                            var resultValid = common.excuteValidationEcSite(error, _this.SH060_PART);
                            if(resultValid){
                                _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                _this.listMessValid = resultValid.msgList;
                                _this.mapMessValid = resultValid.mapMsg;
                                if (error.response.data && error.response.data.errorList && error.response.data.errorList.length > 0 && error.response.data.errorList[0] && error.response.data.errorList[0].groupId) {
                                    for(var i=0; i<error.response.data.errorList[0].groupId.length; i++){
                                        if(error.response.data.errorList[0].groupId[i] == "hopeDay" || error.response.data.errorList[0].groupId[i] == "hopeDayList"){
                                            sessionStorage.removeItem('hopeDayList');
                                            _this.sh060Request.hopeDayList = [];
                                            _this.hatchuCnt = 0;
                                            break;
                                        }
                                    }
                                }
                            }
                            common.scrollTop();
                        }else{
                            if(_this.sh060Init.kessaiCompKbn == 'JCS' && 401 == error.response.status) {
                                _this.msgConfirm = _this.$i18n.t('sh060.messages.sessionErr');
                                _this.isModalShow = true;
                                _this.isButtonCancel = false;

                                EventBus.$on('evtClickOk', function() {
                                    common.errorAPI(error);
                                });
                            } else {
                                common.errorAPI(error);
                            }
                            
                        }
                    }
                }
                _this.$emit("event-loading", false);
            });
        },

        /*
        * SPS 3DS認証処理
        */
        doSpsAuth: function(){
            var _this = this;

            _this.listMessValid = [];
            if(_this.listMessValid.length > 0) {
                EventBus.$emit('message', {});
                common.scrollTop();
                _this.is3DLoding = false
                return;
            }

            _this.$emit("event-loading", true);
            //clear msg valid
            _this.listMessValid = [];
            _this.mapMessValid = [];
            common.clearMessageEcSite(_this.listIdErr, _this.SH060_PART);
            _this.sh060Request.orderNum = _this.sh060Init.orderNum;
            _this.sh060Request.pageNo = 22;
            _this.isDisplayAmazon == 2;
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.SH060 + _this.$UrlConstants.DO_ORDER, _this.sh060Request).then((response) => {

                if(_this.checkRegister == true){
                    _this.check();
                }
                if  (sessionStorage['amazonCheckoutSessionId'] != null) {
                    window.location.href = response.data.response;
                    return;
                }
                if(response.data.respCode == _this.SHOW_ERR_PAGE){
                    _this.$router.push({ name: "SH060ShopperInfoConfirmError"});
                    _this.is3DLoding = false
                    return;
                }
                
                if (response.data.respCode == _this.LEAD_DAY_ERR) {
                    _this.$emit("event-loading", false);
                    _this.msgConfirmAreaCheck = _this.descriptionInfo[8];
                    _this.isModalAreaCheckShow = true;
                    _this.isButtonCancelAreaCheck = false;
                    EventBus.$on('evtClickOk', function() {
                        _this.isModalAreaCheckShow = false;
                    });
                    EventBus.$on('closed', () => {
                        _this.isModalAreaCheckShow = false;
                    });
                    _this.is3DLoding = false;
                    return;
                }
                if(response.data.status == 'OK'){
                    var message = "";
                    var orderCd = "";
                    if(response.data.response != null){
                        message = response.data.response.message;
                        orderCd = response.data.response.orderCd;
                        if (_this.securitySps3DFlg == 1) {
                            _this.doSps3DS(response.data.response);
                            return;
                        }
                    }
                }
                _this.$emit("event-loading", false);
            }).catch(function(error) {
                // eslint-disable-next-line
                _this.is3DLoding = false
                if(error != null && error != undefined){
                    if(error.response != null && error.response != undefined){
                        if(406 == error.response.status){
                            var resultValid = common.excuteValidationEcSite(error, _this.SH060_PART);
                            if(resultValid){
                                _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                _this.listMessValid = resultValid.msgList;
                                _this.mapMessValid = resultValid.mapMsg;
                                if (error.response.data && error.response.data.errorList && error.response.data.errorList.length > 0 && error.response.data.errorList[0] && error.response.data.errorList[0].groupId) {
                                    for(var i=0; i<error.response.data.errorList[0].groupId.length; i++){
                                        if(error.response.data.errorList[0].groupId[i] == "hopeDay" || error.response.data.errorList[0].groupId[i] == "hopeDayList"){
                                            sessionStorage.removeItem('hopeDayList');
                                            _this.sh060Request.hopeDayList = [];
                                            _this.hatchuCnt = 0;
                                            break;
                                        }
                                    }
                                }
                            }
                            common.scrollTop();
                        }else{
                            common.errorAPI(error);
                            
                        }
                    }
                }
                _this.$emit("event-loading", false);
            });
        },

        /*
        * カード番号を削除
        */
        cardNoDelete: function(){
            var _this = this;
            // カード番号
            _this.sh060Request.cardNoDisp = "";
            _this.sh060Request.cardNoDisp1 = "";
            _this.sh060Request.cardNoDisp2 = "";
            _this.sh060Request.cardNoDisp3 = "";
            _this.sh060Request.cardNoDisp4 = "";
            // セキュリティコード
            _this.sh060Request.cardSecurity = "";
            // 名義人
            if (this.sh060Init.kessaiCompKbn !== "SPS") {
                _this.sh060Request.cardNameMyouji = "";
                _this.sh060Request.cardNameNamae = "";
                _this.sh060Request.cardUserNm = "";
            }
            // 有効期限
            this.sh060Request.limitYear = "";
            this.sh060Request.limitMonth = "";
        },
        /*
        * 戻るボタン押下処理
        * 会員の場合はカート確認画面へ、ゲスト購入の場合はオプションによって分岐
        */
        doPageBack: function(){
            var _this = this;

            var backPageNo = 16;
            if (_this.sh060Init.backPageNo == 19) {
                backPageNo = 19;
            } else if (_this.sh060Init.backPageNo == 16) {
                backPageNo = 16;
            } else if (_this.sh060Init.backPageNo == 21) {
                backPageNo = 21;
            }
            this.saveSessionSh060();
            this.$router.push({ name: this.SiteConstants.PG010MAIN, query: {pageNo: backPageNo, orderConfirmFlg: 0}});
        },
        /*
        *  execute update or delete or insert
        */
        doAction: function(){
            var _this = this;
            switch (this.actionFlg) {
                case 1:
                    //this.doPoint();
                    break;
                default:
                    break;
            }
            // Hide alert confirm
            this.isModalShow = false;
            this.isModalAreaCheckShow = false;
            this.actionFlg = 0;
            this.isButtonCancel = true;
        },
        setResultJikantai1: function(){
            var returnVal='';
            var resultJikantaiList = this.sh060Init.giftList;
            if(this.sh060Init.tdkInfo != null) {
                var tdkListMap = this.sh060Init.tdkInfo[0];
                if(resultJikantaiList != null){
                    for (var tdkMap =0; tdkMap < resultJikantaiList.length; tdkMap++) {
                        if (tdkListMap["GIFT_KBN"] == resultJikantaiList[tdkMap]["KEY"]) {  
                            returnVal += resultJikantaiList[tdkMap]["VALUE"];
                        }
                    }
                }
            }
            return returnVal;
        },
        setResultJikantai2: function(){
            var returnVal='';
            var resultJikantaiList = this.sh060Init.jikantaiList;
            if(resultJikantaiList != null){
                var tdkListMap = this.sh060Init.tdkInfo[0];
                for (var tdkMap = 0; tdkMap < resultJikantaiList.length; tdkMap++) {
                    if (tdkListMap.TDK_HMS_KBN == resultJikantaiList[tdkMap].KEY) {  
                        returnVal += resultJikantaiList[tdkMap].VALUE;
                    }
                }
            }
            return returnVal;
        },
         /*
        * Function stringNvl
        */
        stringNvl: function(strVal, defVal){
            if(strVal==undefined){
                return defVal;
            }else{
                return strVal;
            }
        },
        /* 
        * Function excuteValidation 
        * analyst data message and display
        */
        displayWarning(errorList){
            var idList  = [];
            var mapMsg = [];
            var msgList = [];
            var listIdErr = [];
            // check error list
            if(errorList != null && errorList.length > 0){
                //var errorList = error.response.data.errorList;
                for(var index =0;  index < errorList.length; index ++){
                    // row of table
                    var rowTableIndex = errorList[index].rowTableIndex == undefined ? -1 : errorList[index].rowTableIndex;
                    // zoneIndex
                    var zoneIndex = errorList[index].zoneIndex == undefined ? -1 : errorList[index].zoneIndex;

                    // set border-color for input
                    var listGroupId = errorList[index].groupId;
                    if(listGroupId != null && listGroupId.length > 0){
                        for (var keyInx = 0; keyInx < listGroupId.length; keyInx++){
                            var idInput = listGroupId[keyInx];
                            var inputObj = $('#' + idInput);
                            if(inputObj != null && inputObj != undefined){
                                inputObj.css('border-color', "red");
                            }
                            listIdErr.push(idInput);
                        }
                    }

                    // replace messenge
                    var messageList = errorList[index].messageList;
                    if(messageList != null && messageList.length > 0){
                        for (var mesInx = 0; mesInx < messageList.length; mesInx++){
                            var msgTemp = messageList[mesInx].message;
                            var argList =messageList[mesInx].argList;
                            if(argList != null && argList.length > 0){
                                
                                for(var arg=0; arg<argList.length; arg++){
                                    // get lable display of item input 
                                    var idInput = $('#'+ argList[arg] + '_lbl');
                                    var label ='';

                                    if(idInput != null && idInput != undefined){
                                        label =  idInput.text();
                                    }
                                    // replace text for key to display
                                    if(rowTableIndex > -1){
                                        if(label.length > 0){
                                            msgTemp = msgTemp.replace('{' + argList[arg] + '}', label).replace('{rowIndex}', rowTableIndex);   
                                        }else{
                                            msgTemp = msgTemp.replace('{' + argList[arg] + '}', label);   
                                        }
                                    }else{
                                        if(label.length > 0){
                                            msgTemp = msgTemp.replace('{' + argList[arg] + '}', label);   
                                        }
                                    }
                                }
                            }
                            // if message not include key(message common)
                            if(listGroupId != null && listGroupId.length > 0){
                                var obj ={};
                                obj.key = listGroupId[0];
                                obj.mess= msgTemp;
                                mapMsg.push(obj);
                            }else{
                                msgList.push(msgTemp);
                            }
                        }
                    }
                }
                // emit message to componet message
                var msg ={};
                msg.listMess = msgList;
                msg.mapMsg = mapMsg;
                EventBus.$emit('message', msg);
                return listIdErr;
            }
        },
        formatPrice: function(value){
            return common.formatPrice(value);
        },
        /*
        * カード保存フラグのセット
        */
        setCardSaveFlg: function(){
            // 定期商品フラグ || 通常商品の場合かつ現在契約中の定期がある場合
            if (this.sh060Init.teikiFlg == 1 || (this.sh060Init.generalFlg == '1' && this.sh060Init.fea042TeikiFlg == '1')) {
                // クレジットの場合
                if (this.sh060Init.realAuthoriFlg == '1') {
                    this.sh060Request.cardSaveFlg = 1;
                } else {
                    this.sh060Request.cardSaveFlg = 0;
                }
            } else {
                if($('#_card_save_flg').prop('checked')){
                    this.sh060Request.cardSaveFlg = 1;
                }else{
                    this.sh060Request.cardSaveFlg = 0;
                }
            }
        },
        /* 
        * Function nvl for string item 
        */
        stringNvl: function(item, def){
            if(item == null || item == undefined){
                return def;
            }
            return item;
        },

        replaceCharacters(value) {
            if (value && value != '') {
                return value.replace('　定期お届けあり', '');
            }
            return value;
        },
        
        /*
        * isBunkatu:分割であるかどうか
        */
       isBunkatu(key) {
            if (this.sh060Init.payCntList.length > 0) {
               for (var i = 0; i < this.sh060Init.payCntList.length; i++){
                    var item = this.sh060Init.payCntList[i];
                    if(key == item.KEY && '1' == item.PARAM_MARK){
                        this.isBunkatuFlg = true;
                        return true;
                    };
               }
            }
            this.isBunkatuFlg = false;
            return false;
       },

        chgCardPayCnt() {
            this.sh060Request.lastBunkatuKaisu = '';
            if(this.isBunkatu(this.sh060Request.lastCardPayCnt)) {
                this.sh060Request.lastBunkatuKaisu = this.sh060Init.bunkatuKaisuList[0]['KEY'];
            }
        },

        chgCardPayModel() {
            var _this = this;
            _this.sh060Request.bunkatuKaisu = '';
            if(_this.isBunkatu(_this.sh060Request.cardPayCnt)) {
                _this.sh060Request.bunkatuKaisu = _this.sh060Init.bunkatuKaisuList[0]['KEY'];
            }
        },
        // フォーカスが外れた時、月を前０をセットする
        onBlur: function() {
            var limMonth = this.sh060Request.limitMonth;
            this.sh060Request.limitMonth = limMonth.padStart(2, "0");
        },
        // クレジット番号の4桁区切りでスペースを入れる処理
        onCredit: function() {
            var cardNo = this.sh060Request.cardNoDisp;
            const regexp = /^(\d{1,4})?(\d{1,4})?(\d{1,4})?(\d{1,4})?$/;
            const digits = cardNo.replace(/[^0-9]/g, '');
            this.sh060Request.cardNoDisp = [...regexp.exec(digits)].slice(1).filter(e => e).join(' ');
        },
        /**
         * 注文にクーポンコードを追加
         * @param {*} couponCd 
         */
         addCoupon: function(){
            let _this = this;
            _this.listMessValid = [];
            if (_this.addCouponCd == ""){
                return;
            }
            _this.$emit("event-loading", true);
            _this.sh060Request.couponCd = _this.addCouponCd;
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.SH060 + _this.$UrlConstants.DO_INSERT, _this.sh060Request).then(function(response) {
                if(response.data.status == "OK"){
                    _this.addCouponCd = "";
                    _this.sh060Init.couponCount = response.data.couponCount;
                    _this.sh060Init.couponList = response.data.couponList;
                    _this.sh060Init.totalGivenPointNum = response.data.givenPoint;
                    _this.sh060Init.givenPointOfCuppon = response.data.givenPointOfCuppon;
                    _this.doinitFlg = true;
                    _this.doInit();
                }else{
                    _this.listMessValid.push(response.data.response);
                    if(_this.listMessValid.length > 0) {
                        EventBus.$emit('message', {});
                        common.scrollTop();
                    }
                }
                _this.$emit("event-loading", false);
            }).catch(function(error) {
                _this.$emit("event-loading", false);
                common.errorAPI(error);
            });
        },
        /**
         * 指定選択したクーポンコード削除
         * @param {*} couponCd 
         */
        deleteCoupon: function(couponCd){
            var _this = this;
            _this.$emit("event-loading", true);
            _this.sh060Request.couponCd = couponCd;
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.SH060 + _this.$UrlConstants.DO_DELETE, _this.sh060Request).then(function(response) {
                if(response.data.status == "OK"){
                    _this.sh060Init.couponCount = response.data.couponCount;
                    _this.sh060Init.couponList = response.data.couponList;
                    _this.doinitFlg = true;
                    _this.doInit();
                }
                _this.$emit("event-loading", false);
            }).catch(function(error) {
                _this.$emit("event-loading", false);
                common.errorAPI(error);
            });
        },

        /**
         * 配達希望日の有効可否をチェック
         */
        checkTdkYmdNg() {
            var _this = this;
            var minTdkYmd;      // 最小配達希望日
            var maxTdkYmd;      // 最大配達希望日
            var errCnt = 0;     // エラーカウント
            _this.autoHachuKessaiNgFlg = 0;
            // 配達希望日リストの取得
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.SH060 + _this.$UrlConstants.GET_DATA).then(function(response) {
                if(response.data.status == "OK" && _this.sh060Init.tdkInfo != null && _this.sh060Init.tdkInfo.length != undefined){
                    _this.sh060Init.tdkYmdList = response.data.tdkYmdList;

                    if (_this.sh060Init.tdkYmdList.length > 1) {
                        minTdkYmd = _this.sh060Init.tdkYmdList[1]['VALUE'];
                        maxTdkYmd = _this.sh060Init.tdkYmdList[_this.sh060Init.tdkYmdList.length-1]['VALUE'];
                    } else {
                        var dt = new Date();
                        minTdkYmd = dt.getFullYear() + '/' + (dt.getMonth()<10 ? '0'+(dt.getMonth()+1):dt.getMonth()+1) + '/' + (dt.getDate()<10 ? '0'+dt.getDate():dt.getDate());
                        maxTdkYmd = minTdkYmd;
                    }
                    // 通常配達希望日
                    for(var i=0; i<_this.sh060Init.tdkInfo.length; i++){
                        var tdkYmd = _this.sh060Init.tdkInfo[i]['TDK_YMD'];
                        // 配達希望日が指定されている場合
                        if (tdkYmd){
                            if (minTdkYmd > tdkYmd || maxTdkYmd < tdkYmd) {
                                errCnt++;
                                break;
                            }
                        }
                    }
                    // 自動発注配達希望日
                    for(var i=0; i<_this.sh060Request.hopeDayList.length; i++){
                        // 自動発注不可商品が含まれている場合
                        if (_this.sh060Init.autoHachuNgFlg == 1) {
                            errCnt++;
                            break;
                        }
                        else if (!['1', '2', '82' , '6', '993'].includes(_this.sh060Init.kessaiCd)) {
                            _this.autoHachuKessaiNgFlg = 1;
                            errCnt++;
                            break;
                        } else {
                            var tdkYmd = _this.sh060Request.hopeDayList[i];
                            // 配達希望日が指定されている場合
                            if (tdkYmd){
                                if (minTdkYmd > tdkYmd) {
                                    errCnt++;
                                    break;
                                }
                            }
                        }
                    }
                    // 定期配達希望日
                    if (_this.sh060Request.hopeDay && minTdkYmd && maxTdkYmd) {
                        var tdkYmd = _this.sh060Request.hopeDay;
                        if (minTdkYmd > tdkYmd || maxTdkYmd < tdkYmd) {
                            errCnt++;
                        }
                    }
                    // エラーがある場合
                //     if (errCnt > 0) {
                //         _this.updateTdkYmdNg();
                //     }
                }
            }).catch(function(error) {
                common.errorAPI(error);
                return false;
            });
        },
        /**
         * 配達希望日の有効可否をチェック
         */
        updateTdkYmdNg() {
            var _this = this;
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.SH060 + _this.$UrlConstants.DO_UPDATE, _this.sh060Request).then(function(response) {
                if(response.data.status == "OK"){
                    sessionStorage.removeItem('hopeDayList');
                    sessionStorage.removeItem('hopeDay');
                    sessionStorage.removeItem('hopeDayCnt');
                    // if (_this.sh060Init.autoHachuNgFlg == 1) {
                    //     _this.errorMsg = _this.$i18n.t('sh060.messages.autoHachuNg');
                    // } else if (_this.autoHachuKessaiNgFlg == 1) {
                    //     _this.errorMsg = _this.$i18n.t('sh060.messages.autoHachuKessaiNg');
                    //     _this.autoHachuKessaiNgFlg = 0;
                    // } else {
                    //     _this.errorMsg = _this.$i18n.t('sh060.messages.tdKYmdErrMsg');
                    // }
                    _this.isErrorAlert = true;
                    _this.doinitFlg = true;
                    _this.doInit();
                }
            }).catch(function(error) {
                common.errorAPI(error);
            });
        },

        teikiShipCheck() {
            var _this = this;

            _this.$emit("event-loading", true);

            _this.teikiShipCheckErr = false;

            if (!_this.sh060Request.hopeDay || !_this.sh060Request.hopeDayCnt) {
                _this.teikiShipCheckErr = true;
                _this.teikiShipInfo = false;
                _this.$emit("event-loading", false);
                return;
            }

            _this.teikiFirstDay = _this.sh060Request.hopeDay;
            var dt = new Date(_this.teikiFirstDay);
            dt.setDate(dt.getDate() + Number(this.sh060Request.hopeDayCnt));
            _this.teikiNextDay = dt.getFullYear() + '/' + (dt.getMonth()<10 ? '0'+(dt.getMonth()+1):dt.getMonth()+1) + '/' + (dt.getDate()<10 ? '0'+dt.getDate():dt.getDate());
            _this._teikiShipIng = true;

            _this.hopeDayCnt = _this.sh060Request.hopeDayCnt;
            sessionStorage['hopeDayCnt'] = _this.sh060Request.hopeDayCnt;
            sessionStorage['hopeDay'] = _this.sh060Request.hopeDay;
            if(sessionStorage['amazonCheckoutSessionId'] == null && _this.ptInitData && _this.ptInitData.kessaiCd ==  _this.Constants.KESSAI_AMAZONPAY) {
                axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.SH060 + "/updateTekiAmazon", _this.sh060Request).then(function(response) {
                    _this.ptInitData.signature = response.data.signature;
                    _this.ptInitData.payloadJson = response.data.payloadJson;
                    _this.isDisplayAmazon = 0;
                    // 画面上部にAmazonPayボタンを表示(0だったら非表示)
                    // Dynamically load the Amazon Pay SDK script
                    const script = document.createElement('script');
                    script.acceptCharset ="utf-8";
                    script.type = "text/javascript";
                    script.src = 'https://static-fe.payments-amazon.com/checkout.js';
                    script.async = true;
                    document.head.appendChild(script);
                    // Wait for the script to be loaded before rendering the button
                    script.onload = () => {
                        // Check if the AmazonPay object is available
                        amazon.Pay.renderButton('#AmazonPayButton1', {
                            // set checkout environment
                            merchantId: _this.ptInitData.merchantId,
                            ledgerCurrency: 'JPY',   
                            // customize the buyer experience
                            checkoutLanguage: 'ja_JP',
                            productType: 'PayAndShip',
                            placement: 'Checkout',
                            buttonColor: 'Gold',
                            // configure Create Checkout Session request
                            createCheckoutSessionConfig: {        
                                payloadJSON: _this.ptInitData.payloadJson,
                                signature: _this.ptInitData.signature, 
                                publicKeyId: _this.ptInitData.publicKeyId
                            }
                        });
                        
                        };
                }).catch(function(error) {
                    _this.$emit("event-loading", false);
                    common.errorAPI(error);
                });
            }
            _this.$emit("event-loading", false);
            
        },
        /**
         * 定期カレンダー設定
         */
        initTeikiMonths() {
            var _this = this;

            _this.teikiMonths = [];
            if (!_this.sh060Init.tdkYmdList){
                return;
            }
            _this.firstTdkYmd = _this.sh060Init.tdkYmdList[1]['KEY'];
            let months = _this.getNextTwoMonths(_this.firstTdkYmd);

            fetch('https://holidays-jp.github.io/api/v1/date.json').then(function(response) {
                return response.json();
            }).then(function(holidaysObj) {
                let keys = Object.keys(holidaysObj);
                _this.holidays = keys.map(key => key.replace(/-/g, '/'));
            }).catch(function(error) {
                console.error('Error:', error);
            }).finally(function() {
                for (let [index, month] of months.entries()) {

                    let weeks = _this.getWeeksInMonth(month, index);
                    _this.teikiMonths.push({
                        monthNm: month,
                        weeks: weeks
                    });
                }
            });
        },
        /**
         * 次の2ヶ月を取得
         * @param {*} dateStr 
         * @returns 
         */
        getNextTwoMonths(dateStr) {
            const parts = dateStr.split('/');
            const year = parseInt(parts[0], 10);
            const month = parseInt(parts[1], 10) - 1;
            const date = new Date(year, month);

            const result = [];
            for (let i = 0; i < 3; i++) {
                let month = date.getMonth() + 1; 
                let year = date.getFullYear();
                result.push(`${year}/${String(month).padStart(2, '0')}`);
                date.setMonth(date.getMonth() + 1); 
            }

            return result;
        },
        /*
        * 指定月のカレンダーを取得
        */
        getWeeksInMonth(monthStr, index) {
            const parts = monthStr.split('/');
            const year = parseInt(parts[0], 10);
            const month = parseInt(parts[1], 10) - 1;
            const firstDayOfMonth = new Date(year, month, 1);
            const lastDayOfMonth = new Date(year, month + 1, 0);

            const weeks = [];
            for (let i = 0; i < 6; i++) {
                weeks.push(new Array(7).fill(null).map(() => ({ val: null, text: null, youbi: null })));
            }

            let currentWeek = 0;
            let dayOfWeek = firstDayOfMonth.getDay();

            for (let day = 1; day <= lastDayOfMonth.getDate(); day++) {
                const dateStr = `${year}/${String(month + 1).padStart(2, '0')}/${String(day).padStart(2, '0')}`;
                weeks[currentWeek][dayOfWeek] = {
                    val: dateStr,
                    text: day,
                    youbi: dayOfWeek,
                    isHoliday: this.holidays.includes(dateStr),
                    canSelect: ((index === 0 && new Date(dateStr) < new Date(this.firstTdkYmd)) || (this.disableMon && dayOfWeek == 1) || (this.disableTue && dayOfWeek == 2)) ? false : true
                };
                if (dayOfWeek === 6 && day !== lastDayOfMonth.getDate()) {
                    currentWeek++;
                }
                dayOfWeek = (dayOfWeek + 1) % 7;
            }

            return weeks;
        },
        /**
         * 定期カレンダーの色を設定
         * @param {*} day 
         */
        calendarColor(day) {
            var _this = this;
            var color = '';
            // 休日, ブランク
            color = ((day.youbi == 0 || day.isHoliday) ? 'sunDay' : 
                     (day.youbi == 6 ? 'saturDay' :
                     (day.val ? '' : 'blankDay')));

            // 初日、2回目以降の日付
            if (day.val && _this.teikiFirstDay == _this.sh060Request.hopeDay && _this.hopeDayCnt == _this.sh060Request.hopeDayCnt) {
                // カレンダー日付
                var dt1 = new Date(day.val);
                dt1 = new Date(dt1.getFullYear(), dt1.getMonth(), dt1.getDate());
                // 選択した日付
                var dt2 = new Date(_this.sh060Request.hopeDay);
                dt2 = new Date(dt2.getFullYear(), dt2.getMonth(), dt2.getDate());
                // 差分日数
                var diff = (dt1.getTime() - dt2.getTime()) / 86400000;

                // 差分日数が定期間隔の倍数の場合
                if (diff>0 && diff%_this.sh060Request.hopeDayCnt === 0) {
                // 二回目以降の日付
                    color = 'nextDay';
                } else if (diff == 0) {
                    // 0なら初日
                    color = 'firstDay';
                }
            }

            if (color == '') {
                color = 'normalDay';
            }

            return color;
        },
        // 定期の変数をリセット
        resetTeiki() {
            var _this = this;
            _this.teikiFirstDay = '';
            _this.teikiNextDay = '';
            _this.hopeDayCnt = '';
        },
        //ギフト設定
        setGiftKbn:function(){
            let _this = this;
            if (_this.sh060Init.giftFlg == 0) return;
            let giftKbn = '0';
            if(_this.sh060Init != null && this.sh060Init.tdkInfo){
                for(let j=0;j<this.sh060Init.tdkInfo.length;j++){
                    let tdkInfo = this.sh060Init.tdkInfo[j];
                    if(tdkInfo['TDK_FLG'] == 1 && tdkInfo['TDK_M_SEQ'] == 0){
                        giftKbn = '0';
                    }else{
                        giftKbn = '1';
                        break;
                    }
                }
                _this.sh060Request.hidGiftCd = giftKbn;
            }
        },
        
        // 与信限度額チェック
        doYoshinLimitCheck:function(){
            var _this = this;

            var yoshinLimitKin = _this.sh060Init.yoshinLimitKin;
            var misyuKin = _this.sh060Init.misyuKin;
            var seikyuuKin = _this.sh060Init.seikyuuKin;

            var yoshinKin = seikyuuKin + misyuKin;
            var yoshinLimitRitsu = yoshinKin / yoshinLimitKin;

            if (yoshinLimitKin < yoshinKin) {
                var str = _this.descriptionInfo['17'];
                _this.descriptionInfo['17'] = str.replace('{kakeOverKin}', yoshinKin - yoshinLimitKin);
                return 1;
            }
            if (yoshinLimitRitsu >= 0.9) {
                return 2;
            }
            return 0;
        },
        // お届け希望日変更
        changeTdkDay: function(tdkSeq,tdkNo,tdkMSeq,tdkFlg,sagyoNm1,
                            tdkYmd,tdkHmsKbn,tdkYmdHissuFlg,tdkHstmHissuFlg,
                            chakubiKbn,updChakubiKbn,tdkYmdErrFlg,tdkHstmErrFlg,
                            binsyuKbn,wappingOkFlg,noshiOkFlg){
            //chakubiKbn:商品マスタの着日区分値
            //updChakubiKbn:ワーク「W_EA012_ORDERADDR」の着日区分値
            //console.log('tdkSeq:'+tdkSeq);
            //console.log('tdkNo:'+tdkNo);
            //console.log('tdkMSeq:'+tdkMSeq);
            //console.log('tdkFlg:'+tdkFlg);
            //console.log('sagyoNm1:'+sagyoNm1);
            //console.log('tdkYmd:'+tdkYmd);
            //console.log('tdkYmd:'+tdkHmsKbn);
            //console.log('tdkYmdHissuFlg:'+tdkYmdHissuFlg);
            //console.log('tdkYmdErrFlg:'+tdkYmdErrFlg);
            //console.log('tdkHstmHissuFlg:'+tdkHstmHissuFlg);
            //console.log('tdkHstmErrFlg:'+tdkHstmErrFlg);
            //console.log('chakubiKbn:'+chakubiKbn);
            //console.log('updChakubiKbn:'+updChakubiKbn);
            //console.log('binsyuKbn:'+binsyuKbn);
            //console.log('wappingOkFlg:'+wappingOkFlg);
            //console.log('noshiOkFlg:'+noshiOkFlg);
            var _this = this;
            _this.showSh063Flg = true;//画面表示
            _this.reqModel.tdkNo = tdkNo;
            _this.reqModel.tdkSeq = tdkSeq;
            _this.reqModel.tdkMSeq = tdkMSeq;
            _this.reqModel.tdkFlg = tdkFlg;
            _this.reqModel.sagyoNm1 = sagyoNm1;//包装
            _this.reqModel.tdkYmd = tdkYmd;//お届け希望日
            _this.reqModel.pickupYmd = tdkYmd;//受取日
            _this.reqModel.tdkHmsKbn = tdkHmsKbn;//お届け希望時間帯

            _this.reqModel.chakubiKbn = chakubiKbn;//商品マスタの着日区分値
            _this.reqModel.updChakubiKbn = updChakubiKbn;//ワーク「W_EA012_ORDERADDR」の着日区分値
            _this.reqModel.tdkYmdHissuFlg = tdkYmdHissuFlg;//着日必須フラグ
            _this.reqModel.tdkYmdErrFlg = tdkYmdErrFlg;//着日指定不可フラグ
            _this.reqModel.tdkHstmHissuFlg = tdkHstmHissuFlg;//配達時間帯必須フラグ
            _this.reqModel.tdkHstmErrFlg = tdkHstmErrFlg;//配達時間帯指定不可フラグ

            _this.reqModel.binsyuKbn = binsyuKbn;//便種区分
            _this.reqModel.noshiOkFlg = noshiOkFlg;//のし使用可フラグ（配送ごと）
            _this.reqModel.wappingOkFlg = wappingOkFlg;//包装使用可フラグ（配送ごと）


            _this.dataSh063.tdkNo = tdkNo;
            _this.dataSh063.tdkSeq = tdkSeq;
            _this.dataSh063.tdkMSeq = tdkMSeq;
            _this.dataSh063.tdkFlg = tdkFlg;
            _this.dataSh063.sagyoNm1 = sagyoNm1;//包装
            _this.dataSh063.tdkYmd = tdkYmd;
            _this.dataSh063.pickupYmd = tdkYmd;
            _this.dataSh063.tdkHmsKbn = tdkHmsKbn;

            _this.dataSh063.chakubiKbn = chakubiKbn;//商品マスタの着日区分値
            _this.dataSh063.updChakubiKbn = updChakubiKbn;//ワーク「W_EA012_ORDERADDR」の着日区分値
            _this.dataSh063.tdkYmdHissuFlg = tdkYmdHissuFlg;//着日必須フラグ
            _this.dataSh063.tdkYmdErrFlg = tdkYmdErrFlg;//着日指定不可フラグ
            _this.dataSh063.tdkHstmHissuFlg = tdkHstmHissuFlg;//配達時間帯必須フラグ
            _this.dataSh063.tdkHstmErrFlg = tdkHstmErrFlg;//配達時間帯指定不可フラグ

            _this.dataSh063.binsyuKbn = binsyuKbn;//便種区分
            _this.dataSh063.noshiOkFlg = noshiOkFlg;//のし使用可フラグ（配送ごと）
            _this.dataSh063.wappingOkFlg = wappingOkFlg;//包装使用可フラグ（配送ごと）
        },

        setDataSh063: function(responseData){
            if(!responseData) {
                this.showSh063Flg = false;
                this.$router.go(0);
                return;
            }
        },
        
        //配送単位で指定するのしなどのギフト設定を全配送先分に反映する。
        copyTdkGiftSettingConfirm: function(tdkSeq,tdkNo){
            var _this = this;
            if(_this.sh060Init.cartSplitUseFlg == 1){
                _this.outputMsgConfirm = _this.$i18n.t('sh060.messages.copyTdkGiftSettingMsg');
                _this.isShowGiftSettingCopyAlert = true;
                _this.copyRequestModel.tdkSeq = tdkSeq;
                _this.copyRequestModel.tdkNo = tdkNo;
                return false;
            }
        },
        doCopyTdkGiftSetting: function(){
            var _this = this;
            console.log('doCopyTdkGiftSetting');
            this.isShowGiftSettingCopyAlert = false;
            _this.$emit("event-loading", true);

            //clear msg valid
            _this.listMessValid = [];
            _this.mapMessValid = [];
            common.clearMessageEcSite(_this.listIdErr, _this.SH060_PART);

            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.SH060 + _this.$UrlConstants.DO_COPY_TDKGIFT_SETTING, _this.copyRequestModel).then(function(response) {
                if(response.data.status == "OK"){
                    //画面リフレッシュ
                    _this.$router.go(0);
                }
            }).catch(function(error) {
                if(error != null && error != undefined){
                    if(error.response != null && error.response != undefined){
                        if(406 == error.response.status){
                            var resultValid = common.excuteValidationEcSite(error, _this.SH060_PART);
                            if(resultValid){
                                _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                _this.listMessValid = resultValid.msgList;
                                _this.mapMessValid = resultValid.mapMsg;
                            }
                            common.scrollTop();
                        }else{
                            common.errorAPI(error);
                        }
                    }
                }
                _this.$emit("event-loading", false);
            });
        },

        getItemNoshiCd: function(list){
            for (let i = 0; i < list.length; i++) {
                var noshiCd = list[i]['NOSHI_CD'];
                if (noshiCd && noshiCd.trim() !== '') {
                    //console.log('noshiCd:'+noshiCd+i);
                    return noshiCd;
                }
            }
            // 全て空だった場合
            return '';
        },

        getItemNoshiNm: function(list){
            for (let i = 0; i < list.length; i++) {
                var noshiNm = list[i]['NOSHI_NM'];
                if (noshiNm && noshiNm.trim() !== '') {
                    //console.log('noshiNm:'+noshiNm+i);
                    return noshiNm;
                }
            }
            // 全て空だった場合
            return '設定なし';
        },

        getItemNaire: function(list){
            for (let i = 0; i < list.length; i++) {
                var naireValue = list[i]['NAIRE'];
                if (naireValue && naireValue.trim() !== '') {
                    //console.log('naireValue:'+naireValue+i);
                    return naireValue;
                }
            }
            // 全て空だった場合
            return '設定なし';
        }
    },
    
    /*
    * Excute code after an instance is created
    */
    created: function(){
         var _this = this;
        // Get data from params and query
        var paramData = _this.$route.params;
        if(Object.keys(paramData).length > 0){
            _this.sh060Request.backPageNo = paramData.backPageNo;
            _this.sh060Request.teikiAddFlg = paramData.teikiAddFlg;
        }
        this.$on("event-loading-message", (isLoading, message) => {
            this.isLoading = isLoading;
            this.loadingMessage = message;
        });
        var queryData = this.$route.query;
        this.reOrderFlg = queryData.reOrderFlg;  
        if (_this.$route.query){
            if (_this.$route.query.action){
                _this.jasApiSeqNo = _this.$route.query.action;
            }

            if (_this.$route.query.pageNo){
                _this.currPageNo = _this.$route.query.pageNo;
            }
            
            if (_this.jasApiSeqNo){
                _this.is3DLoding = true;
            } else if (_this.$route.query.AccessID){
                _this.gmo2AuthAccessID = _this.$route.query.AccessID;
                _this.is3DLoding = true;
            } else if (_this.$route.query.spsResultId) {
                _this.spsResultId = _this.$route.query.spsResultId;
                _this.operateId = _this.$route.query.operateId;f
                
                _this.is3DLoding = true;
            } else if (_this.$route.query.sbpEmv3dsStatus) {
                _this.sbpEmv3dsStatus = _this.$route.query.sbpEmv3dsStatus;
                if (_this.sbpEmv3dsStatus == 'ok'){
                    _this.securitySbp3DFlg = 1;
                    _this.sbpTdsAuthenticationId = sessionStorage['sbpTdsAuthenticationId'];
                    sessionStorage.removeItem('sbpTdsAuthenticationId');

                    _this.is3DLoding = true;
                }else{
                    /*_this.sh060Request.cardFlg = sessionStorage['sbpCardFlg'];
                    _this.sh060Request.cardSaveFlg = sessionStorage['sbpCardSaveFlg'];
                    _this.sh060Request.limitYear = sessionStorage['sbpLimitYear'];
                    _this.sh060Request.limitMonth = sessionStorage['sbpLimitMonth'];
                    _this.sh060Request.cardPayCnt = sessionStorage['sbpCardPayCnt'];
                    if (sessionStorage['sbpBunkatuKaisu']){
                        _this.sh060Request.bunkatuKaisu = sessionStorage['sbpBunkatuKaisu'];
                    }
                    if (_this.sh060Request.cardFlg == undefined || _this.sh060Request.cardFlg == '0'){
                        _this.sh060Request.securityCode = sessionStorage['sbpSecurityCode'];
                    }else{
                        _this.sh060Request.cardSecurity = sessionStorage['sbpSecurityCode'];
                    }*/
                    
                    _this.sbpTdsAuthenticationId = '';
                    sessionStorage.removeItem('sbpCardFlg');
                    sessionStorage.removeItem('sbpCardSaveFlg');
                    sessionStorage.removeItem('sbpLimitYear');
                    sessionStorage.removeItem('sbpLimitMonth');
                    sessionStorage.removeItem('sbpCardPayCnt');
                    sessionStorage.removeItem('sbpBunkatuKaisu');
                    sessionStorage.removeItem('sbpSecurityCode');
                    sessionStorage.removeItem('sbpTdsAuthenticationId');

                     _this.is3DLoding = false;
                }
                
            } if (_this.$route.query.gmodpaySeqNo){
                _this.is3DLoding = true;
                _this.gmodpaySeqNo = _this.$route.query.gmodpaySeqNo;
                if (sessionStorage['gmoDPayAccessID'] ){
                    _this.gmoDPayAccessID = sessionStorage['gmoDPayAccessID'];
                    sessionStorage.removeItem('gmoDPayAccessID');
                }
           
            } else {
                _this.is3DLoding = false;
            }
            
        }
    },

    beforeDestroy() {
        clearInterval(this.timer);
        EventBus.$off('evtClickOk');
    },

    computed: {
        pan: function () {
            var cardNo;
            if (this.sh060Init.creditInpNumOption == 1) {
                cardNo = this.sh060Request.cardNoDisp;
                if (cardNo != undefined) {
                    cardNo = cardNo.replaceAll(' ','');
                }
                return cardNo;
            } else {
                cardNo = this.sh060Request.cardNoDisp1 + this.sh060Request.cardNoDisp2 + this.sh060Request.cardNoDisp3 + this.sh060Request.cardNoDisp4
                return cardNo;
            }
        },
        expiryDate: function() {
            return this.sh060Request.limitMonth + this.sh060Request.limitYear;
        },
        tourokuKbn: function() {
            return this.sh060Request.cardSaveFlg ? 'i' : '3';
        },
        msgDigest: function() {
            if(this.sh060Init.kessaiCompKbn != 'JCS') return '';

            let tourokuKbn = this.sh060Request.cardSaveFlg ? 'i' : '3';
            let payModel = this.sh060Request.cardPayCnt;
            let payCount = this.sh060Request.bunkatuKaisu;
            let keyAppend = '';
            if(payModel == 61) {
                keyAppend = '_' + payCount;
            }

            return this.sh060Init.msgDigestMap[tourokuKbn + '_' + payModel + keyAppend];
        },
        totalSeikyuKin: function() {
            let totalPointKin = parseInt(common.numberNvl(sessionStorage['totalPointKin']), 10);
            let currentSeikyuuKin = common.numberNvl(this.sh060Init.seikyuuKin) + common.numberNvl(this.sh060Init.pointKin);
            let onetimeKin = (this.hatchuCnt - 1) * this.sh060Init.oneTimeCupponKin;
            if(this.sh060Init.zengakuPointCnt) {
                return (currentSeikyuuKin * this.sh060Init.zengakuPointCnt + this.sh060Init.motoSeikyuKin * (this.hatchuCnt - this.sh060Init.zengakuPointCnt) - totalPointKin) + onetimeKin;
            }
            return (currentSeikyuuKin * this.hatchuCnt - totalPointKin) + onetimeKin;
        },
        hopeDayStr: function() {
            return JSON.parse(sessionStorage['hopeDayList']).join(', ');
        }

    },
    watch: {
        sh060Request: {
            handler: function() {
                this.saveSessionSh060();
            },
            deep: true
        },
    }
}
</script>
<style scoped>
a.messageErrorLineSh060{
    color:#dc3545!important;
}
.firstDay{
    background-color: #FFF399;
}
.nextDay{
    background-color: #D7FF88;
}
.sunDay{
    background-color: #FFD1D1;
    color:#990000;
}
.saturDay{
    background-color: #CCF9FF;
    color:#0000FF;
}
.blankDay{
    background-color: #DEDEDE;
}
.dt-col {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
}
.dt-table {
    display: flex;
    flex-direction: column;
    border-top: 1px solid #b59f9f;
    border-left: 1px solid #b59f9f;
    font-size: 12px;
}
.dt-row {
    display: flex;
}
.dt-cell {
    flex: 1;
    padding: 8px;
    border-bottom: 1px solid #b59f9f;
    border-right: 1px solid #b59f9f;
    justify-content: center;
    height: 1.8rem;
    width: 2.2rem;
    line-height: 0.9rem;
}
#tdStyle{
    text-align:center !important;
}
#sh060 table tr td:nth-child(1):before {
    content: "" !important;
}
.loading-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  z-index: 1000;
}

.loading-message {
    color: black;
    font-size: 2em;
}
.vld-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>